const mock_recipient_episodes_of_care = {
  resourceType: "Bundle",
  type: "searchset",
  total: 1,
  link: [
    {
      relation: "self",
      url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare?patient=TK8ubh9iKIhZtIpBirKZfEAL7xP-B04MxP3vZoYfrrnwB&type=urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130%7C4&status=active",
    },
  ],
  entry: [
    {
      link: [
        {
          relation: "self",
          url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
        },
      ],
      fullUrl:
        "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
      resource: {
        resourceType: "EpisodeOfCare",
        id: "exqtC8q0VjpjgnwtPxSBdtQ3",
        extension: [
          {
            valueString: "Kidney Transplant Referral - 9/5/2024",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
          },
          {
            valueCodeableConcept: {
              coding: [
                {
                  system: "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  code: "2",
                  display: "Recipient",
                },
              ],
              text: "Recipient",
            },
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      code: "16",
                      display: "Kidney",
                    },
                  ],
                  text: "Kidney",
                },
                url: "organ-class",
              },
              {
                valueReference: {
                  reference:
                    "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
                  type: "Practitioner",
                  display: "Jennifer Velupillai, RN",
                },
                url: "coordinator",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      code: "10",
                      display: "Referral",
                    },
                  ],
                  text: "Referral",
                },
                url: "phase",
              },
              {
                valueString: "Active",
                url: "status",
              },
              {
                valueString: "Accepted",
                url: "reason",
              },
              {
                valueDate: "2024-05-09",
                url: "effective",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
          },
          {
            valueDate: "2024-05-09",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
          },
          {
            valueString: "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
          },
        ],
        status: "active",
        type: [
          {
            coding: [
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                code: "49",
                display: "Transplant",
              },
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                code: "4",
                display: "Transplant",
              },
            ],
            text: "Transplant",
          },
        ],
        patient: {
          reference: "Patient/ee32WyakHGVPqiGDtEgFRqg3",
          type: "Patient",
          display: "TestOne, VirologyOneWaitlist Kingthree",
        },
        period: {
          start: "2024-05-09",
        },
        team: [
          {
            reference: "CareTeam/e.Uj.9UaIvgjfhnHkIf1K1nxo8DU0GDJzERZ8AJKabBQ3",
            type: "CareTeam",
          },
        ],
      },
      search: {
        mode: "match",
      },
    },
    {
      link: [
        {
          relation: "self",
          url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
        },
      ],
      fullUrl:
        "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3",
      resource: {
        resourceType: "EpisodeOfCare",
        id: "ffffffffffffffffff",
        extension: [
          {
            valueString: "Kidney Transplant Referral - 8/1/2024",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
          },
          {
            valueCodeableConcept: {
              coding: [
                {
                  system: "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  code: "2",
                  display: "Recipient",
                },
              ],
              text: "Recipient",
            },
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      code: "16",
                      display: "Kidney",
                    },
                  ],
                  text: "Kidney",
                },
                url: "organ-class",
              },
              {
                valueReference: {
                  reference:
                    "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
                  type: "Practitioner",
                  display: "Jennifer Velupillai, RN",
                },
                url: "coordinator",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      code: "10",
                      display: "Referral",
                    },
                  ],
                  text: "Referral",
                },
                url: "phase",
              },
              {
                valueString: "Active",
                url: "status",
              },
              {
                valueString: "Accepted",
                url: "reason",
              },
              {
                valueDate: "2024-05-09",
                url: "effective",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
          },
          {
            valueDate: "2024-05-09",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
          },
          {
            valueString: "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
          },
        ],
        status: "active",
        type: [
          {
            coding: [
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                code: "49",
                display: "Transplant",
              },
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                code: "4",
                display: "Transplant",
              },
            ],
            text: "Transplant",
          },
        ],
        patient: {
          reference: "Patient/ee32WyakHGVPqiGDtEgFRqg3",
          type: "Patient",
          display: "TestOne, VirologyOneWaitlist Kingthree",
        },
        period: {
          start: "2024-05-09",
        },
        team: [
          {
            reference: "CareTeam/e.Uj.9UaIvgjfhnHkIf1K1nxo8DU0GDJzERZ8AJKabBQ3",
            type: "CareTeam",
          },
        ],
      },
      search: {
        mode: "match",
      },
    },
  ],
};

const mock_donor_episodes_of_care = {
  resourceType: "Bundle",
  type: "searchset",
  total: 1,
  link: [
    {
      relation: "self",
      url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare?patient=TPOUFHrnSp1nyB54DoKJbJrSU7Kgfi0YnF1oqHAIeEfgB&type=urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130|4",
    },
  ],
  entry: [
    {
      link: [
        {
          relation: "self",
          url: "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eHoAunDtjEHdrQcuQhNgA-Q3",
        },
      ],
      fullUrl:
        "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eHoAunDtjEHdrQcuQhNgA-Q3",
      resource: {
        resourceType: "EpisodeOfCare",
        id: "eHoAunDtjEHdrQcuQhNgA-Q3",
        extension: [
          {
            valueString: "Kidney Donor Referral - 13/9/2024",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
          },
          {
            valueCodeableConcept: {
              coding: [
                {
                  system: "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  code: "1",
                  display: "Donor",
                },
              ],
              text: "Donor",
            },
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      code: "16",
                      display: "Kidney",
                    },
                  ],
                  text: "Kidney",
                },
                url: "organ-class",
              },
              {
                valueReference: {
                  reference:
                    "Practitioner/eLEavf4IPOCgFXBunI-92x3jMbMB4H30c4MkrjP3IraI3",
                  type: "Practitioner",
                  display: "Michelle Richter",
                },
                url: "coordinator",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
          },
          {
            extension: [
              {
                valueCodeableConcept: {
                  coding: [
                    {
                      system:
                        "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      code: "10",
                      display: "Referral",
                    },
                  ],
                  text: "Referral",
                },
                url: "phase",
              },
              {
                valueString: "Active",
                url: "status",
              },
              {
                valueDate: "2024-09-13",
                url: "effective",
              },
            ],
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
          },
          {
            valueDate: "2024-09-13",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
          },
          {
            valueString: "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            url: "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
          },
        ],
        status: "active",
        type: [
          {
            coding: [
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                code: "49",
                display: "Transplant",
              },
              {
                system: "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                code: "4",
                display: "Transplant",
              },
            ],
            text: "Transplant",
          },
        ],
        patient: {
          reference: "Patient/e6n18sZacMpSAByfiE8Ph-Q3",
          type: "Patient",
          display: "OneOATS, DonorEpic",
        },
        period: {
          start: "2024-09-15",
        },
        team: [
          {
            reference: "CareTeam/eeDu6CGEUzDdeaRHRE8r0N50YMgww0LDk126pbIBfjZ43",
            type: "CareTeam",
          },
        ],
      },
      search: {
        mode: "match",
      },
    },
  ],
};
const mock_donor_and_recipient_EOC = {
  "resourceType": "Bundle",
  "type": "searchset",
  "total": 11,
  "link": [
    {
      "relation": "self",
      "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare?patient=TcNLDD43.rRgWdRGcqBsh5Qto5aRBxhoyrZADHldKBmUB&type=urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130|4"
    }
  ],
  "entry": [
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eJBgn.R9kvGSFAJLxeHZRpA3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eJBgn.R9kvGSFAJLxeHZRpA3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "eJBgn.R9kvGSFAJLxeHZRpA3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant - 7/8/2024 - Not Followed  (#1)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
    //               "type": "Practitioner",
    //               "display": "Jennifer Velupillai, RN"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "50",
    //                   "display": "Transplanted"
    //                 }
    //               ],
    //               "text": "Transplanted"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Not Followed",
    //             "url": "status"
    //           },
    //           {
    //             "valueString": "Patient Died",
    //             "url": "reason"
    //           },
    //           {
    //             "valueDate": "2024-08-08",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-08-01",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valuePeriod": {
    //           "start": "2024-08-02",
    //           "end": "2024-08-03"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
    //       },
    //       {
    //         "valueDate": "2024-08-03",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-08-03",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-08-07",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       },
    //       {
    //         "valueReference": {
    //           "reference": "BodyStructure/efZZmZ3ZD28PoDcjdCpPVMjue-lEypIrY63lv5uGMrsBbvacP0sKOCgnGVoAw2-Ed3",
    //           "type": "BodyStructure",
    //           "display": "Right Kidney"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
    //       }
    //     ],
    //     "status": "finished",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-09-08",
    //       "end": "2024-09-08"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWL0iVqzOshzUiMZCS6tOM8I3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e1ZS.CP.TTP-eKsTwXxumUQ3"
        }
      ],
      "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e1ZS.CP.TTP-eKsTwXxumUQ3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "e1ZS.CP.TTP-eKsTwXxumUQ3",
        "extension": [
          {
            "valueString": "Kidney Donor Referral - 24/7/2024",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "1",
                  "display": "Donor"
                }
              ],
              "text": "Donor"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "16",
                      "display": "Kidney"
                    }
                  ],
                  "text": "Kidney"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eTZruHD5aMHHy3hOfPmQbbw3",
                  "type": "Practitioner",
                  "display": "Coordinator Phoenix, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2024-07-24",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2024-07-24",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                "code": "49",
                "display": "Transplant"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "Transplant"
          }
        ],
        "patient": {
          "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
          "type": "Patient",
          "display": "Phxtst, Hyperdrive"
        },
        "period": {
          "start": "2024-07-24"
        },
        "team": [
          {
            "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWIAec9e9Kp9NYqLlyt9.nM43",
            "type": "CareTeam"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/etfWDFBSL7oJSuf.ZunY4ig3"
        }
      ],
      "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/etfWDFBSL7oJSuf.ZunY4ig3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "etfWDFBSL7oJSuf.ZunY4ig3",
        "extension": [
          {
            "valueString": "Kidney Transplant Referral - 10/7/2024",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "16",
                      "display": "Kidney"
                    }
                  ],
                  "text": "Kidney"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eTZruHD5aMHHy3hOfPmQbbw3",
                  "type": "Practitioner",
                  "display": "Coordinator Phoenix, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2024-08-13",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2024-07-10",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                "code": "49",
                "display": "Transplant"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "Transplant"
          }
        ],
        "diagnosis": [
          {
            "condition": {
              "reference": "Condition/eQ7Nr28rYNpIBYMvaD1Lwcw3",
              "type": "Condition",
              "display": "CKD (chronic kidney disease)"
            }
          }
        ],
        "patient": {
          "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
          "type": "Patient",
          "display": "Phxtst, Hyperdrive"
        },
        "period": {
          "start": "2024-07-10"
        },
        "team": [
          {
            "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWNzGjo9cAO26fG1ehCe1MjU3",
            "type": "CareTeam"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eh0yk6z71a.2oHZka5DmM3g3"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eh0yk6z71a.2oHZka5DmM3g3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "eh0yk6z71a.2oHZka5DmM3g3",
        "extension": [
          {
            "valueString": "Kidney, Pancreas Transplant Referral - 3/3/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "16",
                      "display": "Kidney"
                    }
                  ],
                  "text": "Kidney"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/ezAPguRm6DIJyx4nLB0Zf5Q3",
                  "type": "Practitioner",
                  "display": "Lok, Charmaine E., MD"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "4",
                      "display": "Pancreas"
                    }
                  ],
                  "text": "Pancreas"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/ezAPguRm6DIJyx4nLB0Zf5Q3",
                  "type": "Practitioner",
                  "display": "Lok, Charmaine E., MD"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2026-03-03",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-03-03",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/e0lrTDei5Oia3Q1ztPvRILg3",
          "type": "Patient",
          "display": "UHNFour, RecipientFour"
        },
        "period": {
          "start": "2026-03-03"
        },
        "team": [
          {
            "reference": "CareTeam/eQP2CEO9CxNxEWHFggGTI.XunwXh1c1rGYtCK3GpBCGU3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eAV3WHk7HPeQ.LyKZ7dJ3Zw3"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eAV3WHk7HPeQ.LyKZ7dJ3Zw3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "eAV3WHk7HPeQ.LyKZ7dJ3Zw3",
        "extension": [
          {
            "valueString": "Liver Transplant Referral - 23/3/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "8",
                      "display": "Liver"
                    }
                  ],
                  "text": "Liver"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2026-03-23",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-03-23",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/e0lrTDei5Oia3Q1ztPvRILg3",
          "type": "Patient",
          "display": "UHNFour, RecipientFour"
        },
        "period": {
          "start": "2026-03-23"
        },
        "team": [
          {
            "reference": "CareTeam/eQP2CEO9CxNxEWHFggGTI.VbcB5bNox5nFJ6ii8qMbSQ3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/ef-S50W4w7uXvl7WjNo3zyg3"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/ef-S50W4w7uXvl7WjNo3zyg3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "ef-S50W4w7uXvl7WjNo3zyg3",
        "extension": [
          {
            "valueString": "Lung Transplant Referral - 23/2/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "2",
                      "display": "Lung"
                    }
                  ],
                  "text": "Lung"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueString": "Accepted",
                "url": "reason"
              },
              {
                "valueDate": "2026-02-23",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-02-23",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/eI38ArXZIU79zcIA3UjJigQ3",
          "type": "Patient",
          "display": "UhnOne, RecipientOne Testone, test, test"
        },
        "period": {
          "start": "2026-02-23"
        },
        "team": [
          {
            "reference": "CareTeam/elM6BPsWwelMQcxD6TD3PIqdw2bbtY.-UTtUWwSacoTw3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/epRu8p55b48F-I0gMQts8mA3"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/epRu8p55b48F-I0gMQts8mA3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "epRu8p55b48F-I0gMQts8mA3",
        "extension": [
          {
            "valueString": "Heart Transplant Referral - 12/1/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "64",
                      "display": "Heart"
                    }
                  ],
                  "text": "Heart"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueString": "Accepted",
                "url": "reason"
              },
              {
                "valueDate": "2026-02-23",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-01-12",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          },
          {
            "valueReference": {
              "reference": "BodyStructure/eFBn2j2GOhpjzrNOK3N-JYac2HQLDcfHsUCPz6IPLTq0TRxCg0jHAB2HFRA7Id-FN3",
              "type": "BodyStructure",
              "display": "Heart"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/e0lrTDei5Oia3Q1ztPvRILg3",
          "type": "Patient",
          "display": "UHNFour, RecipientFour"
        },
        "period": {
          "start": "2026-01-12"
        },
        "team": [
          {
            "reference": "CareTeam/eQP2CEO9CxNxEWHFggGTI.Z0cTHRZ4rJ7vuVr3M10KmA3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/epRu8p55b48F-I0gMQts8mB4"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/epRu8p55b48F-I0gMQts8mB4",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "epRu8p55b48F-I0gMQts8mB4",
        "extension": [
          {
            "valueString": "Intestine Transplant Referral - 12/1/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "32",
                      "display": "Intestine"
                    }
                  ],
                  "text": "Intestine"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueString": "Accepted",
                "url": "reason"
              },
              {
                "valueDate": "2026-02-23",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-01-12",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          },
          {
            "valueReference": {
              "reference": "BodyStructure/eFBn2j2GOhpjzrNOK3N-JYac2HQLDcfHsUCPz6IPLTq0TRxCg0jHAB2HFRA7Id-FN3",
              "type": "BodyStructure",
              "display": "Intestine"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/e0lrTDei5Oia3Q1ztPvRILg3",
          "type": "Patient",
          "display": "UHNFour, RecipientFour"
        },
        "period": {
          "start": "2026-01-12"
        },
        "team": [
          {
            "reference": "CareTeam/eQP2CEO9CxNxEWHFggGTI.Z0cTHRZ4rJ7vuVr3M10KmA3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://fhirnpd.kidshealthalliance.ca/fhirtst/api/FHIR/R4/EpisodeOfCare/elFJHKZ3.kxnPa4CYBfoeFqCbf1PIWyaEy6cHStmY30Q3"
        }
      ],
      "fullUrl": "https://fhirnpd.kidshealthalliance.ca/fhirtst/api/FHIR/R4/EpisodeOfCare/elFJHKZ3.kxnPa4CYBfoeFqCbf1PIWyaEy6cHStmY30Q3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "elFJHKZ3.kxnPa4CYBfoeFqCbf1PIWyaEy6cHStmY30Q3",
        "extension": [
          {
            "valueString": "Liver, Intestine Transplant Referral - 25/8/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "8",
                      "display": "Liver"
                    }
                  ],
                  "text": "Liver"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/e2sprIUCzTkCLziAOujj00Q3",
                  "type": "Practitioner",
                  "display": "Sk Transplant, Nurse"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "32",
                      "display": "Intestine"
                    }
                  ],
                  "text": "Intestine"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/e2sprIUCzTkCLziAOujj00Q3",
                  "type": "Practitioner",
                  "display": "Sk Transplant, Nurse"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2026-08-25",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-08-25",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "SickKids",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.15.3.7.2.726668",
                "code": "49",
                "display": "Transplant"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.15.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "Transplant"
          }
        ],
        "patient": {
          "reference": "Patient/eq208qzF.Bn5nfHfkn8oWFUVjHgFSJ8iSXHkjFXVRW5U3",
          "type": "Patient",
          "display": "HSCTwo, RecipientTwo EMRTwo"
        },
        "period": {
          "start": "2026-08-25"
        },
        "team": [
          {
            "reference": "CareTeam/er6K9DI3JDagRu58JMwsgyxfBBdJ8KWCzS5RPVEX-JCU3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://fhirnpd.kidshealthalliance.ca/fhirtst/api/FHIR/R4/EpisodeOfCare/eRhSGfmIPcTZA2gFkVr6MtGoSRPeKgYHaxM7xp0VtUjM3"
        }
      ],
      "fullUrl": "https://fhirnpd.kidshealthalliance.ca/fhirtst/api/FHIR/R4/EpisodeOfCare/eRhSGfmIPcTZA2gFkVr6MtGoSRPeKgYHaxM7xp0VtUjM3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "eRhSGfmIPcTZA2gFkVr6MtGoSRPeKgYHaxM7xp0VtUjM3",
        "extension": [
          {
            "valueString": "Intestine, Liver Transplant Referral - 1/9/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "32",
                      "display": "Intestine"
                    }
                  ],
                  "text": "Intestine"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/e2sprIUCzTkCLziAOujj00Q3",
                  "type": "Practitioner",
                  "display": "Sk Transplant, Nurse"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "8",
                      "display": "Liver"
                    }
                  ],
                  "text": "Liver"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/e2sprIUCzTkCLziAOujj00Q3",
                  "type": "Practitioner",
                  "display": "Sk Transplant, Nurse"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2026-09-01",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-09-01",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "SickKids",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.15.3.7.2.726668",
                "code": "49",
                "display": "Transplant"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.15.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "Transplant"
          }
        ],
        "patient": {
          "reference": "Patient/eq208qzF.Bn5nfHfkn8oWFUVjHgFSJ8iSXHkjFXVRW5U3",
          "type": "Patient",
          "display": "HSCTwo, RecipientTwo EMRTwo"
        },
        "period": {
          "start": "2026-09-01"
        },
        "team": [
          {
            "reference": "CareTeam/er6K9DI3JDagRu58JMwsgy31z-HJkVnxoSbcxAZWtNwg3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/epRu8p55b48F-I0gMQtsASD"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/epRu8p55b48F-I0gMQtsASD",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "epRu8p55b48F-I0gMQtsASD",
        "extension": [
          {
            "valueString": "Islet Transplant Referral - 12/1/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "128",
                      "display": "Islet"
                    }
                  ],
                  "text": "Islet"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueString": "Accepted",
                "url": "reason"
              },
              {
                "valueDate": "2026-02-23",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-01-12",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          },
          {
            "valueReference": {
              "reference": "BodyStructure/eFBn2j2GOhpjzrNOK3N-JYac2HQLDcfHsUCPz6IPLTq0TRxCg0jHAB2HFRA7Id-FN3",
              "type": "BodyStructure",
              "display": "Islet"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/e0lrTDei5Oia3Q1ztPvRILg3",
          "type": "Patient",
          "display": "UHNFour, RecipientFour"
        },
        "period": {
          "start": "2026-01-12"
        },
        "team": [
          {
            "reference": "CareTeam/eQP2CEO9CxNxEWHFggGTI.Z0cTHRZ4rJ7vuVr3M10KmA3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eTe7beWAtbhGfjLyr6loSVg3"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eTe7beWAtbhGfjLyr6loSVg3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "eTe7beWAtbhGfjLyr6loSVg3",
        "extension": [
          {
            "valueString": "Pancreas Transplant Referral - 2/2/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "4",
                      "display": "Pancreas"
                    }
                  ],
                  "text": "Pancreas"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2026-02-02",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-02-02",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          },
          {
            "valueReference": {
              "reference": "BodyStructure/eMyalwwV..nmZv60RnQrzhUwkrTKgq1pcyqh-l7eXIW0ljIgOIP-JbmyEu4yC56vO3",
              "type": "BodyStructure",
              "display": "Pancreas"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/e0lrTDei5Oia3Q1ztPvRILg3",
          "type": "Patient",
          "display": "UHNFour, RecipientFour"
        },
        "period": {
          "start": "2026-02-02",
          "end": "2026-02-03"
        },
        "team": [
          {
            "reference": "CareTeam/eQP2CEO9CxNxEWHFggGTI.R8FPjhMZM3sx4Wib.60BDo3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    {
      "link": [
        {
          "relation": "self",
          "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eaTUHINnuXwWmwE3dqP0gsw3"
        }
      ],
      "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eaTUHINnuXwWmwE3dqP0gsw3",
      "resource": {
        "resourceType": "EpisodeOfCare",
        "id": "eaTUHINnuXwWmwE3dqP0gsw3",
        "extension": [
          {
            "valueString": "Pancreas, Kidney Transplant Referral - 23/3/2026",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
          },
          {
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                  "code": "2",
                  "display": "Recipient"
                }
              ],
              "text": "Recipient"
            },
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "4",
                      "display": "Pancreas"
                    }
                  ],
                  "text": "Pancreas"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                      "code": "16",
                      "display": "Kidney"
                    }
                  ],
                  "text": "Kidney"
                },
                "url": "organ-class"
              },
              {
                "valueReference": {
                  "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                  "type": "Practitioner",
                  "display": "Phoenix, Coordinator, RN"
                },
                "url": "coordinator"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
          },
          {
            "extension": [
              {
                "valueCodeableConcept": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                      "code": "10",
                      "display": "Referral"
                    }
                  ],
                  "text": "Referral"
                },
                "url": "phase"
              },
              {
                "valueString": "Active",
                "url": "status"
              },
              {
                "valueDate": "2026-03-23",
                "url": "effective"
              }
            ],
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
          },
          {
            "valueDate": "2026-03-23",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
          },
          {
            "valueString": "University Health Network",
            "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
          }
        ],
        "status": "active",
        "type": [
          {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                "code": "49",
                "display": "TRANSPLANT"
              },
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                "code": "4",
                "display": "Transplant"
              }
            ],
            "text": "TRANSPLANT"
          }
        ],
        "patient": {
          "reference": "Patient/eqPNlojUKdXxGhWkzbJPveg3",
          "type": "Patient",
          "display": "UhnNine, RecipientNine MiddleName"
        },
        "period": {
          "start": "2026-03-23"
        },
        "team": [
          {
            "reference": "CareTeam/eQhsTzfT6zMPcBZG-4la4LKPkwZAiF40sy2XYtjjanWo3",
            "type": "CareTeam",
            "display": "Care Team"
          }
        ]
      },
      "search": {
        "mode": "match"
      }
    },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e7U4kq8myhJpJRF-RmoFxvg3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e7U4kq8myhJpJRF-RmoFxvg3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "e7U4kq8myhJpJRF-RmoFxvg3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 10/7/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/eizqfOoqat9nXDsTJWcT-ZLrXKoZRf-SbW6DZPJCr1Lw3",
    //               "type": "Practitioner",
    //               "display": "Jackie Gamble, RPN"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-07-10",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-07-10",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-07-10"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWG1yRaxdiP.6jCBbfCT9s7A3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ebSLpyLqDE92opoNBDhZ48A3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ebSLpyLqDE92opoNBDhZ48A3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "ebSLpyLqDE92opoNBDhZ48A3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Donor Referral - 21/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "1",
    //               "display": "Donor"
    //             }
    //           ],
    //           "text": "Donor"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/eLEavf4IPOCgFXBunI-92x3jMbMB4H30c4MkrjP3IraI3",
    //               "type": "Practitioner",
    //               "display": "Michelle Richter"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-21",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-21",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-21"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWCqEd65QD5HrE.y9-UI-Np83",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eQNAhWxmPZqWTn0QyKMsXag3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eQNAhWxmPZqWTn0QyKMsXag3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "eQNAhWxmPZqWTn0QyKMsXag3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 10/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-10",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-10",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-10"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWCmd89vK9u0G56rO2MGaKpk3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/es5uJ7KxuvCos-dW7ljgmAA3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/es5uJ7KxuvCos-dW7ljgmAA3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "es5uJ7KxuvCos-dW7ljgmAA3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 6/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-06",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-06",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-06"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWJj9CmyERLcTGvY.NXaYcR03",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e18eozRQE7LTWg4WdpdMGHw3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/e18eozRQE7LTWg4WdpdMGHw3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "e18eozRQE7LTWg4WdpdMGHw3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Evaluation - 10/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "20",
    //                   "display": "Evaluation"
    //                 }
    //               ],
    //               "text": "Evaluation"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-10",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-05",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valuePeriod": {
    //           "start": "2024-06-10"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       },
    //       {
    //         "valueReference": {
    //           "reference": "BodyStructure/eJEABpnipUW9RepJgiXDpwtwbqYbCh8yYk1DNf3WW9mWnU9sTuSZzqDEe.0eu8cVb3",
    //           "type": "BodyStructure",
    //           "display": "Right Kidney"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-05"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWIBqKa29eQDW2UyD8cntYBk3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ejc-OPcOxAbvKwm6CFMnxTw3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/ejc-OPcOxAbvKwm6CFMnxTw3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "ejc-OPcOxAbvKwm6CFMnxTw3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 4/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-04",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-04",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-04"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWE26EZfBqJvPiocTDko2b2o3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/efDch2meyM59p8HHBt2X8uA3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/efDch2meyM59p8HHBt2X8uA3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "efDch2meyM59p8HHBt2X8uA3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant Referral - 4/6/2024",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
    //               "type": "Practitioner",
    //               "display": "Jennifer Donnelly"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "10",
    //                   "display": "Referral"
    //                 }
    //               ],
    //               "text": "Referral"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-06-04",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-06-04",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-06-04"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWECRcw7Ikyj9Vms-JvNNNqg3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // },
    // {
    //   "link": [
    //     {
    //       "relation": "self",
    //       "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eYiwQ74F8j2vobqxY4PFG8A3"
    //     }
    //   ],
    //   "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/EpisodeOfCare/eYiwQ74F8j2vobqxY4PFG8A3",
    //   "resource": {
    //     "resourceType": "EpisodeOfCare",
    //     "id": "eYiwQ74F8j2vobqxY4PFG8A3",
    //     "extension": [
    //       {
    //         "valueString": "Kidney Transplant - 27/2/2024  (#1)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
    //       },
    //       {
    //         "valueCodeableConcept": {
    //           "coding": [
    //             {
    //               "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
    //               "code": "2",
    //               "display": "Recipient"
    //             }
    //           ],
    //           "text": "Recipient"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
    //                   "code": "16",
    //                   "display": "Kidney"
    //                 }
    //               ],
    //               "text": "Kidney"
    //             },
    //             "url": "organ-class"
    //           },
    //           {
    //             "valueReference": {
    //               "reference": "Practitioner/egdmEZfQprtaIOyol25BVo1XR9ugRfm1-UQXvsO0oQ-43",
    //               "type": "Practitioner",
    //               "display": "Jennifer Velupillai, RN"
    //             },
    //             "url": "coordinator"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
    //       },
    //       {
    //         "extension": [
    //           {
    //             "valueCodeableConcept": {
    //               "coding": [
    //                 {
    //                   "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
    //                   "code": "50",
    //                   "display": "Transplanted"
    //                 }
    //               ],
    //               "text": "Transplanted"
    //             },
    //             "url": "phase"
    //           },
    //           {
    //             "valueString": "Active Follow-up",
    //             "url": "status"
    //           },
    //           {
    //             "valueDate": "2024-02-27",
    //             "url": "effective"
    //           }
    //         ],
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
    //       },
    //       {
    //         "valueDate": "2024-01-27",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
    //       },
    //       {
    //         "valuePeriod": {
    //           "start": "2024-02-06",
    //           "end": "2024-02-13"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
    //       },
    //       {
    //         "valueDate": "2024-02-13",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-02-13",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
    //       },
    //       {
    //         "valueDate": "2024-02-27",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
    //       },
    //       {
    //         "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)",
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
    //       },
    //       {
    //         "valueReference": {
    //           "reference": "BodyStructure/eShUHVELuRWdGcm.lmksNyeh2Pl2Z.DpR9jGBurrIRERQ7pCwGVEs-3n2jippQz.D3",
    //           "type": "BodyStructure",
    //           "display": "Left Kidney"
    //         },
    //         "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
    //       }
    //     ],
    //     "status": "cancelled",
    //     "type": [
    //       {
    //         "coding": [
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
    //             "code": "49",
    //             "display": "Transplant"
    //           },
    //           {
    //             "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
    //             "code": "4",
    //             "display": "Transplant"
    //           }
    //         ],
    //         "text": "Transplant"
    //       }
    //     ],
    //     "patient": {
    //       "reference": "Patient/euIfIDVBfPh845vh4p482Ig3",
    //       "type": "Patient",
    //       "display": "Phxtst, Hyperdrive"
    //     },
    //     "period": {
    //       "start": "2024-02-27"
    //     },
    //     "team": [
    //       {
    //         "reference": "CareTeam/eDUEQVefZY4noM2gKQRAoWG-ObqyeiDgzHYXOoy3JlXg3",
    //         "type": "CareTeam"
    //       }
    //     ]
    //   },
    //   "search": {
    //     "mode": "match"
    //   }
    // }
  ]
}
const mock_patient = {
  resourceType: "Patient",
  id: "eOPSKZbz6YIgoilQprzPy0Q3",
  extension: [
    {
      valueCodeableConcept: {
        coding: [
          {
            system:
              "urn:oid:1.2.840.114350.1.13.0.1.7.10.698084.130.657370.19999000",
            code: "female",
            display: "female",
          },
        ],
      },
      url: "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex",
    },
    {
      valueCodeableConcept: {
        coding: [
          {
            system:
              "urn:oid:1.2.840.114350.1.13.0.1.7.10.698084.130.657370.19999000",
            code: "female",
            display: "female",
          },
        ],
      },
      url: "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use",
    },
    {
      extension: [
        {
          valueCoding: {
            system: "urn:oid:2.16.840.1.113883.6.238",
            code: "2131-1",
            display: "Other Race",
          },
          url: "ombCategory",
        },
        { valueString: "Other", url: "text" },
      ],
      url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race",
    },
    {
      extension: [ { valueString: "Unknown", url: "text" } ],
      url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity",
    },
    {
      valueCode: "248152002",
      url: "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex",
    },
    {
      valueCodeableConcept: {
        coding: [
          {
            system: "http://loinc.org",
            code: "LA29519-8",
            display: "she/her/her/hers/herself",
          },
        ],
      },
      url: "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text",
    },
  ],
  identifier: [
    {
      use: "usual",
      type: { text: "CEID" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.3.688884.100",
      value: "FHR6VKV43W653Q4",
    },
    {
      use: "usual",
      type: { text: "EPIC" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.0",
      value: "E2651",
    },
    {
      use: "usual",
      type: { text: "EXTERNAL" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.2.698084",
      value: "Z4529",
    },
    {
      use: "usual",
      type: { text: "FHIR" },
      system:
        "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
      value: "T1wI5bk8n1YVgvWk9D05BmRV0Pi3ECImNSK8DKyKltsMB",
    },
    {
      use: "usual",
      type: { text: "FHIR STU3" },
      system: "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
      value: "eOPSKZbz6YIgoilQprzPy0Q3",
    },
    {
      use: "usual",
      type: { text: "INTERNAL" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.2.698084",
      value: " Z4529",
    },
    {
      use: "usual",
      type: { text: "EPI" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.5.737384.14",
      value: "202417",
    },
    {
      use: "usual",
      type: { text: "MYCHARTLOGIN" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.3.878082.110",
      value: "CADENCEANNA",
    },
    {
      use: "usual",
      type: { text: "WPRINTERNAL" },
      system: "urn:oid:1.2.840.114350.1.13.0.1.7.2.878082",
      value: "84",
    },
    {
      use: "usual",
      system: "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
      value: "123455589",
    },
  ],
  active: true,
  name: [
    {
      use: "official",
      text: "Anna Cadence",
      family: "Cadence",
      given: [ "Anna" ],
    },
    { use: "usual", text: "Anna Cadence", family: "Cadence", given: [ "Anna" ] },
  ],
  telecom: [
    { system: "phone", value: "608-271-9000", use: "home" },
    { system: "email", value: "sleeplessinseattle@ymail.com", rank: 1 },
  ],
  gender: "female",
  birthDate: "1983-09-09",
  deceasedBoolean: false,
  address: [
    {
      use: "home",
      line: [ "8799 1st Street" ],
      city: "VERONA",
      district: "DANE",
      state: "WI",
      postalCode: "53593",
      country: "US",
    },
    {
      use: "old",
      line: [ "8799 1st Street" ],
      city: "VERONA",
      district: "DANE",
      state: "WI",
      postalCode: "53593",
      country: "US",
    },
  ],
  maritalStatus: { text: "Single" },
  contact: [
    {
      name: { use: "usual", text: "Smith, John" },
      telecom: [ { system: "phone", value: "608-271-9000", use: "home" } ],
      address: {
        use: "home",
        line: [ "8799 1st Street" ],
        city: "VERONA",
        district: "DANE",
        state: "WI",
        postalCode: "53593",
        country: "US",
      },
    },
    {
      relationship: [
        {
          coding: [
            {
              system: "http://terminology.hl7.org/CodeSystem/v2-0131",
              code: "E",
              display: "Employer",
            },
          ],
        },
      ],
      telecom: [ { system: "phone", value: "608-271-9000", use: "work" } ],
      address: {
        use: "work",
        line: [ "1979 MILKY WAY" ],
        city: "VERONA",
        district: "DANE",
        state: "WI",
        postalCode: "53593",
        country: "US",
      },
      organization: { display: "Ehs Generic Employer" },
    },
  ],
  communication: [
    {
      language: {
        coding: [ { system: "urn:ietf:bcp:47", code: "en", display: "English" } ],
        text: "English",
      },
      preferred: true,
    },
  ],
  generalPractitioner: [
    {
      reference: "Practitioner/eM5CWtq15N0WJeuCet5bJlQ3",
      type: "Practitioner",
      display: "Physician Family Medicine, MD",
    },
  ],
  managingOrganization: {
    reference: "Organization/enRyWnSP963FYDpoks4NHOA3",
    display: "Epic Hospital System",
  },
};

const mock_patient_bundle = {
  "patient": {
      "resourceType": "Patient",
      "id": "eTBYY2m2lofBOygbq9ebQjg3",
      "meta": {
          "versionId": "1",
          "lastUpdated": "2025-05-20T18:16:04.926+00:00",
          "source": "#Eqx1XeZT3CpWyRGJ"
      },
      "text": {
          "status": "generated",
          "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><div class=\"hapiHeaderText\">Ram_Update <b>KUMAR </b></div><table class=\"hapiPropertyTable\"><tbody><tr><td>Identifier</td><td>SJT2S3Q1XVZ9NXP</td></tr><tr><td>Address</td><td><span>abc street </span><br/><span>Oshawa </span><span>ON </span><span>CA </span></td></tr><tr><td>Date of birth</td><td><span>11 October 1967</span></td></tr></tbody></table></div>"
      },
      "extension": [
          {
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex",
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                          "code": "male",
                          "display": "male"
                      }
                  ]
              }
          },
          {
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use",
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                          "code": "male",
                          "display": "male"
                      }
                  ]
              }
          },
          {
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race",
              "extension": [
                  {
                      "url": "ombCategory",
                      "valueCoding": {
                          "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                          "code": "UNK",
                          "display": "Unknown"
                      }
                  },
                  {
                      "url": "text",
                      "valueString": "Unknown"
                  }
              ]
          },
          {
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity",
              "extension": [
                  {
                      "url": "text",
                      "valueString": "Unknown"
                  }
              ]
          },
          {
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex",
              "valueCode": "248153007"
          },
          {
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text",
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "http://loinc.org",
                          "code": "LA29518-0",
                          "display": "he/him/his/his/himself"
                      }
                  ]
              }
          }
      ],
      "identifier": [
          {
              "use": "usual",
              "type": {
                  "text": "CEID"
              },
              "system": "urn:oid:1.2.840.114350.1.13.403.3.7.3.688884.100",
              "value": "SJT2S3Q1XVZ9NXP"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPIC"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.0",
              "value": "E17286"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EXTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
              "value": "Z18990"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
              "value": "Tl8fLgaHMq9pzzlLW2910c9FHa3PHNPtk.L.ai-wcq9oB"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR STU3"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
              "value": "eTBYY2m2lofBOygbq9ebQjg3"
          },
          {
              "use": "usual",
              "type": {
                  "text": "INTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
              "value": "    Z18990"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPI"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.14",
              "value": "J0002009634"
          },
          {
              "use": "usual",
              "type": {
                  "text": "TGLNRecipient"
              },
              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.1650000001",
              "value": "650913"
          }
      ],
      "active": true,
      "name": [
          {
              "use": "official",
              "text": "Ram_Update Kumar",
              "family": "Kumar",
              "given": [
                  "Ram_Update"
              ]
          },
          {
              "use": "usual",
              "text": "Ram_Update Kumar",
              "family": "Kumar",
              "given": [
                  "Ram_Update"
              ]
          },
          {
              "use": "old",
              "text": "KUMAR,RAM",
              "family": "Kumar",
              "given": [
                  "Ram"
              ]
          }
      ],
      "telecom": [
          {
              "system": "phone",
              "value": "416-989-8583",
              "use": "home",
              "rank": 2
          },
          {
              "system": "phone",
              "value": "226-989-8585",
              "use": "work",
              "rank": 3
          },
          {
              "system": "phone",
              "value": "905-522-1155",
              "use": "mobile"
          },
          {
              "system": "other",
              "value": "519-787-8964",
              "rank": 1
          },
          {
              "system": "fax",
              "value": "519-502-1122",
              "use": "home"
          },
          {
              "system": "other",
              "value": "705-522-1122"
          },
          {
              "system": "email",
              "value": "5687@hotmail.com",
              "rank": 1
          }
      ],
      "gender": "male",
      "birthDate": "1967-10-11",
      "deceasedBoolean": true,
      "address": [
          {
              "use": "home",
              "line": [
                  "abc street"
              ],
              "city": "Oshawa",
              "state": "ON",
              "postalCode": "L1J 0V4",
              "country": "CA",
              "period": {
                  "start": "2024-06-13"
              }
          },
          {
              "use": "old",
              "line": [
                  "abc street"
              ],
              "city": "City of Colorado",
              "postalCode": "C1C 2C8",
              "country": "CA"
          },
          {
              "use": "old",
              "line": [
                  "abc street"
              ],
              "city": "Oshawa",
              "state": "ON",
              "postalCode": "L1J 0V4",
              "country": "CA"
          }
      ],
      "managingOrganization": {
          "reference": "Organization/eoC57gcpft1DFUAEXm4.fXg3",
          "display": "St. Joseph's Healthcare Hamilton"
      }
  },
  "entries": [
      [
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Coverage/eWjFRu63344",
              "resource": {
                  "resourceType": "Coverage",
                  "id": "eWjFRu63344",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:48:39.468+00:00",
                      "source": "#XctM8wyo9Nqk17B7"
                  },
                  "contained": [
                      {
                          "resourceType": "Organization",
                          "id": "org1",
                          "type": [
                              {
                                  "coding": [
                                      {
                                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.678671.120",
                                          "code": "3",
                                          "display": "Insurance Plan"
                                      }
                                  ],
                                  "text": "Insurance Plan"
                              }
                          ],
                          "contact": [
                              {
                                  "purpose": {
                                      "coding": [
                                          {
                                              "system": "http://terminology.hl7.org/CodeSystem/contactentity-type",
                                              "code": "BILL",
                                              "display": "Billing"
                                          }
                                      ]
                                  },
                                  "address": {
                                      "use": "billing",
                                      "state": "PE",
                                      "country": "CA"
                                  }
                              }
                          ]
                      }
                  ],
                  "extension": [
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/billing-organization",
                          "valueReference": {
                              "reference": "#org1"
                          }
                      }
                  ],
                  "identifier": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.678671",
                          "value": "8613"
                      }
                  ],
                  "status": "active",
                  "subscriber": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Davidfour, Chantwo Kingthree"
                  },
                  "beneficiary": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Davidfour, Chantwo Kingthree"
                  },
                  "relationship": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.678671.305",
                              "code": "01",
                              "display": "Self"
                          },
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/subscriber-relationship",
                              "code": "self",
                              "display": "Self"
                          }
                      ],
                      "text": "Self"
                  },
                  "payor": [
                      {
                          "reference": "Organization/er-pZJXa05FxXHp6DEOzH5w3",
                          "identifier": {
                              "use": "official",
                              "system": "http://open.epic.com/FHIR/StructureDefinition/payer-id",
                              "value": "237"
                          },
                          "display": "OUT OF PROVINCE"
                      }
                  ],
                  "class": [
                      {
                          "extension": [
                              {
                                  "url": "http://open.epic.com/FHIR/StructureDefinition/extension/epic-id",
                                  "valueIdentifier": {
                                      "use": "secondary",
                                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698080",
                                      "value": "23704"
                                  }
                              }
                          ],
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/coverage-class",
                                      "code": "plan",
                                      "display": "Plan"
                                  }
                              ]
                          },
                          "value": "23704",
                          "name": "OTHER PROVINCE - PRINCE EDWARD ISLAND"
                      }
                  ],
                  "order": 1
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
        {
 
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fVa7HPlh3k0YA6oXG2sxD-A4",
          "resource": {
            "resourceType": "Observation",
            "id": "fVa7HPlh3k0YA6oXG2sxD-A4",
            "status": "unknown",
            "category": [
              {
                "coding": [
                  {
                    "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                    "code": "smartdata",
                    "display": "SmartData"
                  }
                ],
                "text": "SmartData"
              }
            ],
            "code": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#7926",
                  "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                }
              ],
              "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
            },
            "subject": {
              "reference": "Patient/eg4w2uavogNXkl9HAAw2Pzg3",
              "display": "SMHTwo, RecipientTwo EMRTwo"
            },
            "focus": [
              {
                "reference": "EpisodeOfCare/esuoTAkQrfuGmIj5rwXaW9w3"
              }
            ],
            "issued": "2025-08-06T03:07:18Z",
            "performer": [
              {
                "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                "display": "CHUNG, SARAH"
              }
            ],
            "component": [
              {
                "code": {
                  "text": "Line 1"
                },
                "valueBoolean": true
              }
            ]
          },
          "search": {
            "mode": "match"
          }
        },
        {
         
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBaDfWywYerbMp95JTS6C8g4",
          "resource": {
            "resourceType": "Observation",
            "id": "fBaDfWywYerbMp95JTS6C8g4",
            "status": "unknown",
            "category": [
              {
                "coding": [
                  {
                    "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                    "code": "smartdata",
                    "display": "SmartData"
                  }
                ],
                "text": "SmartData"
              }
            ],
            "code": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "TXP#263",
                  "display": "OATS INTEGRATION - OTHER ETHNICITY"
                }
              ],
              "text": "OATS INTEGRATION - OTHER ETHNICITY"
            },
            "subject": {
              "reference": "Patient/eg4w2uavogNXkl9HAAw2Pzg3",
              "display": "SMHTwo, RecipientTwo EMRTwo"
            },
            "focus": [
              {
                "reference": "Patient/eg4w2uavogNXkl9HAAw2Pzg3",
                "display": "SMHTwo, RecipientTwo EMRTwo"
              }
            ],
            "issued": "2025-08-21T17:33:27Z",
            "performer": [
              {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
              }
            ],
            "component": [
              {
                "code": {
                  "text": "Line 1"
                },
                "valueString": "testing"
              }
            ]
          },
          "search": {
            "mode": "match"
          }
        },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63334",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63334",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:41:46.653+00:00",
                      "source": "#McMVQ8KWpCXXEbf2"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#262",
                              "display": "OATS INTEGRATION - ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Indian Sub-Continent"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63335",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63335",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:45:49.602+00:00",
                      "source": "#iNSWo9pGwp9VeJxM"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#332",
                              "display": "OATS ABO BLOOD TYPE"
                          }
                      ],
                      "text": "OATS ABO BLOOD TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "B"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63336",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63336",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:46:35.019+00:00",
                      "source": "#HP28ZbUCMopbV5gH"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#333",
                              "display": "OATS ABO RH FACTOR"
                          }
                      ],
                      "text": "OATS ABO RH FACTOR"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Negative"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63337",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63337",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:47:13.826+00:00",
                      "source": "#tYSqnyxVGDg6MoLP"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#359",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63343",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63343",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:47:58.544+00:00",
                      "source": "#ymQ8VXbrEBnhqJeZ"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Patient passed away in motor vehicle accident."
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63338",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63338",
                  "meta": {
                      "versionId": "4",
                      "lastUpdated": "2025-05-14T18:09:28.345+00:00",
                      "source": "#333Dyw7UhdtIlMvi"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "ACCIDENT"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63339",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63339",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T17:55:41.677+00:00",
                      "source": "#NiGpSsqIxdRWwEtJ"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "ACCIDENT UNRELATED TO TREATMENT"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63340",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63340",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:21:13.971+00:00",
                      "source": "#Bv3vNOXFtwaz4Kcb"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other death type field"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63341",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63341",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:31:40.908+00:00",
                      "source": "#f8rOTsi4uhZH9XWC"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-02-03"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63342",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63342",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:40:02.076+00:00",
                      "source": "#k0hnj2EPSF6cwThf"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/Observation/eWjFRu63343",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eWjFRu63343",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-14T18:41:54.840+00:00",
                      "source": "#Cr7l8tzMsHo1LyfJ"
                  },
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "display": "Oatsintegrationreferral Phoenix"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                          "display": "Oatsintegrationreferral Phoenix"
                      }
                  ],
                  "issued": "2024-05-09T15:03:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Patient passed away in motor vehicle accident."
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
     "fullUrl": "",
    "resource": {
      "resourceType": "Observation",
      "id": "elDV8pUwep.uUDSQiGb7LIjX0QS2s9DOScMkYy9vZ5OIvYt1M08DH0MoWgBpfGndqXUY9U04ipAf2rENc2Po5Cw3",
      "status": "unknown",
      "category": [
        {
          "coding": [
            {
              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
              "code": "smartdata",
              "display": "SmartData"
            }
          ],
          "text": "SmartData"
        }
      ],
      "code": {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
            "code": "TXP#135",
            "display": "TXP - CURRENT CPRA"
          }
        ],
        "text": "TXP - CURRENT CPRA"
      },
      "subject": {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Oats, Recipient"
      },
      "focus": [
        {
          "reference": "EpisodeOfCare/eSD.IDoT7Y0NTRaGGZqXH3w3"
        }
      ],
      "issued": "2024-04-16T18:31:09Z",
      "performer": [
        {
          "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
          "display": "PHOENIX, COORDINATOR"
        }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "0"
        }
      ]
    },
    "search": {
      "mode": "match"
    }
  },
  {
"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eCLG8ZQ7wkG2.Jh7eVZiUT2GKQZMsQaPE7LT5W0-tdRDMwutDtMWvOxuqIzW4UYrF5pv1MQDz9MZJ7m4RcLx.7w3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#348",
        "display": "OATS DONOR CRITERIA HEP B CORE AB+"
      }
    ],
    "text": "OATS DONOR CRITERIA HEP B CORE AB+"
  },
  "subject": {
    "reference": "Patient/ez7bORHxLJcCMUFzc3ajq0g3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-06T21:14:44Z",
  "performer": [
    {
      "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
      "display": "GONZALES, ALVIN"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueBoolean": true
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
 "resourceType": "Observation",
 "id": "ebQGdW9z4ZDLSGWt98EWpnTBO1J9p1-.YOtU750bIxWDkzOR3w6wol032ZSBZ-SCb-DmdDTcW28JnRyZPG-wFcA3",
 "status": "unknown",
 "category": [
   {
     "coding": [
       {
         "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
         "code": "smartdata",
         "display": "SmartData"
       }
     ],
     "text": "SmartData"
   }
 ],
 "code": {
   "coding": [
     {
       "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
       "code": "TXP#377",
       "display": "OATS RECIPIENT STATUS"
     }
   ],
   "text": "OATS RECIPIENT STATUS"
 },
 "subject": {
   "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
   "display": "Death, Recipient"
 },
 "focus": [
   {
     "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
   }
 ],
 "issued": "2024-12-06T16:49:22Z",
 "performer": [
   {
     "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
     "display": "PHOENIX, COORDINATOR"
   }
 ],
 "component": [
   {
     "code": {
       "text": "Line 1"
     },
     "valueString": "Recipient death"
   }
 ]
},
},
{

"fullUrl": "",
"resource": {
 "resourceType": "Observation",
 "id": "e5V9-uWOdKU5GlzUfPVBKdvQD8W5pGfssjyga4B56IBxGNOQ5rweqexxYGpzZJwyI33Z6pr3L6K2lo2m7II2j.g3",
 "status": "unknown",
 "category": [
   {
     "coding": [
       {
         "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
         "code": "smartdata",
         "display": "SmartData"
       }
     ],
     "text": "SmartData"
   }
 ],
 "code": {
   "coding": [
     {
       "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
       "code": "TXP#309",
       "display": "OATS FOLLOWUP SOURCE INFORMATION"
     }
   ],
   "text": "OATS FOLLOWUP SOURCE INFORMATION"
 },
 "subject": {
   "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
   "display": "MayUpgradeTwoFour, ScriptEightySevenR"
 },
 "focus": [
   {
     "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
   }
 ],
 "issued": "2024-11-08T21:19:17Z",
 "performer": [
   {
     "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
     "display": "PHOENIX, COORDINATOR"
   }
 ],
 "component": [
   {
     "code": {
       "text": "Line 1"
     },
     "valueString": "Transplant Program"
   }
 ]
},
"search": {
 "mode": "match"
}
},
{
"fullUrl": "",
"resource": {
"resourceType": "Observation",
"id": "exi7B6CeCkkHs7d0XnM4CvSCKvwbOAdgeGhzzuHucxZxcv6zu3K.il5rCiW7t7jTctmc5UGYSoE8Al20ab2MORA3",
"status": "unknown",
"category": [
  {
    "coding": [
      {
        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
        "code": "smartdata",
        "display": "SmartData"
      }
    ],
    "text": "SmartData"
  }
],
"code": {
  "coding": [
    {
      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
      "code": "SK#8089",
      "display": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
    }
  ],
  "text": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
},
"subject": {
  "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
  "display": "MayUpgradeTwoFour, ScriptEightySevenR"
},
"focus": [
  {
    "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
  }
],
"issued": "2024-11-08T21:19:17Z",
"performer": [
  {
    "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
    "display": "PHOENIX, COORDINATOR"
  }
],
"component": [
  {
    "code": {
      "text": "Line 1"
    },
    "valueString": "This is the source of information other field."
  }
]
},
"search": {
"mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "e0ENcoXUz67.czWbGVq0cXT0IS4dekEq2DcW2mjANd3kppI9v8yx6V41P7axFpTvbN53SLYJGg8TU5UM5UMmmbQ3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#314",
        "display": "OATS FOLLOWUP CLINIC VISIT DATE"
      }
    ],
    "text": "OATS FOLLOWUP CLINIC VISIT DATE"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-08T21:19:17Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueDateTime": "2024-11-08"
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
 "resourceType": "Observation",
 "id": "eH8l4RHRdXjOvIfktWvusH5rhsHuYww6isZkpOw.oa-SX5ithn20igDTeIRcj7NbRK.jX68SX-LLBRM8a5wbNLA3",
 "status": "unknown",
 "category": [
   {
     "coding": [
       {
         "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
         "code": "smartdata",
         "display": "SmartData"
       }
     ],
     "text": "SmartData"
   }
 ],
 "code": {
   "coding": [
     {
       "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
       "code": "SK#8091",
       "display": "OATS FOLLOWUP COMMENTS"
     }
   ],
   "text": "OATS FOLLOWUP COMMENTS"
 },
 "subject": {
   "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
   "display": "Death, Recipient"
 },
 "focus": [
   {
     "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
   }
 ],
 "issued": "2024-12-06T16:49:22Z",
 "performer": [
   {
     "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
     "display": "PHOENIX, COORDINATOR"
   }
 ],
 "component": [
   {
     "code": {
       "text": "Line 1"
     },
     "valueString": "Follow up comments for recipient death"
   }
 ]
},
"search": {
 "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "e6bOIHnvwv89RlaTap-U0Kt1ltG4QDvSpfOg4z1CWknak5aOyINUZc7ytIAvNs6WB0baqoKP8.Qa6jBmj8YO.tg3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#329",
        "display": "OATS FOLLOWUP - CREATININE UNKNOWN"
      }
    ],
    "text": "OATS FOLLOWUP - CREATININE UNKNOWN"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-08T21:19:17Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueBoolean": true
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eMbCHo5tmM34A0-4OrVi5-A8gLaAE6Po61Lg.i9glHSGK0nejY2hgyNYfPUCMmXWCjC0Vi-gat9HAiAXk-24OxA3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#316",
        "display": "OATS RETURN TO DIALYSIS"
      }
    ],
    "text": "OATS RETURN TO DIALYSIS"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "MayUpgradeTwoFour, ScriptEightySevenR"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
    }
  ],
  "issued": "2024-11-08T21:19:17Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueBoolean": true
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

"fullUrl": "",
"resource": {
"resourceType": "Observation",
"id": "eG2BMebkdPQZVHScdueqmN5E6yaOCcaQmfURqxMwMc7dK87elYkBuRsUdGfYzTOxHnG8bVUfPp1u1VqClE79O3Q3",
"status": "unknown",
"category": [
  {
    "coding": [
      {
        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
        "code": "smartdata",
        "display": "SmartData"
      }
    ],
    "text": "SmartData"
  }
],
"code": {
  "coding": [
    {
      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
      "code": "TXP#317",
      "display": "OATS RETURN TO DIALYSIS DATE"
    }
  ],
  "text": "OATS RETURN TO DIALYSIS DATE"
},
"subject": {
  "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
  "display": "MayUpgradeTwoFour, ScriptEightySevenR"
},
"focus": [
  {
    "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
  }
],
"issued": "2024-11-08T21:19:17Z",
"performer": [
  {
    "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
    "display": "PHOENIX, COORDINATOR"
  }
],
"component": [
  {
    "code": {
      "text": "Line 1"
    },
    "valueDateTime": "2024-11-08"
  }
]
},
"search": {
"mode": "match"
}
},
{

"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eNieCs.vBcfC1YK7xvcM-U6nmJMQcVr5ecp5IyVLWwyNzMQSkIfxy29tdy0wh7e6WQNGJCc9.u2e3uXmW-BZZ3Q3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "SK#8158",
        "display": "OATS FAILURE DATE"
      }
    ],
    "text": "OATS FAILURE DATE"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "Failure, Graft"
  },
  "focus": [
    {
      "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
    }
  ],
  "issued": "2024-12-06T16:45:25Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueDateTime": "2024-12-06"
    }
  ]
},
"search": {
  "mode": "match"
}
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eyoMRUjclNBbwhXQ598UPLZ3LV6i5b-cxDxTsW6XCjynyrM5vrJTTrKfDCY34GKyLw2O8Rn4ywxXs-Tu5.vnRxw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#379",
          "display": "OATS FAILURE CAUSE"
        }
      ],
      "text": "OATS FAILURE CAUSE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Failure, Graft"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
      }
    ],
    "issued": "2024-12-06T16:45:25Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "OTHER"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e4Os5bxLCrJBuTAJhZvHElMtw0eqchzU7F5W4M9DFjhkUpOjNoG6P2mYULKub5Osyjsfz2GH9HKM2JZ.D-YOyrQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "SK#8161",
          "display": "OATS FAILURE CAUSE OTHER"
        }
      ],
      "text": "OATS FAILURE CAUSE OTHER"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Failure, Graft"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
      }
    ],
    "issued": "2024-12-06T16:45:25Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "other field for failure cause"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ektMsJVoHAKz-yVgTshgnMHZtQAbFYXSYKWSoRk9fAh3-zgRLvWeLzkfRuPXLgRJT3Ql9p6h7pkozVYrqRJsxfw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#319",
          "display": "OATS LOST TO FOLLOWUP REASON"
        }
      ],
      "text": "OATS LOST TO FOLLOWUP REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-08T21:19:17Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient refused ongoing follow-up care"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eVW-.gWTdJaUpgDzd9mD2GmlibjYEUK3E3aXGhBA-BDiMGnO0Ps9Wlf-ovphpwueCG-yu0savaSsrs5rj.K2CeA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#381",
          "display": "OATS DEATH DATE (EPISODE)"
        }
      ],
      "text": "OATS DEATH DATE (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-12-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eLWnVolSwv1z-90Pk-Dw-Bq.tYqNYsxSJinbotG.0.dA5kdc8fMC9ouTHVi4Zvu-1D3T2g5AfI0ny8.kJEBIVfA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#325",
          "display": "OATS DEATH DATE ESTIMATED (EPISODE)"
        }
      ],
      "text": "OATS DEATH DATE ESTIMATED (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eJsgNAx.8b56PBP3jMTkQ8y2UOeijfdzpHuKsyL0lLSu271W.K6t0-LrdcNnQPIxkMt6yhqyCM8oK1ctd.gRFiA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#383",
          "display": "OATS CAUSE OF DEATH CATEGORY (EPISODE)"
        }
      ],
      "text": "OATS CAUSE OF DEATH CATEGORY (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "INFECTION"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOOEifZPVH0rCHaX2aO7rz7PL-XD7mkSSfdKzwS5jdh1HRUY8vpmzLrsIyXb0gnBrOYrjNqPlXjpH04RHTpSh3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#384",
          "display": "OATS CAUSE OF DEATH TYPE (EPISODE)"
        }
      ],
      "text": "OATS CAUSE OF DEATH TYPE (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "SEPSIS"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOOEifZPVH0rCHaX2aO7rz7PL-XD7mkSSfdKzwS5jdh1HRUY8vpmzLrsIyXb0gnBrOYrjNqPlXjpH04RHTpSh3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#351",
          "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
        }
      ],
      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Seychelle Yohanna [SEYCHELLE.YOHANNA@ONEID.ON.CA]"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOOEifZPVH0rCHaX2aO7rz7PL-XD7mkSSfdKzwS5jdh1HRUY8vpmzLrsIyXb0gnBrOYrjNqPlXjpH04RHTpSh3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#386",
          "display": "OATS CAUSE OF DEATH TYPE (EPISODE)"
        }
      ],
      "text": "OATS CAUSE OF DEATH TYPE (EPISODE)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "SEPSIS"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eFiDAIk49KTHa3p45E0h5zgV1P30p.jLp97s8KuNpxYFsk91.Qom0O8a-56qv.J3Gmi66jJvuZbK-Cl1CE73J5A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#326",
          "display": "OATS GRAFT FUNCTION AT DEATH"
        }
      ],
      "text": "OATS GRAFT FUNCTION AT DEATH"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Death, Recipient"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/etJ4tHBnqDhnf3X3UfaYw9A3"
      }
    ],
    "issued": "2024-12-06T16:49:22Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "No"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e.-2N0XaROEk8DkDGB3..olEG5CkJtyCSw6VMeRLR-Ipfz6eYba.o0VSRcZ-Ff4rBTg6.4SeIOwGYl-yW1DbW3g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#296",
          "display": "OATS - STAGED KIDNEY"
        }
      ],
      "text": "OATS - STAGED KIDNEY"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eKxNEM342PwGAoOGbndKO88Ewx4Q3jV7EIM4z-sYYiilv.-0NEdpcHExeY4nC8lsEIP.fcR6WW1kUD5OO9Sd-CQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#192",
          "display": "TXP RISK PROFILE - MEDICAL RISK REASON"
        }
      ],
      "text": "TXP RISK PROFILE - MEDICAL RISK REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoLabs, OATS GroupOneTwoThree"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/ezDgWeaSRNV7wlsepclJ7ZA3"
      }
    ],
    "issued": "2024-11-01T19:07:06Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Kidney Specific Details general comments are entered here."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},

{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ejCHnJtKqKqHD0toR-JxapraSqUAiwdTD6XXNWCo8J5rSvak0za9yvMz2nbgM5EAFOSTttnGotsxknygVGdiTTw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#297",
          "display": "OATS - KPD PATIENT"
        }
      ],
      "text": "OATS - KPD PATIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e5Cibpo12EUcnMQm0-M2zhHzpLDTYAQcGGnwsMgt0PHlYggcGe-62A8ZgepFOMUmBhzWFm69i11OfWWCI5gitjA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#299",
          "display": "OATS - LIST EXCHANGE PATIENT"
        }
      ],
      "text": "OATS - LIST EXCHANGE PATIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e8PcFV46.9qaiA9C7FL5AnyDHboRIjvtRU8meUdjU9EqlgMSdOIIVbVJ8WGwjV.hNt3QH3GCIFcL4dFrPOtNe2A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#300",
          "display": "OATS - LIST EXCHANGE DATE"
        }
      ],
      "text": "OATS - LIST EXCHANGE DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eAkOqE43Nr9Q8Mx8VQ-8p3.Daov8yjZUbBDlVM2Xva4eePHVDvWq.JJkFzZSJrr9mHqbDdz7NDB6TtDUnkEI2YA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#301",
          "display": "OATS - PREVIOUS LIVING DONOR"
        }
      ],
      "text": "OATS - PREVIOUS LIVING DONOR"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3"
      }
    ],
    "issued": "2024-09-04T18:16:31Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eJjHVizenxuIfUDPODIHdOp.APmtIhOgyZBhiPxoIJN5boW0jO8TdQrY-yZiQ3T4jhpYWc0bKw6QTkQGEvy9caw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#303",
          "display": "OATS - PREVIOUS DONATION DATE"
        }
      ],
      "text": "OATS - PREVIOUS DONATION DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/exqtC8q0VjpjgnwtPxSBdtQ3"
      }
    ],
    "issued": "2024-09-04T18:16:31Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-09-04"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOxUlziSC9i6X9w.h5L8tvfVC4-piYAJljG2xzX9xrV8N0IItwO7LZZK1Dsn9aT7FztMFKzFbtqsL06o4GOUqZg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#184",
          "display": "TXP DIALYSIS - PRE-EMPTIVE"
        }
      ],
      "text": "TXP DIALYSIS - PRE-EMPTIVE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoLabs, OATS GroupOneTwoThree"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "NoLabs, OATS GroupOneTwoThree"
      }
    ],
    "issued": "2024-11-01T19:24:03Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ezQyHkgeitIjgCmRY7LkbjTamKWFjE.Cc.US-.Ad.767lPmKWnvRFS1.f3rllVv4J3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
        "display": "Creatinine"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Lab",
            "display": "Lab"
          }
        ],
        "text": "Lab"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "14682-9",
          "display": "Creatinine [Moles/volume] in Serum or Plasma"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "CRV"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1526296"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "1526296",
          "display": "Creatinine"
        }
      ],
      "text": "Creatinine"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239102"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-16T20:15:00Z",
    "issued": "2024-09-18T13:56:28Z",
    "valueQuantity": {
      "value": 50,
      "unit": "umol/L",
      "system": "http://unitsofmeasure.org",
      "code": "umol/L"
    },
    "specimen": {
      "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
      "display": "Specimen 24SJC-260Y0005"
    },
    "referenceRange": [
      {
        "low": {
          "value": 49,
          "unit": "umol/L",
          "system": "http://unitsofmeasure.org",
          "code": "umol/L"
        },
        "high": {
          "value": 90,
          "unit": "umol/L",
          "system": "http://unitsofmeasure.org",
          "code": "umol/L"
        },
        "text": "49 - 90 umol/L"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ezQyHkgeitIjgCmRY7LkbjaiNoUsRGo5irZGmu6zIkpbZmZmXHFhWTvJMg41lIIi-3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
        "display": "Creatinine"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Lab",
            "display": "Lab"
          }
        ],
        "text": "Lab"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "62238-1",
          "display": "Glomerular filtration rate/1.73 sq M.predicted [Volume Rate/Area] in Serum or Plasma by Creatinine-based formula (MDRD)"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "EGFRV"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1740200"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "1740200",
          "display": "Estimated Glomerular Filtration Rate (eGFR)"
        }
      ],
      "text": "Estimated Glomerular Filtration Rate (eGFR)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239102"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-16T20:15:00Z",
    "issued": "2024-09-18T13:56:28Z",
    "valueQuantity": {
      "value": 109,
      "unit": "ml/min/1.73m2"
    },
    "note": [
      {
        "text": "UNITS: mL/min/1.73m2\r\n\r\nInvalid for drug dosing, pregnancy, extremes of muscle mass, and pediatric patients.\r\neGFR is calculated using the CKD-EPI 2021 equation which does not use a race-based adjustment.\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
      "display": "Specimen 24SJC-260Y0005"
    },
    "referenceRange": [
      {
        "text": ">60"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "epkN.mAgi7tBGZQGFjHQ-LJB12oWAZzi9lYYN1h66SDU-3wjVtEkh0MlTVwO88tbAhSIDSX69CGI9ML1XEedSEQ3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eaU5ek1w-hf-d68JhamE3OrofVPT9iSW-wxieR5zrY7I3",
        "display": "HbA1c"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Lab",
            "display": "Lab"
          }
        ],
        "text": "Lab"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "4548-4",
          "display": "Hemoglobin A1c/Hemoglobin.total in Blood"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "HBA1CP"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1231986"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210100689",
          "display": "HBA1C (%)"
        }
      ],
      "text": "HBA1C (%)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239102"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-16T20:15:00Z",
    "issued": "2024-09-18T14:08:07Z",
    "valueQuantity": {
      "value": 4.9,
      "unit": "%",
      "system": "http://unitsofmeasure.org",
      "code": "%"
    },
    "specimen": {
      "reference": "Specimen/eUwvxkmfjIiyIHL3VVCaaeox1ZITQQCRFLaqBO4-1pPc3",
      "display": "Specimen 24HGH-260R0001"
    },
    "referenceRange": [
      {
        "low": {
          "value": 4,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "high": {
          "value": 6,
          "unit": "%",
          "system": "http://unitsofmeasure.org",
          "code": "%"
        },
        "text": "4.0 - 6.0 %"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuaZsRS-Ht617BSSPmIuhu4C5iG9tnc7K--GRMAkuTSo5PmB60Dt35.yFEvZdtcVF6A3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "11",
          "display": "Height"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tteYX0mvKJRZuX-Q9jdhkdg0",
          "display": "Height"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "8302-2"
        },
        {
          "system": "http://loinc.org",
          "code": "8302-2",
          "display": "Body height"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Height"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2024-07-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 110,
      "unit": "cm",
      "system": "http://unitsofmeasure.org",
      "code": "cm"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuQwBd6I2aOYUcjfs9i.1ovWzY0wioOV0-bb5uSvN553UywPesCpo3dYNFL740wSkoQ3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "14",
          "display": "Weight"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tPU0I.Sg9hES99nfwfWDhhg0",
          "display": "Weight"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "29463-7"
        },
        {
          "system": "http://loinc.org",
          "code": "29463-7",
          "display": "Body weight"
        },
        {
          "system": "http://loinc.org",
          "code": "3141-9",
          "display": "Body weight Measured"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Weight"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2024-07-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 52,
      "unit": "kg",
      "system": "http://unitsofmeasure.org",
      "code": "kg"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuaZsRS-Ht617BSSPmIuhu4C5iG9tnc7K--GRMAkuTSo5PmB60Dt35.yFEvZdtcVF6A3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "11",
          "display": "Height"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tteYX0mvKJRZuX-Q9jdhkdg0",
          "display": "Height"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "8302-2"
        },
        {
          "system": "http://loinc.org",
          "code": "8302-2",
          "display": "Body height"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Height"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2025-05-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 110,
      "unit": "cm",
      "system": "http://unitsofmeasure.org",
      "code": "cm"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e92LEJ2G3Ac2.pYH3Uk0EuQwBd6I2aOYUcjfs9i.1ovWzY0wioOV0-bb5uSvN553UywPesCpo3dYNFL740wSkoQ3",
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "vital-signs",
            "display": "Vital Signs"
          }
        ],
        "text": "Vital Signs"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.707679",
          "code": "14",
          "display": "Weight"
        },
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
          "code": "tPU0I.Sg9hES99nfwfWDhhg0",
          "display": "Weight"
        },
        {
          "system": "urn:oid:1.2.246.537.6.96",
          "code": "29463-7"
        },
        {
          "system": "http://loinc.org",
          "code": "29463-7",
          "display": "Body weight"
        },
        {
          "system": "http://loinc.org",
          "code": "3141-9",
          "display": "Body weight Measured"
        },
        {
          "system": "http://loinc.org",
          "code": "8716-3",
          "display": "Vital signs"
        }
      ],
      "text": "Weight"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "encounter": {
      "reference": "Encounter/evFU8gsEXGlB8Xkh80XeuOQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237542"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2025-05-02T19:00:00Z",
    "issued": "2024-05-02T19:25:57Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "Coordinator Phoenix, RN"
      }
    ],
    "valueQuantity": {
      "value": 51,
      "unit": "kg",
      "system": "http://unitsofmeasure.org",
      "code": "kg"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eO4hmfldYRw9IZDzc3f6lIrM3fSTmwME1Bd.zNN.F0.LOxyDIftqMNbP453AgEjlJmvgsyR2P04-R-meTOlmsUg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#177",
          "display": "TXP DIALYSIS - DIALYSIS TYPE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:42:16Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Other/Unknown"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "efqiEDA563rIrvWJI7aQorCOL3fWbHJbsFK4Gblpp2Pw0QAVVZh0iN8.lwM6YdcTXqF5E3TUbP7-KH7EtIbmXjA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#178",
          "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:42:16Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Other"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
"fullUrl": "",
"resource": {
  "resourceType": "Observation",
  "id": "eh2MSMvpcDBtB1A09.VwEJ5EAEKesi229s.QfY9N8oN80YbojhpxN3e5.TiBhfQBcjGxWpmySUsxjekJ-5WR06g3",
  "status": "unknown",
  "category": [
    {
      "coding": [
        {
          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
          "code": "smartdata",
          "display": "SmartData"
        }
      ],
      "text": "SmartData"
    }
  ],
  "code": {
    "coding": [
      {
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
        "code": "TXP#179",
        "display": "TXP DIALYSIS - DIALYSIS LOCATION"
      }
    ],
    "text": "TXP DIALYSIS - DIALYSIS LOCATION"
  },
  "subject": {
    "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
    "display": "Kumar, Ram_Update"
  },
  "focus": [
    {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    }
  ],
  "issued": "2024-06-14T12:42:16Z",
  "performer": [
    {
      "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
      "display": "PHOENIX, COORDINATOR"
    }
  ],
  "component": [
    {
      "code": {
        "text": "Line 1"
      },
      "valueString": "Other"
    }
  ]
},
"search": {
  "mode": "match"
}
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ekm1ui3nRYm.rTvLyFSlmtrnxf3XnTnF0H1geKA4WVRsak3HsK-Y4MeNkXHoVrnt.vfSnNU7aWhfqlSM2EMhvjg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#180",
          "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
        }
      ],
      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:42:16Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Anything"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWI7FHG3cmasHW6vTNExcuDktd8jm1LQAys2Sfvy.iMw.KGgV5WcvvSZnmZEShreFUGj.EHQ255.4GtKbDKkYHw3",
  "resource": {
    "resourceType": "Observation",
    "id": "eWI7FHG3cmasHW6vTNExcuDktd8jm1LQAys2Sfvy.iMw.KGgV5WcvvSZnmZEShreFUGj.EHQ255.4GtKbDKkYHw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#207",
          "display": "TXP DIALYSIS - DIALYSIS CENTRE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:41:48Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Carveth Care Centre"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/e2GaclBwAC5LSBO0rIgqjIusK-OOp9bt34ovsftU3fyIonZwQNk92GBMhj9QjA6ld37tK0DRD-8FfuIlbHSBuKA3",
  "resource": {
    "resourceType": "Observation",
    "id": "e2GaclBwAC5LSBO0rIgqjIusK-OOp9bt34ovsftU3fyIonZwQNk92GBMhj9QjA6ld37tK0DRD-8FfuIlbHSBuKA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#330",
          "display": "TXP DIALYSIS - DIALYSIS START DATE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS START DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:41:48Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2023-05-05"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eAxF9aR7.7CpyftAgV566hpXf7yxSBtezDSi28eUr98yeLc4nMXQCxS7uL5ZTwcV7-Hx1vOkbGM2Plcg-a2QhGw3",
  "resource": {
    "resourceType": "Observation",
    "id": "eAxF9aR7.7CpyftAgV566hpXf7yxSBtezDSi28eUr98yeLc4nMXQCxS7uL5ZTwcV7-Hx1vOkbGM2Plcg-a2QhGw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#331",
          "display": "TXP DIALYSIS - DIALYSIS END DATE"
        }
      ],
      "text": "TXP DIALYSIS - DIALYSIS END DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
        "display": "Kumar, Ram_Update"
      }
    ],
    "issued": "2024-06-14T12:40:26Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-06-01"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ePXk3HH14ej51QhJXDsxPanX531PflmPWjE0Rynm3v8u01GDTo6pQSm2PXFnR6Dh3KlAeDTsiV-3fBmbCD0OORA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#335",
          "display": "OATS REFERRAL DECISION DATE"
        }
      ],
      "text": "OATS REFERRAL DECISION DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-29"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eAYrDuiWL1SE3hK70aR0mjfHC6Sgp4PE.3dQBJmzcSRl34yGNv.ejk6bDPmJxuaCtrEBg5P7C2e5GlbFmIzNivw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#337",
          "display": "REFERRAL PRIMARY DIAGNOSIS"
        }
      ],
      "text": "REFERRAL PRIMARY DIAGNOSIS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "AMYLOID"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e05qLf9drtWf2J3ltR.oQ3nWQ65U2RlQM.X.NOPU5AF-Pe96zY672n6CcAQ6izZiKzQECGP4pZfkev8a1t91cww3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#338",
          "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
        }
      ],
      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-29"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eDLLQzbUkAfBD9MDcaSPV4i6RTowwJ349pfT3BOYJM-NWfOJ8xbobLh4poIJ9TjnyVXKLZOnriaIiRfnW-THu9g3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#276",
          "display": "OATS - REFERRING ORGANIZATION NAME"
        }
      ],
      "text": "OATS - REFERRING ORGANIZATION NAME"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "OrgSeven"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eDjuIlsL6fRWeEpQH6Qms4nYfUPazMDYP-k9Tf-QeGJGOqZ9qnGR7U.doA3Y6uSTvvDeV5DZ9kJL14lrkg518KA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#277",
          "display": "OATS REFERRING ORGANIZATION TYPE"
        }
      ],
      "text": "OATS REFERRING ORGANIZATION TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Dialysis Centre"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eClGKjjJ5cxXT--tfB4edcOPR5qeHjyighQDdcvIUkpMAxVFCjkyA9ucwBYVkG4xGbFrHP2vrJjXSD0VSn-F8Gg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#278",
          "display": "OATS - REFERRING ORGANIZATION TYPE OTHER"
        }
      ],
      "text": "OATS - REFERRING ORGANIZATION TYPE OTHER"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is other organization type text field."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "etfjRnM-ARg7Duntwi-EeFcYINvYHpNl4mmpLq3L6.CAnA84YZWhJjK31RsPegB8llRd7DXbbL-AExfXe5Npz8Q3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#340",
          "display": "OATS REFERRING PROVIDER TYPE"
        }
      ],
      "text": "OATS REFERRING PROVIDER TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "NEPHROLOGIST"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e0zkLwVTHny4KyvnIT.6WF0w8TBB1AbfawijqPUJg-nse5ibGK0KPw-G9qCbn-fLkcjgSKmGW.akCbUmJdrPNGQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#334",
          "display": "OATS REFERRAL DECISION"
        }
      ],
      "text": "OATS REFERRAL DECISION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:14:59Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Referral Accepted"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e.tbAOZJmbbXw8RBT-6BQms59ZtYhiRYfDTwVH95dybl3gQUyeMXTs5zTRIknx9QCHAbsjmEkEAO48YEoTCRviw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#323",
          "display": "OATS - REFERRAL DETAILS - COMMENTS"
        }
      ],
      "text": "OATS - REFERRAL DETAILS - COMMENTS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:05:22Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is for referral decision comment."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eMH6uq0kBfkKupgSLVnpZe8yhs0F95.ikdDi14sQZoX5YWtJMnPjQ3B1ErhJ.PHcWyiVBqNl-VdYZDxBV02zfqw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#279",
          "display": "OATS - CONSULTATION DATE"
        }
      ],
      "text": "OATS - CONSULTATION DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e5Q8Vq2FhBQyAVLWDFnh1urOtifF6e9Zlo5EdwOR9wdyCFxTTwAVWqhOXrc1kw3ID9GgtThBeInAH93fu-yqpng3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#273",
          "display": "OATS - CONSULTATION DECISION"
        }
      ],
      "text": "OATS - CONSULTATION DECISION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Consult Completed"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eqrUbOmMl50OK0xMChDVxVTIPMCYXo8oAKb0khQe4CakfYNVlbSSQAi8S5irmlFHuezf20bUJ-mEQ0GFaT1xN1A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#274",
          "display": "OATS - CONSULTATION CANCELLED REASONS"
        }
      ],
      "text": "OATS - CONSULTATION CANCELLED REASONS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Patient Death Related to Organ Failure"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e02ESnz9T23Q1GU-2RcKybQ.1f1Clz2eYe-6z98PIXEbjH3R6oJF3dylyQdj-Rop2bD8CcOZh6WWvMHM-ocBzcA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#275",
          "display": "OATS - CONSULTATION DEFERRED REASON"
        }
      ],
      "text": "OATS - CONSULTATION DEFERRED REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Abstinence from Substance"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
  "resource": {
    "resourceType": "Observation",
    "id": "eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#282",
          "display": "OATS - DELAY START DATE"
        }
      ],
      "text": "OATS - DELAY START DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-05"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eAveF-aMGBJcv7OH3nC3SgXg7VbM2er2OVDw.Q33Q-wiWjjHNfppYpzVs0327-IpjcZH0qNrVMXFF.IDJSD0tKg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#283",
          "display": "OATS - DELAY END DATE"
        }
      ],
      "text": "OATS - DELAY END DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-06"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ellTrL1p2WI8QjNMYjelLtRcwEnOSOe6OTUT8fhAD3b3l-ub7BxwFr23kVJLuDsXxWGBfLvAUqMIOXu3b0-LRiw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#284",
          "display": "OATS - CONSULTATION COMMENTS"
        }
      ],
      "text": "OATS - CONSULTATION COMMENTS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is for consultation comments."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eqDZDhRamxPgJrPSFP9uBcayqx.ozGsy-YpnNJZj8.MuimH4ALyxQB-QAmI7kCor3fpNEToYJua2xF3uhA2MM.Q3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#285",
          "display": "OATS - MEDICAL ASSESSMENT DATE"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT DATE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-11-29"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "edZmwB9HHQxh9.i3hSLY8tBXFYuyE6tOsTsTGQPQfsdKArbsuK3z23zgTdYF4z1j4DA6NEr9o1ge7HdvHSeH9Vw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#287",
          "display": "OATS - MEDICAL ASSESSMENT DECISION"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT DECISION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient Not Eligible for Transplant"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eEY6QUFLjk.6utt6AMxpFeHPwE8Bx4J1IwK9S86MwFKM5u.OBqzcgpMSlWBS2BXsuuQJifS53BWrPMVUr-OBgNg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#288",
          "display": "OATS - MEDICAL ASSESSMENT CANCELLED"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT CANCELLED"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient Death Related to Organ Failure"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ezOI4wA1544vR-YyamuQlmnpGwDvcz4MCrMNwby-sCnsDQkUu4odZTTqT3anAZLKH913VsMaE1HHqNokgis.fAQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#289",
          "display": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Recipient does not meet listing criteria"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e3zPGgVwXGU9ZJmm32I24--RP5WAZuhtlxig4bc1CmG.qrUoScgpcfp6d22OgQ.KEfxSpNN4bNRchRsQO6Hy0VQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#290",
          "display": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Down staging for HCC"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e58WVNM0jb629nEMoRQLKgz0zLIo-u6pNIPq6t5dqF5.tU8JjuTdwkXoCmZ089TPENJmYfO7lxv1bdRS7zi9kkg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#327",
          "display": "OATS - FURTHER TESTING REQUIRED OTHER"
        }
      ],
      "text": "OATS - FURTHER TESTING REQUIRED OTHER"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is an other field for medical assessment decision reason."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "edB41AO1moSG0eIEmOJPz0DFWaiAOOyOApcHvu5C7DPKgv.Y2jz2vgAdBWXwhGee0NNphXS2CvaWnTO83IOa8jA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#291",
          "display": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Comorbidities"
      },
      {
        "code": {
          "text": "Line 2"
        },
        "valueString": "Consent"
      },
      {
        "code": {
          "text": "Line 3"
        },
        "valueString": "Post-Transplant Care"
      },
      {
        "code": {
          "text": "Line 4"
        },
        "valueString": "Psychosocial Considerations"
      },
      {
        "code": {
          "text": "Line 5"
        },
        "valueString": "Malignancy"
      },
      {
        "code": {
          "text": "Line 6"
        },
        "valueString": "Pulmoary Disease"
      },
      {
        "code": {
          "text": "Line 7"
        },
        "valueString": "Cardiac Disease"
      },
      {
        "code": {
          "text": "Line 8"
        },
        "valueString": "Peripheral Vascular Disease"
      },
      {
        "code": {
          "text": "Line 9"
        },
        "valueString": "Gastrointestinal Disease"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e512AOvSC3zGPs1dz1bxr2D3aBjBi9iR2.x2OwWmIGEu-akVsVkB0rp9s2mhOqZUakc9mxb2O8EZfhTrNZdBzTA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#292",
          "display": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2024-11-29T20:21:50Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Age and functional capacity"
      },
      {
        "code": {
          "text": "Line 2"
        },
        "valueString": "Cause of Kidney Disease"
      },
      {
        "code": {
          "text": "Line 3"
        },
        "valueString": "Psychosocial Considerations"
      },
      {
        "code": {
          "text": "Line 4"
        },
        "valueString": "Obesity"
      },
      {
        "code": {
          "text": "Line 5"
        },
        "valueString": "Systemic Diseases"
      },
      {
        "code": {
          "text": "Line 6"
        },
        "valueString": "Infections"
      },
      {
        "code": {
          "text": "Line 7"
        },
        "valueString": "Pulmonary Disease"
      },
      {
        "code": {
          "text": "Line 8"
        },
        "valueString": "Cardiac Disease"
      },
      {
        "code": {
          "text": "Line 9"
        },
        "valueString": "Cerebral Vascular Disease"
      },
      {
        "code": {
          "text": "Line 10"
        },
        "valueString": "Peripheral Vascular Disease"
      },
      {
        "code": {
          "text": "Line 11"
        },
        "valueString": "Gastrointestinal Disease"
      },
      {
        "code": {
          "text": "Line 12"
        },
        "valueString": "Liver Disease"
      },
      {
        "code": {
          "text": "Line 13"
        },
        "valueString": "Genitourinary Disease"
      },
      {
        "code": {
          "text": "Line 14"
        },
        "valueString": "Hematologic Disorders"
      },
      {
        "code": {
          "text": "Line 15"
        },
        "valueString": "Hyperparathyroidism"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eYMv.VXCa1cortPkJbBnfFnWSHdFDk7ZurHmVM2onD8XtdafA2w2-XDnrJ65fVd-uv5w-mxNMy-FJGSBAPY8TaA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#293",
          "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
        }
      ],
      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:12:39Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is medical assessment comments."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eLdguideZV8-3c3oMdw420ZzrSKWm0000ppv9zyyedeJfjXIGjgoktCWqGitsSuAqfV9ikeoSvsw6VAz.CxBzLA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#395",
          "display": "OATS TRANSPLANT TYPE"
        }
      ],
      "text": "OATS TRANSPLANT TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2025-01-27T17:26:04Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "LEFT KIDNEY"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ePY2Ysj4f3oC6wdLvPGVlNDLuUo1BDP2c0Tm8thU-sIVeX8xa8YcROrt6PO8Tks9mN0AnzaeAGQHzUgCyztVytfoS29Uw1kdivKr-9mJmRz83cXuoirhRT4eVFZEbNaMY3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#16533",
          "display": "TRANSPLANT START TIME"
        }
      ],
      "text": "TRANSPLANT START TIME"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
        "display": "LEFT KIDNEY"
      }
    ],
    "issued": "2025-01-27T17:26:29Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2025-01-27T17:26:25Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eF.9zCb7Yor34baCiakOleVyDQ12t5Jljosk6woV9V7RHrKUcIbyiaZetOCi5CNNNVNFojazey03BDmXXugjHUw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#396",
          "display": "OATS REMOVED FROM COLD"
        }
      ],
      "text": "OATS REMOVED FROM COLD"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2025-01-27T17:26:04Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2025-01-27T17:26:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ey1IkMl.TcO0ESxthi2wcm-fqbg9NLCcBFywkYwIEn8.8e7.SJ6Q36V.veOoRFwJtOmPD5CWTKnm8KAfahJc5pg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#397",
          "display": "OATS CLAMP REMOVAL"
        }
      ],
      "text": "OATS CLAMP REMOVAL"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
      }
    ],
    "issued": "2025-01-27T17:26:08Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2025-01-27T17:26:07Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e653H0el5RdbIq5pMpfS38zVDMuOvCY9ftUoUQOVwEPZ.yp2DVNfQCiAj6SEd2zL6-iQu51Q1h-U6tmlMJp7N-KJWYuiN0eXczcCgVieVP6p.Kkm4m1s4GaFtf2pqjimA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#123",
          "display": "SURGICAL TXP - WIT 2"
        }
      ],
      "text": "SURGICAL TXP - WIT 2"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
        "display": "LEFT KIDNEY"
      }
    ],
    "issued": "2025-01-27T17:26:29Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "0.0166666666666667"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eIIjl6j8WzxHG7IxgAVf0-79ZQFYXZp4d6tc-piPs4DmjcIh5v.tHVb.cQ5sRo0bUQnlRI4K.XdpODAF7x09rBM8qOSOJNRMmfRdPtyFeBzWQhpurIfWfEdaVY79ZVfNX3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#121",
          "display": "SURGICAL TXP - CIT"
        }
      ],
      "text": "SURGICAL TXP - CIT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "BodyStructure/e5079wnZFwMKK1LMi.BaZ5Njmt163zL8pcEkSHIdnW7r638nYJjq.nM9lp3kUyiIe3",
        "display": "RIGHT KIDNEY_102924"
      }
    ],
    "issued": "2024-10-16T15:08:54Z",
    "performer": [
      {
        "reference": "Practitioner/e-yoIPAqwXr6xcRnkjh7bqA3",
        "display": "INTRA-OP, NURSE"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "512"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ea2AFR3odH01ZbvP-5B41JbA2zjr9GurRjkBbpah0ufOJU58IzqKdLTg4YRuXKD4xUkA7S4OJc7YvewADYGFxREEsTBf9VU.dZzyfOtQTcgoZ1x5GrpHX0RIZsf4z950o3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#126",
          "display": "RECIPIENT VESSELS USED"
        }
      ],
      "text": "RECIPIENT VESSELS USED"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Kumar, Ram_Update"
    },
    "focus": [
      {
        "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
        "display": "LEFT KIDNEY"
      }
    ],
    "issued": "2025-01-27T17:26:29Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eEJw6qX7IvWPqo2WFHhfOaT.wBAhZGy4ovFb9LIrIoiOZB.H11aJ2.c432qiUIyYXCnyV-OWsb9VcP3kt3RwCUQ3",
    "basedOn": [
      {
        "reference": "ServiceRequest/ezwx7BZ2e0kUyUmv48J-em2aOq-BdoYryoDP3ZZrIb3s3",
        "display": "Cytomegalovirus immunity, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "22244-8",
          "display": "Cytomegalovirus IgG Ab [Presence] in Serum or Plasma"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SCMVII"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1612379"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102689",
          "display": "CMV IgG Ab"
        }
      ],
      "text": "CMV IgG Ab"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:24:51Z",
    "valueString": "Reactive",
    "note": [
      {
        "text": "Considered IMMUNE to Cytomegalovirus.\r\n\r\nTesting performed on the Abbott architect.\r\n\r\nVirology comment 1\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/e-1A5mqMjdLukfmdJxpT1vU2EX1EPdPqMCucEVNQjnbY3",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  "link": [
    {
      "relation": "self",
      "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3"
    }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
  "resource": {
    "resourceType": "Observation",
    "id": "eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
    "basedOn": [
      {
        "reference": "ServiceRequest/ewg.SQoTDaIplJv-4B5y4ba.Xsc8d4wW83Z6LRk3nksI3",
        "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
          "code": "21594-7"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
          "code": "12822",
          "display": "Varicella-zoster virus antibody OLIS"
        }
      ],
      "text": "Varicella-zoster virus antibody OLIS"
    },
    "subject": {
      "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
      "display": "SITSix, SITSix SITMIDDLESIX"
    },
    "encounter": {
      "reference": "Encounter/eaIzbITSKPAVKHOe8sOT1Net2NHD3VpZmA-0HYKR27yQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
        "value": "10000112148"
      },
      "display": "Orders Only"
    },
    "effectiveDateTime": "2025-10-21T01:41:00Z",
    "issued": "2025-10-21T01:46:43Z",
    "valueString": "Nonreactive",
    "specimen": {
      "reference": "Specimen/eErTiRuXFLOYu-PFkedf-ViVIZM5sFzHLSyIq24ySAwU3",
      "display": "Specimen"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eKZbfGb8MqhGV7VxIPXU4v5EKBEcftuwRKzxkSrIyrEVMq0unAnAGmSRQAfSKSL3FT3AS.G7BfhYP6vwTOpDumA3",
    "basedOn": [
      {
        "reference": "ServiceRequest/evmY-v7iva.4Oy1G5BT27r2JxS07EwdPS7Dl6CqZRjHY3",
        "display": "Cytomegalovirus diagnosis, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "30325-5",
          "display": "Cytomegalovirus IgM Ab [Presence] in Serum or Plasma"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SCMVDI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1510340"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102688",
          "display": "CMV IgM Ab"
        }
      ],
      "text": "CMV IgM Ab"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:25:27Z",
    "valueString": "Non-reactive",
    "note": [
      {
        "text": "No evidence of acute CMV infection.\r\n\r\nTesting performed on the Abbott architect.\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/el13P0T0VLCe2WSDJydgY5CTOqjsUf1PJ50f7WL3BNl03",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{

  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e09RfQxyQJiNg4GOH1Bu7b4JFT93noWxPQdshnSzWTjbZAwB3r89CpLiDImaJRTnuncbWvSNls6jHuIhfIbp5Gg3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eh-1VqnmU37VMELURRk6b3fCw7qule94A1vqU.8nvJIo3",
        "display": "Hepatitis B surface antigen, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "5195-3",
          "display": "Hepatitis B virus surface Ag [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHBSAGI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1232903"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102718",
          "display": "HBsAg Screen"
        }
      ],
      "text": "HBsAg Screen"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eRBnCDoF82PAbVQpoCd7E0g3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237960"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-05-30T21:14:00Z",
    "issued": "2024-05-31T11:34:26Z",
    "valueString": "Non-reactive",
    "specimen": {
      "reference": "Specimen/eE6VnFy.r7JyHEFAJQa66QB4uBJ6y8rgBz3-80yYCloo3",
      "display": "Specimen 24SJC-151V0005"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eMIl6Y9ZHcgFzzYop6CFaq-2eBnJsEfxxaV6w5bLZtKJtEBrGUaH8aCr1wyKO3tl72dHTTLdZcXth0vtRvZHQHQ3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eDn7.csXGU-grjQ9.JBXtOXcEHL3g6WRV99Kev8mTchw3",
        "display": "Hepatitis B core antibody, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "13952-7",
          "display": "Hepatitis B virus core Ab [Units/volume] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHBCI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1232905"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102709",
          "display": "Anti-HBcore"
        }
      ],
      "text": "Anti-HBcore"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eRBnCDoF82PAbVQpoCd7E0g3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237960"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-05-30T21:14:00Z",
    "issued": "2024-05-31T11:35:09Z",
    "valueString": "Non-reactive",
    "specimen": {
      "reference": "Specimen/eoT5z4gpZEhD8cxYLVsQcy-wgVavbAC.8pj5.R-6.11U3",
      "display": "Specimen 24SJC-151V0006"
    },
    "referenceRange": [
      {
        "text": "Non-reactive"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eQeRs10bZ96W7cu3HLu2GQWbkUg5OIC6CjUccH3AknUHEFDB2A.MzMD5hAyTVHbgw3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eEZgcnRIz-VKcfC5G70f4Qe-KEK26evKiMCFrTHlOmHg3",
        "display": "Hepatitis C antibody, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "16128-1",
          "display": "Hepatitis C virus Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHCI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1232907"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "595",
          "display": "ANTI-HEPATITIS C SCREEN"
        }
      ],
      "text": "ANTI-HEPATITIS C SCREEN"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:28:31Z",
    "valueString": "Non-reactive",
    "note": [
      {
        "text": "Testing performed on the Abbott architect.\r\n\r\nVirology comment 7\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/emiNzUzvNmdtbn6XyFAtMUF88Gysslh0C.9Jb8C.5IPw3",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ekic0pe2AZv6a.-16bDi3mrGy3ut5d3Nkd4xe-qUN4Goby76ZXywAKds3hUfwICgJbR2byGmrOq92bURQK-zg3g3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eJnxqU-hWzmi-jYdBw0WjhJjOK8KZH8Lq2QOFRymIThg3",
        "display": "HTLV 1/2 antibody, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "16982-1",
          "display": "HTLV I+II Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SHTLVI"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1810837"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102755",
          "display": "HTLV 1/2 Ab Scr"
        }
      ],
      "text": "HTLV 1/2 Ab Scr"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "OneOATS, DonorEpic"
    },
    "encounter": {
      "reference": "Encounter/eKWbRphjYOxUbO9hhwFkdQg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200239141"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-09-18T14:21:00Z",
    "issued": "2024-09-18T14:29:21Z",
    "valueString": "Non-Reactive",
    "note": [
      {
        "text": "No HTLV 1/2 antibodies detected. \r\n\r\nTesting performed on the Abbott Architect.\r\n\r\nVirology comment 10\r\n"
      }
    ],
    "specimen": {
      "reference": "Specimen/eVbbak1UJbvXI8oBfgYkqRhTFgooqWD78t58Ggqfgrr43",
      "display": "Specimen 24SJC-261V0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eOYnFBYvSw5.MG9QWZwAB3HaZBP2PPt8Cdmz8NkjHcRt50jhL8DurN0qxhR7Rrejz3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eRkvtEf8VsylG88.BDMeBmvm5dwXgYSQ5S-eGLJ8KyCI3",
        "display": "Varicella zoster immunity, serology"
      }
    ],
    "status": "amended",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "19162-7",
          "display": "Varicella zoster virus IgG Ab [Presence] in Serum by Immunoassay"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SVZVII"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1552053"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "2658",
          "display": "Varicella Zoster IgG Antibody"
        }
      ],
      "text": "Varicella Zoster IgG Antibody"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eRBnCDoF82PAbVQpoCd7E0g3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237960"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-06-01T21:14:00Z",
    "issued": "2024-06-20T16:07:53Z",
    "valueString": "reactive",
    "note": [
      {
        "text": "changed to reactive"
      }
    ],
    "specimen": {
      "reference": "Specimen/eg56uOuQa1GGDP5-YOMsBOYuMPGMF0x8qA4n2iq2Mjww3",
      "display": "Specimen 24HGH-151I0002"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "emWRDtImyXgL2eyzF-4M4h8JoQeaL69vPNaZhR3ri6sSicBehcKiAfYWMl938B86B3",
    "basedOn": [
      {
        "reference": "ServiceRequest/emeCu9grTwawHQDrP7dNmZJJ2nocgrU6uhCFE9NRZLvY3",
        "display": "Measles immunity, serology"
      }
    ],
    "status": "final",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "20479-2",
          "display": "Measles virus IgG Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "267"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "3276",
          "display": "Measles IgG Antibody"
        }
      ],
      "text": "Measles IgG Antibody"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "RecipientSix, RecordSix"
    },
    "encounter": {
      "reference": "Encounter/ew.0e7gKoOuaVHlTl4aPuRg3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200238368"
      },
      "display": "Appointment"
    },
    "effectiveDateTime": "2024-07-03T17:53:00Z",
    "issued": "2024-07-03T17:53:19Z",
    "valueString": "Reactive",
    "note": [
      {
        "text": "Tested"
      }
    ],
    "specimen": {
      "reference": "Specimen/eSgn.AByCuCYr8mQG33wc7D292gb0ARvQJK9xiO0GS6M3",
      "display": "Specimen 24HGH-184I0001"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  "link": [
    {
      "relation": "self",
      "url": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eAbIOI25PmBMkNb11SvT2hA3CwqMpUQmt5cVfhka3POrVnF2coovb2zv1raIbOBgs3"
    }
  ],
  "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eAbIOI25PmBMkNb11SvT2hA3CwqMpUQmt5cVfhka3POrVnF2coovb2zv1raIbOBgs3",
  "resource": {
    "resourceType": "Observation",
    "id": "eAbIOI25PmBMkNb11SvT2hA3CwqMpUQmt5cVfhka3POrVnF2coovb2zv1raIbOBgs3",
    "basedOn": [
      {
        "reference": "ServiceRequest/erRToBK4LTl5zYPtGXAYVK27Azn4Zl5jl-MnUvVpL1l43",
        "display": "Mumps immunity, serology"
      }
    ],
    "status": "amended",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "22415-4",
          "display": "Mumps virus IgG Ab [Presence] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1990000492"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "3312",
          "display": "Mumps IgG Interpretation"
        }
      ],
      "text": "Mumps IgG Interpretation"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "Sam, Vel Jay"
    },
    "encounter": {
      "reference": "Encounter/ecvT5vmYAeWq1MD9N6RrQCw3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237633"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2023-06-01T13:55:00Z",
    "issued": "2024-05-08T15:10:57Z",
    "valueString": "Negative",
    "note": [
      {
        "text": "Comment 4"
      }
    ],
    "specimen": {
      "reference": "Specimen/e5bNrB5IqYgdP7XPKFyTasckg-aNfn7wUIvwYpanurks3",
      "display": "Specimen"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eTha2eMoZXcDT8M8uJKYvXf5AR6FzCpi1q9VHpXoY.ikuQq45HEJRb..KX-PrTQxNrUkHZyoTQxNWxWxjeVdIwA3",
    "basedOn": [
      {
        "reference": "ServiceRequest/eQqWuf9jakHWhCHcQy4VKRVB70uZ95Ho1yAyxYYWRAcs3",
        "display": "Rubella immunity, serology"
      }
    ],
    "status": "amended",
    "category": [
      {
        "coding": [
          {
            "system": "http://terminology.hl7.org/CodeSystem/observation-category",
            "code": "laboratory",
            "display": "Laboratory"
          }
        ],
        "text": "Laboratory"
      },
      {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
            "code": "Microbiology",
            "display": "Microbiology"
          }
        ],
        "text": "Microbiology"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "http://loinc.org",
          "code": "25514-1",
          "display": "Rubella virus IgG Ab [Units/volume] in Serum"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
          "code": "SRUBII"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
          "code": "1511311"
        },
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
          "code": "210102789",
          "display": "Rubella IgG Ab"
        }
      ],
      "text": "Rubella IgG Ab"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "TestOne, VirologyOneWaitlist Kingthree"
    },
    "encounter": {
      "reference": "Encounter/eWW5AXxD9QOaFKmcqlwSyhQ3",
      "identifier": {
        "use": "usual",
        "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
        "value": "200237656"
      },
      "display": "Documentation"
    },
    "effectiveDateTime": "2023-06-01T13:55:00Z",
    "issued": "2024-06-10T17:24:36Z",
    "valueString": "Negative",
    "note": [
      {
        "text": "Changed to negative"
      }
    ],
    "specimen": {
      "reference": "Specimen/e5gCc8YbIM2SL5nQAeuOplZv2vDNnyVUqLtaj.mwybSs3",
      "display": "Specimen"
    }
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "edSxBjWH2.T4kig-0u05CskYQOhS8PkUB.yHwMK66bbUUykr9tdezi0-7csdfDhtdKR.fjvaSBiBX1F6tgzU09w3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#357",
          "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
        }
      ],
      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Deceased or Living Donor"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eylg1IQ2jDdEJt48BhHcGvgwJnrfEb0yaaXwt.R0zVzi-TIGb4e7ORUNKHtNrz7ACl2c4lJloKpr5qx0XVxBuBg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#345",
          "display": "OATS DONOR CRITERIA A2 OR A2B"
        }
      ],
      "text": "OATS DONOR CRITERIA A2 OR A2B"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ewA0Rk2N.GT0JVHmObAdandPc2wHZWSoAF0wnWmLPLgjdifLRo8T1QLCyKfo7PlbEPgKvQmrGuc6Zuh3qdfdkgA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#343",
          "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
        }
      ],
      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eqmhIaVWPEPWunkWCJOT7UveBDhuPQATLd6hopWLOceE3mqgWHYP3kVdDtZRk2TKCEnilW2khP4YSklgbk-7Czw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#347",
          "display": "OATS DONOR CRITERIA HCV AB+"
        }
      ],
      "text": "OATS DONOR CRITERIA HCV AB+"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "epF6.iPUyo.CUVqf759h8MspMuXfmsXRHb-VTpI-BgQaAKuZqt12MHStJzSPwz8l6Rpv0kcPbm.4Hc7c8sKl7iA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#346",
          "display": "OATS DONOR CRITERIA HCV NAT+"
        }
      ],
      "text": "OATS DONOR CRITERIA HCV NAT+"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eZBfCDwpUw0MSZjdm0lE0QPXXoMjnYMdoRSDt3xE6QNEmBeusTIm25L0AwzpAn.gz-qeZu366iCZPrXLek6I56Q3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#349",
          "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
        }
      ],
      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
      }
    ],
    "issued": "2024-11-06T21:14:44Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": false
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eRmqOqzV5pBMxmml0m09q.laQiPt10d0tGDGSBVf0zjqXZVgmD.PIGz3Ma4oMBLweznB3oJDhH4Bx.tOKJ1freQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#361",
          "display": "OATS LIVING DONOR TO DONATE TO"
        }
      ],
      "text": "OATS LIVING DONOR TO DONATE TO"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:36Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Pre-selected Recipient"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eHDAX8WFRPCqQPRr.KLBBkHRui2fqDDbxmNljH68w9hep76WHwSM7cEhri16tyxw4RXzdsKoSTIduy5fqfy1P.A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#362",
          "display": "OATS PRE-SELECTED RECIPIENT"
        }
      ],
      "text": "OATS PRE-SELECTED RECIPIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:36Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Intended Recipient"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
 
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eIOdFNY2QutYtTz3.Q8zpgecZY.fi989O5LK4X2EsVL6LDB8y71B6aEdO6l9ysiCHydQiL84SH.kswzYeDRe0QA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#363",
          "display": "OATS TO BE ALLOCATED TO A RECIPIENT"
        }
      ],
      "text": "OATS TO BE ALLOCATED TO A RECIPIENT"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "NoVirology, OATSTwo GroupSix"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/eREj2vT7oIOc5gdeJ9U45ag3"
      }
    ],
    "issued": "2024-11-01T19:35:35Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Non-Directed Donation (KPD - End of Chain)"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
    
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eXX2ZT5xwnUCbQ1OB1JKNmL-19gpe7tMudJeIqwmNWWbbUarG5FBwjfE5jCeAvVUsClGooczH8vne8a8JgMQpfA3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#358",
          "display": "OATS ABO A SUB TYPE"
        }
      ],
      "text": "OATS ABO A SUB TYPE"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
        "display": "MayUpgradeTwoFour, ScriptEightySevenD"
      }
    ],
    "issued": "2024-11-06T22:03:36Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "A1"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e-euaniUF7nr3PVd9Z46Gp4u0DFHLj20XFSDk3E1.-SjTSIpz4T.0Fj4Aloxyqr-ZUeMFe5RuQzNsL1z0aqJMWQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#034",
          "display": "EXCEPTIONAL DISTRIBUTION CONSIDERATION"
        }
      ],
      "text": "EXCEPTIONAL DISTRIBUTION CONSIDERATION"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:40Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueBoolean": true
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eMylcWMPJuKzCxY0P8iXLe9Dk2jIuIXcUfcNv.U0pSobS8iDz-SEvsPHXfJgrScc6WcEtJby0V-BHRuvbyloqqg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#373",
          "display": "OATS EXECPTIONAL DISTRIBUTION REASON(S)"
        }
      ],
      "text": "OATS EXECPTIONAL DISTRIBUTION REASON(S)"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-18T17:55:08Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Other"
      },
      {
        "code": {
          "text": "Line 2"
        },
        "valueString": "History of malignancy"
      },
      {
        "code": {
          "text": "Line 3"
        },
        "valueString": "Travel to/lived in history with risk for"
      },
      {
        "code": {
          "text": "Line 4"
        },
        "valueString": "IRD - History IVDU in preceding 5 years"
      },
      {
        "code": {
          "text": "Line 5"
        },
        "valueString": "IRD - Known sex history risk"
      },
      {
        "code": {
          "text": "Line 6"
        },
        "valueString": "IRD - Incarceration > 72 hours in last 12 months"
      },
      {
        "code": {
          "text": "Line 7"
        },
        "valueString": "IRD - Tattoo/piercing with non-sterile procedures < 12 months"
      },
      {
        "code": {
          "text": "Line 8"
        },
        "valueString": "IRD - Intranasal cocaine use < 6 months"
      },
      {
        "code": {
          "text": "Line 9"
        },
        "valueString": "Positive for Sexually Transmitted Infection"
      },
      {
        "code": {
          "text": "Line 10"
        },
        "valueString": "Hep B Core +"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
  
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e00RDWiVoXIGigiKeEFy3-mnBm43OHPImjANAeZZqBbWdej2oKZiz-AZ0-stOeue2VdHDjHsQ7mxLVKGi0QtZ6w3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#374",
          "display": "OATS EXCEPTIONAL DISTRIBUTION OTHER REASON"
        }
      ],
      "text": "OATS EXCEPTIONAL DISTRIBUTION OTHER REASON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-11-06T22:03:58Z",
    "performer": [
      {
        "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
        "display": "GONZALES, ALVIN"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "This is the exceptional distribution other reason."
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eYtH0sqQjmcgUoqPRK4EmnMjBMOXbOl-luyAas.7Z37RtE13fGpDqJU9kko0uOVRTSaK2xtfSoaqALIpQrqOAEw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#404",
          "display": "OATS DONOR RELATIONSHIP V2"
        }
      ],
      "text": "OATS DONOR RELATIONSHIP V2"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-23T19:08:10Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "PARENT"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
    
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eA60MOYd9.z8RLbBNJdW5GukGwZQ9lWxIF4uYtumT0Kg2sgRyBZ1pUm7YtJt-JuGOBXN8N3ghSagqmIRZqmfA5A3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#112",
          "display": "DONOR RECOVERY SURGEON"
        }
      ],
      "text": "DONOR RECOVERY SURGEON"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-10-10T13:37:30Z",
    "performer": [
      {
        "reference": "Practitioner/e-yoIPAqwXr6xcRnkjh7bqA3",
        "display": "INTRA-OP, NURSE"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Dr. Lambe"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eBQ2hevutR2qPSNe41N9ZN74nydvVZXobzDOm7h3IbnSzABLnJ7pYu8R9MWJ6pgB1qY0km6qFhJZ7NhJnKyu2Yg3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#398",
          "display": "OATS RECOVERY START"
        }
      ],
      "text": "OATS RECOVERY START"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-11T19:14:11Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T14:41:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "e7DDutO7oLy-Vf1leMByWP0kJMKTVugG2ZT888qmtU7QlAIvar-ZbrAVUfr4DMUIayGK4ozpiBccVCU6E0cUOMQ3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#399",
          "display": "OATS RECOVERY END"
        }
      ],
      "text": "OATS RECOVERY END"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-11T19:14:11Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T15:17:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
   
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "ew6G70ye3DdpZ2RR7VTM.zgoffofpUCobC7x6U2-hNhUji6AVDxPCUN8PXcroquoAgaqVpkOQs.9tHmS6VPvsmw3",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#400",
          "display": "OATS CROSS CLAMP"
        }
      ],
      "text": "OATS CROSS CLAMP"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenD"
    },
    "focus": [
      {
        "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
      }
    ],
    "issued": "2024-12-11T19:11:56Z",
    "performer": [
      {
        "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
        "display": "PHOENIX, COORDINATOR"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T13:32:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
{
    
  "fullUrl": "",
  "resource": {
    "resourceType": "Observation",
    "id": "eDXTTcWT5s3vfbESqUSt.WBSIxujM9vaHdk5SJi.63gRPVxtoWDf1jEh8vQeVJR49ESOTlLM731p5FbuNc2vveT8PICoEt79BPKJaRi03vQi7.Of4qj7wdfWeUSGyYms13",
    "status": "unknown",
    "category": [
      {
        "coding": [
          {
            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
            "code": "smartdata",
            "display": "SmartData"
          }
        ],
        "text": "SmartData"
      }
    ],
    "code": {
      "coding": [
        {
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
          "code": "TXP#114",
          "display": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
        }
      ],
      "text": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
    },
    "subject": {
      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
      "display": "MayUpgradeTwoFour, ScriptEightySevenR"
    },
    "focus": [
      {
        "reference": "BodyStructure/e5079wnZFwMKK1LMi.BaZ5Njmt163zL8pcEkSHIdnW7r638nYJjq.nM9lp3kUyiIe3",
        "display": "RIGHT KIDNEY_102924"
      }
    ],
    "issued": "2024-10-10T13:38:48Z",
    "performer": [
      {
        "reference": "Practitioner/e-yoIPAqwXr6xcRnkjh7bqA3",
        "display": "INTRA-OP, NURSE"
      }
    ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueDateTime": "2024-10-10T13:38:00Z"
      }
    ]
  },
  "search": {
    "mode": "match"
  }
},
      ],
      
      [
          {
              "fullUrl": "http://localhost:4004/hapi-fhir-jpaserver/fhir/EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3",
              "resource": {
                  "resourceType": "EpisodeOfCare",
                  "id": "eh55rvilfnQJ.b5vLlatESw3",
                  "meta": {
                      "versionId": "1",
                      "lastUpdated": "2025-05-20T18:20:14.045+00:00",
                      "source": "#zqE5oLQ57XthVqjV"
                  },
                  "extension": [
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name",
                          "valueString": "Kidney Transplant Waitlist - Qualified: 27/1/2025"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient",
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                                      "code": "2",
                                      "display": "Recipient"
                                  }
                              ],
                              "text": "Recipient"
                          }
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator",
                          "extension": [
                              {
                                  "url": "organ-class",
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                                              "code": "16",
                                              "display": "Kidney"
                                          }
                                      ],
                                      "text": "Kidney"
                                  }
                              },
                              {
                                  "url": "coordinator",
                                  "valueReference": {
                                      "reference": "Practitioner/e6zs7QnhOHCa9Td08H6Y8MF4G-UvFNh0wg85S4XIH0Vc3",
                                      "type": "Practitioner",
                                      "display": "Jennifer Donnelly"
                                  }
                              }
                          ]
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status",
                          "extension": [
                              {
                                  "url": "phase",
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                                              "code": "30",
                                              "display": "Waitlist"
                                          }
                                      ],
                                      "text": "Waitlist"
                                  }
                              },
                              {
                                  "url": "status",
                                  "valueString": "Active"
                              },
                              {
                                  "url": "effective",
                                  "valueDate": "2025-01-27"
                              }
                          ]
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date",
                          "valueDate": "2024-05-08"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation",
                          "valuePeriod": {
                              "start": "2024-11-29",
                              "end": "2025-01-27"
                          }
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date",
                          "valueDate": "2025-01-27"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date",
                          "valueDate": "2025-01-27"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center",
                          "valueString": "St. Joseph's Healthcare Hamilton (Hamilton, ON)"
                      },
                      {
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ",
                          "valueReference": {
                              "reference": "BodyStructure/etcItSK6S-VNvvdoYPSAegTOkTI3pkr-ywEFGTX8QdFASQ58bwrFipL5299Fb3bzT3",
                              "type": "BodyStructure",
                              "display": "Left Kidney"
                          }
                      }
                  ],
                  "status": "active",
                  "type": [
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.726668",
                                  "code": "49",
                                  "display": "Transplant"
                              },
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.4.726668.130",
                                  "code": "4",
                                  "display": "Transplant"
                              }
                          ],
                          "text": "Transplant"
                      }
                  ],
                  "patient": {
                      "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                      "type": "Patient",
                      "display": "Kumar, Ram_Update"
                  },
                  "period": {
                      "start": "2024-05-08"
                  },
                  "team": [
                      {
                          "reference": "CareTeam/em44bHHpWYvu4PckY1XP9uZsKtuMc6dvpJ4P8rW7LxWw3",
                          "type": "CareTeam"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ]
  ],
  "sectionsChecked": []
};
const mock_patient_RAM = {
  "resourceType": "Patient",
  "id": "eTBYY2m2lofBOygbq9ebQjg3",
  "meta": {
      "versionId": "1",
      "lastUpdated": "2025-04-28T19:09:43.670+00:00",
      "source": "#xDDqZabb6i5txIYl"
  },
  "text": {
      "status": "generated",
      "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><div class=\"hapiHeaderText\">Ram_Update <b>KUMAR </b></div><table class=\"hapiPropertyTable\"><tbody><tr><td>Identifier</td><td>SJT2S3Q1XVZ9NXP</td></tr><tr><td>Address</td><td><span>abc street </span><br/><span>Oshawa </span><span>ON </span><span>CA </span></td></tr><tr><td>Date of birth</td><td><span>11 October 1967</span></td></tr></tbody></table></div>"
  },
  "extension": [
      {
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex",
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                      "code": "male",
                      "display": "male"
                  }
              ]
          }
      },
      {
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use",
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.698084.130.657370.25811",
                      "code": "male",
                      "display": "male"
                  }
              ]
          }
      },
      {
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race",
          "extension": [
              {
                  "url": "ombCategory",
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  }
              },
              {
                  "url": "text",
                  "valueString": "Unknown"
              }
          ]
      },
      {
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity",
          "extension": [
              {
                  "url": "text",
                  "valueString": "Unknown"
              }
          ]
      },
      {
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex",
          "valueCode": "248153007"
      },
      {
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text",
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          }
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID" 
          },
          "system": "urn:oid:1.2.840.114350.1.13.403.3.7.3.688884.100",
          "value": "SJT2S3Q1XVZ9NXP"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.0",
          "value": "E17286"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
          "value": "Z18990"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "Tl8fLgaHMq9pzzlLW2910c9FHa3PHNPtk.L.ai-wcq9oB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eTBYY2m2lofBOygbq9ebQjg3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.698084",
          "value": "    Z18990"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.14",
          "value": "J0002009634"
      },
      {
          "use": "usual",
          "type": {
              "text": "TGLNRecipient"
          },
          "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.1650000001",
          "value": "650913"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "Ram_Update Kumar",
          "family": "Kumar",
          "given": [
              "Ram_Update",
              "Middle"
          ]
      },
      {
          "use": "usual",
          "text": "Ram_Update Kumar",
          "family": "Kumar",
          "given": [
              "Ram_Update" 
          ]
      },
      {
          "use": "old",
          "text": "KUMAR,RAM",
          "family": "Kumar",
          "given": [
              "Ram"
          ]
      }
  ],
  "telecom": [
      {
          "system": "phone",
          "value": "416-989-8583",
          "use": "home",
          "rank": 2
      },
      {
          "system": "phone",
          "value": "226-989-8585",
          "use": "work",
          "rank": 3
      },
      {
          "system": "phone",
          "value": "905-522-1155",
          "use": "mobile" 
      },
      {
          "system": "other",
          "value": "519-787-8964",
          "rank": 1
      },
      {
          "system": "fax",
          "value": "519-502-1122",
          "use": "home"
      },
      {
          "system": "other",
          "value": "705-522-1122"
      },
      {
          "system": "email",
          "value": "5687@hotmail.com",
          "rank": 1
      },
      {
        "system": "pager",
        "value": "ttte0",
        "rank": 1
    }
  ],
  "gender": "male",
  "birthDate": "1967-10-11",
  "deceasedBoolean": true,
  "address": [
      {
          "use": "home",
          "line": [
              "abc street"
          ],
          "city": "Oshawa",
          "state": "ON",
          "postalCode": "L1J 0V4",
          "country": "CA",
          "period": {
              "start": "2024-06-13"
          }
      },
      {
          "use": "old",
          "line": [
              "abc street"
          ],
          "city": "City of Colorado",
          "postalCode": "C1C 2C8",
          "country": "CA"
      },
      {
          "use": "old",
          "line": [
              "abc street"
          ],
          "city": "Oshawa",
          "state": "ON",
          "postalCode": "L1J 0V4",
          "country": "CA"
      }
  ],
  "managingOrganization": {
      "reference": "Organization/eoC57gcpft1DFUAEXm4.fXg3",
      "display": "St. Joseph's Healthcare Hamilton"
  }
};
const mock_patient_SMHOne = {
  "resourceType": "Patient",
  "id": "eZ4Fxy8ToBxyhpU9iFBCBKA3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ],
              "text": "Male"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
      },
      {
          "valueCode": "M",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "248153007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPOKDLK7VXPBVRP"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3517"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000811"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3523"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "TSEz66EdHpd1B2KJf9z7AfVZaMfqLagYbO2VwNdy1OngB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eZ4Fxy8ToBxyhpU9iFBCBKA3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3523"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientOne SMHOne",
          "family": "SMHOne",
          "given": [
              "RecipientOne"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientOne SMHOne",
          "family": "SMHOne",
          "given": [
              "RecipientOne"
          ]
      }
  ],
  "gender": "male",
  "birthDate": "1991-11-07",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "465 Yonge St\r\nToronto M4Y 1X4\r\nCanada",
          "line": [
              "465 Yonge St"
          ],
          "city": "Toronto",
          "state": "ON",
          "postalCode": "M4Y 1X4",
          "country": "CA",
          "period": {
              "start": "2025-08-05"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const mock_patient_SMHTwo = {
  "resourceType": "Patient",
  "id": "eg4w2uavogNXkl9HAAw2Pzg3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "female",
                      "display": "female"
                  }
              ],
              "text": "Female"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://hl7.org/fhir/gender-identity",
                      "code": "male",
                      "display": "male"
                  }
              ],
              "text": "Male"
          },
          "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
      },
      {
          "valueCode": "F",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-birthsex"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "184115007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://snomed.info/sct",
                      "code": "446151000124109",
                      "display": "Identifies as male gender (finding)"
                  }
              ]
          },
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-genderIdentity"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPOD37D37Q75KG8"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3518"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000812"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3524"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "T1gbhbIGozuug.5sTvq-ztiHvc4F2aPIfYc1U36LOy9cB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eg4w2uavogNXkl9HAAw2Pzg3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3524"
      },
      {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "3011479387"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientTwo EMRTwo SMHTwo",
          "family": "SMHTwo",
          "given": [
              "RecipientTwo",
              "EMRTwo"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientTwo EMRTwo SMHTwo",
          "family": "SMHTwo",
          "given": [
              "RecipientTwo",
              "EMRTwo"
          ]
      }
  ],
  "telecom": [
      {
          "system": "phone",
          "value": "+1 416-989-8583",
          "use": "home",
          "rank": 1
      },
      {
          "system": "phone",
          "value": "+1 226-989-8585",
          "use": "mobile",
          "rank": 2
      },
      {
          "system": "email",
          "value": "qwerty@gmail.com",
          "rank": 1
      }
  ],
  "gender": "female",
  "birthDate": "1990-11-11",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "123 abc street\r\nCity of Colorado M4Y 1X4\r\nCanada",
          "line": [
              "123 abc street"
          ],
          "city": "City of Colorado",
          "state": "MB",
          "postalCode": "M4Y 1X4",
          "country": "CA",
          "period": {
              "start": "2025-08-05"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const mock_patient_SMHThree = {
  "resourceType": "Patient",
  "id": "eFH6wiZlxSz18W5j4PJARuw3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "unknown",
                      "display": "unknown"
                  }
              ],
              "text": "Unknown"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://hl7.org/fhir/gender-identity",
                      "code": "other",
                      "display": "other"
                  }
              ],
              "text": "Not Listed"
          },
          "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "184115007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "https://open.epic.com/FHIR/Epic/pronoun-set",
                      "code": "EP-PS-DO-NOT-USE-PRONOUNS",
                      "display": "do not use pronouns"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPODMC76W6DRRTN"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3521"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000815"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3527"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "TSsiMsJ3s0nQoh-HBSzBQoaR.JNQc6bZazHvzt3cZaToB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eFH6wiZlxSz18W5j4PJARuw3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3527"
      },
      {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "574357317"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientThree EMRThree SMHThree",
          "family": "SMHThree",
          "given": [
              "RecipientThree",
              "EMRThree"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientThree EMRThree SMHThree",
          "family": "SMHThree",
          "given": [
              "RecipientThree",
              "EMRThree"
          ]
      }
  ],
  "gender": "unknown",
  "birthDate": "1960-12-12",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "280 Dundas Street\r\nRichmond Hill AL 23456\r\nUnited States of America",
          "line": [
              "280 Dundas Street"
          ],
          "city": "Richmond Hill",
          "state": "AL",
          "postalCode": "23456",
          "country": "US",
          "period": {
              "start": "2025-08-06"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const mock_patient_SMHFour = {
  "resourceType": "Patient",
  "id": "eyOhcUNJTB0DMWk0EgziXJA3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ],
              "text": "Male"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
        "valueCodeableConcept": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/gender-identity",
              "code": "other",
              "display": "other"
            }
          ],
          "text": "Trans Woman"
        },
        "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "248153007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPO8PZD582H7H2D"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3519"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000813"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3525"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "TjDLEYtFXc2J-HkCOO27T-rI08QPCJMdudbuYvMpyQGoB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eyOhcUNJTB0DMWk0EgziXJA3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3525"
      },
      {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "1234567890"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "RecipientFour SMHFour",
          "family": "SMHFour",
          "given": [
              "RecipientFour"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientFour SMHFour",
          "family": "SMHFour",
          "given": [
              "RecipientFour"
          ]
      }
  ],
  "gender": "male",
  "birthDate": "1960-11-12",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "280 Dundas Street\r\nRichmond Hill AL 23456\r\nUnited States of America",
          "line": [
              "280 Dundas Street"
          ],
          "city": "Richmond Hill",
          "state": "AL",
          "postalCode": "23456",
          "country": "US",
          "period": {
              "start": "2025-08-05"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const initialDataMock3 = {
  "patient": {
      "resourceType": "Patient",
      "id": "eZ4Fxy8ToBxyhpU9iFBCBKA3",
      "extension": [
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                          "code": "male",
                          "display": "male"
                      }
                  ],
                  "text": "Male"
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "http://hl7.org/fhir/gender-identity",
                          "code": "other",
                          "display": "other"
                      }
                  ],
                  "text": "Trans Woman"
              },
              "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
          },
          {
              "extension": [
                  {
                      "valueCoding": {
                          "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                          "code": "UNK",
                          "display": "Unknown"
                      },
                      "url": "ombCategory"
                  },
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
          },
          {
              "extension": [
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
          },
          {
              "valueCode": "184115007",
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "https://open.epic.com/FHIR/Epic/pronoun-set",
                          "code": "EP-PS-DO-NOT-USE-PRONOUNS",
                          "display": "do not use pronouns"
                      }
                  ]
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
          }
      ],
      "identifier": [
          {
              "use": "usual",
              "type": {
                  "text": "EPIC"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
              "value": "E3517"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPI"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
              "value": "900000811"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EXTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
              "value": "TSEz66EdHpd1B2KJf9z7AfVZaMfqLagYbO2VwNdy1OngB"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR STU3"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
              "value": "eZ4Fxy8ToBxyhpU9iFBCBKA3"
          },
          {
              "use": "usual",
              "type": {
                  "text": "INTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "     Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "TGLNRecipient"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.1650000006",
              "value": "67540"
          },
          {
              "use": "usual",
              "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
              "value": "1234567890"
          }
      ],
      "active": true,
      "name": [
          {
              "use": "official",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          },
          {
              "use": "usual",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          }
      ],
      "telecom": [
          {
              "system": "phone",
              "value": "+1 416-360-4000",
              "use": "home"
          },
          {
              "system": "phone",
              "value": "+1 416-340-3666",
              "use": "work"
          },
          {
              "system": "phone",
              "value": "+1 416-285-3666",
              "use": "mobile"
          },
          {
              "system": "email",
              "value": "123@oats.ca",
              "rank": 1
          }
      ],
      "gender": "male",
      "birthDate": "1991-11-07",
      "deceasedBoolean": false,
      "address": [
          {
              "use": "home",
              "text": "465 Yonge St\r\nToronto TORONTO M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "district": "TORONTO",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-10-02"
              }
          },
          {
              "use": "old",
              "text": "465 Yonge St\r\nToronto M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-08-05",
                  "end": "2025-10-02"
              }
          }
      ],
      "managingOrganization": {
          "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
          "display": "UNITY SERVICE AREA"
      }
  },
  "entries": [
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
              "resource": {
                  "resourceType": "Coverage",
                  "id": "emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
                  "contained": [
                      {
                          "resourceType": "Organization",
                          "id": "org1",
                          "type": [
                              {
                                  "coding": [
                                      {
                                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.678671.120",
                                          "code": "3",
                                          "display": "Insurance Plan"
                                      }
                                  ],
                                  "text": "Insurance Plan"
                              }
                          ],
                          "name": "OHIP",
                          "contact": [
                              {
                                  "purpose": {
                                      "coding": [
                                          {
                                              "system": "http://terminology.hl7.org/CodeSystem/contactentity-type",
                                              "code": "BILL",
                                              "display": "Billing"
                                          }
                                      ]
                                  },
                                  "address": {
                                      "use": "billing",
                                      "line": [
                                          "EXEC TOWER  OSHAWA CENTRE",
                                          "419 KING ST WEST"
                                      ],
                                      "city": "Toronto",
                                      "state": "ON",
                                      "postalCode": "L1H 8L4",
                                      "country": "CA"
                                  }
                              }
                          ]
                      }
                  ],
                  "extension": [
                      {
                          "valueReference": {
                              "reference": "#org1"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/billing-organization"
                      }
                  ],
                  "identifier": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.678671",
                          "value": "1465"
                      },
                      {
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                                      "code": "MB",
                                      "display": "Member Number"
                                  }
                              ]
                          },
                          "value": "1234567890"
                      }
                  ],
                  "status": "active",
                  "subscriber": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "subscriberId": "1234567890",
                  "beneficiary": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "relationship": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.678671.305",
                              "code": "01",
                              "display": "Self"
                          },
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/subscriber-relationship",
                              "code": "self",
                              "display": "Self"
                          }
                      ],
                      "text": "Self"
                  },
                  "period": {
                      "start": "2013-03-31"
                  },
                  "payor": [
                      {
                          "reference": "Organization/edfM-VF1iMIWPWTWdwpoNdQ3",
                          "identifier": {
                              "use": "official",
                              "system": "http://open.epic.com/FHIR/StructureDefinition/payer-id",
                              "value": "10000"
                          },
                          "display": "OHIP"
                      }
                  ],
                  "class": [
                      {
                          "extension": [
                              {
                                  "valueIdentifier": {
                                      "use": "secondary",
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698080",
                                      "value": "1000001"
                                  },
                                  "url": "http://open.epic.com/FHIR/StructureDefinition/extension/epic-id"
                              }
                          ],
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/coverage-class",
                                      "code": "plan",
                                      "display": "Plan"
                                  }
                              ]
                          },
                          "value": "1000001",
                          "name": "OHIP"
                      }
                  ],
                  "order": 1
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "elDMk6vH3DhXdUaTg5SUXJwXtvmXFV7qP19LVRNLmkyg835ouDn6aT5w.V7XvGW-HGubK7BlUGOrB.oM3S0Prcg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#336",
                    "display": "OATS REFERRAL DECISION DECLINE REASON"
                  }
                ],
                "text": "OATS REFERRAL DECISION DECLINE REASON"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2024-11-06T21:05:22Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Patient does not meet referral criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
   
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eBQ2hevutR2qPSNe41N9ZN74nydvVZXobzDOm7h3IbnSzABLnJ7pYu8R9MWJ6pgB1qY0km6qFhJZ7NhJnKyu2Yg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#398",
                    "display": "OATS RECOVERY START"
                  }
                ],
                "text": "OATS RECOVERY START"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
                "display": "MayUpgradeTwoFour, ScriptEightySevenD"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
                }
              ],
              "issued": "2024-12-11T19:14:11Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-10-10T14:41:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fT6SpekJyJHjnYKBKiiFBjg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16574",
                    "display": "OATS - REFERRAL CANCELLED REASON"
                  }
                ],
                "text": "OATS - REFERRAL CANCELLED REASON"
              },
              "subject": {
                "reference": "Patient/eoN4fz8OEXuw.slGH1SO2XQ3",
                "display": "SITFourthteen, SITFourthteen"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2025-10-24T17:13:06Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient relocated"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fgVk6SkJBJCzMJOw0GDud.g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16539",
                    "display": "OATS - LIVING DONOR RECOVERY COMMENTS"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMMENTS"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Testing recovery details "
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fOk3JvQnmUhsc9nMaoxeOcQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16540",
                    "display": "OATS - LIVING DONOR RECOVERY COMPLETED"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMPLETED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fKfPw--KbYC4NuauObvPlxw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16542",
                    "display": "OATS - ORGAN SHIPPED"
                  }
                ],
                "text": "OATS - ORGAN SHIPPED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "faLXUefq0EQcaKWk5FuUv-Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16569",
                    "display": "OATS - SHIPPED OUT OF PROVINCE"
                  }
                ],
                "text": "OATS - SHIPPED OUT OF PROVINCE"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fXgKmOYsXSD0Y9rfxEyPBEA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16571",
                    "display": "OATS - PERFUSION PUMP"
                  }
                ],
                "text": "OATS - PERFUSION PUMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fu4tYEvA48HaaIvI49TPWYQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16572",
                    "display": "OATS - PERFUSION DATE AND TIME"
                  }
                ],
                "text": "OATS - PERFUSION DATE AND TIME"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-06T14:19:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4",
            "resource": {
              "resourceType": "Observation",
              "id": "fw.eFFHpMBrYMfuPKEVma-A4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16573",
                    "display": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
                  }
                ],
                "text": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNEFwsvfbpROAIGPjn4X6LA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#400",
                    "display": "OATS CROSS CLAMP"
                  }
                ],
                "text": "OATS CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:53:18Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-09-22T17:51:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fP.al0N1Pg1QvD15OFVmyZA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#114",
                    "display": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
                  }
                ],
                "text": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-02T17:24:13Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-02T17:23:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fhb6S8X-Xaqo8XpI1XAsemg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#7928",
                    "display": "OATS - UNKNOWN GENDER"
                  }
                ],
                "text": "OATS - UNKNOWN GENDER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSix, SITSix SITMIDDLESIX"
              },
              "focus": [
                {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                }
              ],
              "issued": "2025-10-27T20:15:00Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Trans Woman"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eyoMRUjclNBbwhXQ598UPLZ3LV6i5b-cxDxTsW6XCjynyrM5vrJTTrKfDCY34GKyLw2O8Rn4ywxXs-Tu5.vnRxw3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#379",
                    "display": "OATS FAILURE CAUSE"
                  }
                ],
                "text": "OATS FAILURE CAUSE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Failure, Graft"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
                }
              ],
              "issued": "2024-12-06T16:45:25Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "OTHER"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4",
            "resource": {
              "resourceType": "Observation",
              "id": "f8RoGoKpeGNWz1L2xAPLnKg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16519",
                    "display": "OATS - LDCMVLAB"
                  }
                ],
                "text": "OATS - LDCMVLAB"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                  "display": "SITLDOne, SITLDOne"
                }
              ],
              "issued": "2025-10-16T15:43:20Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "PUBLIC HEALTH LABORATORY"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fimmZL1g-v932shUu4axPFw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#403",
                    "display": "OATS LINKED RECIPIENT TGLN"
                  }
                ],
                "text": "OATS LINKED RECIPIENT TGLN"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/en6mARfmq0F5hQzOiCBNPwA3"
                }
              ],
              "issued": "2025-10-27T20:00:48Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "68641"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSrGw3FZrFH2zVbrhV-eP2g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#309",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Other"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fcZRyeFT99RbVk1VzmsCzBg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#8089",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "testing f/u comment"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fGomxQtUjGJEya-3Xr-emCQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#314",
                    "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                  }
                ],
                "text": "OATS FOLLOWUP CLINIC VISIT DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSgdUp9YF7xzfCcoyIEgJOw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#317",
                    "display": "OATS RETURN TO DIALYSIS DATE"
                  }
                ],
                "text": "OATS RETURN TO DIALYSIS DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-27"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4",
            "resource": {
              "resourceType": "Observation",
              "id": "fkN6XBHLNAj8-F2U90OiZ7w4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#329",
                    "display": "OATS FOLLOWUP - CREATININE UNKNOWN"
                  }
                ],
                "text": "OATS FOLLOWUP - CREATININE UNKNOWN"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fHIdwecqHGXKE4fk0tSYKuw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16510",
                    "display": "OATS - LDHEPBCORE"
                  }
                ],
                "text": "OATS - LDHEPBCORE"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fzDkTD-1obxXqR5mA0Vyh8g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16558",
                    "display": "OATS - LDCMVINSTANT"
                  }
                ],
                "text": "OATS - LDCMVINSTANT"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22T17:24:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4",
            "resource": {
              "resourceType": "Observation",
              "id": "fulpq4zpkgTvQEmrPLl0Bug4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16511",
                    "display": "OATS - LDHEPBSAB"
                  }
                ],
                "text": "OATS - LDHEPBSAB"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "f.KdXM9H-xk5PA7qfFeCxIQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16512",
                    "display": "OATS - LDCMV"
                  }
                ],
                "text": "OATS - LDCMV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNCoY7ON5v3jN3wbAhoY3tQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16513",
                    "display": "OATS - LDHEPBSAG"
                  }
                ],
                "text": "OATS - LDHEPBSAG"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "ffaDats9QarIDNgygzKFQwQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16514",
                    "display": "OATS - LDHEPC"
                  }
                ],
                "text": "OATS - LDHEPC"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fppzCzpxRewghVKNVLrUQoA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16515",
                    "display": "OATS - LDHIV"
                  }
                ],
                "text": "OATS - LDHIV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fIzbl-Qdo8qfYeGu2ExlsJw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16516",
                    "display": "OATS - LDVDRL"
                  }
                ],
                "text": "OATS - LDVDRL"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "frQpp0jBy-GJKPQc3KBaP4Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16517",
                    "display": "OATS - LDEBV"
                  }
                ],
                "text": "OATS - LDEBV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fd4cy5DQo80TXwSgMuMNFHg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16518",
                    "display": "OATS - WNV"
                  }
                ],
                "text": "OATS - WNV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e512AOvSC3zGPs1dz1bxr2D3aBjBi9iR2.x2OwWmIGEu-akVsVkB0rp9s2mhOqZUakc9mxb2O8EZfhTrNZdBzTA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#292",
                    "display": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Age and functional capacity"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Cause of Kidney Disease"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Obesity"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Systemic Diseases"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Infections"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Pulmonary Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Cerebral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 10"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 11"
                  },
                  "valueString": "Gastrointestinal Disease"
                },
                {
                  "code": {
                    "text": "Line 12"
                  },
                  "valueString": "Liver Disease"
                },
                {
                  "code": {
                    "text": "Line 13"
                  },
                  "valueString": "Genitourinary Disease"
                },
                {
                  "code": {
                    "text": "Line 14"
                  },
                  "valueString": "Hematologic Disorders"
                },
                {
                  "code": {
                    "text": "Line 15"
                  },
                  "valueString": "Hyperparathyroidism"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "edB41AO1moSG0eIEmOJPz0DFWaiAOOyOApcHvu5C7DPKgv.Y2jz2vgAdBWXwhGee0NNphXS2CvaWnTO83IOa8jA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#291",
                    "display": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Comorbidities"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Consent"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Post-Transplant Care"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Malignancy"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Pulmoary Disease"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Gastrointestinal Disease"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e58WVNM0jb629nEMoRQLKgz0zLIo-u6pNIPq6t5dqF5.tU8JjuTdwkXoCmZ089TPENJmYfO7lxv1bdRS7zi9kkg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#327",
                    "display": "OATS - FURTHER TESTING REQUIRED OTHER"
                  }
                ],
                "text": "OATS - FURTHER TESTING REQUIRED OTHER"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "This is an other field for medical assessment decision reason."
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezOI4wA1544vR-YyamuQlmnpGwDvcz4MCrMNwby-sCnsDQkUu4odZTTqT3anAZLKH913VsMaE1HHqNokgis.fAQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#289",
                    "display": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient does not meet listing criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eAveF-aMGBJcv7OH3nC3SgXg7VbM2er2OVDw.Q33Q-wiWjjHNfppYpzVs0327-IpjcZH0qNrVMXFF.IDJSD0tKg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#283",
                    "display": "OATS - DELAY END DATE"
                  }
                ],
                "text": "OATS - DELAY END DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-06"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
            "resource": {
              "resourceType": "Observation",
              "id": "eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#282",
                    "display": "OATS - DELAY START DATE"
                  }
                ],
                "text": "OATS - DELAY START DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-05"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eEY6QUFLjk.6utt6AMxpFeHPwE8Bx4J1IwK9S86MwFKM5u.OBqzcgpMSlWBS2BXsuuQJifS53BWrPMVUr-OBgNg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#288",
                    "display": "OATS - MEDICAL ASSESSMENT CANCELLED"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT CANCELLED"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient Death Related to Organ Failure"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e3zPGgVwXGU9ZJmm32I24--RP5WAZuhtlxig4bc1CmG.qrUoScgpcfp6d22OgQ.KEfxSpNN4bNRchRsQO6Hy0VQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#290",
                    "display": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Down staging for HCC"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fwzFV6yBHYlxXobiHrZHxtw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#262",
                              "display": "OATS INTEGRATION - ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fI4wqWREJVMOVc3ybaeR5hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#263",
                              "display": "OATS INTEGRATION - OTHER ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - OTHER ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other eth"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient proceeding with living donor transplant"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIShZ3BsZUb8xu.XdBOCbwQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fUVgmmS0QIEoyT-53X7GxRQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7928",
                              "display": "OATS - UNKNOWN GENDER"
                          }
                      ],
                      "text": "OATS - UNKNOWN GENDER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other gender"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#8091",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgBfEfOG6EFBRskvJjZV2bw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#332",
                              "display": "OATS ABO BLOOD TYPE"
                          }
                      ],
                      "text": "OATS ABO BLOOD TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AB"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fbNY2qVwHTsoHow5DY5LKgw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#333",
                              "display": "OATS ABO RH FACTOR"
                          }
                      ],
                      "text": "OATS ABO RH FACTOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Positive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#334",
                              "display": "OATS REFERRAL DECISION"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Referral Accepted"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#359",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient to be Listed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#8091",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#334",
                              "display": "OATS REFERRAL DECISION"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Referral Accepted"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#359",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
              "resource": {
                  "resourceType": "EpisodeOfCare",
                  "id": "eBoTe.FFtYzhCAhiO-M2TbA3",
                  "extension": [
                      {
                          "valueString": "Kidney Transplant - 2/10/2025  (#1)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                      },
                      {
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                                      "code": "2",
                                      "display": "Recipient"
                                  }
                              ],
                              "text": "Recipient"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                                              "code": "16",
                                              "display": "Kidney"
                                          }
                                      ],
                                      "text": "Kidney"
                                  },
                                  "url": "organ-class"
                              },
                              {
                                  "valueReference": {
                                      "reference": "Practitioner/el16FdtlssUCWMkeZfO2CMg3",
                                      "type": "Practitioner",
                                      "display": "Coordinator Phoenix, RN"
                                  },
                                  "url": "coordinator"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                                              "code": "50",
                                              "display": "Transplanted"
                                          }
                                      ],
                                      "text": "Transplanted"
                                  },
                                  "url": "phase"
                              },
                              {
                                  "valueString": "Active Follow-up",
                                  "url": "status"
                              },
                              {
                                  "valueDate": "2025-10-02",
                                  "url": "effective"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                      },
                      {
                          "valueDate": "2025-08-05",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                      },
                      {
                          "valuePeriod": {
                              "start": "2025-09-24",
                              "end": "2025-10-02"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
                      },
                      {
                          "valueString": "St. Michael's Hospital (Toronto, ON)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                      }
                  ],
                  "status": "active",
                  "type": [
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.726668",
                                  "code": "49",
                                  "display": "Transplant"
                              },
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.726668.130",
                                  "code": "4",
                                  "display": "Transplant"
                              }
                          ],
                          "text": "Transplant"
                      }
                  ],
                  "patient": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "type": "Patient",
                      "display": "SMHOne, RecipientOne"
                  },
                  "period": {
                      "start": "2025-08-05"
                  },
                  "team": [
                      {
                          "reference": "CareTeam/e6YjTLfVn73.lWbazIyc1OfLJ1ja9HdjQ.4m.riSPdvw3",
                          "type": "CareTeam",
                          "display": "Care Team"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "11",
                              "display": "Height"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "tqIZ.9Xom.NjB5dsfS9O.Ow0",
                              "display": "Height"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "8302-2"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8302-2",
                              "display": "Body height"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Height"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 90,
                      "unit": "cm",
                      "system": "http://unitsofmeasure.org",
                      "code": "cm"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "14",
                              "display": "Weight"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "t5Cn9FBZGCKy2gCB5bnkZtA0",
                              "display": "Weight"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "29463-7"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "29463-7",
                              "display": "Body weight"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "3141-9",
                              "display": "Body weight Measured"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Weight"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 90,
                      "unit": "kg",
                      "system": "http://unitsofmeasure.org",
                      "code": "kg"
                  }
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eeQwI6dztGI3giM225fSFdxv40GCiATH0tSWVuRPNCNc3",
                          "display": "Hepatitis B Core Antibody"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "13952-7",
                              "display": "Hepatitis B virus core Ab [Presence] in Serum or Plasma by Immunoassay"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551494"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "13952-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis B virus core Ab:ACnc:Pt:Ser:Ord:EIA"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV18"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551494",
                              "display": "Hepatitis B Core Total (IgG+IgM) Antibody"
                          }
                      ],
                      "text": "Hepatitis B Core Total (IgG+IgM) Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:46:00Z",
                  "issued": "2025-08-20T18:49:06Z",
                  "valueString": "Reactive",
                  "interpretation": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation",
                                  "code": "A",
                                  "display": "Abnormal"
                              }
                          ],
                          "text": "Abnormal"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/ejRQHev1n95WqzM2rB3jFHg3",
                      "display": "Specimen 25S-232C0004"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezQyHkgeitIjgCmRY7LkbjTamKWFjE.Cc.US-.Ad.767lPmKWnvRFS1.f3rllVv4J3",
              "basedOn": [
                {
                  "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
                  "display": "Creatinine"
                }
              ],
              "status": "final",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                      "code": "laboratory",
                      "display": "Laboratory"
                    }
                  ],
                  "text": "Laboratory"
                },
                {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
                      "code": "Lab",
                      "display": "Lab"
                    }
                  ],
                  "text": "Lab"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
                    "code": "CRV"
                  },
                  {
                    "system": "http://loinc.org",
                    "code": "14682-9",
                    "display": "Creatinine [Moles/volume] in Serum or Plasma"
                  },
                  
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
                    "code": "1526296"
                  },
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
                    "code": "1526296",
                    "display": "Creatinine"
                  }
                ],
                "text": "Creatinine"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "TestOne, VirologyOneWaitlist Kingthree"
              },
              "encounter": {
                "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
                "identifier": {
                  "use": "usual",
                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
                  "value": "200239102"
                },
                "display": "Appointment"
              },
              "effectiveDateTime": "2024-09-16T20:15:00Z",
              "issued": "2024-09-18T13:56:28Z",
              "valueQuantity": {
                "value": 50,
                "unit": "umol/L",
                "system": "http://unitsofmeasure.org",
                "code": "umol/L"
              },
              "specimen": {
                "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
                "display": "Specimen 24SJC-260Y0005"
              },
              "referenceRange": [
                {
                  "low": {
                    "value": 49,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "high": {
                    "value": 90,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "text": "49 - 90 umol/L"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "PABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "MABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "NABSN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "890-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1631699"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Blood group antibody screen:PrThr:Pt:Ser/Plas:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1631699",
                              "display": "Antibody Screen"
                          }
                      ],
                      "text": "Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueQuantity": {
                      "value": 1234556
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "note": [
                      {
                          "text": "Previously Final Verified Results Added"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071384"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22244-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071384",
                              "display": "Cytomegalovirus IgG CLIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3"
                }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
              "resource": {
                "resourceType": "Observation",
                "id": "eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
                "basedOn": [
                  {
                    "reference": "ServiceRequest/ewg.SQoTDaIplJv-4B5y4ba.Xsc8d4wW83Z6LRk3nksI3",
                    "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                  }
                ],
                "status": "final",
                "category": [
                  {
                    "coding": [
                      {
                        "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                        "code": "laboratory",
                        "display": "Laboratory"
                      }
                    ],
                    "text": "Laboratory"
                  },
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                        "code": "Microbiology",
                        "display": "Microbiology"
                      }
                    ],
                    "text": "Microbiology"
                  }
                ],
                "code": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
                      "code": "21594-7"
                    },
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                      "code": "12822",
                      "display": "Varicella-zoster virus antibody OLIS"
                    }
                  ],
                  "text": "Varicella-zoster virus antibody OLIS"
                },
                "subject": {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                },
                "encounter": {
                  "reference": "Encounter/eaIzbITSKPAVKHOe8sOT1Net2NHD3VpZmA-0HYKR27yQ3",
                  "identifier": {
                    "use": "usual",
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                    "value": "10000112148"
                  },
                  "display": "Orders Only"
                },
                "effectiveDateTime": "2025-10-21T01:41:00Z",
                "issued": "2025-10-21T01:46:43Z",
                "valueString": "Nonreactive",
                "specimen": {
                  "reference": "Specimen/eErTiRuXFLOYu-PFkedf-ViVIZM5sFzHLSyIq24ySAwU3",
                  "display": "Specimen"
                }
              },
              "search": {
                "mode": "match"
              }
            },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071385"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30325-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071385",
                              "display": "Cytomegalovirus IgM EIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071386"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071386",
                              "display": "Epstein Barr Virus VCA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "7883-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "EPSTEIN BARR VIRUS NUCLEAR AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071387"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071387",
                              "display": "Epstein Barr Virus EBNA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus EBNA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071388"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071388",
                              "display": "Epstein Barr Virus VCA IgM MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071400"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16128-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS C VIRUS AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071400",
                              "display": "Hepatitis C Antibody"
                          }
                      ],
                      "text": "Hepatitis C Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071407"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12263-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV 1+2 Ab+Ag:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071407",
                              "display": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                          }
                      ],
                      "text": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071408"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16982-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HTLV 1+2 Ab:ACnc:Pt:Ser:Ord:IB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071408",
                              "display": "HTLV I/II Antibody Screen"
                          }
                      ],
                      "text": "HTLV I/II Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071411"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20479-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071411",
                              "display": "Measles IgG MFI"
                          }
                      ],
                      "text": "Measles IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071412"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21503-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071412",
                              "display": "Measles IgM MFI"
                          }
                      ],
                      "text": "Measles IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071424"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "25514-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071424",
                              "display": "Rubella IgG EIA"
                          }
                      ],
                      "text": "Rubella IgG EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071425"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "31616-6"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071425",
                              "display": "Rubella IgM EIA"
                          }
                      ],
                      "text": "Rubella IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071429"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22587-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:PrThr:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071429",
                              "display": "Syphilis Antibody screen"
                          }
                      ],
                      "text": "Syphilis Antibody screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071430"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "41122-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TREPONEMA PALLIDUM AB:ACNC:PT:XXX:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071430",
                              "display": "Syphilis RPR Quantitation"
                          }
                      ],
                      "text": "Syphilis RPR Quantitation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071431"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24312-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:Aggl"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071431",
                              "display": "Syphilis TP.PA"
                          }
                      ],
                      "text": "Syphilis TP.PA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071433"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22580-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071433",
                              "display": "Toxoplasmosis IgG CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071434"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "8040-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGM:ACNC:PT:SER:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071434",
                              "display": "Toxoplasmosis IgM CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgM CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071436"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21597-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071436",
                              "display": "Varicella-Zoster IgM"
                          }
                      ],
                      "text": "Varicella-Zoster IgM"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071444"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071444",
                              "display": "CMV Interpretation"
                          }
                      ],
                      "text": "CMV Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "No evidence of past exposure; indicates susceptibility.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071445"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071445",
                              "display": "CMV Note"
                          }
                      ],
                      "text": "CMV Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.\r\n",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071448"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071448",
                              "display": "Epstein Barr Virus Interpretation"
                          }
                      ],
                      "text": "Epstein Barr Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "No laboratory evidence of recent/past EBV infection.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071457"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071457",
                              "display": "Hepatitis C Interpretation"
                          }
                      ],
                      "text": "Hepatitis C Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "No evidence of HCV Antibody",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071461"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13032-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV final interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071461",
                              "display": "HIV Final Interpretation"
                          }
                      ],
                      "text": "HIV Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Non-reactive for HIV-1 p24 antigen and HIV-1/HIV-2 antibodies.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071462"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071462",
                              "display": "HIV Final Note"
                          }
                      ],
                      "text": "HIV Final Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "For high-risk exposures, repeat HIV testing at 3 weeks and, if negative, at 6 weeks after possible exposure, or on presentation of symptoms compatible with acute HIV infection.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071463"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13563-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071463",
                              "display": "HTLV I/II Final Interpretation"
                          }
                      ],
                      "text": "HTLV I/II Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "No HTLV I / II antibodies detected.",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071465"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071465",
                              "display": "Measles Interpretation"
                          }
                      ],
                      "text": "Measles Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "No serological evidence of recent or past Measles infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071466"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071466",
                              "display": "Measles Note"
                          }
                      ],
                      "text": "Measles Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071467"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10842-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION:IMP:Pt:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071467",
                              "display": "Mumps Interpretation"
                          }
                      ],
                      "text": "Mumps Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "No evidence of immunity (indicates susceptibility)",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071468"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071468",
                              "display": "Mumps Note"
                          }
                      ],
                      "text": "Mumps Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient. For assistance regarding the interpretation of specific IgG and IgM serology refer to Public Health Labstract Diagnostic Interpretation of Viral Specific IgM and IgG  Serology Lab-SD-044 at: http:www.publichealthontario.ca/Labstracts",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071473"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071473",
                              "display": "Rubella Interpretation"
                          }
                      ],
                      "text": "Rubella Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "No serological evidence of recent or past Rubella infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071474"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071474",
                              "display": "Rubella Note"
                          }
                      ],
                      "text": "Rubella Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071477"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071477",
                              "display": "Syphilis Serology Interpretation"
                          }
                      ],
                      "text": "Syphilis Serology Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No serological evidence of current or past infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071478"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071478",
                              "display": "Syphilis Serology Note"
                          }
                      ],
                      "text": "Syphilis Serology Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No confirmatory testing is performed on samples with non-reactive screening results. If not done already, repeat syphilis serology testing is recommended in 4 weeks for individuals suspected of syphilis infection or re-infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071479"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071479",
                              "display": "Toxoplasmosis Interpretation"
                          }
                      ],
                      "text": "Toxoplasmosis Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "No serological evidence of recent or past Toxoplasma gondii infection.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071480"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071480",
                              "display": "Toxoplasmosis Note"
                          }
                      ],
                      "text": "Toxoplasmosis Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Results should be interpreted in conjunction with clinical history, signs and symptoms.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071481"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071481",
                              "display": "Varicella-Zoster Interpretation"
                          }
                      ],
                      "text": "Varicella-Zoster Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "No serological evidence of recent or past Varicella-Zoster infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071482"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071482",
                              "display": "Varicella-Zoster Note"
                          }
                      ],
                      "text": "Varicella-Zoster Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22415-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071488"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MUMPS VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071488",
                              "display": "Mumps IgG MFI"
                          }
                      ],
                      "text": "Mumps IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123120003"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "19162-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123120003",
                              "display": "Varicella-Zoster IgG"
                          }
                      ],
                      "text": "Varicella-Zoster IgG"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1230300203"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13050-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis C virus Ab supplemental:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1230300203",
                              "display": "Hepatitis C Antibody Supplemental"
                          }
                      ],
                      "text": "Hepatitis C Antibody Supplemental"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "note": [
                      {
                          "text": "HCV RNA reflex testing is performed on: \r\n1) First-time reactive HCV antibody results to determine active/current infection.\r\n2) Patients with a previous Positive HCV antibody result with no history of HCV RNA testing\r\n3) Inconclusive HCV antibody results. \r\nFor other HCV RNA requests, submit a serum specimen for HCV RNA testing Following PHOL recommended guidelines found at publichealthontario.ca/HepCRNA."
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200001"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5393-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:IF"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200001",
                              "display": "Syphilis FTA Abs"
                          }
                      ],
                      "text": "Syphilis FTA Abs"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200002"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20507-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Reagin Ab:ACnc:Pt:Ser:Ord:RPR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200002",
                              "display": "Syphilis RPR Screen"
                          }
                      ],
                      "text": "Syphilis RPR Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701021"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17850-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 1 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701021",
                              "display": "Herpes Simplex Virus 1 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 1 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701022"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17851-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 2 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701022",
                              "display": "Herpes Simplex Virus 2 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 2 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701023"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701023",
                              "display": "Herpes Simplex Virus Interpretation"
                          }
                      ],
                      "text": "Herpes Simplex Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Herpes Simplex Virus 1 IgG and Herpes Simplex Virus 2 IgG antibodies not detected.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701024"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701024",
                              "display": "Herpes Simplex Virus Note"
                          }
                      ],
                      "text": "Herpes Simplex Virus Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Note: Early antiviral therapy following acute HSV infection may result in a blunted or delayed IgG antibody response. The absence of detectable HSV IgG antibodies may not rule out recent HSV infection. If a recent HSV infection is suspected and has not been confirmed by virus detection (e.g. culture), a follow-up blood sample should be submitted 3-6 months post-exposure to detect the late development of HSV antibodies. Diagnosis of HSV infection is best performed by culture of the virus from vesicular fluid or lesion scrapings.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          }
      ]
  ],
  "sectionsChecked": [],
  "episode_id": "eBoTe.FFtYzhCAhiO-M2TbA3"
}
const mock_patient_UHNOne = {
  "resourceType": "Patient",
  "id": "eyOhcUNJTB0DMWk0EgziXJA3",
  "extension": [
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ],
              "text": "Male"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
        "valueCodeableConcept": {
          "coding": [
            {
              "system": "http://hl7.org/fhir/gender-identity",
              "code": "other",
              "display": "other"
            }
          ],
          "text": "Trans Woman"
        },
        "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                      "code": "male",
                      "display": "male"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
      },
      {
          "extension": [
              {
                  "valueCoding": {
                      "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                      "code": "UNK",
                      "display": "Unknown"
                  },
                  "url": "ombCategory"
              },
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
          "extension": [
              {
                  "valueString": "Unknown",
                  "url": "text"
              }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
          "valueCode": "248153007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
          "valueCodeableConcept": {
              "coding": [
                  {
                      "system": "http://loinc.org",
                      "code": "LA29518-0",
                      "display": "he/him/his/his/himself"
                  }
              ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
  ],
  "identifier": [
      {
          "use": "usual",
          "type": {
              "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.688884.100",
          "value": "UPO8PZD582H7H2D"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
          "value": "E3519"
      },
      {
          "use": "usual",
          "type": {
              "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
          "value": "900000813"
      },
      {
          "use": "usual",
          "type": {
              "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "Z3525"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "TjDLEYtFXc2J-HkCOO27T-rI08QPCJMdudbuYvMpyQGoB"
      },
      {
          "use": "usual",
          "type": {
              "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "eyOhcUNJTB0DMWk0EgziXJA3"
      },
      {
          "use": "usual",
          "type": {
              "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
          "value": "     Z3525"
      },
      {
        "use": "usual",
        "type": {
          "text": "TGLNDonor"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.1650000002",
        "value": "129464"
      },
      {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "1234567890"
      }
  ],
  "active": true,
  "name": [
      {
          "use": "official",
          "text": "Recipient UHNOne",
          "family": "UHNOne",
          "given": [
              "RecipientFour"
          ]
      },
      {
          "use": "usual",
          "text": "RecipientFour UHNOne",
          "family": "UHNOne",
          "given": [
              "UHNOne"
          ]
      }
  ],
  "gender": "m",
  "birthDate": "1975-12-30",
  "deceasedBoolean": false,
  "address": [
      {
          "use": "home",
          "text": "280 Dundas Street\r\nRichmond Hill AL 23456\r\nUnited States of America",
          "line": [
              "280 Dundas Street"
          ],
          "city": "Richmond Hill",
          "state": "AL",
          "postalCode": "23456",
          "country": "US",
          "period": {
              "start": "2025-08-05"
          }
      }
  ],
  "managingOrganization": {
      "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
      "display": "UNITY SERVICE AREA"
  }
};
const mock_patient_UHNTwo = {
  "resourceType": "Patient",
  "id": "e-BeVshgS5-abjhhwwYzq8A3",
  "extension": [
    {
      "valueCodeableConcept": {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.630.3.7.10.698084.130.657370.258",
            "code": "M",
            "display": "M"
          }
        ],
        "text": "Male"
      },
      "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
    },
    {
      "valueCodeableConcept": {
        "coding": [
          {
            "system": "urn:oid:1.2.840.114350.1.13.630.3.7.10.698084.130.657370.258",
            "code": "M",
            "display": "M"
          }
        ]
      },
      "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
    },
    {
      "extension": [
        {
          "valueCoding": {
            "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
            "code": "UNK",
            "display": "Unknown"
          },
          "url": "ombCategory"
        },
        {
          "valueString": "Unknown",
          "url": "text"
        }
      ],
      "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
    },
    {
      "extension": [
        {
          "valueString": "Unknown",
          "url": "text"
        }
      ],
      "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
    },
    {
      "valueCode": "248153007",
      "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
    },
    {
      "valueCodeableConcept": {
        "coding": [
          {
            "system": "http://loinc.org",
            "code": "LA29518-0",
            "display": "he/him/his/his/himself"
          }
        ]
      },
      "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
    }
  ],
  "identifier": [
    {
      "use": "usual",
      "type": {
        "text": "CEID"
      },
      "system": "urn:oid:1.2.840.114350.1.13.630.3.7.3.688884.100",
      "value": "UHMN4S23V38426M"
    },
    {
      "use": "usual",
      "type": {
        "text": "EPIC"
      },
      "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.0",
      "value": "E14203"
    },
    {
      "use": "usual",
      "type": {
        "text": "EXTERNAL"
      },
      "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.698084",
      "value": "Z14252"
    },
    {
      "use": "usual",
      "type": {
        "text": "FHIR"
      },
      "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
      "value": "TTVPZIOClTc49DbkOiovTB0O4iBSGF-RVdTbFZui6BPUB"
    },
    {
      "use": "usual",
      "type": {
        "text": "FHIR STU3"
      },
      "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
      "value": "e-BeVshgS5-abjhhwwYzq8A3"
    },
    {
      "use": "usual",
      "type": {
        "text": "INTERNAL"
      },
      "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.698084",
      "value": "    Z14252"
    },
    {
      "use": "usual",
      "type": {
        "text": "SK MRN"
      },
      "system": "urn:oid:1.2.840.114350.1.13.15.3.7.5.737384.8",
      "value": "115072"
    },
    {
      "use": "usual",
      "type": {
        "text": "EPI"
      },
      "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.14",
      "value": "100005950"
    },
    {
      "use": "usual",
      "type": {
        "text": "TGLNRecipient"
      },
      "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.1650000001",
      "value": "71099"
    },
    {
      "use": "usual",
      "type": {
        "text": "WPRINTERNAL"
      },
      "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.878082",
      "value": "5595"
    }
  ],
  "active": true,
  "name": [
    {
      "use": "official",
      "text": "Three UHN OATSrecipient",
      "family": "OATSrecipient",
      "given": [
        "Three",
        "UHN"
      ]
    },
    {
      "use": "usual",
      "text": "Three UHN OATSrecipient",
      "family": "OATSrecipient",
      "given": [
        "Three",
        "UHN"
      ]
    },
    {
      "use": "old",
      "text": "OATSRECIPIENT,THREE",
      "family": "Oatsrecipient",
      "given": [
        "Three"
      ]
    }
  ],
  "telecom": [
    {
      "system": "phone",
      "value": "+1 647-524-7853",
      "use": "home",
      "rank": 1
    },
    {
      "system": "phone",
      "value": "+1 416-876-9352",
      "use": "mobile",
      "rank": 3
    },
  ],
  "gender": "Male",
  "birthDate": "1994-09-20",
  "deceasedBoolean": false,
  "address": [
    {
      "use": "home",
      "text": "123 Anywhere Street\r\nToronto ON M4A 2C2\r\nCanada",
      "line": [
        "123 Anywhere Street"
      ],
      "city": "Toronto",
      "state": "ON",
      "postalCode": "M4A 2C2",
      "country": "CA",
      "period": {
        "start": "2026-04-13"
      }
    },
    {
      "use": "old",
      "text": "123 Fake Street\r\nMississauga ON L4J 3C6\r\nCanada",
      "line": [
        "123 Fake Street"
      ],
      "city": "Mississauga",
      "state": "ON",
      "postalCode": "L4J 3C6",
      "country": "CA",
      "period": {
        "start": "2026-04-08",
        "end": "2026-04-13"
      }
    }
  ],
  "communication": [
    {
      "extension": [
        {
          "extension": [
            {
              "valueCoding": {
                "system": "http://terminology.hl7.org/CodeSystem/v3-LanguageAbilityMode",
                "code": "ESP",
                "display": "Expressed spoken"
              },
              "url": "type"
            }
          ],
          "url": "http://hl7.org/fhir/StructureDefinition/patient-proficiency"
        }
      ],
      "language": {
        "coding": [
          {
            "system": "urn:ietf:bcp:47",
            "code": "en",
            "display": "English"
          }
        ],
        "text": "English"
      },
      "preferred": true,
      "_preferred": {
        "extension": [
          {
            "valueCoding": {
              "system": "http://hl7.org/fhir/language-preference-type",
              "code": "verbal",
              "display": "verbal"
            },
            "url": "http://hl7.org/fhir/StructureDefinition/patient-preferenceType"
          }
        ]
      }
    }
  ],
  "managingOrganization": {
    "reference": "Organization/eMcbVZ0EE4K-bd39cda1-dQ3",
    "display": "UHN"
  }
};
const mock_patient_UHNThree = {
    "resourceType": "Patient",
    "id": "ehk6OQzO8ppvDFfY0u4VhGg3",
    "extension": [
      {
        "valueCodeableConcept": {
          "coding": [
            {
              "system": "urn:oid:1.2.840.114350.1.13.630.3.7.10.698084.130.657370.258",
              "code": "M",
              "display": "M"
            }
          ],
          "text": "Male"
        },
        "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
      },
      {
        "valueCodeableConcept": {
          "coding": [
            {
              "system": "urn:oid:1.2.840.114350.1.13.630.3.7.10.698084.130.657370.258",
              "code": "M",
              "display": "M"
            }
          ]
        },
        "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
      },
      {
        "extension": [
          {
            "valueCoding": {
              "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
              "code": "UNK",
              "display": "Unknown"
            },
            "url": "ombCategory"
          },
          {
            "valueString": "Unknown",
            "url": "text"
          }
        ],
        "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
      },
      {
        "extension": [
          {
            "valueString": "Unknown",
            "url": "text"
          }
        ],
        "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
      },
      {
        "valueCode": "248153007",
        "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
      },
      {
        "valueCodeableConcept": {
          "coding": [
            {
              "system": "http://loinc.org",
              "code": "LA29518-0",
              "display": "he/him/his/his/himself"
            }
          ]
        },
        "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
      }
    ],
    "identifier": [
      {
        "use": "usual",
        "type": {
          "text": "CEID"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.3.688884.100",
        "value": "UHMPGC37DB2CRNT"
      },
      {
        "use": "usual",
        "type": {
          "text": "EPIC"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.0",
        "value": "E14206"
      },
      {
        "use": "usual",
        "type": {
          "text": "EXTERNAL"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.698084",
        "value": "Z14255"
      },
      {
        "use": "usual",
        "type": {
          "text": "FHIR"
        },
        "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
        "value": "T4Ekzs0t1YucWAQWVuDiZYa5o5l534y59Wv.h1zL0tcYB"
      },
      {
        "use": "usual",
        "type": {
          "text": "FHIR STU3"
        },
        "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
        "value": "ehk6OQzO8ppvDFfY0u4VhGg3"
      },
      {
        "use": "usual",
        "type": {
          "text": "INTERNAL"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.698084",
        "value": "    Z14255"
      },
      {
        "use": "usual",
        "type": {
          "text": "EPI"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.14",
        "value": "100005953"
      },
      {
        "use": "usual",
        "type": {
          "text": "TGLNDonor"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.1650000002",
        "value": "129464"
      },
      {
        "use": "usual",
        "type": {
          "text": "WPRINTERNAL"
        },
        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.878082",
        "value": "5598"
      },
      {
        "use": "usual",
        "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
        "value": "5881482029"
      }
    ],
    "active": true,
    "name": [
      {
        "use": "official",
        "text": "One UHN OATSdonor",
        "family": "OATSdonor",
        "given": [
          "One",
          "UHN"
        ]
      },
      {
        "use": "usual",
        "text": "One UHN OATSdonor",
        "family": "OATSdonor",
        "given": [
          "One",
          "UHN"
        ]
      },
      {
        "use": "old",
        "text": "OATSDONOR,ONE",
        "family": "Oatsdonor",
        "given": [
          "One"
        ]
      }
    ],
    "gender": "M",
    "birthDate": "2004-01-21",
    "deceasedBoolean": false,
    "address": [
      {
        "use": "home",
        "text": "321 Anywhere Street\r\nToronto ON M5A 2C2\r\nCanada",
        "line": [
          "321 Anywhere Street"
        ],
        "city": "Toronto",
        "state": "ON",
        "postalCode": "M5A 2C2",
        "country": "CA",
        "period": {
          "start": "2026-04-08"
        }
      }
    ],
    "communication": [
      {
        "extension": [
          {
            "extension": [
              {
                "valueCoding": {
                  "system": "http://terminology.hl7.org/CodeSystem/v3-LanguageAbilityMode",
                  "code": "ESP",
                  "display": "Expressed spoken"
                },
                "url": "type"
              }
            ],
            "url": "http://hl7.org/fhir/StructureDefinition/patient-proficiency"
          }
        ],
        "language": {
          "coding": [
            {
              "system": "urn:ietf:bcp:47",
              "code": "en",
              "display": "English"
            }
          ],
          "text": "English"
        },
        "preferred": true,
        "_preferred": {
          "extension": [
            {
              "valueCoding": {
                "system": "http://hl7.org/fhir/language-preference-type",
                "code": "verbal",
                "display": "verbal"
              },
              "url": "http://hl7.org/fhir/StructureDefinition/patient-preferenceType"
            }
          ]
        }
      }
    ],
    "managingOrganization": {
      "reference": "Organization/eMcbVZ0EE4K-bd39cda1-dQ3",
      "display": "UHN"
    }

};
const uhnDataMock1 = {
  "patient": {
      "resourceType": "Patient",
      "id": "eZ4Fxy8ToBxyhpU9iFBCBKA3",
      "extension": [
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                          "code": "male",
                          "display": "male"
                      }
                  ],
                  "text": "Male"
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "http://hl7.org/fhir/gender-identity",
                          "code": "other",
                          "display": "other"
                      }
                  ],
                  "text": "Trans Woman"
              },
              "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
          },
          {
              "extension": [
                  {
                      "valueCoding": {
                          "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                          "code": "UNK",
                          "display": "Unknown"
                      },
                      "url": "ombCategory"
                  },
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
          },
          {
              "extension": [
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
          },
          {
              "valueCode": "184115007",
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "https://open.epic.com/FHIR/Epic/pronoun-set",
                          "code": "EP-PS-DO-NOT-USE-PRONOUNS",
                          "display": "do not use pronouns"
                      }
                  ]
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
          }
      ],
      "identifier": [
          {
              "use": "usual",
              "type": {
                  "text": "EPIC"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
              "value": "E3517"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPI"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
              "value": "900000811"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EXTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
              "value": "TSEz66EdHpd1B2KJf9z7AfVZaMfqLagYbO2VwNdy1OngB"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR STU3"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
              "value": "eZ4Fxy8ToBxyhpU9iFBCBKA3"
          },
          {
              "use": "usual",
              "type": {
                  "text": "INTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "     Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "TGLNRecipient"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.1650000006",
              "value": "67540"
          },
          {
              "use": "usual",
              "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
              "value": "1234567890"
          }
      ],
      "active": true,
      "name": [
          {
              "use": "official",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          },
          {
              "use": "usual",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          }
      ],
      "telecom": [
          {
              "system": "phone",
              "value": "+1 416-360-4000",
              "use": "home"
          },
          {
              "system": "phone",
              "value": "+1 416-340-3666",
              "use": "work"
          },
          {
              "system": "phone",
              "value": "+1 416-285-3666",
              "use": "mobile"
          },
          {
              "system": "email",
              "value": "123@oats.ca",
              "rank": 1
          }
      ],
      "gender": "male",
      "birthDate": "1991-11-07",
      "deceasedBoolean": false,
      "address": [
          {
              "use": "home",
              "text": "465 Yonge St\r\nToronto TORONTO M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "district": "TORONTO",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-10-02"
              }
          },
          {
              "use": "old",
              "text": "465 Yonge St\r\nToronto M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-08-05",
                  "end": "2025-10-02"
              }
          }
      ],
      "managingOrganization": {
          "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
          "display": "UNITY SERVICE AREA"
      }
  },
  "entries": [
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
              "resource": {
                  "resourceType": "Coverage",
                  "id": "emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
                  "contained": [
                      {
                          "resourceType": "Organization",
                          "id": "org1",
                          "type": [
                              {
                                  "coding": [
                                      {
                                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.678671.120",
                                          "code": "3",
                                          "display": "Insurance Plan"
                                      }
                                  ],
                                  "text": "Insurance Plan"
                              }
                          ],
                          "name": "OHIP",
                          "contact": [
                              {
                                  "purpose": {
                                      "coding": [
                                          {
                                              "system": "http://terminology.hl7.org/CodeSystem/contactentity-type",
                                              "code": "BILL",
                                              "display": "Billing"
                                          }
                                      ]
                                  },
                                  "address": {
                                      "use": "billing",
                                      "line": [
                                          "EXEC TOWER  OSHAWA CENTRE",
                                          "419 KING ST WEST"
                                      ],
                                      "city": "Toronto",
                                      "state": "ON",
                                      "postalCode": "L1H 8L4",
                                      "country": "CA"
                                  }
                              }
                          ]
                      }
                  ],
                  "extension": [
                      {
                          "valueReference": {
                              "reference": "#org1"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/billing-organization"
                      }
                  ],
                  "identifier": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.678671",
                          "value": "1465"
                      },
                      {
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                                      "code": "MB",
                                      "display": "Member Number"
                                  }
                              ]
                          },
                          "value": "1234567890"
                      }
                  ],
                  "status": "active",
                  "subscriber": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "subscriberId": "1234567890",
                  "beneficiary": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "relationship": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.678671.305",
                              "code": "01",
                              "display": "Self"
                          },
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/subscriber-relationship",
                              "code": "self",
                              "display": "Self"
                          }
                      ],
                      "text": "Self"
                  },
                  "period": {
                      "start": "2013-03-31"
                  },
                  "payor": [
                      {
                          "reference": "Organization/edfM-VF1iMIWPWTWdwpoNdQ3",
                          "identifier": {
                              "use": "official",
                              "system": "http://open.epic.com/FHIR/StructureDefinition/payer-id",
                              "value": "10000"
                          },
                          "display": "SK Workers Comp"
                      }
                  ],
                  "class": [
                      {
                          "extension": [
                              {
                                  "valueIdentifier": {
                                      "use": "secondary",
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698080",
                                      "value": "1000001"
                                  },
                                  "url": "http://open.epic.com/FHIR/StructureDefinition/extension/epic-id"
                              }
                          ],
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/coverage-class",
                                      "code": "plan",
                                      "display": "Plan"
                                  }
                              ]
                          },
                          "value": "1000001",
                          "name": "OHIP"
                      }
                  ],
                  "order": 1
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "elDMk6vH3DhXdUaTg5SUXJwXtvmXFV7qP19LVRNLmkyg835ouDn6aT5w.V7XvGW-HGubK7BlUGOrB.oM3S0Prcg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#336",
                    "display": "OATS REFERRAL DECISION DECLINE REASON"
                  }
                ],
                "text": "OATS REFERRAL DECISION DECLINE REASON"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2024-11-06T21:05:22Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Patient does not meet referral criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
   
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eBQ2hevutR2qPSNe41N9ZN74nydvVZXobzDOm7h3IbnSzABLnJ7pYu8R9MWJ6pgB1qY0km6qFhJZ7NhJnKyu2Yg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#398",
                    "display": "OATS RECOVERY START"
                  }
                ],
                "text": "OATS RECOVERY START"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
                "display": "MayUpgradeTwoFour, ScriptEightySevenD"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
                }
              ],
              "issued": "2024-12-11T19:14:11Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-10-10T14:41:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fT6SpekJyJHjnYKBKiiFBjg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16574",
                    "display": "OATS - REFERRAL CANCELLED REASON"
                  }
                ],
                "text": "OATS - REFERRAL CANCELLED REASON"
              },
              "subject": {
                "reference": "Patient/eoN4fz8OEXuw.slGH1SO2XQ3",
                "display": "SITFourthteen, SITFourthteen"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2025-10-24T17:13:06Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient relocated"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fgVk6SkJBJCzMJOw0GDud.g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16539",
                    "display": "OATS - LIVING DONOR RECOVERY COMMENTS"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMMENTS"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Testing recovery details "
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fOk3JvQnmUhsc9nMaoxeOcQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16540",
                    "display": "OATS - LIVING DONOR RECOVERY COMPLETED"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMPLETED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fKfPw--KbYC4NuauObvPlxw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16542",
                    "display": "OATS - ORGAN SHIPPED"
                  }
                ],
                "text": "OATS - ORGAN SHIPPED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "faLXUefq0EQcaKWk5FuUv-Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16569",
                    "display": "OATS - SHIPPED OUT OF PROVINCE"
                  }
                ],
                "text": "OATS - SHIPPED OUT OF PROVINCE"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fXgKmOYsXSD0Y9rfxEyPBEA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16571",
                    "display": "OATS - PERFUSION PUMP"
                  }
                ],
                "text": "OATS - PERFUSION PUMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fu4tYEvA48HaaIvI49TPWYQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16572",
                    "display": "OATS - PERFUSION DATE AND TIME"
                  }
                ],
                "text": "OATS - PERFUSION DATE AND TIME"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-06T14:19:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4",
            "resource": {
              "resourceType": "Observation",
              "id": "fw.eFFHpMBrYMfuPKEVma-A4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16573",
                    "display": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
                  }
                ],
                "text": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNEFwsvfbpROAIGPjn4X6LA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#400",
                    "display": "OATS CROSS CLAMP"
                  }
                ],
                "text": "OATS CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:53:18Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-09-22T17:51:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fP.al0N1Pg1QvD15OFVmyZA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#114",
                    "display": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
                  }
                ],
                "text": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-02T17:24:13Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-02T17:23:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fhb6S8X-Xaqo8XpI1XAsemg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#7928",
                    "display": "OATS - UNKNOWN GENDER"
                  }
                ],
                "text": "OATS - UNKNOWN GENDER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSix, SITSix SITMIDDLESIX"
              },
              "focus": [
                {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                }
              ],
              "issued": "2025-10-27T20:15:00Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Trans Woman"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eyoMRUjclNBbwhXQ598UPLZ3LV6i5b-cxDxTsW6XCjynyrM5vrJTTrKfDCY34GKyLw2O8Rn4ywxXs-Tu5.vnRxw3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#379",
                    "display": "OATS FAILURE CAUSE"
                  }
                ],
                "text": "OATS FAILURE CAUSE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Failure, Graft"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
                }
              ],
              "issued": "2024-12-06T16:45:25Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "OTHER"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4",
            "resource": {
              "resourceType": "Observation",
              "id": "f8RoGoKpeGNWz1L2xAPLnKg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16519",
                    "display": "OATS - LDCMVLAB"
                  }
                ],
                "text": "OATS - LDCMVLAB"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                  "display": "SITLDOne, SITLDOne"
                }
              ],
              "issued": "2025-10-16T15:43:20Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "PUBLIC HEALTH LABORATORY"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fimmZL1g-v932shUu4axPFw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#403",
                    "display": "OATS LINKED RECIPIENT TGLN"
                  }
                ],
                "text": "OATS LINKED RECIPIENT TGLN"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/en6mARfmq0F5hQzOiCBNPwA3"
                }
              ],
              "issued": "2025-10-27T20:00:48Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "68641"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSrGw3FZrFH2zVbrhV-eP2g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#309",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Other"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fcZRyeFT99RbVk1VzmsCzBg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#8089",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "testing f/u comment"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fGomxQtUjGJEya-3Xr-emCQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#314",
                    "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                  }
                ],
                "text": "OATS FOLLOWUP CLINIC VISIT DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSgdUp9YF7xzfCcoyIEgJOw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#317",
                    "display": "OATS RETURN TO DIALYSIS DATE"
                  }
                ],
                "text": "OATS RETURN TO DIALYSIS DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-27"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4",
            "resource": {
              "resourceType": "Observation",
              "id": "fkN6XBHLNAj8-F2U90OiZ7w4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#329",
                    "display": "OATS FOLLOWUP - CREATININE UNKNOWN"
                  }
                ],
                "text": "OATS FOLLOWUP - CREATININE UNKNOWN"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fHIdwecqHGXKE4fk0tSYKuw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16510",
                    "display": "OATS - LDHEPBCORE"
                  }
                ],
                "text": "OATS - LDHEPBCORE"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fzDkTD-1obxXqR5mA0Vyh8g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16558",
                    "display": "OATS - LDCMVINSTANT"
                  }
                ],
                "text": "OATS - LDCMVINSTANT"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22T17:24:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4",
            "resource": {
              "resourceType": "Observation",
              "id": "fulpq4zpkgTvQEmrPLl0Bug4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16511",
                    "display": "OATS - LDHEPBSAB"
                  }
                ],
                "text": "OATS - LDHEPBSAB"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "f.KdXM9H-xk5PA7qfFeCxIQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16512",
                    "display": "OATS - LDCMV"
                  }
                ],
                "text": "OATS - LDCMV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNCoY7ON5v3jN3wbAhoY3tQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16513",
                    "display": "OATS - LDHEPBSAG"
                  }
                ],
                "text": "OATS - LDHEPBSAG"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "ffaDats9QarIDNgygzKFQwQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16514",
                    "display": "OATS - LDHEPC"
                  }
                ],
                "text": "OATS - LDHEPC"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fppzCzpxRewghVKNVLrUQoA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16515",
                    "display": "OATS - LDHIV"
                  }
                ],
                "text": "OATS - LDHIV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fIzbl-Qdo8qfYeGu2ExlsJw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16516",
                    "display": "OATS - LDVDRL"
                  }
                ],
                "text": "OATS - LDVDRL"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "frQpp0jBy-GJKPQc3KBaP4Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16517",
                    "display": "OATS - LDEBV"
                  }
                ],
                "text": "OATS - LDEBV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fd4cy5DQo80TXwSgMuMNFHg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16518",
                    "display": "OATS - WNV"
                  }
                ],
                "text": "OATS - WNV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e512AOvSC3zGPs1dz1bxr2D3aBjBi9iR2.x2OwWmIGEu-akVsVkB0rp9s2mhOqZUakc9mxb2O8EZfhTrNZdBzTA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#292",
                    "display": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Age and functional capacity"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Cause of Kidney Disease"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Obesity"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Systemic Diseases"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Infections"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Pulmonary Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Cerebral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 10"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 11"
                  },
                  "valueString": "Gastrointestinal Disease"
                },
                {
                  "code": {
                    "text": "Line 12"
                  },
                  "valueString": "Liver Disease"
                },
                {
                  "code": {
                    "text": "Line 13"
                  },
                  "valueString": "Genitourinary Disease"
                },
                {
                  "code": {
                    "text": "Line 14"
                  },
                  "valueString": "Hematologic Disorders"
                },
                {
                  "code": {
                    "text": "Line 15"
                  },
                  "valueString": "Hyperparathyroidism"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "edB41AO1moSG0eIEmOJPz0DFWaiAOOyOApcHvu5C7DPKgv.Y2jz2vgAdBWXwhGee0NNphXS2CvaWnTO83IOa8jA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#291",
                    "display": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Comorbidities"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Consent"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Post-Transplant Care"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Malignancy"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Pulmoary Disease"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Gastrointestinal Disease"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e58WVNM0jb629nEMoRQLKgz0zLIo-u6pNIPq6t5dqF5.tU8JjuTdwkXoCmZ089TPENJmYfO7lxv1bdRS7zi9kkg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#327",
                    "display": "OATS - FURTHER TESTING REQUIRED OTHER"
                  }
                ],
                "text": "OATS - FURTHER TESTING REQUIRED OTHER"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "This is an other field for medical assessment decision reason."
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezOI4wA1544vR-YyamuQlmnpGwDvcz4MCrMNwby-sCnsDQkUu4odZTTqT3anAZLKH913VsMaE1HHqNokgis.fAQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#289",
                    "display": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient does not meet listing criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eAveF-aMGBJcv7OH3nC3SgXg7VbM2er2OVDw.Q33Q-wiWjjHNfppYpzVs0327-IpjcZH0qNrVMXFF.IDJSD0tKg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#283",
                    "display": "OATS - DELAY END DATE"
                  }
                ],
                "text": "OATS - DELAY END DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-06"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
            "resource": {
              "resourceType": "Observation",
              "id": "eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#282",
                    "display": "OATS - DELAY START DATE"
                  }
                ],
                "text": "OATS - DELAY START DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-05"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eEY6QUFLjk.6utt6AMxpFeHPwE8Bx4J1IwK9S86MwFKM5u.OBqzcgpMSlWBS2BXsuuQJifS53BWrPMVUr-OBgNg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#288",
                    "display": "OATS - MEDICAL ASSESSMENT CANCELLED"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT CANCELLED"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient Death Related to Organ Failure"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e3zPGgVwXGU9ZJmm32I24--RP5WAZuhtlxig4bc1CmG.qrUoScgpcfp6d22OgQ.KEfxSpNN4bNRchRsQO6Hy0VQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#290",
                    "display": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Down staging for HCC"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fwzFV6yBHYlxXobiHrZHxtw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7924",
                              "display": "OATS INTEGRATION - ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
            "resource": {
                "resourceType": "Observation",
                "id": "fwzFV6yBHYlxXobiHrZHxtw4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "UHN#3842",
                            "display": "OATS INTEGRATION - ETHNICITY"
                        }
                    ],
                    "text": "OATS INTEGRATION - ETHNICITY"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
                        "display": "SMHOne, RecipientOne"
                    }
                ],
                "issued": "2025-10-10T17:45:05Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                    {
                        "code": {
                            "text": "Line 1"
                        },
                        "valueString": "Accident related to treatments"
                    }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
        {
          "link": [
              {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
              }
          ],
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
          "resource": {
              "resourceType": "Observation",
              "id": "fwzFV6yBHYlxXobiHrZHxtw4",
              "status": "unknown",
              "category": [
                  {
                      "coding": [
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                              "code": "smartdata",
                              "display": "SmartData"
                          }
                      ],
                      "text": "SmartData"
                  }
              ],
              "code": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                          "code": "SK#7935",
                          "display": "OATS INTEGRATION - ETHNICITY"
                      }
                  ],
                  "text": "OATS INTEGRATION - ETHNICITY"
              },
              "subject": {
                  "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "SMHOne, RecipientOne"
              },
              "focus": [
                  {
                      "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
                      "display": "SMHOne, RecipientOne"
                  }
              ],
              "issued": "2025-10-10T17:45:05Z",
              "performer": [
                  {
                      "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                      "display": "PHOENIX, COORDINATOR"
                  }
              ],
              "component": [
                  {
                      "code": {
                          "text": "Line 1"
                      },
                      "valueString": "Others"
                  }
              ]
          },
          "search": {
              "mode": "match"
          }
      },
      {
        "link": [
            {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
            }
        ],
        "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
        "resource": {
            "resourceType": "Observation",
            "id": "fwzFV6yBHYlxXobiHrZHxtw4",
            "status": "unknown",
            "category": [
                {
                    "coding": [
                        {
                            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                            "code": "smartdata",
                            "display": "SmartData"
                        }
                    ],
                    "text": "SmartData"
                }
            ],
            "code": {
                "coding": [
                    {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                        "code": "SK#7935",
                        "display": "OATS INTEGRATION - ETHNICITY"
                    }
                ],
                "text": "OATS INTEGRATION - ETHNICITY"
            },
            "subject": {
                "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "SMHOne, RecipientOne"
            },
            "focus": [
                {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                }
            ],
            "issued": "2025-10-10T17:45:05Z",
            "performer": [
                {
                    "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                    "display": "PHOENIX, COORDINATOR"
                }
            ],
            "component": [
                {
                    "code": {
                        "text": "Line 1"
                    },
                    "valueString": "FFOthers"
                }
            ]
        },
        "search": {
            "mode": "match"
        }
    },
        {
          "link": [
              {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
              }
          ],
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
          "resource": {
              "resourceType": "Observation",
              "id": "fwzFV6yBHYlxXobiHrZHxtw4",
              "status": "unknown",
              "category": [
                  {
                      "coding": [
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                              "code": "smartdata",
                              "display": "SmartData"
                          }
                      ],
                      "text": "SmartData"
                  }
              ],
              "code": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                          "code": "UHN#4132",
                          "display": "OATS INTEGRATION - ETHNICITY"
                      }
                  ],
                  "text": "OATS INTEGRATION - ETHNICITY"
              },
              "subject": {
                  "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "SMHOne, RecipientOne"
              },
              "focus": [
                  {
                      "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
                      "display": "SMHOne, RecipientOne"
                  }
              ],
              "issued": "2025-10-10T17:45:05Z",
              "performer": [
                  {
                      "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                      "display": "PHOENIX, COORDINATOR"
                  }
              ],
              "component": [
                  {
                      "code": {
                          "text": "Line 1"
                      },
                      "valueString": "Accident related to treatment"
                  }
              ]
          },
          "search": {
              "mode": "match"
          }
      },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fI4wqWREJVMOVc3ybaeR5hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7925",
                              "display": "OATS INTEGRATION - OTHER ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - OTHER ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other eth"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient proceeding with living donor transplant"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIShZ3BsZUb8xu.XdBOCbwQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fUVgmmS0QIEoyT-53X7GxRQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7928",
                              "display": "OATS - UNKNOWN GENDER"
                          }
                      ],
                      "text": "OATS - UNKNOWN GENDER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other gender"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#8091",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgBfEfOG6EFBRskvJjZV2bw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7929",
                              "display": "OATS ABO BLOOD TYPE"
                          }
                      ],
                      "text": "OATS ABO BLOOD TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AB"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4",
            "resource": {
                "resourceType": "Observation",
                "id": "fgBfEfOG6EFBRskvJjZV2bw4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "UHN#3829",
                            "display": "EXCEPTIONAL DISTRIBUTION REASON(S)"
                        }
                    ],
                    "text": "OATS ABO BLOOD TYPE"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                        "display": "SMHOne, RecipientOne"
                    }
                ],
                "issued": "2025-08-06T02:57:09Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                  {
                    "code": {
                      "text": "Line 1"
                    },
                    "valueString": "Hep B Core +"
                  },
                  {
                    "code": {
                      "text": "Line 2"
                    },
                    "valueString": "IRD Known sex history risk"
                  },
                  {
                    "code": {
                      "text": "Line 3"
                    },
                    "valueString": "Travel to/lived in history with risk for"
                  },
                  {
                    "code": {
                      "text": "Line 4"
                    },
                    "valueString": "IRD Incarceration >72 consecutive hours in last 3 months"
                  }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fbNY2qVwHTsoHow5DY5LKgw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7930",
                              "display": "OATS ABO RH FACTOR"
                          }
                      ],
                      "text": "OATS ABO RH FACTOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Positive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#334",
                              "display": "OATS REFERRAL DECISION"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Referral Accepted"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
            "resource": {
                "resourceType": "Observation",
                "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "TXP#334",
                            "display": "OATS REFERRAL DECISION"
                        }
                    ],
                    "text": "OATS REFERRAL DECISION"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                    }
                ],
                "issued": "2025-08-19T14:54:38Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                    {
                        "code": {
                            "text": "Line 1"
                        },
                        "valueString": "Referral Accepted"
                    }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
        {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
            "resource": {
                "resourceType": "Observation",
                "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "UHN#4112",
                            "display": "OATS REFERRAL DECISION"
                        }
                    ],
                    "text": "OATS REFERRAL DECISION"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                    }
                ],
                "issued": "2025-08-19T14:54:38Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                    {
                        "code": {
                            "text": "Line 1"
                        },
                        "valueString": "Referral Accepted Test"
                    }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
        {
          "link": [
              {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
              }
          ],
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
          "resource": {
              "resourceType": "Observation",
              "id": "fqYHEIsMGTeS0j5NQiKddnA4",
              "status": "unknown",
              "category": [
                  {
                      "coding": [
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                              "code": "smartdata",
                              "display": "SmartData"
                          }
                      ],
                      "text": "SmartData"
                  }
              ],
              "code": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                          "code": "SK#7975",
                          "display": "UHN TXP OATS REFERRAL DECISION DATE"
                      }
                  ],
                  "text": "OATS REFERRAL DECISION"
              },
              "subject": {
                  "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "SMHOne, RecipientOne"
              },
              "focus": [
                  {
                      "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "issued": "2025-08-19T14:54:38Z",
              "performer": [
                  {
                      "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                      "display": "PHOENIX, COORDINATOR"
                  }
              ],
              "component": [
                  {
                      "code": {
                          "text": "Line 1"
                      },
                     "valueDateTime": "2018-03-23"
                  }
              ]
          },
          "search": {
              "mode": "match"
          }
      },
      {
        "link": [
            {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
            }
        ],
        "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
        "resource": {
            "resourceType": "Observation",
            "id": "fqYHEIsMGTeS0j5NQiKddnA4",
            "status": "unknown",
            "category": [
                {
                    "coding": [
                        {
                            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                            "code": "smartdata",
                            "display": "SmartData"
                        }
                    ],
                    "text": "SmartData"
                }
            ],
            "code": {
                "coding": [
                    {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                        "code": "SK#8286",
                        "display": "UHN TXP OATS REFERRAL DECISION DATE"
                    }
                ],
                "text": "OATS REFERRAL DECISION"
            },
            "subject": {
                "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "SMHOne, RecipientOne"
            },
            "focus": [
                {
                    "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
            ],
            "issued": "2025-08-19T14:54:38Z",
            "performer": [
                {
                    "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                    "display": "PHOENIX, COORDINATOR"
                }
            ],
            "component": [
                {
                    "code": {
                        "text": "Line 1"
                    },
                   "valueString": "Referral Cancelled"
                }
            ]
        },
        "search": {
            "mode": "match"
        }
    },
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                      "code": "SK#8287",
                      "display": "UHN TXP OATS REFERRAL DECISION DATE"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
              {
                  "code": {
                      "text": "Line 1"
                  },
                 "valueString": "Duplicate Referral"
              }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
    
      {
        "link": [
            {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
            }
        ],
        "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
        "resource": {
            "resourceType": "Observation",
            "id": "fqYHEIsMGTeS0j5NQiKddnA4",
            "status": "unknown",
            "category": [
                {
                    "coding": [
                        {
                            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                            "code": "smartdata",
                            "display": "SmartData"
                        }
                    ],
                    "text": "SmartData"
                }
            ],
            "code": {
                "coding": [
                    {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                        "code": "UHN#1652",
                        "display": "UHN TXP OATS REFERRAL DECISION DATE"
                    }
                ],
                "text": "OATS REFERRAL DECISION"
            },
            "subject": {
                "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "SMHOne, RecipientOne"
            },
            "focus": [
                {
                    "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
            ],
            "issued": "2025-08-19T14:54:38Z",
            "performer": [
                {
                    "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                    "display": "PHOENIX, COORDINATOR"
                }
            ],
            "component": [
                {
                    "code": {
                        "text": "Line 1"
                    },
                   "valueString": "Double/right side preferred"
                }
            ]
        },
        "search": {
            "mode": "match"
        }
    },
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                      "code": "UHN#4055",
                      "display": "UHN TXP OATS DONOR RELATIONSHIP TO RECIPIENT"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
            {
              "code": {
                "text": "Line 1"
              },
              "valueCodeableConcept": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.798271.315",
                    "code": "165010",
                    "display": "UNRELATED"
                  }
                ],
                "text": "UNRELATED"
              }
            }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#8292",
                    "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
          {
            "code": {
              "text": "Line 1"
            },
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.798271.1505",
                  "code": "3006",
                  "display": "Focal Glomerular Sclerosis (Focal Segmental - FSG)"
                }
              ],
              "text": "FOCAL GLOMERULOSCLEROSIS - ADULTS"
            }
          }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#8406",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "Cardiomyopathy"
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#8294",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.798271.1505",
                "code": "3006",
                "display": "Focal Glomerular Sclerosis (Focal Segmental - FSG)"
              }
            ],
            "text": "Liver GLOMERULOSCLEROSIS - ADULTS"
          }
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#8295",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.798271.1505",
                "code": "3006",
                "display": "Focal Glomerular Sclerosis (Focal Segmental - FSG)"
              }
            ],
            "text": "Liver sec"
          }
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#8293",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.798271.1505",
                "code": "3006",
                "display": "Focal Glomerular Sclerosis (Focal Segmental - FSG)"
              }
            ],
            "text": "seddd"
          }
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "UHN#3604",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "GENERAL AND FAMILY PRACTICE",
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "UHN#3973",
                    "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueString": "Referral Accepted"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#7985",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Recipient Not Eligible for Transplant"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#7987",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Recipient does not meet listing criteria"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "UHN#3787",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Co-morbidities"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "UHN#3559",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Consultation Completed"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "UHN#3975",
                  "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Recipient request"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#7964",
                  "display": "UHN TXP OATS REF PROV PROVINCE"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "ONTARIO"
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                  "code": "SK#7963",
                  "display": "UHN TXP OATS REF PROV PROVINCE"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "CANADA"
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                       "code": "SK#8259",
                    "display": "HTLV -1"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                   "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "UHNFour, RecipientFour"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
              {
                  "code": {
                      "text": "Line 1"
                  },
                  "valueString": "Detected"
              }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "SK#8260",
                  "display": "HTLV -1"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueDateTime": "2026-09-14"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8261",
                "display": "HTLV -1"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueTime": "10:00:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8233",
                "display": "HTLV -1"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Negative"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8234",
                "display": "HTLV -1"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueDateTime": "2026-09-15"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8235",
                "display": "HTLV -1"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueTime": "10:00:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8002",
                "display": "HTLV -1"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueTime": "10:00:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8003",
                "display": "HTLV -1"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueDateTime": "2026-09-25"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3882",
                  "display": "HUMAN IMMUNODEFICIENCY VIRUS NAT"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueString": "Negative"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#3923",
                "display": "HUMAN IMMUNODEFICIENCY VIRUS NAT"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Negative"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                       "code": "UHN#3886",
                    "display": "HTLV -1 DATE"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                   "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "UHNFour, RecipientFour"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
              {
                  "code": {
                      "text": "Line 1"
                  },
                  "valueDateTime": "2026-02-11"
              }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3887",
                  "display": "HTLV -1 DATE"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueTime": "11:11:00"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3924",
                  "display": "HTLV -1 DATE"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueDateTime": "2026-02-09"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#3925",
                "display": "HTLV -1 DATE"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueTime": "11:11:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3883",
                  "display": "HUMAN IMMUNODEFICIENCY VIRUS NAT DATE"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueDateTime": "2026-03-01"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3887",
                  "display": "HTLV -1 TIME"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueTime": "11:11:00"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                       "code": "SK#8214",
                       "display": "Actual TLC"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
              {
                  "code": {
                      "text": "Line 1"
                  },
                 "valueString": "39"
              }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "SK#8226",
                     "display": "Actual TLC"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
               "valueBoolean": true
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "SK#8046",
                     "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
                }
            ],
            "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
               "valueBoolean": false
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8048",
                   "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueBoolean": true
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8049",
                   "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-08-06"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8284",
                   "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "4"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8422",
                   "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "06/08/2026"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8232",
                   "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Testing population and pushing data to OATS - re-sending!"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8076",
                   "display": "DATE OF MELD"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueDateTime": "2026-09-03"
        }
        ,
        {
          "code": {
            "text": "Line 2"
          },
          "valueDateTime": "2026-08-30"
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8077",
                   "display": "DATE OF MELD"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "123"
        }
        //,
        // {
        //   "code": {
        //     "text": "Line 1"
        //   },
        //   "valueString": "122"
        // }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8079",
                   "display": "DATE OF MELD"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueString": "123"
        }
        //,
        // {
        //   "code": {
        //     "text": "Line 1"
        //   },
        //   "valueString": "122"
        // }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8080",
                   "display": "DATE OF MELD"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueBoolean": true
        }
        //,
        // {
        //   "code": {
        //     "text": "Line 1"
        //   },
        //   "valueString": "122"
        // }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8081",
                   "display": "DATE OF MELD"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
    "component": [
              {
                "code": {
                  "text": "Line 1"
                },
                "valueString": "On Mechanical Ventilator"
              },
               {
                 "code": {
                   "text": "Line 2"
                 },
                 "valueString": "Gastrointestinal Bleeding/On Intestine List"
               },
              {
                "code": {
                  "text": "Line 3"
                },
                "valueString": "Glasgow Coma <10"
              },
              {
                "code": {
                  "text": "Line 4"
                },
                "valueString": "Renal Failure"
              }
            ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8485",
                   "display": "DATE OF MELD"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
    "component": [
      {
        "code": {
          "text": "Line 1"
        },
        "valueString": "Metabolic Disorders"
      },
      {
        "code": {
          "text": "Line 2"
        },
        "valueString": "Hepatoblastoma"
      },
      {
        "code": {
          "text": "Line 3"
        },
        "valueString": "Primary Sclerosing Cholangitis"
      }
            ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8301",
                   "display": "UHN TXP OATS TRANSPLANT TYPE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Kidney - Left"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8084",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-02-03"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8025",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueBoolean": true
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8026",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueBoolean": false
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4148",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Left Kidney"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4069",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Directed Donation"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#3827",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "To be allocated to a Recipient"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#3993",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Pre-m recipient"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#3833",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueBoolean": false
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4073",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "SELZNER, MARKUS"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4074",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-04-17"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4075",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueTime": "16:17:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4076",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-04-17"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4077",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueTime": "16:18:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4061",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-04-17"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4063",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-04-18"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4064",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueTime": "00:15:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#4062",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueTime": "20:00:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8024",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Deceased or Living Donor"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8491",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueBoolean": true
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8492",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueBoolean": true
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8493",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "20-70"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8494",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "12-46"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8087",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Alive with Functional Graft"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8088",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Other"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8090",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-10-07"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8087",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "graft failure"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8155",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
        {
          "code": {
            "text": "Line 1"
          },
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.15.3.7.4.798271.402",
                "code": "303",
                "display": "Bleeding"
              }
            ],
            "text": "Bleeding"
          }
        }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8139",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Unknown"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8085",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueTime": "21:24:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8303",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-04-19"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8304",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueTime": "21:24:00"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8311",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueBoolean": true
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
      {
          "link": [
              {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
              }
          ],
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
          "resource": {
              "resourceType": "Observation",
              "id": "fqYHEIsMGTeS0j5NQiKddnA4",
              "status": "unknown",
              "category": [
                  {
                      "coding": [
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                              "code": "smartdata",
                              "display": "SmartData"
                          }
                      ],
                      "text": "SmartData"
                  }
              ],
              "code": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                          "code": "SK#7975",
                          "display": "UHN TXP OATS REFERRAL DECISION DATE"
                      }
                  ],
                  "text": "OATS REFERRAL DECISION"
              },
              "subject": {
                  "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "SMHOne, RecipientOne"
              },
              "focus": [
                  {
                      "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "issued": "2025-08-19T14:54:38Z",
              "performer": [
                  {
                      "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                      "display": "PHOENIX, COORDINATOR"
                  }
              ],
              "component": [
                  {
                      "code": {
                          "text": "Line 1"
                      },
                     "valueDateTime": "2017-02-23"
                  }
              ]
          },
          "search": {
              "mode": "match"
          }
      },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7931",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient proceeding with living donor transplant"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#8091",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7931",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
              "resource": {
                  "resourceType": "EpisodeOfCare",
                  "id": "eBoTe.FFtYzhCAhiO-M2TbA3",
                  "extension": [
                      {
                          "valueString": "Kidney Transplant - 2/10/2025  (#1)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                      },
                      {
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                                      "code": "2",
                                      "display": "Recipient"
                                  }
                              ],
                              "text": "Recipient"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                                              "code": "16",
                                              "display": "Kidney"
                                          }
                                      ],
                                      "text": "Kidney"
                                  },
                                  "url": "organ-class"
                              },
                              {
                                  "valueReference": {
                                      "reference": "Practitioner/el16FdtlssUCWMkeZfO2CMg3",
                                      "type": "Practitioner",
                                      "display": "Coordinator Phoenix, RN"
                                  },
                                  "url": "coordinator"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                                              "code": "50",
                                              "display": "Transplanted"
                                          }
                                      ],
                                      "text": "Transplanted"
                                  },
                                  "url": "phase"
                              },
                              {
                                  "valueString": "Active Follow-up",
                                  "url": "status"
                              },
                              {
                                  "valueDate": "2025-10-02",
                                  "url": "effective"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                      },
                      {
                          "valueDate": "2025-08-05",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                      },
                      {
                          "valuePeriod": {
                              "start": "2025-09-24",
                              "end": "2025-10-02"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
                      },
                      {
                          "valueString": "St. Michael's Hospital (Toronto, ON)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                      }
                  ],
                  "status": "active",
                  "type": [
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.726668",
                                  "code": "49",
                                  "display": "Transplant"
                              },
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.726668.130",
                                  "code": "4",
                                  "display": "Transplant"
                              }
                          ],
                          "text": "Transplant"
                      }
                  ],
                  "patient": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "type": "Patient",
                      "display": "SMHOne, RecipientOne"
                  },
                  "period": {
                      "start": "2025-08-05"
                  },
                  "team": [
                      {
                          "reference": "CareTeam/e6YjTLfVn73.lWbazIyc1OfLJ1ja9HdjQ.4m.riSPdvw3",
                          "type": "CareTeam",
                          "display": "Care Team"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
              "resource": {
                  "resourceType": "EpisodeOfCare",
                  "id": "xeBoTe.FFtYzhCAhiO-M2TbA3",
                  "extension": [
                      {
                          "valueString": "Kidney Transplant - 2/10/2025  (#1)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                      },
                      {
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                                      "code": "2",
                                      "display": "Recipient"
                                  }
                              ],
                              "text": "Recipient"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                                              "code": "16",
                                              "display": "Kidney"
                                          }
                                      ],
                                      "text": "Kidney"
                                  },
                                  "url": "organ-class"
                              },
                              {
                                  "valueReference": {
                                      "reference": "Practitioner/el16FdtlssUCWMkeZfO2CMg3",
                                      "type": "Practitioner",
                                      "display": "Coordinator Phoenix, RN"
                                  },
                                  "url": "coordinator"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                                              "code": "50",
                                              "display": "Transplanted"
                                          }
                                      ],
                                      "text": "Transplanted"
                                  },
                                  "url": "phase"
                              },
                              {
                                  "valueString": "Active Follow-up",
                                  "url": "status"
                              },
                              {
                                  "valueDate": "2025-10-02",
                                  "url": "effective"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                      },
                      {
                          "valueDate": "2025-08-05",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                      },
                      {
                          "valuePeriod": {
                              "start": "2025-09-24",
                              "end": "2025-10-02"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
                      },
                      {
                          "valueString": "St. Michael's Hospital (Toronto, ON)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                      }
                  ],
                  "status": "active",
                  "type": [
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.726668",
                                  "code": "49",
                                  "display": "Transplant"
                              },
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.726668.130",
                                  "code": "4",
                                  "display": "Transplant"
                              }
                          ],
                          "text": "Transplant"
                      }
                  ],
                  "patient": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "type": "Patient",
                      "display": "SMHOne, RecipientOne"
                  },
                  "period": {
                      "start": "2025-08-05"
                  },
                  "team": [
                      {
                          "reference": "CareTeam/e6YjTLfVn73.lWbazIyc1OfLJ1ja9HdjQ.4m.riSPdvw3",
                          "type": "CareTeam",
                          "display": "Care Team"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "11",
                              "display": "Height"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "tqIZ.9Xom.NjB5dsfS9O.Ow0",
                              "display": "Height"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "8302-2"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8302-2",
                              "display": "Body height"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Height"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 154,
                      "unit": "cm",
                      "system": "http://unitsofmeasure.org",
                      "code": "cm"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "14",
                              "display": "Weight"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "t5Cn9FBZGCKy2gCB5bnkZtA0",
                              "display": "Weight"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "29463-7"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "29463-7",
                              "display": "Body weight"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "3141-9",
                              "display": "Body weight Measured"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Weight"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 56,
                      "unit": "kg",
                      "system": "http://unitsofmeasure.org",
                      "code": "kg"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
            "resource": {
                "resourceType": "Observation",
                "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
                "extension": [
                    {
                        "valueIdentifier": {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                            "value": "395"
                        },
                        "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                    }
                ],
                "status": "final",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                "code": "vital-signs",
                                "display": "Vital Signs"
                            }
                        ],
                        "text": "Vital Signs"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                            "code": "14",
                            "display": "Weight"
                        },
                        {
                            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                            "code": "t5Cn9FBZGCKy2gCB5bnkZtA0",
                            "display": "Weight"
                        },
                        {
                            "system": "urn:oid:1.2.246.537.6.96",
                            "code": "29463-7"
                        },
                        {
                            "system": "http://loinc.org",
                            "code": "29463-7",
                            "display": "Body weight"
                        },
                        {
                            "system": "http://loinc.org",
                            "code": "3141-9",
                            "display": "Body weight Measured"
                        },
                        {
                            "system": "http://loinc.org",
                            "code": "8716-3",
                            "display": "Vital signs"
                        }
                    ],
                    "text": "Weight"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "encounter": {
                    "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                    "identifier": {
                        "use": "usual",
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                        "value": "10000043660"
                    },
                    "display": "Treatment"
                },
                "effectiveDateTime": "2024-10-02T14:46:00Z",
                "issued": "2025-08-06T02:47:23Z",
                "performer": [
                    {
                        "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                        "display": "Sarah Chung"
                    }
                ],
                "valueQuantity": {
                    "value": 56,
                    "unit": "kg",
                    "system": "http://unitsofmeasure.org",
                    "code": "kg"
                }
            },
            "search": {
                "mode": "match"
            }
        }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eeQwI6dztGI3giM225fSFdxv40GCiATH0tSWVuRPNCNc3",
                          "display": "Hepatitis B Core Antibody"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "13952-7",
                              "display": "Hepatitis B virus core Ab [Presence] in Serum or Plasma by Immunoassay"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551494"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "13952-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis B virus core Ab:ACnc:Pt:Ser:Ord:EIA"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV18"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551494",
                              "display": "Hepatitis B Core Total (IgG+IgM) Antibody"
                          }
                      ],
                      "text": "Hepatitis B Core Total (IgG+IgM) Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:46:00Z",
                  "issued": "2025-08-20T18:49:06Z",
                  "valueString": "Reactive",
                  "interpretation": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation",
                                  "code": "A",
                                  "display": "Abnormal"
                              }
                          ],
                          "text": "Abnormal"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/ejRQHev1n95WqzM2rB3jFHg3",
                      "display": "Specimen 25S-232C0004"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezQyHkgeitIjgCmRY7LkbjTamKWFjE.Cc.US-.Ad.767lPmKWnvRFS1.f3rllVv4J3",
              "basedOn": [
                {
                  "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
                  "display": "Creatinine"
                }
              ],
              "status": "final",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                      "code": "laboratory",
                      "display": "Laboratory"
                    }
                  ],
                  "text": "Laboratory"
                },
                {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
                      "code": "Lab",
                      "display": "Lab"
                    }
                  ],
                  "text": "Lab"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
                    "code": "CRV"
                  },
                  {
                    "system": "http://loinc.org",
                    "code": "14682-9",
                    "display": "Creatinine [Moles/volume] in Serum or Plasma"
                  },
                  
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
                    "code": "1526296"
                  },
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
                    "code": "1526296",
                    "display": "Creatinine"
                  }
                ],
                "text": "Creatinine"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "TestOne, VirologyOneWaitlist Kingthree"
              },
              "encounter": {
                "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
                "identifier": {
                  "use": "usual",
                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
                  "value": "200239102"
                },
                "display": "Appointment"
              },
              "effectiveDateTime": "2024-09-16T20:15:00Z",
              "issued": "2024-09-18T13:56:28Z",
              "valueQuantity": {
                "value": 50,
                "unit": "umol/L",
                "system": "http://unitsofmeasure.org",
                "code": "umol/L"
              },
              "specimen": {
                "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
                "display": "Specimen 24SJC-260Y0005"
              },
              "referenceRange": [
                {
                  "low": {
                    "value": 49,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "high": {
                    "value": 90,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "text": "49 - 90 umol/L"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "PABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "MABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "NABSN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "890-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1631699"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Blood group antibody screen:PrThr:Pt:Ser/Plas:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1631699",
                              "display": "Antibody Screen"
                          }
                      ],
                      "text": "Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueQuantity": {
                      "value": 1234556
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "note": [
                      {
                          "text": "Previously Final Verified Results Added"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071384"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22244-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071384",
                              "display": "Cytomegalovirus IgG CLIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3"
                }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
              "resource": {
                "resourceType": "Observation",
                "id": "eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
                "basedOn": [
                  {
                    "reference": "ServiceRequest/ewg.SQoTDaIplJv-4B5y4ba.Xsc8d4wW83Z6LRk3nksI3",
                    "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                  }
                ],
                "status": "final",
                "category": [
                  {
                    "coding": [
                      {
                        "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                        "code": "laboratory",
                        "display": "Laboratory"
                      }
                    ],
                    "text": "Laboratory"
                  },
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                        "code": "Microbiology",
                        "display": "Microbiology"
                      }
                    ],
                    "text": "Microbiology"
                  }
                ],
                "code": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
                      "code": "21594-7"
                    },
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                      "code": "12822",
                      "display": "Varicella-zoster virus antibody OLIS"
                    }
                  ],
                  "text": "Varicella-zoster virus antibody OLIS"
                },
                "subject": {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                },
                "encounter": {
                  "reference": "Encounter/eaIzbITSKPAVKHOe8sOT1Net2NHD3VpZmA-0HYKR27yQ3",
                  "identifier": {
                    "use": "usual",
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                    "value": "10000112148"
                  },
                  "display": "Orders Only"
                },
                "effectiveDateTime": "2025-10-21T01:41:00Z",
                "issued": "2025-10-21T01:46:43Z",
                "valueString": "Nonreactive",
                "specimen": {
                  "reference": "Specimen/eErTiRuXFLOYu-PFkedf-ViVIZM5sFzHLSyIq24ySAwU3",
                  "display": "Specimen"
                }
              },
              "search": {
                "mode": "match"
              }
            },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071385"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30325-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071385",
                              "display": "Cytomegalovirus IgM EIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071386"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071386",
                              "display": "Epstein Barr Virus VCA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "7883-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "EPSTEIN BARR VIRUS NUCLEAR AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071387"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071387",
                              "display": "Epstein Barr Virus EBNA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus EBNA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071388"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071388",
                              "display": "Epstein Barr Virus VCA IgM MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071400"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16128-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS C VIRUS AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071400",
                              "display": "Hepatitis C Antibody"
                          }
                      ],
                      "text": "Hepatitis C Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071407"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12263-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV 1+2 Ab+Ag:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071407",
                              "display": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                          }
                      ],
                      "text": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071408"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16982-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HTLV 1+2 Ab:ACnc:Pt:Ser:Ord:IB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071408",
                              "display": "HTLV I/II Antibody Screen"
                          }
                      ],
                      "text": "HTLV I/II Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071411"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20479-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071411",
                              "display": "Measles IgG MFI"
                          }
                      ],
                      "text": "Measles IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071412"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21503-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071412",
                              "display": "Measles IgM MFI"
                          }
                      ],
                      "text": "Measles IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071424"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "25514-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071424",
                              "display": "Rubella IgG EIA"
                          }
                      ],
                      "text": "Rubella IgG EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071425"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "31616-6"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071425",
                              "display": "Rubella IgM EIA"
                          }
                      ],
                      "text": "Rubella IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071429"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22587-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:PrThr:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071429",
                              "display": "Syphilis Antibody screen"
                          }
                      ],
                      "text": "Syphilis Antibody screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071430"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "41122-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TREPONEMA PALLIDUM AB:ACNC:PT:XXX:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071430",
                              "display": "Syphilis RPR Quantitation"
                          }
                      ],
                      "text": "Syphilis RPR Quantitation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071431"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24312-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:Aggl"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071431",
                              "display": "Syphilis TP.PA"
                          }
                      ],
                      "text": "Syphilis TP.PA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071433"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22580-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071433",
                              "display": "Toxoplasmosis IgG CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071434"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "8040-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGM:ACNC:PT:SER:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071434",
                              "display": "Toxoplasmosis IgM CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgM CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071436"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21597-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071436",
                              "display": "Varicella-Zoster IgM"
                          }
                      ],
                      "text": "Varicella-Zoster IgM"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071444"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071444",
                              "display": "CMV Interpretation"
                          }
                      ],
                      "text": "CMV Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "No evidence of past exposure; indicates susceptibility.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071445"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071445",
                              "display": "CMV Note"
                          }
                      ],
                      "text": "CMV Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.\r\n",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071448"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071448",
                              "display": "Epstein Barr Virus Interpretation"
                          }
                      ],
                      "text": "Epstein Barr Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "No laboratory evidence of recent/past EBV infection.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071457"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071457",
                              "display": "Hepatitis C Interpretation"
                          }
                      ],
                      "text": "Hepatitis C Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "No evidence of HCV Antibody",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071461"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13032-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV final interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071461",
                              "display": "HIV Final Interpretation"
                          }
                      ],
                      "text": "HIV Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Non-reactive for HIV-1 p24 antigen and HIV-1/HIV-2 antibodies.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071462"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071462",
                              "display": "HIV Final Note"
                          }
                      ],
                      "text": "HIV Final Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "For high-risk exposures, repeat HIV testing at 3 weeks and, if negative, at 6 weeks after possible exposure, or on presentation of symptoms compatible with acute HIV infection.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071463"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13563-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071463",
                              "display": "HTLV I/II Final Interpretation"
                          }
                      ],
                      "text": "HTLV I/II Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "No HTLV I / II antibodies detected.",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071465"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071465",
                              "display": "Measles Interpretation"
                          }
                      ],
                      "text": "Measles Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "No serological evidence of recent or past Measles infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071466"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071466",
                              "display": "Measles Note"
                          }
                      ],
                      "text": "Measles Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071467"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10842-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION:IMP:Pt:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071467",
                              "display": "Mumps Interpretation"
                          }
                      ],
                      "text": "Mumps Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "No evidence of immunity (indicates susceptibility)",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071468"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071468",
                              "display": "Mumps Note"
                          }
                      ],
                      "text": "Mumps Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient. For assistance regarding the interpretation of specific IgG and IgM serology refer to Public Health Labstract Diagnostic Interpretation of Viral Specific IgM and IgG  Serology Lab-SD-044 at: http:www.publichealthontario.ca/Labstracts",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071473"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071473",
                              "display": "Rubella Interpretation"
                          }
                      ],
                      "text": "Rubella Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "No serological evidence of recent or past Rubella infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071474"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071474",
                              "display": "Rubella Note"
                          }
                      ],
                      "text": "Rubella Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071477"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071477",
                              "display": "Syphilis Serology Interpretation"
                          }
                      ],
                      "text": "Syphilis Serology Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No serological evidence of current or past infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071478"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071478",
                              "display": "Syphilis Serology Note"
                          }
                      ],
                      "text": "Syphilis Serology Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No confirmatory testing is performed on samples with non-reactive screening results. If not done already, repeat syphilis serology testing is recommended in 4 weeks for individuals suspected of syphilis infection or re-infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071479"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071479",
                              "display": "Toxoplasmosis Interpretation"
                          }
                      ],
                      "text": "Toxoplasmosis Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "No serological evidence of recent or past Toxoplasma gondii infection.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071480"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071480",
                              "display": "Toxoplasmosis Note"
                          }
                      ],
                      "text": "Toxoplasmosis Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Results should be interpreted in conjunction with clinical history, signs and symptoms.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071481"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071481",
                              "display": "Varicella-Zoster Interpretation"
                          }
                      ],
                      "text": "Varicella-Zoster Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "No serological evidence of recent or past Varicella-Zoster infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071482"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071482",
                              "display": "Varicella-Zoster Note"
                          }
                      ],
                      "text": "Varicella-Zoster Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22415-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071488"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MUMPS VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071488",
                              "display": "Mumps IgG MFI"
                          }
                      ],
                      "text": "Mumps IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123120003"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "19162-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123120003",
                              "display": "Varicella-Zoster IgG"
                          }
                      ],
                      "text": "Varicella-Zoster IgG"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1230300203"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13050-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis C virus Ab supplemental:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1230300203",
                              "display": "Hepatitis C Antibody Supplemental"
                          }
                      ],
                      "text": "Hepatitis C Antibody Supplemental"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "note": [
                      {
                          "text": "HCV RNA reflex testing is performed on: \r\n1) First-time reactive HCV antibody results to determine active/current infection.\r\n2) Patients with a previous Positive HCV antibody result with no history of HCV RNA testing\r\n3) Inconclusive HCV antibody results. \r\nFor other HCV RNA requests, submit a serum specimen for HCV RNA testing Following PHOL recommended guidelines found at publichealthontario.ca/HepCRNA."
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200001"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5393-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:IF"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200001",
                              "display": "Syphilis FTA Abs"
                          }
                      ],
                      "text": "Syphilis FTA Abs"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200002"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20507-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Reagin Ab:ACnc:Pt:Ser:Ord:RPR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200002",
                              "display": "Syphilis RPR Screen"
                          }
                      ],
                      "text": "Syphilis RPR Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701021"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17850-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 1 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701021",
                              "display": "Herpes Simplex Virus 1 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 1 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701022"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17851-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 2 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701022",
                              "display": "Herpes Simplex Virus 2 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 2 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701023"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701023",
                              "display": "Herpes Simplex Virus Interpretation"
                          }
                      ],
                      "text": "Herpes Simplex Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Herpes Simplex Virus 1 IgG and Herpes Simplex Virus 2 IgG antibodies not detected.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701024"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701024",
                              "display": "Herpes Simplex Virus Note"
                          }
                      ],
                      "text": "Herpes Simplex Virus Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Note: Early antiviral therapy following acute HSV infection may result in a blunted or delayed IgG antibody response. The absence of detectable HSV IgG antibodies may not rule out recent HSV infection. If a recent HSV infection is suspected and has not been confirmed by virus detection (e.g. culture), a follow-up blood sample should be submitted 3-6 months post-exposure to detect the late development of HSV antibodies. Diagnosis of HSV infection is best performed by culture of the virus from vesicular fluid or lesion scrapings.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          }
      ]
  ],
  "sectionsChecked": [],
  "episode_id": "eBoTe.FFtYzhCAhiO-M2TbA3"
};
const uhnDataMock3 = {
  "patient": {
    "resource": {
      "resourceType": "Patient",
      "id": "ehk6OQzO8ppvDFfY0u4VhGg3",
      "extension": [
        {
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.10.698084.130.657370.258",
                "code": "M",
                "display": "M"
              }
            ],
            "text": "Male"
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
        },
        {
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "urn:oid:1.2.840.114350.1.13.630.3.7.10.698084.130.657370.258",
                "code": "M",
                "display": "M"
              }
            ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/sex-for-clinical-use"
        },
        {
          "extension": [
            {
              "valueCoding": {
                "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                "code": "UNK",
                "display": "Unknown"
              },
              "url": "ombCategory"
            },
            {
              "valueString": "Unknown",
              "url": "text"
            }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
        },
        {
          "extension": [
            {
              "valueString": "Unknown",
              "url": "text"
            }
          ],
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
        },
        {
          "valueCode": "248153007",
          "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
        },
        {
          "valueCodeableConcept": {
            "coding": [
              {
                "system": "http://loinc.org",
                "code": "LA29518-0",
                "display": "he/him/his/his/himself"
              }
            ]
          },
          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
        }
      ],
      "identifier": [
        {
          "use": "usual",
          "type": {
            "text": "CEID"
          },
          "system": "urn:oid:1.2.840.114350.1.13.630.3.7.3.688884.100",
          "value": "UHMPGC37DB2CRNT"
        },
        {
          "use": "usual",
          "type": {
            "text": "EPIC"
          },
          "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.0",
          "value": "E14206"
        },
        {
          "use": "usual",
          "type": {
            "text": "EXTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.698084",
          "value": "Z14255"
        },
        {
          "use": "usual",
          "type": {
            "text": "FHIR"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
          "value": "T4Ekzs0t1YucWAQWVuDiZYa5o5l534y59Wv.h1zL0tcYB"
        },
        {
          "use": "usual",
          "type": {
            "text": "FHIR STU3"
          },
          "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
          "value": "ehk6OQzO8ppvDFfY0u4VhGg3"
        },
        {
          "use": "usual",
          "type": {
            "text": "INTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.698084",
          "value": "    Z14255"
        },
        {
          "use": "usual",
          "type": {
            "text": "EPI"
          },
          "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.14",
          "value": "100005953"
        },
        {
          "use": "usual",
          "type": {
            "text": "TGLNDonor"
          },
          "system": "urn:oid:1.2.840.114350.1.13.630.3.7.5.737384.1650000002",
          "value": "129464"
        },
        {
          "use": "usual",
          "type": {
            "text": "WPRINTERNAL"
          },
          "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.878082",
          "value": "5598"
        },
        {
          "use": "usual",
          "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
          "value": "5881482029"
        }
      ],
      "active": true,
      "name": [
        {
          "use": "official",
          "text": "One UHN OATSdonor",
          "family": "OATSdonor",
          "given": [
            "One",
            "UHN"
          ]
        },
        {
          "use": "usual",
          "text": "One UHN OATSdonor",
          "family": "OATSdonor",
          "given": [
            "One",
            "UHN"
          ]
        },
        {
          "use": "old",
          "text": "OATSDONOR,ONE",
          "family": "Oatsdonor",
          "given": [
            "One"
          ]
        }
      ],
      "telecom": [
        {
          "system": "phone",
          "value": "+1 416-875-9654",
          "use": "home",
          "rank": 1
        },
        {
          "system": "phone",
          "value": "+1 437-485-1256",
          "use": "mobile",
          "rank": 2
        },
        {
          "system": "email",
          "value": "one.oatsdonor@me.com",
          "rank": 1
        }
      ],
      "gender": "M",
      "birthDate": "2004-01-21",
      "deceasedBoolean": false,
      "address": [
        {
          "use": "home",
          "text": "321 Anywhere Street\r\nBarbados",
          "line": [
            "321 Anywhere Street"
          ],
          "country": "BB",
          "period": {
            "start": "2026-04-29"
          }
        },
        {
          "use": "old",
          "text": "321 Anywhere Street\r\nToronto ON M5A 2C2\r\nCanada",
          "line": [
            "321 Anywhere Street"
          ],
          "city": "Toronto",
          "state": "ON",
          "postalCode": "M5A 2C2",
          "country": "CA",
          "period": {
            "start": "2026-04-08",
            "end": "2026-04-29"
          }
        }
      ],
      "communication": [
        {
          "extension": [
            {
              "extension": [
                {
                  "valueCoding": {
                    "system": "http://terminology.hl7.org/CodeSystem/v3-LanguageAbilityMode",
                    "code": "ESP",
                    "display": "Expressed spoken"
                  },
                  "url": "type"
                }
              ],
              "url": "http://hl7.org/fhir/StructureDefinition/patient-proficiency"
            }
          ],
          "language": {
            "coding": [
              {
                "system": "urn:ietf:bcp:47",
                "code": "en",
                "display": "English"
              }
            ],
            "text": "English"
          },
          "preferred": true,
          "_preferred": {
            "extension": [
              {
                "valueCoding": {
                  "system": "http://hl7.org/fhir/language-preference-type",
                  "code": "verbal",
                  "display": "verbal"
                },
                "url": "http://hl7.org/fhir/StructureDefinition/patient-preferenceType"
              }
            ]
          }
        }
      ],
      "managingOrganization": {
        "reference": "Organization/eMcbVZ0EE4K-bd39cda1-dQ3",
        "display": "UHN"
      }
    }
  },
  "entries": [
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
              "resource": {
                  "resourceType": "Coverage",
                  "id": "emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
                  "contained": [
                      {
                          "resourceType": "Organization",
                          "id": "org1",
                          "type": [
                              {
                                  "coding": [
                                      {
                                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.678671.120",
                                          "code": "3",
                                          "display": "Insurance Plan"
                                      }
                                  ],
                                  "text": "Insurance Plan"
                              }
                          ],
                          "name": "OHIP",
                          "contact": [
                              {
                                  "purpose": {
                                      "coding": [
                                          {
                                              "system": "http://terminology.hl7.org/CodeSystem/contactentity-type",
                                              "code": "BILL",
                                              "display": "Billing"
                                          }
                                      ]
                                  },
                                  "address": {
                                      "use": "billing",
                                      "line": [
                                          "EXEC TOWER  OSHAWA CENTRE",
                                          "419 KING ST WEST"
                                      ],
                                      "city": "Toronto",
                                      "state": "ON",
                                      "postalCode": "L1H 8L4",
                                      "country": "CA"
                                  }
                              }
                          ]
                      }
                  ],
                  "extension": [
                      {
                          "valueReference": {
                              "reference": "#org1"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/billing-organization"
                      }
                  ],
                  "identifier": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.678671",
                          "value": "1465"
                      },
                      {
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                                      "code": "MB",
                                      "display": "Member Number"
                                  }
                              ]
                          },
                          "value": "1234567890"
                      }
                  ],
                  "status": "active",
                  "subscriber": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "subscriberId": "1234567890",
                  "beneficiary": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "relationship": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.678671.305",
                              "code": "01",
                              "display": "Self"
                          },
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/subscriber-relationship",
                              "code": "self",
                              "display": "Self"
                          }
                      ],
                      "text": "Self"
                  },
                  "period": {
                      "start": "2013-03-31"
                  },
                  "payor": [
                      {
                          "reference": "Organization/edfM-VF1iMIWPWTWdwpoNdQ3",
                          "identifier": {
                              "use": "official",
                              "system": "http://open.epic.com/FHIR/StructureDefinition/payer-id",
                              "value": "10000"
                          },
                          "display": "OHIP"
                      }
                  ],
                  "class": [
                      {
                          "extension": [
                              {
                                  "valueIdentifier": {
                                      "use": "secondary",
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698080",
                                      "value": "1000001"
                                  },
                                  "url": "http://open.epic.com/FHIR/StructureDefinition/extension/epic-id"
                              }
                          ],
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/coverage-class",
                                      "code": "plan",
                                      "display": "Plan"
                                  }
                              ]
                          },
                          "value": "1000001",
                          "name": "OHIP"
                      }
                  ],
                  "order": 1
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
  ],
  "sectionsChecked": [],
  "episode_id": "eBoTe.FFtYzhCAhiO-M2TbA3"
};
const uhnDataMock2 = {
  "patient": {
      "resourceType": "Patient",
      "id": "eZ4Fxy8ToBxyhpU9iFBCBKA3",
      "extension": [
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.698084.130.657370.334219900",
                          "code": "male",
                          "display": "male"
                      }
                  ],
                  "text": "Male"
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/legal-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "http://hl7.org/fhir/gender-identity",
                          "code": "other",
                          "display": "other"
                      }
                  ],
                  "text": "Trans Woman"
              },
              "url": "http://hl7.org/fhir/StructureDefinition/patient-genderIdentity"
          },
          {
              "extension": [
                  {
                      "valueCoding": {
                          "system": "http://terminology.hl7.org/CodeSystem/v3-NullFlavor",
                          "code": "UNK",
                          "display": "Unknown"
                      },
                      "url": "ombCategory"
                  },
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-race"
          },
          {
              "extension": [
                  {
                      "valueString": "Unknown",
                      "url": "text"
                  }
              ],
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-ethnicity"
          },
          {
              "valueCode": "184115007",
              "url": "http://hl7.org/fhir/us/core/StructureDefinition/us-core-sex"
          },
          {
              "valueCodeableConcept": {
                  "coding": [
                      {
                          "system": "https://open.epic.com/FHIR/Epic/pronoun-set",
                          "code": "EP-PS-DO-NOT-USE-PRONOUNS",
                          "display": "do not use pronouns"
                      }
                  ]
              },
              "url": "http://open.epic.com/FHIR/StructureDefinition/extension/calculated-pronouns-to-use-for-text"
          }
      ],
      "identifier": [
          {
              "use": "usual",
              "type": {
                  "text": "EPIC"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.0",
              "value": "E3517"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EPI"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.14",
              "value": "900000811"
          },
          {
              "use": "usual",
              "type": {
                  "text": "EXTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-dstu2-fhir-id",
              "value": "TSEz66EdHpd1B2KJf9z7AfVZaMfqLagYbO2VwNdy1OngB"
          },
          {
              "use": "usual",
              "type": {
                  "text": "FHIR STU3"
              },
              "system": "http://open.epic.com/FHIR/StructureDefinition/patient-fhir-id",
              "value": "eZ4Fxy8ToBxyhpU9iFBCBKA3"
          },
          {
              "use": "usual",
              "type": {
                  "text": "INTERNAL"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698084",
              "value": "     Z3523"
          },
          {
              "use": "usual",
              "type": {
                  "text": "TGLNRecipient"
              },
              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.1650000006",
              "value": "67540"
          },
          {
              "use": "usual",
              "system": "https://open.epic.com/FHIR/StructureDefinition/PayerMemberId",
              "value": "1234567890"
          }
      ],
      "active": true,
      "name": [
          {
              "use": "official",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          },
          {
              "use": "usual",
              "text": "RecipientOne SMHOne",
              "family": "SMHOne",
              "given": [
                  "RecipientOne"
              ]
          }
      ],
      "telecom": [
          {
              "system": "phone",
              "value": "+1 416-360-4000",
              "use": "home"
          },
          {
              "system": "phone",
              "value": "+1 416-340-3666",
              "use": "work"
          },
          {
              "system": "phone",
              "value": "+1 416-285-3666",
              "use": "mobile"
          },
          {
              "system": "email",
              "value": "123@oats.ca",
              "rank": 1
          }
      ],
      "gender": "male",
      "birthDate": "1991-11-07",
      "deceasedBoolean": false,
      "address": [
          {
              "use": "home",
              "text": "465 Yonge St\r\nToronto TORONTO M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "district": "TORONTO",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-10-02"
              }
          },
          {
              "use": "old",
              "text": "465 Yonge St\r\nToronto M4Y 1X4\r\nCanada",
              "line": [
                  "465 Yonge St"
              ],
              "city": "Toronto",
              "state": "ON",
              "postalCode": "M4Y 1X4",
              "country": "CA",
              "period": {
                  "start": "2025-08-05",
                  "end": "2025-10-02"
              }
          }
      ],
      "managingOrganization": {
          "reference": "Organization/epl8pKYqH0a4Few804sH00Q3",
          "display": "UNITY SERVICE AREA"
      }
  },
  "entries": [
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Coverage/emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
              "resource": {
                  "resourceType": "Coverage",
                  "id": "emhPlfKo8G47e2Us700i22TZOql9PFZtf2Pz94OUjjQ03",
                  "contained": [
                      {
                          "resourceType": "Organization",
                          "id": "org1",
                          "type": [
                              {
                                  "coding": [
                                      {
                                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.678671.120",
                                          "code": "3",
                                          "display": "Insurance Plan"
                                      }
                                  ],
                                  "text": "Insurance Plan"
                              }
                          ],
                          "name": "OHIP",
                          "contact": [
                              {
                                  "purpose": {
                                      "coding": [
                                          {
                                              "system": "http://terminology.hl7.org/CodeSystem/contactentity-type",
                                              "code": "BILL",
                                              "display": "Billing"
                                          }
                                      ]
                                  },
                                  "address": {
                                      "use": "billing",
                                      "line": [
                                          "EXEC TOWER  OSHAWA CENTRE",
                                          "419 KING ST WEST"
                                      ],
                                      "city": "Toronto",
                                      "state": "ON",
                                      "postalCode": "L1H 8L4",
                                      "country": "CA"
                                  }
                              }
                          ]
                      }
                  ],
                  "extension": [
                      {
                          "valueReference": {
                              "reference": "#org1"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/billing-organization"
                      }
                  ],
                  "identifier": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.678671",
                          "value": "1465"
                      },
                      {
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                                      "code": "MB",
                                      "display": "Member Number"
                                  }
                              ]
                          },
                          "value": "1234567890"
                      }
                  ],
                  "status": "active",
                  "subscriber": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "subscriberId": "1234567890",
                  "beneficiary": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "relationship": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.678671.305",
                              "code": "01",
                              "display": "Self"
                          },
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/subscriber-relationship",
                              "code": "self",
                              "display": "Self"
                          }
                      ],
                      "text": "Self"
                  },
                  "period": {
                      "start": "2013-03-31"
                  },
                  "payor": [
                      {
                          "reference": "Organization/edfM-VF1iMIWPWTWdwpoNdQ3",
                          "identifier": {
                              "use": "official",
                              "system": "http://open.epic.com/FHIR/StructureDefinition/payer-id",
                              "value": "10000"
                          },
                          "display": "OHIP"
                      }
                  ],
                  "class": [
                      {
                          "extension": [
                              {
                                  "valueIdentifier": {
                                      "use": "secondary",
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.698080",
                                      "value": "1000001"
                                  },
                                  "url": "http://open.epic.com/FHIR/StructureDefinition/extension/epic-id"
                              }
                          ],
                          "type": {
                              "coding": [
                                  {
                                      "system": "http://terminology.hl7.org/CodeSystem/coverage-class",
                                      "code": "plan",
                                      "display": "Plan"
                                  }
                              ]
                          },
                          "value": "1000001",
                          "name": "OHIP"
                      }
                  ],
                  "order": 1
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "elDMk6vH3DhXdUaTg5SUXJwXtvmXFV7qP19LVRNLmkyg835ouDn6aT5w.V7XvGW-HGubK7BlUGOrB.oM3S0Prcg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#336",
                    "display": "OATS REFERRAL DECISION DECLINE REASON"
                  }
                ],
                "text": "OATS REFERRAL DECISION DECLINE REASON"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2024-11-06T21:05:22Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Patient does not meet referral criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
   
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eBQ2hevutR2qPSNe41N9ZN74nydvVZXobzDOm7h3IbnSzABLnJ7pYu8R9MWJ6pgB1qY0km6qFhJZ7NhJnKyu2Yg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#398",
                    "display": "OATS RECOVERY START"
                  }
                ],
                "text": "OATS RECOVERY START"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg",
                "display": "MayUpgradeTwoFour, ScriptEightySevenD"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/euwNx6uQyy3aQAne1I5KUUw3"
                }
              ],
              "issued": "2024-12-11T19:14:11Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-10-10T14:41:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fT6SpekJyJHjnYKBKiiFBjg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fT6SpekJyJHjnYKBKiiFBjg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16574",
                    "display": "OATS - REFERRAL CANCELLED REASON"
                  }
                ],
                "text": "OATS - REFERRAL CANCELLED REASON"
              },
              "subject": {
                "reference": "Patient/eoN4fz8OEXuw.slGH1SO2XQ3",
                "display": "SITFourthteen, SITFourthteen"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
              ],
              "issued": "2025-10-24T17:13:06Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient relocated"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgVk6SkJBJCzMJOw0GDud.g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fgVk6SkJBJCzMJOw0GDud.g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16539",
                    "display": "OATS - LIVING DONOR RECOVERY COMMENTS"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMMENTS"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Testing recovery details "
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fOk3JvQnmUhsc9nMaoxeOcQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fOk3JvQnmUhsc9nMaoxeOcQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16540",
                    "display": "OATS - LIVING DONOR RECOVERY COMPLETED"
                  }
                ],
                "text": "OATS - LIVING DONOR RECOVERY COMPLETED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKfPw--KbYC4NuauObvPlxw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fKfPw--KbYC4NuauObvPlxw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16542",
                    "display": "OATS - ORGAN SHIPPED"
                  }
                ],
                "text": "OATS - ORGAN SHIPPED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:37:12Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/faLXUefq0EQcaKWk5FuUv-Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "faLXUefq0EQcaKWk5FuUv-Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16569",
                    "display": "OATS - SHIPPED OUT OF PROVINCE"
                  }
                ],
                "text": "OATS - SHIPPED OUT OF PROVINCE"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXgKmOYsXSD0Y9rfxEyPBEA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fXgKmOYsXSD0Y9rfxEyPBEA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16571",
                    "display": "OATS - PERFUSION PUMP"
                  }
                ],
                "text": "OATS - PERFUSION PUMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fu4tYEvA48HaaIvI49TPWYQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fu4tYEvA48HaaIvI49TPWYQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16572",
                    "display": "OATS - PERFUSION DATE AND TIME"
                  }
                ],
                "text": "OATS - PERFUSION DATE AND TIME"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-06T14:19:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw.eFFHpMBrYMfuPKEVma-A4",
            "resource": {
              "resourceType": "Observation",
              "id": "fw.eFFHpMBrYMfuPKEVma-A4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16573",
                    "display": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
                  }
                ],
                "text": "OATS - ORGAN SUCCESSFULLY TRANSPLANTED"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-06T14:19:31Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fNEFwsvfbpROAIGPjn4X6LA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNEFwsvfbpROAIGPjn4X6LA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#400",
                    "display": "OATS CROSS CLAMP"
                  }
                ],
                "text": "OATS CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-09-25T17:53:18Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-09-22T17:51:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fP.al0N1Pg1QvD15OFVmyZA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fP.al0N1Pg1QvD15OFVmyZA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#114",
                    "display": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
                  }
                ],
                "text": "DONOR - DONOR FLUSH TIME END/CROSS CLAMP"
              },
              "subject": {
                "reference": "Patient/e6yYsC5fTKgIcRvhWqcHH8g3",
                "display": "LivingOne, SMHLDOne EMROne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/epspQsrXP6ZpFroOEL3g1kw3"
                }
              ],
              "issued": "2025-10-02T17:24:13Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-02T17:23:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fhb6S8X-Xaqo8XpI1XAsemg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fhb6S8X-Xaqo8XpI1XAsemg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#7928",
                    "display": "OATS - UNKNOWN GENDER"
                  }
                ],
                "text": "OATS - UNKNOWN GENDER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSix, SITSix SITMIDDLESIX"
              },
              "focus": [
                {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                }
              ],
              "issued": "2025-10-27T20:15:00Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Trans Woman"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eyoMRUjclNBbwhXQ598UPLZ3LV6i5b-cxDxTsW6XCjynyrM5vrJTTrKfDCY34GKyLw2O8Rn4ywxXs-Tu5.vnRxw3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#379",
                    "display": "OATS FAILURE CAUSE"
                  }
                ],
                "text": "OATS FAILURE CAUSE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Failure, Graft"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/efztqfGU03Gqvo01NlU5tOw3"
                }
              ],
              "issued": "2024-12-06T16:45:25Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "OTHER"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f8RoGoKpeGNWz1L2xAPLnKg4",
            "resource": {
              "resourceType": "Observation",
              "id": "f8RoGoKpeGNWz1L2xAPLnKg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16519",
                    "display": "OATS - LDCMVLAB"
                  }
                ],
                "text": "OATS - LDCMVLAB"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                  "display": "SITLDOne, SITLDOne"
                }
              ],
              "issued": "2025-10-16T15:43:20Z",
              "performer": [
                {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "PUBLIC HEALTH LABORATORY"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fimmZL1g-v932shUu4axPFw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fimmZL1g-v932shUu4axPFw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#403",
                    "display": "OATS LINKED RECIPIENT TGLN"
                  }
                ],
                "text": "OATS LINKED RECIPIENT TGLN"
              },
              "subject": {
                "reference": "Patient/e3rg0mjTOTi7wdQLUZ0kkyw3",
                "display": "SITLDOne, SITLDOne"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/en6mARfmq0F5hQzOiCBNPwA3"
                }
              ],
              "issued": "2025-10-27T20:00:48Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "68641"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSrGw3FZrFH2zVbrhV-eP2g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSrGw3FZrFH2zVbrhV-eP2g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#309",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Other"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fcZRyeFT99RbVk1VzmsCzBg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fcZRyeFT99RbVk1VzmsCzBg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#8089",
                    "display": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
                  }
                ],
                "text": "OATS FOLLOWUP SOURCE INFORMATION OTHER"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "testing f/u comment"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fGomxQtUjGJEya-3Xr-emCQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fGomxQtUjGJEya-3Xr-emCQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#314",
                    "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                  }
                ],
                "text": "OATS FOLLOWUP CLINIC VISIT DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fSgdUp9YF7xzfCcoyIEgJOw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fSgdUp9YF7xzfCcoyIEgJOw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#317",
                    "display": "OATS RETURN TO DIALYSIS DATE"
                  }
                ],
                "text": "OATS RETURN TO DIALYSIS DATE"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-27"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fkN6XBHLNAj8-F2U90OiZ7w4",
            "resource": {
              "resourceType": "Observation",
              "id": "fkN6XBHLNAj8-F2U90OiZ7w4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#329",
                    "display": "OATS FOLLOWUP - CREATININE UNKNOWN"
                  }
                ],
                "text": "OATS FOLLOWUP - CREATININE UNKNOWN"
              },
              "subject": {
                "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                "display": "SITSixupdate, SITSixUpdate SITMIDDLESIXupdate"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/e9ohqnnNLu8QTyi7Vl29JfA3"
                }
              ],
              "issued": "2025-10-27T20:42:01Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueBoolean": true
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fHIdwecqHGXKE4fk0tSYKuw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fHIdwecqHGXKE4fk0tSYKuw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16510",
                    "display": "OATS - LDHEPBCORE"
                  }
                ],
                "text": "OATS - LDHEPBCORE"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fzDkTD-1obxXqR5mA0Vyh8g4",
            "resource": {
              "resourceType": "Observation",
              "id": "fzDkTD-1obxXqR5mA0Vyh8g4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16558",
                    "display": "OATS - LDCMVINSTANT"
                  }
                ],
                "text": "OATS - LDCMVINSTANT"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2025-10-22T17:24:00Z"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fulpq4zpkgTvQEmrPLl0Bug4",
            "resource": {
              "resourceType": "Observation",
              "id": "fulpq4zpkgTvQEmrPLl0Bug4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16511",
                    "display": "OATS - LDHEPBSAB"
                  }
                ],
                "text": "OATS - LDHEPBSAB"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/f.KdXM9H-xk5PA7qfFeCxIQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "f.KdXM9H-xk5PA7qfFeCxIQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16512",
                    "display": "OATS - LDCMV"
                  }
                ],
                "text": "OATS - LDCMV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fNCoY7ON5v3jN3wbAhoY3tQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "fNCoY7ON5v3jN3wbAhoY3tQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16513",
                    "display": "OATS - LDHEPBSAG"
                  }
                ],
                "text": "OATS - LDHEPBSAG"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/ffaDats9QarIDNgygzKFQwQ4",
            "resource": {
              "resourceType": "Observation",
              "id": "ffaDats9QarIDNgygzKFQwQ4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16514",
                    "display": "OATS - LDHEPC"
                  }
                ],
                "text": "OATS - LDHEPC"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fppzCzpxRewghVKNVLrUQoA4",
            "resource": {
              "resourceType": "Observation",
              "id": "fppzCzpxRewghVKNVLrUQoA4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16515",
                    "display": "OATS - LDHIV"
                  }
                ],
                "text": "OATS - LDHIV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fIzbl-Qdo8qfYeGu2ExlsJw4",
            "resource": {
              "resourceType": "Observation",
              "id": "fIzbl-Qdo8qfYeGu2ExlsJw4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16516",
                    "display": "OATS - LDVDRL"
                  }
                ],
                "text": "OATS - LDVDRL"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Positive"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/frQpp0jBy-GJKPQc3KBaP4Q4",
            "resource": {
              "resourceType": "Observation",
              "id": "frQpp0jBy-GJKPQc3KBaP4Q4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16517",
                    "display": "OATS - LDEBV"
                  }
                ],
                "text": "OATS - LDEBV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Negative"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
            "link": [
              {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4"
              }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/fd4cy5DQo80TXwSgMuMNFHg4",
            "resource": {
              "resourceType": "Observation",
              "id": "fd4cy5DQo80TXwSgMuMNFHg4",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "TXP#16518",
                    "display": "OATS - WNV"
                  }
                ],
                "text": "OATS - WNV"
              },
              "subject": {
                "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                "display": "SITLDThree, SITLDThree"
              },
              "focus": [
                {
                  "reference": "Patient/eD6.wIJQ0Xs9-W6OXePNpaw3",
                  "display": "SITLDThree, SITLDThree"
                }
              ],
              "issued": "2025-10-24T17:24:47Z",
              "performer": [
                {
                  "reference": "Practitioner/egEp7NOpHL.5Z5bb4Yv9JAQ3",
                  "display": "PHOENIX, CLINIC ASSISTANT"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Not Tested"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {

            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e512AOvSC3zGPs1dz1bxr2D3aBjBi9iR2.x2OwWmIGEu-akVsVkB0rp9s2mhOqZUakc9mxb2O8EZfhTrNZdBzTA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#292",
                    "display": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT REL CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Age and functional capacity"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Cause of Kidney Disease"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Obesity"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Systemic Diseases"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Infections"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Pulmonary Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Cerebral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 10"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 11"
                  },
                  "valueString": "Gastrointestinal Disease"
                },
                {
                  "code": {
                    "text": "Line 12"
                  },
                  "valueString": "Liver Disease"
                },
                {
                  "code": {
                    "text": "Line 13"
                  },
                  "valueString": "Genitourinary Disease"
                },
                {
                  "code": {
                    "text": "Line 14"
                  },
                  "valueString": "Hematologic Disorders"
                },
                {
                  "code": {
                    "text": "Line 15"
                  },
                  "valueString": "Hyperparathyroidism"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "edB41AO1moSG0eIEmOJPz0DFWaiAOOyOApcHvu5C7DPKgv.Y2jz2vgAdBWXwhGee0NNphXS2CvaWnTO83IOa8jA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#291",
                    "display": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT ABS CONTRAINDICATIONS"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Comorbidities"
                },
                {
                  "code": {
                    "text": "Line 2"
                  },
                  "valueString": "Consent"
                },
                {
                  "code": {
                    "text": "Line 3"
                  },
                  "valueString": "Post-Transplant Care"
                },
                {
                  "code": {
                    "text": "Line 4"
                  },
                  "valueString": "Psychosocial Considerations"
                },
                {
                  "code": {
                    "text": "Line 5"
                  },
                  "valueString": "Malignancy"
                },
                {
                  "code": {
                    "text": "Line 6"
                  },
                  "valueString": "Pulmoary Disease"
                },
                {
                  "code": {
                    "text": "Line 7"
                  },
                  "valueString": "Cardiac Disease"
                },
                {
                  "code": {
                    "text": "Line 8"
                  },
                  "valueString": "Peripheral Vascular Disease"
                },
                {
                  "code": {
                    "text": "Line 9"
                  },
                  "valueString": "Gastrointestinal Disease"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e58WVNM0jb629nEMoRQLKgz0zLIo-u6pNIPq6t5dqF5.tU8JjuTdwkXoCmZ089TPENJmYfO7lxv1bdRS7zi9kkg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#327",
                    "display": "OATS - FURTHER TESTING REQUIRED OTHER"
                  }
                ],
                "text": "OATS - FURTHER TESTING REQUIRED OTHER"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "This is an other field for medical assessment decision reason."
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezOI4wA1544vR-YyamuQlmnpGwDvcz4MCrMNwby-sCnsDQkUu4odZTTqT3anAZLKH913VsMaE1HHqNokgis.fAQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#289",
                    "display": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT NOT ELIGIBLE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "Kumar, Ram_Update"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/eh55rvilfnQJ.b5vLlatESw3"
                }
              ],
              "issued": "2024-11-29T20:21:50Z",
              "performer": [
                {
                  "reference": "Practitioner/evGB5mMzYec-cCjoOzypCYg3",
                  "display": "PHOENIX, COORDINATOR"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient does not meet listing criteria"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eAveF-aMGBJcv7OH3nC3SgXg7VbM2er2OVDw.Q33Q-wiWjjHNfppYpzVs0327-IpjcZH0qNrVMXFF.IDJSD0tKg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#283",
                    "display": "OATS - DELAY END DATE"
                  }
                ],
                "text": "OATS - DELAY END DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-06"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
 
            "fullUrl": "https://epicintnp.stjoes.ca/Interconnect-FHIR-TST/api/FHIR/R4/Observation/eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
            "resource": {
              "resourceType": "Observation",
              "id": "eWg3JhB-KqjIeXeJEUvFp3l3toZtuC-giMFccaguGNELDJ5wff7IOL.AEdb.F1F5GnTnqEYSy5EXZhVBXFjyOCA3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#282",
                    "display": "OATS - DELAY START DATE"
                  }
                ],
                "text": "OATS - DELAY START DATE"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueDateTime": "2024-11-05"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "eEY6QUFLjk.6utt6AMxpFeHPwE8Bx4J1IwK9S86MwFKM5u.OBqzcgpMSlWBS2BXsuuQJifS53BWrPMVUr-OBgNg3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#288",
                    "display": "OATS - MEDICAL ASSESSMENT CANCELLED"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT CANCELLED"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Recipient Death Related to Organ Failure"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
  
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "e3zPGgVwXGU9ZJmm32I24--RP5WAZuhtlxig4bc1CmG.qrUoScgpcfp6d22OgQ.KEfxSpNN4bNRchRsQO6Hy0VQ3",
              "status": "unknown",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                    }
                  ],
                  "text": "SmartData"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.727688",
                    "code": "TXP#290",
                    "display": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
                  }
                ],
                "text": "OATS - MEDICAL ASSESSMENT FURTHER TESTING"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "MayUpgradeTwoFour, ScriptEightySevenR"
              },
              "focus": [
                {
                  "reference": "EpisodeOfCare/edfpfWCdR3i3qupf9sBzIVA3"
                }
              ],
              "issued": "2024-11-06T21:12:39Z",
              "performer": [
                {
                  "reference": "Practitioner/eaVD9PYCobA5BsWiQclQp-A3",
                  "display": "GONZALES, ALVIN"
                }
              ],
              "component": [
                {
                  "code": {
                    "text": "Line 1"
                  },
                  "valueString": "Down staging for HCC"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fwzFV6yBHYlxXobiHrZHxtw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7924",
                              "display": "OATS INTEGRATION - ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
            "resource": {
                "resourceType": "Observation",
                "id": "fwzFV6yBHYlxXobiHrZHxtw4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "UHN#3842",
                            "display": "OATS INTEGRATION - ETHNICITY"
                        }
                    ],
                    "text": "OATS INTEGRATION - ETHNICITY"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
                        "display": "SMHOne, RecipientOne"
                    }
                ],
                "issued": "2025-10-10T17:45:05Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                    {
                        "code": {
                            "text": "Line 1"
                        },
                        "valueString": "Accident related to treatment"
                    }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
        {
          "link": [
              {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4"
              }
          ],
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fwzFV6yBHYlxXobiHrZHxtw4",
          "resource": {
              "resourceType": "Observation",
              "id": "fwzFV6yBHYlxXobiHrZHxtw4",
              "status": "unknown",
              "category": [
                  {
                      "coding": [
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                              "code": "smartdata",
                              "display": "SmartData"
                          }
                      ],
                      "text": "SmartData"
                  }
              ],
              "code": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                          "code": "UHN#4132",
                          "display": "OATS INTEGRATION - ETHNICITY"
                      }
                  ],
                  "text": "OATS INTEGRATION - ETHNICITY"
              },
              "subject": {
                  "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "SMHOne, RecipientOne"
              },
              "focus": [
                  {
                      "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
                      "display": "SMHOne, RecipientOne"
                  }
              ],
              "issued": "2025-10-10T17:45:05Z",
              "performer": [
                  {
                      "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                      "display": "PHOENIX, COORDINATOR"
                  }
              ],
              "component": [
                  {
                      "code": {
                          "text": "Line 1"
                      },
                      "valueString": "Accident related to treatment"
                  }
              ]
          },
          "search": {
              "mode": "match"
          }
      },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fI4wqWREJVMOVc3ybaeR5hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fI4wqWREJVMOVc3ybaeR5hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7925",
                              "display": "OATS INTEGRATION - OTHER ETHNICITY"
                          }
                      ],
                      "text": "OATS INTEGRATION - OTHER ETHNICITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other eth"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient to be Listed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIShZ3BsZUb8xu.XdBOCbwQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIShZ3BsZUb8xu.XdBOCbwQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fUVgmmS0QIEoyT-53X7GxRQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fUVgmmS0QIEoyT-53X7GxRQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7928",
                              "display": "OATS - UNKNOWN GENDER"
                          }
                      ],
                      "text": "OATS - UNKNOWN GENDER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-10-10T17:45:05Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "testing other gender"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#8091",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgBfEfOG6EFBRskvJjZV2bw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7929",
                              "display": "OATS ABO BLOOD TYPE"
                          }
                      ],
                      "text": "OATS ABO BLOOD TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AB"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgBfEfOG6EFBRskvJjZV2bw4",
            "resource": {
                "resourceType": "Observation",
                "id": "fgBfEfOG6EFBRskvJjZV2bw4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "UHN#3829",
                            "display": "EXCEPTIONAL DISTRIBUTION REASON(S)"
                        }
                    ],
                    "text": "OATS ABO BLOOD TYPE"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                        "display": "SMHOne, RecipientOne"
                    }
                ],
                "issued": "2025-08-06T02:57:09Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                  {
                    "code": {
                      "text": "Line 1"
                    },
                    "valueString": "Hep B Core +"
                  },
                  {
                    "code": {
                      "text": "Line 2"
                    },
                    "valueString": "IRD Known sex history risk"
                  },
                  {
                    "code": {
                      "text": "Line 3"
                    },
                    "valueString": "Travel to/lived in history with risk for"
                  },
                  {
                    "code": {
                      "text": "Line 4"
                    },
                    "valueString": "IRD Incarceration >72 consecutive hours in last 3 months"
                  }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fbNY2qVwHTsoHow5DY5LKgw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fbNY2qVwHTsoHow5DY5LKgw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7930",
                              "display": "OATS ABO RH FACTOR"
                          }
                      ],
                      "text": "OATS ABO RH FACTOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                          "display": "SMHOne, RecipientOne"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Positive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#334",
                              "display": "OATS REFERRAL DECISION"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Referral Accepted"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
            "resource": {
                "resourceType": "Observation",
                "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "TXP#334",
                            "display": "OATS REFERRAL DECISION"
                        }
                    ],
                    "text": "OATS REFERRAL DECISION"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                    }
                ],
                "issued": "2025-08-19T14:54:38Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                    {
                        "code": {
                            "text": "Line 1"
                        },
                        "valueString": "Referral Accepted"
                    }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
        {
            "link": [
                {
                    "relation": "self",
                    "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                }
            ],
            "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
            "resource": {
                "resourceType": "Observation",
                "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                "status": "unknown",
                "category": [
                    {
                        "coding": [
                            {
                                "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                "code": "smartdata",
                                "display": "SmartData"
                            }
                        ],
                        "text": "SmartData"
                    }
                ],
                "code": {
                    "coding": [
                        {
                            "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                            "code": "UHN#4112",
                            "display": "OATS REFERRAL DECISION"
                        }
                    ],
                    "text": "OATS REFERRAL DECISION"
                },
                "subject": {
                    "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                    "display": "SMHOne, RecipientOne"
                },
                "focus": [
                    {
                        "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                    }
                ],
                "issued": "2025-08-19T14:54:38Z",
                "performer": [
                    {
                        "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                        "display": "PHOENIX, COORDINATOR"
                    }
                ],
                "component": [
                    {
                        "code": {
                            "text": "Line 1"
                        },
                        "valueString": "Referral Accepted Test"
                    }
                ]
            },
            "search": {
                "mode": "match"
            }
        },
        {
          "link": [
              {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
              }
          ],
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
          "resource": {
              "resourceType": "Observation",
              "id": "fqYHEIsMGTeS0j5NQiKddnA4",
              "status": "unknown",
              "category": [
                  {
                      "coding": [
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                              "code": "smartdata",
                              "display": "SmartData"
                          }
                      ],
                      "text": "SmartData"
                  }
              ],
              "code": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                          "code": "SK#7975",
                          "display": "UHN TXP OATS REFERRAL DECISION DATE"
                      }
                  ],
                  "text": "OATS REFERRAL DECISION"
              },
              "subject": {
                  "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "SMHOne, RecipientOne"
              },
              "focus": [
                  {
                      "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "issued": "2025-08-19T14:54:38Z",
              "performer": [
                  {
                      "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                      "display": "PHOENIX, COORDINATOR"
                  }
              ],
              "component": [
                  {
                      "code": {
                          "text": "Line 1"
                      },
                     "valueDateTime": "2018-02-23"
                  }
              ]
          },
          "search": {
              "mode": "match"
          }
      },
      {
        "link": [
            {
                "relation": "self",
                "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
            }
        ],
        "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
        "resource": {
            "resourceType": "Observation",
            "id": "fqYHEIsMGTeS0j5NQiKddnA4",
            "status": "unknown",
            "category": [
                {
                    "coding": [
                        {
                            "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                            "code": "smartdata",
                            "display": "SmartData"
                        }
                    ],
                    "text": "SmartData"
                }
            ],
            "code": {
                "coding": [
                    {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                        "code": "UHN#1652",
                        "display": "UHN TXP OATS REFERRAL DECISION DATE"
                    }
                ],
                "text": "OATS REFERRAL DECISION"
            },
            "subject": {
                "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "SMHOne, RecipientOne"
            },
            "focus": [
                {
                    "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                }
            ],
            "issued": "2025-08-19T14:54:38Z",
            "performer": [
                {
                    "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                    "display": "PHOENIX, COORDINATOR"
                }
            ],
            "component": [
                {
                    "code": {
                        "text": "Line 1"
                    },
                   "valueString": "Double/right side preferred"
                }
            ]
        },
        "search": {
            "mode": "match"
        }
    },
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                      "code": "UHN#4055",
                      "display": "UHN TXP OATS DONOR RELATIONSHIP TO RECIPIENT"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
            {
              "code": {
                "text": "Line 1"
              },
              "valueCodeableConcept": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.798271.315",
                    "code": "165010",
                    "display": "UNRELATED"
                  }
                ],
                "text": "UNRELATED"
              }
            }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                    "code": "SK#8292",
                    "display": "UHN TXP OATS PRIMARY DIAGNOSIS"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
          {
            "code": {
              "text": "Line 1"
            },
            "valueCodeableConcept": {
              "coding": [
                {
                  "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.798271.1505",
                  "code": "3006",
                  "display": "Focal Glomerular Sclerosis (Focal Segmental - FSG)"
                }
              ],
              "text": "Focal Glomerular Sclerosis (Focal Segmental - FSG)"
            }
          }
        ]
    },
    "search": {
        "mode": "match"
    }
},
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                       "code": "UHN#3885",
                    "display": "HTLV -1"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                   "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "UHNFour, RecipientFour"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
              {
                  "code": {
                      "text": "Line 1"
                  },
                  "valueString": "Detected"
              }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3882",
                  "display": "HUMAN IMMUNODEFICIENCY VIRUS NAT"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueString": "Negative"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "UHN#3923",
                "display": "HUMAN IMMUNODEFICIENCY VIRUS NAT"
              }
          ],
          "text": "OATS REFERRAL DECISION"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
               "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "UHNFour, RecipientFour"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
              "valueString": "Negative"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                       "code": "UHN#3886",
                    "display": "HTLV -1 DATE"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                   "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "UHNFour, RecipientFour"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
              {
                  "code": {
                      "text": "Line 1"
                  },
                  "valueDateTime": "2026-02-09"
              }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3924",
                  "display": "HTLV -1 DATE"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueDateTime": "2026-02-09"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3883",
                  "display": "HUMAN IMMUNODEFICIENCY VIRUS NAT DATE"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueDateTime": "2026-03-01"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "UHN#3887",
                  "display": "HTLV -1 TIME"
                }
            ],
            "text": "OATS REFERRAL DECISION"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                 "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                "display": "UHNFour, RecipientFour"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
                "valueTime": "11:11:00"
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
    {
      "link": [
          {
              "relation": "self",
              "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
          }
      ],
      "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
      "resource": {
          "resourceType": "Observation",
          "id": "fqYHEIsMGTeS0j5NQiKddnA4",
          "status": "unknown",
          "category": [
              {
                  "coding": [
                      {
                          "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                          "code": "smartdata",
                          "display": "SmartData"
                      }
                  ],
                  "text": "SmartData"
              }
          ],
          "code": {
              "coding": [
                  {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                       "code": "SK#8214",
                       "display": "Actual TLC"
                  }
              ],
              "text": "OATS REFERRAL DECISION"
          },
          "subject": {
              "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
              "display": "SMHOne, RecipientOne"
          },
          "focus": [
              {
                  "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
              }
          ],
          "issued": "2025-08-19T14:54:38Z",
          "performer": [
              {
                  "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                  "display": "PHOENIX, COORDINATOR"
              }
          ],
          "component": [
              {
                  "code": {
                      "text": "Line 1"
                  },
                 "valueString": "40"
              }
          ]
      },
      "search": {
          "mode": "match"
      }
  },
  {
    "link": [
        {
            "relation": "self",
            "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
        }
    ],
    "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
    "resource": {
        "resourceType": "Observation",
        "id": "fqYHEIsMGTeS0j5NQiKddnA4",
        "status": "unknown",
        "category": [
            {
                "coding": [
                    {
                        "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                        "code": "smartdata",
                        "display": "SmartData"
                    }
                ],
                "text": "SmartData"
            }
        ],
        "code": {
            "coding": [
                {
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                     "code": "SK#8046",
                     "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
                }
            ],
            "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
        },
        "subject": {
            "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
            "display": "SMHOne, RecipientOne"
        },
        "focus": [
            {
                "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
            }
        ],
        "issued": "2025-08-19T14:54:38Z",
        "performer": [
            {
                "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                "display": "PHOENIX, COORDINATOR"
            }
        ],
        "component": [
            {
                "code": {
                    "text": "Line 1"
                },
               "valueBoolean": false
            }
        ]
    },
    "search": {
        "mode": "match"
    }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8232",
                   "display": "UHN TXP OATS KIDNEY STAGED KIDNEY"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Lung transplant comments"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8076",
                   "display": "DATE OF MELD"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2025-04-07"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8301",
                   "display": "UHN TXP OATS TRANSPLANT TYPE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueString": "Kidney - Left"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
{
  "link": [
      {
          "relation": "self",
          "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
      }
  ],
  "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
  "resource": {
      "resourceType": "Observation",
      "id": "fqYHEIsMGTeS0j5NQiKddnA4",
      "status": "unknown",
      "category": [
          {
              "coding": [
                  {
                      "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                      "code": "smartdata",
                      "display": "SmartData"
                  }
              ],
              "text": "SmartData"
          }
      ],
      "code": {
          "coding": [
              {
                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                   "code": "SK#8084",
                   "display": "UHN TXP OATS TRANSPLANT START DATE"
              }
          ],
          "text": "UHN TXP OATS KIDNEY STAGED KIDNEY"
      },
      "subject": {
          "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
          "display": "SMHOne, RecipientOne"
      },
      "focus": [
          {
              "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
          }
      ],
      "issued": "2025-08-19T14:54:38Z",
      "performer": [
          {
              "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
              "display": "PHOENIX, COORDINATOR"
          }
      ],
      "component": [
          {
              "code": {
                  "text": "Line 1"
              },
             "valueDateTime": "2026-02-03"
          }
      ]
  },
  "search": {
      "mode": "match"
  }
},
      {
          "link": [
              {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
              }
          ],
          "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
          "resource": {
              "resourceType": "Observation",
              "id": "fqYHEIsMGTeS0j5NQiKddnA4",
              "status": "unknown",
              "category": [
                  {
                      "coding": [
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                              "code": "smartdata",
                              "display": "SmartData"
                          }
                      ],
                      "text": "SmartData"
                  }
              ],
              "code": {
                  "coding": [
                      {
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                          "code": "SK#7975",
                          "display": "UHN TXP OATS REFERRAL DECISION DATE"
                      }
                  ],
                  "text": "OATS REFERRAL DECISION"
              },
              "subject": {
                  "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                  "display": "SMHOne, RecipientOne"
              },
              "focus": [
                  {
                      "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "issued": "2025-08-19T14:54:38Z",
              "performer": [
                  {
                      "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                      "display": "PHOENIX, COORDINATOR"
                  }
              ],
              "component": [
                  {
                      "code": {
                          "text": "Line 1"
                      },
                     "valueDateTime": "2017-02-23"
                  }
              ]
          },
          "search": {
              "mode": "match"
          }
      },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7931",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f6a65I9z6dU8udcUn9imK2Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f6a65I9z6dU8udcUn9imK2Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#059",
                              "display": "cPRA"
                          }
                      ],
                      "text": "CPRA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueQuantity": {
                              "value": 456
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSzs64wACKwaRyM0ChW-8gg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSzs64wACKwaRyM0ChW-8gg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16525",
                              "display": "OATS - PUSH DATA"
                          }
                      ],
                      "text": "OATS - PUSH DATA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fsEjuE08ag3FANsbstvAfMA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fsEjuE08ag3FANsbstvAfMA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16531",
                              "display": "OATS - GENERAL KIDNEY COMMENTS"
                          }
                      ],
                      "text": "OATS - GENERAL KIDNEY COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Comments six"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fuYccAx.BXrHtCKygaGQflw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fuYccAx.BXrHtCKygaGQflw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16532",
                              "display": "OATS - DONOR ACCEPTANCE COMMENTS"
                          }
                      ],
                      "text": "OATS - DONOR ACCEPTANCE COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:11:28Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Donor Acceptance Comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fQ9eG5nH-ZyBPQwmMCDhYpA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fQ9eG5nH-ZyBPQwmMCDhYpA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16533",
                              "display": "OATS - TRANSPLANT START"
                          }
                      ],
                      "text": "OATS - TRANSPLANT START"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSOtYTvg3RlCpGVbFRJEIwg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSOtYTvg3RlCpGVbFRJEIwg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16534",
                              "display": "OATS - REWARM TIME"
                          }
                      ],
                      "text": "OATS - REWARM TIME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fo4qGLHFpnudFgahiv6D2Ew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fo4qGLHFpnudFgahiv6D2Ew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#16535",
                              "display": "OATS - COLD ISCHEMIC TIME (CIT)"
                          }
                      ],
                      "text": "OATS - COLD ISCHEMIC TIME (CIT)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueTime": "01:01:00"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f5lTe6ECyzNSIkXY4oNMkHw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f5lTe6ECyzNSIkXY4oNMkHw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#177",
                              "display": "TXP DIALYSIS - DIALYSIS TYPE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Frequent Nocturnal Dialysis"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJLs2FuJR3mdEKlHkQpgEig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJLs2FuJR3mdEKlHkQpgEig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#178",
                              "display": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS ACCESS MODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Central Venous Catheter (CVC)"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKzLPY7TXE6TfZsnbHKrgcw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKzLPY7TXE6TfZsnbHKrgcw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#179",
                              "display": "TXP DIALYSIS - DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fq6IDTU1JQvz8KDaSaiM0Hg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fq6IDTU1JQvz8KDaSaiM0Hg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#180",
                              "display": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                          }
                      ],
                      "text": "TXP DIALYSIS - OTHER DIALYSIS LOCATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Other Address"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fz5r6xdyXLjU7xNob-Q8lYQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fz5r6xdyXLjU7xNob-Q8lYQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#184",
                              "display": "TXP DIALYSIS - PRE-EMPTIVE"
                          }
                      ],
                      "text": "TXP DIALYSIS - PRE-EMPTIVE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2xLXqBCZHHIvf98aC5Cnng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2xLXqBCZHHIvf98aC5Cnng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#207",
                              "display": "TXP DIALYSIS - DIALYSIS CENTRE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS CENTRE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Alberta Hospital"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fBgBEAl8yLFP5IbboHRuDmQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fBgBEAl8yLFP5IbboHRuDmQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#273",
                              "display": "OATS - CONSULTATION DECISION"
                          }
                      ],
                      "text": "OATS - CONSULTATION DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Consult Completed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frRj0I4JQmBg-rkdrW7uRng4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frRj0I4JQmBg-rkdrW7uRng4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#276",
                              "display": "OATS - REFERRING ORGANIZATION NAME"
                          }
                      ],
                      "text": "OATS - REFERRING ORGANIZATION NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OrgOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYb-lNYyMLSVjOIOry-qMig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYb-lNYyMLSVjOIOry-qMig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#277",
                              "display": "OATS REFERRING ORGANIZATION TYPE"
                          }
                      ],
                      "text": "OATS REFERRING ORGANIZATION TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "DIALYSIS CENTER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f2XIzuam7wDjymR9.70SV1g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f2XIzuam7wDjymR9.70SV1g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#279",
                              "display": "OATS - CONSULTATION DATE"
                          }
                      ],
                      "text": "OATS - CONSULTATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-09-24"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fa2YHVSg23HokaRtpmP.4Fg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fa2YHVSg23HokaRtpmP.4Fg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#284",
                              "display": "OATS - CONSULTATION COMMENTS"
                          }
                      ],
                      "text": "OATS - CONSULTATION COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing consultation comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fw2KyG5W8frBFmRQHvOGOSg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fw2KyG5W8frBFmRQHvOGOSg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#285",
                              "display": "OATS - MEDICAL ASSESSMENT DATE"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fSqBNYzWgrIbXKomhWl9d8Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fSqBNYzWgrIbXKomhWl9d8Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#287",
                              "display": "OATS - MEDICAL ASSESSMENT DECISION"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient to be Listed"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f45VwNXiOchwTqQQ5tDQvig4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f45VwNXiOchwTqQQ5tDQvig4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#293",
                              "display": "OATS - MEDICAL ASSESSMENT COMMENTS"
                          }
                      ],
                      "text": "OATS - MEDICAL ASSESSMENT COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing medical assessment comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fyLiC3oNQuO5.flbtkU2NoA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fyLiC3oNQuO5.flbtkU2NoA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#296",
                              "display": "OATS - STAGED KIDNEY"
                          }
                      ],
                      "text": "OATS - STAGED KIDNEY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIGZf1dNXZJMAiZ7-oDG2yA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIGZf1dNXZJMAiZ7-oDG2yA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#297",
                              "display": "OATS - KPD PATIENT"
                          }
                      ],
                      "text": "OATS - KPD PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/favdd-CaihhV4pVJtUJhiAA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "favdd-CaihhV4pVJtUJhiAA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#299",
                              "display": "OATS - LIST EXCHANGE PATIENT"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE PATIENT"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxoqMbZ5u2yC4tesDN8mtZg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxoqMbZ5u2yC4tesDN8mtZg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#300",
                              "display": "OATS - LIST EXCHANGE DATE"
                          }
                      ],
                      "text": "OATS - LIST EXCHANGE DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-30"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f9MKw7v6sARuNudB9Iop8zQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f9MKw7v6sARuNudB9Iop8zQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#301",
                              "display": "OATS - PREVIOUS LIVING DONOR"
                          }
                      ],
                      "text": "OATS - PREVIOUS LIVING DONOR"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fK-MGYI8MqSwpjNvoSq.8OQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fK-MGYI8MqSwpjNvoSq.8OQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#303",
                              "display": "OATS - PREVIOUS DONATION DATE"
                          }
                      ],
                      "text": "OATS - PREVIOUS DONATION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-09-05T02:18:12Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-31"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fCooSroi6S0sc7HcMgOZVvg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fCooSroi6S0sc7HcMgOZVvg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#309",
                              "display": "OATS FOLLOWUP SOURCE INFORMATION"
                          }
                      ],
                      "text": "OATS FOLLOWUP SOURCE INFORMATION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkIeCuBwW7X6O93Sh8giIIA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkIeCuBwW7X6O93Sh8giIIA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#314",
                              "display": "OATS FOLLOWUP CLINIC VISIT DATE"
                          }
                      ],
                      "text": "OATS FOLLOWUP CLINIC VISIT DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fh8Y8YTD8RqDVpk4iofbHbQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fh8Y8YTD8RqDVpk4iofbHbQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#317",
                              "display": "OATS RETURN TO DIALYSIS DATE"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fawMXHrp7DSOLceAom8xvnw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fawMXHrp7DSOLceAom8xvnw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7926",
                              "display": "OATS - DEMOGRAPHICS GENDER VS SEX"
                          }
                      ],
                      "text": "OATS - DEMOGRAPHICS GENDER VS SEX"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-07T14:39:54Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                    {
                      "code": {
                        "text": "Line 1"
                      },
                      "valueBoolean": true
                    }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGPETej3TGMU3pL9XveqOIg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGPETej3TGMU3pL9XveqOIg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#323",
                              "display": "OATS - REFERRAL DETAILS - COMMENTS"
                          }
                      ],
                      "text": "OATS - REFERRAL DETAILS - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Test "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fJK4vVirmWM63M7wmX.mixw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fJK4vVirmWM63M7wmX.mixw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#325",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0jH0IJMOnl7w2JwyDdHXhw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0jH0IJMOnl7w2JwyDdHXhw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#326",
                              "display": "OATS GRAFT FUNCTION AT DEATH"
                          }
                      ],
                      "text": "OATS GRAFT FUNCTION AT DEATH"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Unknown"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIVycu4A2d615v8Eo1f0-dQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIVycu4A2d615v8Eo1f0-dQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#8091",
                              "display": "OATS FOLLOWUP COMMENTS"
                          }
                      ],
                      "text": "OATS FOLLOWUP COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing post-transplant comments "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fpGbcJ5UaIlt2cnWYq8snIw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fpGbcJ5UaIlt2cnWYq8snIw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#330",
                              "display": "TXP DIALYSIS - DIALYSIS START DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS START DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-14"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fX8Nv6Jfld9qHZa9lAjeQDg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fX8Nv6Jfld9qHZa9lAjeQDg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#331",
                              "display": "TXP DIALYSIS - DIALYSIS END DATE"
                          }
                      ],
                      "text": "TXP DIALYSIS - DIALYSIS END DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-08-17"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fqYHEIsMGTeS0j5NQiKddnA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fqYHEIsMGTeS0j5NQiKddnA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "UHN#3973",
                              "display": "OATS REFERRAL DECISION"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Referral Accepted"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fYenN980Ym00-ubiZqAEhCg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fYenN980Ym00-ubiZqAEhCg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#335",
                              "display": "OATS REFERRAL DECISION DATE"
                          }
                      ],
                      "text": "OATS REFERRAL DECISION DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fxdlSZYm1yXQQe3UX6g8bkg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fxdlSZYm1yXQQe3UX6g8bkg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#337",
                              "display": "REFERRAL PRIMARY DIAGNOSIS"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AMYLOID"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGzKpZVWMcw.n8LqOQuLKWw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGzKpZVWMcw.n8LqOQuLKWw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#338",
                              "display": "REFERRAL PRIMARY DIAGNOSIS DATE"
                          }
                      ],
                      "text": "REFERRAL PRIMARY DIAGNOSIS DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T14:54:38Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2024-07-23"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTZIh7HwDy6IlVOXKpDs29w4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTZIh7HwDy6IlVOXKpDs29w4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#340",
                              "display": "OATS REFERRING PROVIDER TYPE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "GENERAL SURGEON"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f4n5e2R3AQ98g4J.NNVZAbw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f4n5e2R3AQ98g4J.NNVZAbw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#341",
                              "display": "OATS REFERRING PROVIDER FIRST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER FIRST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "NameOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fM1-INlKkzX0agFBewRaenA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fM1-INlKkzX0agFBewRaenA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#342",
                              "display": "OATS REFERRING PROVIDER LAST NAME"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER LAST NAME"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "LastOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkpqOvat7x.2hahHw-g1ITg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkpqOvat7x.2hahHw-g1ITg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#343",
                              "display": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA ABO INCOMPATIBLE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f---pfiVbBXrLZZ2bOj5IDw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f---pfiVbBXrLZZ2bOj5IDw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#345",
                              "display": "OATS DONOR CRITERIA A2 OR A2B"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA A2 OR A2B"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fd-e6RMSIj.k6epGJu2wGhQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fd-e6RMSIj.k6epGJu2wGhQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#346",
                              "display": "OATS DONOR CRITERIA HCV NAT+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV NAT+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fXEE7CfrACs5uginZmoyhXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fXEE7CfrACs5uginZmoyhXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#347",
                              "display": "OATS DONOR CRITERIA HCV AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HCV AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fGTAxybcPbMmF6e0Ft4v0Vw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fGTAxybcPbMmF6e0Ft4v0Vw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#348",
                              "display": "OATS DONOR CRITERIA HEP B CORE AB+"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA HEP B CORE AB+"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frpP.9Tj9LzmtBFQyaK9XzA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frpP.9Tj9LzmtBFQyaK9XzA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#349",
                              "display": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA EXTENDED CRITERIA DONOR (ECD)"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-026jFDg5NfF71jkcxnrQQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-026jFDg5NfF71jkcxnrQQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#351",
                              "display": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                          }
                      ],
                      "text": "OATS CONSULTATION TRANSPLANT PHYSICIAN"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T22:48:08Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Jeff Zaltzman"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f79XbDZMrpFnJ.IGhwSaveA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f79XbDZMrpFnJ.IGhwSaveA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#352",
                              "display": "OATS REFERRING PROVIDER ADDRESS"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER ADDRESS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "AddressOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f25V63huaxM0FexPWcLHF6Q4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f25V63huaxM0FexPWcLHF6Q4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#353",
                              "display": "OATS REFERRING PROVIDER CITY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER CITY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CityOne"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fEC3bziO.tvqnDoa5fqx2sA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fEC3bziO.tvqnDoa5fqx2sA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#354",
                              "display": "OATS REFERRING PROVIDER COUNTRY"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER COUNTRY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "CANADA"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ffxlfqg0iw8TRO4Slvmcnyg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ffxlfqg0iw8TRO4Slvmcnyg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#355",
                              "display": "OATS REFERRING PROVIDER PROVINCE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER PROVINCE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.699080.50",
                                      "code": "58",
                                      "display": "Ontario"
                                  }
                              ],
                              "text": "Ontario"
                          }
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f0p.R8bt-.mVW3x8.UT2yXg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f0p.R8bt-.mVW3x8.UT2yXg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#356",
                              "display": "OATS REFERRING PROVIDER POSTAL CODE"
                          }
                      ],
                      "text": "OATS REFERRING PROVIDER POSTAL CODE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "L1L2L3"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fRdD26SPUCHICBz82O8QrGg4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fRdD26SPUCHICBz82O8QrGg4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#357",
                              "display": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                          }
                      ],
                      "text": "OATS DONOR CRITERIA PREFERRED DONOR TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Deceased or Living Donor"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fPM896dVsaGWG4bA-II14eQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fPM896dVsaGWG4bA-II14eQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "SK#7931",
                              "display": "OATS BLOOD TYPE VERIFIED"
                          }
                      ],
                      "text": "OATS BLOOD TYPE VERIFIED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-06T02:57:09Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fjfjDPe.lXW8pnZAwqNT6DQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fjfjDPe.lXW8pnZAwqNT6DQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#377",
                              "display": "OATS RECIPIENT STATUS"
                          }
                      ],
                      "text": "OATS RECIPIENT STATUS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Recipient death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fLS9O5FTJowQE4.2tP.7gNQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fLS9O5FTJowQE4.2tP.7gNQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#381",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fp6X.EKWV2OVGiuGubVdXOw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fp6X.EKWV2OVGiuGubVdXOw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#383",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fgZSrklcdPBN.2WM1erjnlA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fgZSrklcdPBN.2WM1erjnlA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#386",
                              "display": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT POST-TRANSPLANT FOLLOW-UP - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fkduZImqZR1Zgzrrp3iquCA4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fkduZImqZR1Zgzrrp3iquCA4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#388",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feEFo86i0kqGssRCwOu2ijw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feEFo86i0kqGssRCwOu2ijw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#389",
                              "display": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - DEATH DATE ESTIMATED"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueBoolean": true
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fTWKMh4B-LwbVLRopMhJGew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fTWKMh4B-LwbVLRopMhJGew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#390",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH CATEGORY"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "OTHER"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fB8Yw7UVG0a3Sc0HgrTvSZQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fB8Yw7UVG0a3Sc0HgrTvSZQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#391",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/feYjOGORRj1qx-36eyZRaAw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "feYjOGORRj1qx-36eyZRaAw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#392",
                              "display": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - CAUSE OF DEATH TYPE OTHER"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "other death"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fcihOQFsqALYV.pawMuTY2g4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fcihOQFsqALYV.pawMuTY2g4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#393",
                              "display": "OATS RECIPIENT DEATH DATA - COMMENTS"
                          }
                      ],
                      "text": "OATS RECIPIENT DEATH DATA - COMMENTS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "Testing recipient death comments"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fKM4u1l0CO7AW3XK.d6IuxQ4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fKM4u1l0CO7AW3XK.d6IuxQ4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#395",
                              "display": "OATS TRANSPLANT TYPE"
                          }
                      ],
                      "text": "OATS TRANSPLANT TYPE"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-08-19T15:24:57Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueString": "RIGHT KIDNEY"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/frfiOJ2orNaulWwwS9jjDew4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "frfiOJ2orNaulWwwS9jjDew4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#396",
                              "display": "OATS REMOVED FROM COLD"
                          }
                      ],
                      "text": "OATS REMOVED FROM COLD"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/fIG8aWFGszO4eaWaGjXI3Og4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "fIG8aWFGszO4eaWaGjXI3Og4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#397",
                              "display": "OATS CLAMP REMOVAL"
                          }
                      ],
                      "text": "OATS CLAMP REMOVAL"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:16:37Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ],
                  "component": [
                      {
                          "code": {
                              "text": "Line 1"
                          },
                          "valueDateTime": "2025-10-02T23:16:00Z"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/f-S0KvhLEqrnyRyuq8iDYPw4",
              "resource": {
                  "resourceType": "Observation",
                  "id": "f-S0KvhLEqrnyRyuq8iDYPw4",
                  "status": "unknown",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://open.epic.com/FHIR/StructureDefinition/observation-category",
                                  "code": "smartdata",
                                  "display": "SmartData"
                              }
                          ],
                          "text": "SmartData"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.727688",
                              "code": "TXP#406",
                              "display": "OATS RETURN TO DIALYSIS"
                          }
                      ],
                      "text": "OATS RETURN TO DIALYSIS"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "focus": [
                      {
                          "reference": "EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                      }
                  ],
                  "issued": "2025-10-02T23:20:55Z",
                  "performer": [
                      {
                          "reference": "Practitioner/eIaIp3mCisSmH8XDxb.vyMQ3",
                          "display": "PHOENIX, COORDINATOR"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/EpisodeOfCare/eBoTe.FFtYzhCAhiO-M2TbA3",
              "resource": {
                  "resourceType": "EpisodeOfCare",
                  "id": "eBoTe.FFtYzhCAhiO-M2TbA3",
                  "extension": [
                      {
                          "valueString": "Kidney Transplant - 2/10/2025  (#1)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                      },
                      {
                          "valueCodeableConcept": {
                              "coding": [
                                  {
                                      "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                                      "code": "2",
                                      "display": "Recipient"
                                  }
                              ],
                              "text": "Recipient"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                                              "code": "16",
                                              "display": "Kidney"
                                          }
                                      ],
                                      "text": "Kidney"
                                  },
                                  "url": "organ-class"
                              },
                              {
                                  "valueReference": {
                                      "reference": "Practitioner/el16FdtlssUCWMkeZfO2CMg3",
                                      "type": "Practitioner",
                                      "display": "Coordinator Phoenix, RN"
                                  },
                                  "url": "coordinator"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                      },
                      {
                          "extension": [
                              {
                                  "valueCodeableConcept": {
                                      "coding": [
                                          {
                                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                                              "code": "50",
                                              "display": "Transplanted"
                                          }
                                      ],
                                      "text": "Transplanted"
                                  },
                                  "url": "phase"
                              },
                              {
                                  "valueString": "Active Follow-up",
                                  "url": "status"
                              },
                              {
                                  "valueDate": "2025-10-02",
                                  "url": "effective"
                              }
                          ],
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                      },
                      {
                          "valueDate": "2025-08-05",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                      },
                      {
                          "valuePeriod": {
                              "start": "2025-09-24",
                              "end": "2025-10-02"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
                      },
                      {
                          "valueDate": "2025-10-02",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
                      },
                      {
                          "valueString": "St. Michael's Hospital (Toronto, ON)",
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                      }
                  ],
                  "status": "active",
                  "type": [
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.726668",
                                  "code": "49",
                                  "display": "Transplant"
                              },
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.4.726668.130",
                                  "code": "4",
                                  "display": "Transplant"
                              }
                          ],
                          "text": "Transplant"
                      }
                  ],
                  "patient": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "type": "Patient",
                      "display": "SMHOne, RecipientOne"
                  },
                  "period": {
                      "start": "2025-08-05"
                  },
                  "team": [
                      {
                          "reference": "CareTeam/e6YjTLfVn73.lWbazIyc1OfLJ1ja9HdjQ.4m.riSPdvw3",
                          "type": "CareTeam",
                          "display": "Care Team"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                {
                  "relation": "self",
                  "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eF8QuRLo6pM7Kv5DSc8SIEw3"
                }
              ],
              "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eF8QuRLo6pM7Kv5DSc8SIEw3",
              "resource": {
                "resourceType": "EpisodeOfCare",
                "id": "eF8QuRLo6pM7Kv5DSc8SIEw3",
                "extension": [
                  {
                    "valueString": "Lung Transplant Referral - 24/4/2026",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                  },
                  {
                    "valueCodeableConcept": {
                      "coding": [
                        {
                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                          "code": "2",
                          "display": "Recipient"
                        }
                      ],
                      "text": "Recipient"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                              "code": "2",
                              "display": "Lung"
                            }
                          ],
                          "text": "Lung"
                        },
                        "url": "organ-class"
                      },
                      {
                        "valueReference": {
                          "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                          "type": "Practitioner",
                          "display": "Phoenix, Coordinator, RN"
                        },
                        "url": "coordinator"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                              "code": "50",
                              "display": "Referral"
                            }
                          ],
                          "text": "Referral"
                        },
                        "url": "phase"
                      },
                      {
                        "valueString": "Active",
                        "url": "status"
                      },
                      {
                        "valueDate": "2026-04-24",
                        "url": "effective"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                  },
                  {
                    "valueDate": "2026-04-24",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                  },
                  {
                    "valueString": "University Health Network",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                  }
                ],
                "status": "active",
                "type": [
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                        "code": "49",
                        "display": "TRANSPLANT"
                      },
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                        "code": "4",
                        "display": "Transplant"
                      }
                    ],
                    "text": "TRANSPLANT"
                  }
                ],
                "patient": {
                  "reference": "Patient/e-BeVshgS5-abjhhwwYzq8A3",
                  "type": "Patient",
                  "display": "OATSrecipient, Three UHN"
                },
                "period": {
                  "start": "2026-04-24"
                },
                "team": [
                  {
                    "reference": "CareTeam/e2uCNBywfBIhT0YjEe.Lgi46Ihy7skDtvWOYw-Wya8sM3",
                    "type": "CareTeam",
                    "display": "Care Team"
                  }
                ]
              },
              "search": {
                "mode": "match"
              }
            },
            {
              "link": [
                {
                  "relation": "self",
                  "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eXnJ9xsrVd8Gnkgi.MGk6-g3"
                }
              ],
              "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eXnJ9xsrVd8Gnkgi.MGk6-g3",
              "resource": {
                "resourceType": "EpisodeOfCare",
                "id": "eXnJ9xsrVd8Gnkgi.MGk6-g3",
                "extension": [
                  {
                    "valueString": "Liver Transplant Referral - 24/4/2026",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                  },
                  {
                    "valueCodeableConcept": {
                      "coding": [
                        {
                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                          "code": "2",
                          "display": "Recipient"
                        }
                      ],
                      "text": "Recipient"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                              "code": "8",
                              "display": "Liver"
                            }
                          ],
                          "text": "Liver"
                        },
                        "url": "organ-class"
                      },
                      {
                        "valueReference": {
                          "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                          "type": "Practitioner",
                          "display": "Phoenix, Coordinator, RN"
                        },
                        "url": "coordinator"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                              "code": "50",
                              "display": "Referral"
                            }
                          ],
                          "text": "Referral"
                        },
                        "url": "phase"
                      },
                      {
                        "valueString": "Active",
                        "url": "status"
                      },
                      {
                        "valueDate": "2026-04-24",
                        "url": "effective"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                  },
                  {
                    "valueDate": "2026-04-24",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                  },
                  {
                    "valueString": "University Health Network",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                  }
                ],
                "status": "active",
                "type": [
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                        "code": "49",
                        "display": "TRANSPLANT"
                      },
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                        "code": "4",
                        "display": "Transplant"
                      }
                    ],
                    "text": "TRANSPLANT"
                  }
                ],
                "patient": {
                  "reference": "Patient/e-BeVshgS5-abjhhwwYzq8A3",
                  "type": "Patient",
                  "display": "OATSrecipient, Three UHN"
                },
                "period": {
                  "start": "2026-04-24"
                },
                "team": [
                  {
                    "reference": "CareTeam/e2uCNBywfBIhT0YjEe.Lgi4H4xOErjsm7atnSvjcNTOQ3",
                    "type": "CareTeam",
                    "display": "Care Team"
                  }
                ]
              },
              "search": {
                "mode": "match"
              }
            },
            {
              "link": [
                {
                  "relation": "self",
                  "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/ehmDT6xRacCmjU-0TENq4NA3"
                }
              ],
              "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/ehmDT6xRacCmjU-0TENq4NA3",
              "resource": {
                "resourceType": "EpisodeOfCare",
                "id": "ehmDT6xRacCmjU-0TENq4NA3",
                "extension": [
                  {
                    "valueString": "Kidney Transplant Referral - 21/4/2026",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                  },
                  {
                    "valueCodeableConcept": {
                      "coding": [
                        {
                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                          "code": "2",
                          "display": "Recipient"
                        }
                      ],
                      "text": "Recipient"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                              "code": "16",
                              "display": "Kidney"
                            }
                          ],
                          "text": "Kidney"
                        },
                        "url": "organ-class"
                      },
                      {
                        "valueReference": {
                          "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                          "type": "Practitioner",
                          "display": "Phoenix, Coordinator, RN"
                        },
                        "url": "coordinator"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                              "code": "10",
                              "display": "Referral"
                            }
                          ],
                          "text": "Referral"
                        },
                        "url": "phase"
                      },
                      {
                        "valueString": "Active",
                        "url": "status"
                      },
                      {
                        "valueString": "Accepted",
                        "url": "reason"
                      },
                      {
                        "valueDate": "2026-04-23",
                        "url": "effective"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                  },
                  {
                    "valueDate": "2026-04-21",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                  },
                  {
                    "valueString": "University Health Network",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                  }
                ],
                "status": "active",
                "type": [
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                        "code": "49",
                        "display": "TRANSPLANT"
                      },
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                        "code": "4",
                        "display": "Transplant"
                      }
                    ],
                    "text": "TRANSPLANT"
                  }
                ],
                "patient": {
                  "reference": "Patient/e-BeVshgS5-abjhhwwYzq8A3",
                  "type": "Patient",
                  "display": "OATSrecipient, Three UHN"
                },
                "period": {
                  "start": "2026-04-21"
                },
                "team": [
                  {
                    "reference": "CareTeam/e2uCNBywfBIhT0YjEe.Lgi-KL7RnyEzjXO3t8kL7tEUE3",
                    "type": "CareTeam",
                    "display": "Care Team"
                  }
                ]
              },
              "search": {
                "mode": "match"
              }
            },
            {
              "link": [
                {
                  "relation": "self",
                  "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/e45XbpCss22prb4hs1o3cxQ3"
                }
              ],
              "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/e45XbpCss22prb4hs1o3cxQ3",
              "resource": {
                "resourceType": "EpisodeOfCare",
                "id": "e45XbpCss22prb4hs1o3cxQ3",
                "extension": [
                  {
                    "valueString": "Heart Transplant Evaluation - 20/4/2026",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                  },
                  {
                    "valueCodeableConcept": {
                      "coding": [
                        {
                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                          "code": "2",
                          "display": "Recipient"
                        }
                      ],
                      "text": "Recipient"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                              "code": "64",
                              "display": "Heart"
                            }
                          ],
                          "text": "Heart"
                        },
                        "url": "organ-class"
                      },
                      {
                        "valueReference": {
                          "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                          "type": "Practitioner",
                          "display": "Phoenix, Coordinator, RN"
                        },
                        "url": "coordinator"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                              "code": "20",
                              "display": "Evaluation"
                            }
                          ],
                          "text": "Evaluation"
                        },
                        "url": "phase"
                      },
                      {
                        "valueString": "Active",
                        "url": "status"
                      },
                      {
                        "valueDate": "2026-04-20",
                        "url": "effective"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                  },
                  {
                    "valueDate": "2026-04-20",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                  },
                  {
                    "valuePeriod": {
                      "start": "2026-04-20",
                      "end": "2026-04-20"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
                  },
                  {
                    "valueString": "University Health Network",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                  }
                ],
                "status": "active",
                "type": [
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                        "code": "49",
                        "display": "TRANSPLANT"
                      },
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                        "code": "4",
                        "display": "Transplant"
                      }
                    ],
                    "text": "TRANSPLANT"
                  }
                ],
                "patient": {
                  "reference": "Patient/e-BeVshgS5-abjhhwwYzq8A3",
                  "type": "Patient",
                  "display": "OATSrecipient, Three UHN"
                },
                "period": {
                  "start": "2026-04-20"
                },
                "team": [
                  {
                    "reference": "CareTeam/e2uCNBywfBIhT0YjEe.Lgi3VOS-sknSmRZX5fs9NQr3A3",
                    "type": "CareTeam",
                    "display": "Care Team"
                  }
                ]
              },
              "search": {
                "mode": "match"
              }
            },
            {
              "link": [
                {
                  "relation": "self",
                  "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eggnYq.VK2ZrQLHTUZlfpNQ3"
                }
              ],
              "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/eggnYq.VK2ZrQLHTUZlfpNQ3",
              "resource": {
                "resourceType": "EpisodeOfCare",
                "id": "eggnYq.VK2ZrQLHTUZlfpNQ3",
                "extension": [
                  {
                    "valueString": "Liver Transplant - 19/4/2026  (#2)",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                  },
                  {
                    "valueCodeableConcept": {
                      "coding": [
                        {
                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                          "code": "2",
                          "display": "Recipient"
                        }
                      ],
                      "text": "Recipient"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                              "code": "8",
                              "display": "Liver"
                            }
                          ],
                          "text": "Liver"
                        },
                        "url": "organ-class"
                      },
                      {
                        "valueReference": {
                          "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                          "type": "Practitioner",
                          "display": "Phoenix, Coordinator, RN"
                        },
                        "url": "coordinator"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                              "code": "50",
                              "display": "Transplanted"
                            }
                          ],
                          "text": "Transplanted"
                        },
                        "url": "phase"
                      },
                      {
                        "valueString": "Active Follow-up",
                        "url": "status"
                      },
                      {
                        "valueDate": "2026-04-19",
                        "url": "effective"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                  },
                  {
                    "valueDate": "2026-04-16",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                  },
                  {
                    "valueDate": "2026-04-19",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-admission-date"
                  },
                  {
                    "valueDate": "2026-04-19",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
                  },
                  {
                    "valueString": "University Health Network",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                  },
                  {
                    "valueReference": {
                      "reference": "BodyStructure/e3ttgEw30nCe5g4p33LyUR.kaBKCwDUGtfNw5rbKfIoJve-RF7c6m4kU9lW9mqHy93",
                      "type": "BodyStructure",
                      "display": "Left Liver Lobe"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
                  }
                ],
                "status": "active",
                "type": [
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                        "code": "49",
                        "display": "TRANSPLANT"
                      },
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                        "code": "4",
                        "display": "Transplant"
                      }
                    ],
                    "text": "TRANSPLANT"
                  }
                ],
                "patient": {
                  "reference": "Patient/e-BeVshgS5-abjhhwwYzq8A3",
                  "type": "Patient",
                  "display": "OATSrecipient, Three UHN"
                },
                "period": {
                  "start": "2026-04-16"
                },
                "team": [
                  {
                    "reference": "CareTeam/e2uCNBywfBIhT0YjEe.Lgiz38OuuP.QEb06hSE8dW-mU3",
                    "type": "CareTeam",
                    "display": "Care Team"
                  }
                ]
              },
              "search": {
                "mode": "match"
              }
            },
            {
              "link": [
                {
                  "relation": "self",
                  "url": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/euKV32WUe5R6RUkqVJXw0WA3"
                }
              ],
              "fullUrl": "https://icfgnp.uhn.ca/Interconnect-Oauth2-TST/api/FHIR/R4/EpisodeOfCare/euKV32WUe5R6RUkqVJXw0WA3",
              "resource": {
                "resourceType": "EpisodeOfCare",
                "id": "euKV32WUe5R6RUkqVJXw0WA3",
                "extension": [
                  {
                    "valueString": "Kidney Transplant - 19/4/2026  (#2)",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/episode-name"
                  },
                  {
                    "valueCodeableConcept": {
                      "coding": [
                        {
                          "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30035",
                          "code": "2",
                          "display": "Recipient"
                        }
                      ],
                      "text": "Recipient"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-donor-or-recipient"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30030",
                              "code": "16",
                              "display": "Kidney"
                            }
                          ],
                          "text": "Kidney"
                        },
                        "url": "organ-class"
                      },
                      {
                        "valueReference": {
                          "reference": "Practitioner/eKqanoUjSAm5XT4q72W5vHg3",
                          "type": "Practitioner",
                          "display": "Phoenix, Coordinator, RN"
                        },
                        "url": "coordinator"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ-coordinator"
                  },
                  {
                    "extension": [
                      {
                        "valueCodeableConcept": {
                          "coding": [
                            {
                              "system": "urn:oid:1.2.840.114350.1.72.1.7.7.10.728366.30105",
                              "code": "50",
                              "display": "Transplanted"
                            }
                          ],
                          "text": "Transplanted"
                        },
                        "url": "phase"
                      },
                      {
                        "valueString": "Active Follow-up",
                        "url": "status"
                      },
                      {
                        "valueDate": "2026-04-19",
                        "url": "effective"
                      }
                    ],
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-phase-status"
                  },
                  {
                    "valueDate": "2026-04-13",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-referral-date"
                  },
                  {
                    "valuePeriod": {
                      "end": "2026-04-20"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-evaluation"
                  },
                  {
                    "valueDate": "2026-04-20",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-center-waitlist-date"
                  },
                  {
                    "valueDate": "2026-04-20",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-waitlist-date"
                  },
                  {
                    "valueDate": "2026-04-19",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-admission-date"
                  },
                  {
                    "valueDate": "2026-04-19",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-event-transplanted-date"
                  },
                  {
                    "valueString": "University Health Network",
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-center"
                  },
                  {
                    "valueReference": {
                      "reference": "BodyStructure/eimos0TF.bfz3hS50axtm41mMWrTYlV9pSK5i00FKxZeRUS5zZ.tGUsCGkjl9om-W3",
                      "type": "BodyStructure",
                      "display": "Left Kidney"
                    },
                    "url": "http://open.epic.com/FHIR/StructureDefinition/extension/transplant-organ"
                  }
                ],
                "status": "active",
                "type": [
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.2.726668",
                        "code": "49",
                        "display": "TRANSPLANT"
                      },
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.630.3.7.4.726668.130",
                        "code": "4",
                        "display": "Transplant"
                      }
                    ],
                    "text": "TRANSPLANT"
                  }
                ],
                "patient": {
                  "reference": "Patient/e-BeVshgS5-abjhhwwYzq8A3",
                  "type": "Patient",
                  "display": "OATSrecipient, Three UHN"
                },
                "period": {
                  "start": "2026-04-13"
                },
                "team": [
                  {
                    "reference": "CareTeam/e2uCNBywfBIhT0YjEe.Lgi4pGN35PthxIsexMABpRogU3",
                    "type": "CareTeam",
                    "display": "Care Team"
                  }
                ]
              },
              "search": {
                "mode": "match"
              }
            }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDrkLVLj5ZEgbfLP1XlyebdiNgCulR2kZpTR7Bl3gJ-mww3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "11",
                              "display": "Height"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "tqIZ.9Xom.NjB5dsfS9O.Ow0",
                              "display": "Height"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "8302-2"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8302-2",
                              "display": "Body height"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Height"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 154,
                      "unit": "cm",
                      "system": "http://unitsofmeasure.org",
                      "code": "cm"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e1-OlxqRWZlyiPGMfSGpMIG.nBxJLG1CdnTOvSW9PfDo9ddh5dr34T8R-8jteN7lD2Ubw8Xi-HgpYC8.M1.mvsg3",
                  "extension": [
                      {
                          "valueIdentifier": {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707684",
                              "value": "395"
                          },
                          "url": "http://open.epic.com/FHIR/StructureDefinition/extension/template-id"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "vital-signs",
                                  "display": "Vital Signs"
                              }
                          ],
                          "text": "Vital Signs"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.707679",
                              "code": "14",
                              "display": "Weight"
                          },
                          {
                              "system": "http://open.epic.com/FHIR/StructureDefinition/observation-flowsheet-id",
                              "code": "t5Cn9FBZGCKy2gCB5bnkZtA0",
                              "display": "Weight"
                          },
                          {
                              "system": "urn:oid:1.2.246.537.6.96",
                              "code": "29463-7"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "29463-7",
                              "display": "Body weight"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "3141-9",
                              "display": "Body weight Measured"
                          },
                          {
                              "system": "http://loinc.org",
                              "code": "8716-3",
                              "display": "Vital signs"
                          }
                      ],
                      "text": "Weight"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2024-10-01T14:46:00Z",
                  "issued": "2025-08-06T02:47:23Z",
                  "performer": [
                      {
                          "reference": "Practitioner/enQJjyYC0qHEF4yABThitOQ3",
                          "display": "Sarah Chung"
                      }
                  ],
                  "valueQuantity": {
                      "value": 56,
                      "unit": "kg",
                      "system": "http://unitsofmeasure.org",
                      "code": "kg"
                  }
              },
              "search": {
                  "mode": "match"
              }
          }
      ],
      [
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VUBPFPrgFpE-KyORbErZpzb3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLloyNO9ysvx-k7u4e4uNRU2L3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "5195-3",
                              "display": "Hepatitis B virus surface Ag [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBSAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAG"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551308"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5195-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV13"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551308",
                              "display": "Hepatitis B Surface Antigen"
                          }
                      ],
                      "text": "Hepatitis B Surface Antigen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ezykgctlnASn05IHc9Z6qwAJ1QQaUGjx2jaxKh3-xUtptP84T-f9-e8TrYG-.YraB3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eeQwI6dztGI3giM225fSFdxv40GCiATH0tSWVuRPNCNc3",
                          "display": "Hepatitis B Core Antibody"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "13952-7",
                              "display": "Hepatitis B virus core Ab [Presence] in Serum or Plasma by Immunoassay"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBCT"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1551494"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "13952-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis B virus core Ab:ACnc:Pt:Ser:Ord:EIA"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "PLV18"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1551494",
                              "display": "Hepatitis B Core Total (IgG+IgM) Antibody"
                          }
                      ],
                      "text": "Hepatitis B Core Total (IgG+IgM) Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:46:00Z",
                  "issued": "2025-08-20T18:49:06Z",
                  "valueString": "Reactive",
                  "interpretation": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/v3-ObservationInterpretation",
                                  "code": "A",
                                  "display": "Abnormal"
                              }
                          ],
                          "text": "Abnormal"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/ejRQHev1n95WqzM2rB3jFHg3",
                      "display": "Specimen 25S-232C0004"
                  },
                  "referenceRange": [
                      {
                          "text": "Nonreactive"
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeett5xbrQW8nKXPZs7ijMBtw4MQReuCYD2TIGnZ40VVoqn3ZPCsD3R84JFO6IVVR3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePWcZukcl3CvakNzY1K8.Oc1cPDrFlXm7SiYR0Yz3lGY3",
                          "display": "Hepatitis B Acute Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:36Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eVkGmlR3Rx5655Bhh3U7h5Q3",
                      "display": "Specimen 25S-233C0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
 
            "fullUrl": "",
            "resource": {
              "resourceType": "Observation",
              "id": "ezQyHkgeitIjgCmRY7LkbjTamKWFjE.Cc.US-.Ad.767lPmKWnvRFS1.f3rllVv4J3",
              "basedOn": [
                {
                  "reference": "ServiceRequest/eJLc0cVYCXn0hRIuqJ8tZbcnQKb7f2flHZa-mbil4jzs3",
                  "display": "Creatinine"
                }
              ],
              "status": "final",
              "category": [
                {
                  "coding": [
                    {
                      "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                      "code": "laboratory",
                      "display": "Laboratory"
                    }
                  ],
                  "text": "Laboratory"
                },
                {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.517.3.7.10.798268.30",
                      "code": "Lab",
                      "display": "Lab"
                    }
                  ],
                  "text": "Lab"
                }
              ],
              "code": {
                "coding": [
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30467",
                    "code": "CRV"
                  },
                  {
                    "system": "http://loinc.org",
                    "code": "14682-9",
                    "display": "Creatinine [Moles/volume] in Serum or Plasma"
                  },
                  
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.5.737384.30481",
                    "code": "1526296"
                  },
                  {
                    "system": "urn:oid:1.2.840.114350.1.13.517.3.7.2.768282",
                    "code": "1526296",
                    "display": "Creatinine"
                  }
                ],
                "text": "Creatinine"
              },
              "subject": {
                "reference": "Patient/eTBYY2m2lofBOygbq9ebQjg3",
                "display": "TestOne, VirologyOneWaitlist Kingthree"
              },
              "encounter": {
                "reference": "Encounter/eyfjhroUuSoubei8mEnpfsg3",
                "identifier": {
                  "use": "usual",
                  "system": "urn:oid:1.2.840.114350.1.13.517.3.7.3.698084.8",
                  "value": "200239102"
                },
                "display": "Appointment"
              },
              "effectiveDateTime": "2024-09-16T20:15:00Z",
              "issued": "2024-09-18T13:56:28Z",
              "valueQuantity": {
                "value": 50,
                "unit": "umol/L",
                "system": "http://unitsofmeasure.org",
                "code": "umol/L"
              },
              "specimen": {
                "reference": "Specimen/eVQxcpxJaoMOFEje2nfWh7nijLv7T8Mf9FtpSbcazIY83",
                "display": "Specimen 24SJC-260Y0005"
              },
              "referenceRange": [
                {
                  "low": {
                    "value": 49,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "high": {
                    "value": 90,
                    "unit": "umol/L",
                    "system": "http://unitsofmeasure.org",
                    "code": "umol/L"
                  },
                  "text": "49 - 90 umol/L"
                }
              ]
            },
            "search": {
              "mode": "match"
            }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eIr0-OP5iSIt4q.Zj.2fgjGgS9T3TmmGjfvYEn-fTLlqsQLvv7Qh-WFExAsqIvSUO3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ePfLrb8Bugk9qhqwHqJap.7rhdvL8MfIjLtTeXEiUc-M3",
                          "display": "Hepatitis B Chronic Infection"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "22322-2",
                              "display": "Hepatitis B virus surface Ab [Presence] in Serum"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "HBAB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1558020"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22322-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS B VIRUS SURFACE AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1558020",
                              "display": "Hepatitis B Surface Antibody"
                          }
                      ],
                      "text": "Hepatitis B Surface Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:43:00Z",
                  "issued": "2025-08-20T18:49:26Z",
                  "dataAbsentReason": {
                      "coding": [
                          {
                              "system": "http://terminology.hl7.org/CodeSystem/data-absent-reason",
                              "code": "unknown",
                              "display": "Unknown"
                          }
                      ],
                      "text": "No value exists"
                  },
                  "note": [
                      {
                          "text": "Non-Immune <10 IU/L\r\nImmune >=10 IU/L\r\n"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/eSZiNo5Xv7Y-iUeBhQc2CMA3",
                      "display": "Specimen 25S-232C0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM99G7XpMo2Us8ACUMGAn8k-xrjj8IuQ9mJzltCuYMyZF3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "ABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "PABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "MABSC"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.221",
                              "code": "NABSN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "890-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1631699"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABSC_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Blood group antibody screen:PrThr:Pt:Ser/Plas:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1631699",
                              "display": "Antibody Screen"
                          }
                      ],
                      "text": "Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbkpjlbkJ0GKcOlfWgtLn7Sj3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqDMDCEZveMrQfHn8qpvN8HX3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1Dyhyw0agG62PudKen1O42kiZ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "883-9",
                              "display": "ABO group [Type] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "ABO"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "883-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810065"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "ABO_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "ABO GROUP:TYPE:PT:BLD:NOM"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810065",
                              "display": "ABO"
                          }
                      ],
                      "text": "ABO"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "AB",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eHCsP2ilPvbE.we1el6iDM6AbrKI0QM1tgXYxG7K1QbmlUvsMt3yh1kbuoZliZVrM3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e9Z6HgdlGQmfrvB7.hME-qjRecLKelzDpIgV6zmNrkUk3",
                          "display": "Group and Screen"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Lab",
                                  "display": "Lab"
                              }
                          ],
                          "text": "Lab"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-06T02:49:00Z",
                  "issued": "2025-08-06T02:51:56Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/e8qTwcBSD7LKWWR1eqqyXrg3",
                      "display": "Specimen 25M-217B0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ep-y4TEriJafoE3zaQfocPINRru4scC4iY2K0gcnQeqBS7QQMgWBGkcFWXKMWZVWJ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eBnUSBLRX7gujIpIzU6C5nIAXnVbtzPwHZ9h0WquLy4Q3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-05T04:00:00Z",
                  "issued": "2025-08-06T02:45:02Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/exzjcaL0oP1WOlfV1.GsQcFnq0A0lZQOiLcpvIfy6vGU3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eG4UkvKVVW6WpyUQc7p3aDky7U1IPRzhww8KCrIb1DygmmWRw1CAg2K28R6kmUVWT3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eTBKrcF4sGTwXKaSxqHUfwMOC-pquDSUdLvkKYf4rBOM3",
                          "display": "External ABO/Rh Results"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Blood Bank",
                                  "display": "Blood Bank"
                              }
                          ],
                          "text": "Blood Bank"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "http://loinc.org",
                              "code": "1305-2",
                              "display": "D Ag [Presence] in Blood"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "TRH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.219",
                              "code": "RH"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "14908-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1810067"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.251",
                              "code": "RH_INTEP"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Rh:Type:Pt:Bld^newborn:Nom"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1810067",
                              "display": "Rh"
                          }
                      ],
                      "text": "Rh"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/etA0v7eY4nGbRs-ARpLOOp5QKR1E7UHULOcM0OFDqd8s3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000043660"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-04T04:00:00Z",
                  "issued": "2025-08-06T02:44:12Z",
                  "valueString": "Positive",
                  "specimen": {
                      "reference": "Specimen/eWz6HL7SgVO7IbG1jMI7Nw5RNdk23MbBVwEacCml0Gpc3",
                      "display": "Specimen"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJwKrWZTVT03vs-9Dvq8yWl7kr74vAy22ZSHeY9mhx1LA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygIjmeKkNSKddSPqwrJbZ2Ty6YhmF3U4bgVqc-jT07.Yw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTdkgCOYmwvT55Z3Afg1j.4g4VeqBvKiAOgIzUZllhBXw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXxZGI2v5J9rRqfCXKabPlOM-E1wW8S2QLUwM76L7A0tYA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLWTtdei2MiRpOEE-083aRHY-t4gNo1tAhKTQmOJK1P3DQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5HqRz07ksVeEEhpUi1MMK2C2ft3ypMdHKqsFTdxsf8MXA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueQuantity": {
                      "value": 1234556
                  },
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLL0RmPxu6BKvCD6JvEcnLSFkKUdbFzj5kxlJnigc-shg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza0jRcBePaIMBkPQT56AtCxgtaIp34bnZivTKXektvvOEg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.McNIJzchmaoHWRlQW6pZPFQRuadRq9gzVRR-uubVxk0Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqBVavhsBz7Vl2BI4ErsmC1nctvaBBWD1p3OCTvam91fUg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvH.XBhmUrLNNwA9o1L2eeSe7KUiZt8duG7vocKJneahA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "note": [
                      {
                          "text": "Previously Final Verified Results Added"
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhIFg1pk54us84ccpjSj90JFSFdfVdtGIu8QbC9okP.w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++30896-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071371",
                              "display": "Referral Lab Number"
                          }
                      ],
                      "text": "Referral Lab Number"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueQuantity": {
                      "value": 123456
                  },
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpm7KK29muTzetgLHy4G3OhH910y4KhPafvg37kFUyh7Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071384"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22244-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071384",
                              "display": "Cytomegalovirus IgG CLIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                {
                  "relation": "self",
                  "url": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3"
                }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-TST/api/FHIR/R4/Observation/eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
              "resource": {
                "resourceType": "Observation",
                "id": "eDIt2N3wFe5abF2J8QW9xxVbmPHlSUeznNFPiZgLtLT8.K3wAPbH1zFzpNNrPXL4N3",
                "basedOn": [
                  {
                    "reference": "ServiceRequest/ewg.SQoTDaIplJv-4B5y4ba.Xsc8d4wW83Z6LRk3nksI3",
                    "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                  }
                ],
                "status": "final",
                "category": [
                  {
                    "coding": [
                      {
                        "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                        "code": "laboratory",
                        "display": "Laboratory"
                      }
                    ],
                    "text": "Laboratory"
                  },
                  {
                    "coding": [
                      {
                        "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                        "code": "Microbiology",
                        "display": "Microbiology"
                      }
                    ],
                    "text": "Microbiology"
                  }
                ],
                "code": {
                  "coding": [
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.165",
                      "code": "21594-7"
                    },
                    {
                      "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                      "code": "12822",
                      "display": "Varicella-zoster virus antibody OLIS"
                    }
                  ],
                  "text": "Varicella-zoster virus antibody OLIS"
                },
                "subject": {
                  "reference": "Patient/eOA1Ao1.9YCGgDZtD8zYWJQ3",
                  "display": "SITSix, SITSix SITMIDDLESIX"
                },
                "encounter": {
                  "reference": "Encounter/eaIzbITSKPAVKHOe8sOT1Net2NHD3VpZmA-0HYKR27yQ3",
                  "identifier": {
                    "use": "usual",
                    "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                    "value": "10000112148"
                  },
                  "display": "Orders Only"
                },
                "effectiveDateTime": "2025-10-21T01:41:00Z",
                "issued": "2025-10-21T01:46:43Z",
                "valueString": "Nonreactive",
                "specimen": {
                  "reference": "Specimen/eErTiRuXFLOYu-PFkedf-ViVIZM5sFzHLSyIq24ySAwU3",
                  "display": "Specimen"
                }
              },
              "search": {
                "mode": "match"
              }
            },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpTMwrwfODKHkwEr6AeJkssf3l0iz6tE.-2Q5GZ07E-Qw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071385"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "30325-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "CYTOMEGALOVIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071385",
                              "display": "Cytomegalovirus IgM EIA"
                          }
                      ],
                      "text": "Cytomegalovirus IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLV4HM8nidfKEMczAXpG64nmEBvnZ7YsWmsNSGv-fIKhyg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24114-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071386"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071386",
                              "display": "Epstein Barr Virus VCA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXUrYrJFjm1IXby4g9aTvXzYy280Ie5GUSUmPUnGM.79g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "7883-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "EPSTEIN BARR VIRUS NUCLEAR AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071387"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071387",
                              "display": "Epstein Barr Virus EBNA IgG MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus EBNA IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLXh4adD5GTaLG4EatEavshgrazbb8huf4bb3kJZJUWPPg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071388"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "+++24115-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071388",
                              "display": "Epstein Barr Virus VCA IgM MFI"
                          }
                      ],
                      "text": "Epstein Barr Virus VCA IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza3uEv0JILQeyH674qSwd7FSoghSOzCMEEdC7pojLVNePQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071400"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16128-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HEPATITIS C VIRUS AB:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071400",
                              "display": "Hepatitis C Antibody"
                          }
                      ],
                      "text": "Hepatitis C Antibody"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNKXSYoW7QYDEQaLdD5am5rpFnyJlwIiAQLKuffrz9gYmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071407"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12263-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV 1+2 Ab+Ag:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071407",
                              "display": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                          }
                      ],
                      "text": "HIV-1/HIV-2 Ag/Ab Combo Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCvavJ.YbTzWsHCFEO9jCgrh.9UcreZSiPhiIHU9.qlBdA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071408"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "16982-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HTLV 1+2 Ab:ACnc:Pt:Ser:Ord:IB"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071408",
                              "display": "HTLV I/II Antibody Screen"
                          }
                      ],
                      "text": "HTLV I/II Antibody Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXLXY7eGJuUXB5G3CHZZw02XPVsTNpf7jeBYoISYsl1tLw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071411"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20479-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071411",
                              "display": "Measles IgG MFI"
                          }
                      ],
                      "text": "Measles IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXJhPq9dDziPe7zwNWzJneCyWaNeh8E43ImJhC-gmN0xHw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071412"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21503-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MEASLES VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071412",
                              "display": "Measles IgM MFI"
                          }
                      ],
                      "text": "Measles IgM MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.O1apVdvBzq0ceUOvprvgUMXsg8zQtrnVvH7VS8A9gVRA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071424"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "25514-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071424",
                              "display": "Rubella IgG EIA"
                          }
                      ],
                      "text": "Rubella IgG EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.N-lyySKpovmInVs0pBHUHLXs.odoIDY3cPNsHjQNKl5Q3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071425"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "31616-6"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "RUBELLA VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071425",
                              "display": "Rubella IgM EIA"
                          }
                      ],
                      "text": "Rubella IgM EIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRCiwVPnWk8l.zfnc7ij0MFWYXwOZGC9mmvnlyvBJCHvg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071429"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22587-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:PrThr:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071429",
                              "display": "Syphilis Antibody screen"
                          }
                      ],
                      "text": "Syphilis Antibody screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJQJ3khv3WFZGIcvwJ99-WD3p3EVvFrGbw.hqw5k4VChZw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071430"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "41122-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TREPONEMA PALLIDUM AB:ACNC:PT:XXX:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071430",
                              "display": "Syphilis RPR Quantitation"
                          }
                      ],
                      "text": "Syphilis RPR Quantitation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRshHFi76UYFcf72cl93WN8WiaXKI4OxIMBJIqs1WmZyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071431"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "24312-1"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:Aggl"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071431",
                              "display": "Syphilis TP.PA"
                          }
                      ],
                      "text": "Syphilis TP.PA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyhQl-AxEGvVGbdy820owLFvyd-1DbgToi1YKaNI9Qe1aA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071433"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22580-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071433",
                              "display": "Toxoplasmosis IgG CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygUwbOaACSZBj9FJKxeTn7k3on1GNSYmAQpsrKcBc72Eg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071434"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "8040-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "TOXOPLASMA GONDII AB.IGM:ACNC:PT:SER:QN"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071434",
                              "display": "Toxoplasmosis IgM CLIA"
                          }
                      ],
                      "text": "Toxoplasmosis IgM CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqAyxfnC4bkjjoVhEehx6atf.9gm-kqEmFhm94jYCoWFPQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071436"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "21597-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGM:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071436",
                              "display": "Varicella-Zoster IgM"
                          }
                      ],
                      "text": "Varicella-Zoster IgM"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdqhrni0KGlwS0qiQNfxXX4mwzhdGY-.XJvsbcU5jX7pmA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071444"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071444",
                              "display": "CMV Interpretation"
                          }
                      ],
                      "text": "CMV Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "No evidence of past exposure; indicates susceptibility.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7CKJCOMzNitVQMNNSRjGRyCOxAVPX1Xlh78havbZQdpkU4g15V9rUIsT1umdK2oxIGaR4LhHn-fE6XsfoSFLtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/en0CidtqqPlhWhF78Gz72qvq3ir4912xgWNSuPjEPoVg3",
                          "display": "Cytomegalovirus (CMV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071445"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071445",
                              "display": "CMV Note"
                          }
                      ],
                      "text": "CMV Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:01Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.\r\n",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eTsUnImdfIVOcnyHcKgm2JvYdOTp6u2EY3VECu3x6OLVyIfNp-AHgeZ3jZOpi9a1NwANA8epjYTitGoHTvJEINg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eIQMSG8iBJD9fMPR0PY-nsU.zwMpPDgtLSKnGObIjcpA3",
                          "display": "Epstein-Barr Virus (EBV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071448"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071448",
                              "display": "Epstein Barr Virus Interpretation"
                          }
                      ],
                      "text": "Epstein Barr Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:11Z",
                  "valueString": "No laboratory evidence of recent/past EBV infection.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1XWx1bDGMonihTx60MY-8YmQJvhYiuN1hEglCx7lU8FQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071457"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071457",
                              "display": "Hepatitis C Interpretation"
                          }
                      ],
                      "text": "Hepatitis C Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "No evidence of HCV Antibody",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJK-wdc8xJ1RnwK8xK5ezgxNKy28AuxTh9BVWBCIuW3lA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071461"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13032-8"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HIV final interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071461",
                              "display": "HIV Final Interpretation"
                          }
                      ],
                      "text": "HIV Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "Non-reactive for HIV-1 p24 antigen and HIV-1/HIV-2 antibodies.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3hRqDS1t23w2ygcD2L2q5gzKR-o8HL1OuMlq6URnhNJXwCMX0x.14C7SKKx8wzDetLshANnXx1gzV.4ZH5k9ww3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eLwDP-vrzQTpX9DgOc5amZrioC6.x3Dnfzz55Ygs13J03",
                          "display": "HIV Serology - Routine Diagnosis"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071462"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071462",
                              "display": "HIV Final Note"
                          }
                      ],
                      "text": "HIV Final Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:56Z",
                  "valueString": "For high-risk exposures, repeat HIV testing at 3 weeks and, if negative, at 6 weeks after possible exposure, or on presentation of symptoms compatible with acute HIV infection.\r\n",
                  "specimen": {
                      "reference": "Specimen/etYHbZgIFadX42lGGkMUTFg3",
                      "display": "Specimen 25X-233P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "ekHWmbpp4Y6W50d5B0Lw0rLiTVtNQ-DymhgZR-mbqtCu1kzB.e1zmUJAjE2fdDCubi6NWrcO3z98VoV8vhsWMOw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eYWJ86ouL84fxt4TzBllaBxBw78gdCovhQO2LFE1aCMM3",
                          "display": "HTLV I and II, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071463"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13563-2"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Interpretation:Imp:Pt:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071463",
                              "display": "HTLV I/II Final Interpretation"
                          }
                      ],
                      "text": "HTLV I/II Final Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:50:41Z",
                  "valueString": "No HTLV I / II antibodies detected.",
                  "specimen": {
                      "reference": "Specimen/e8QxLw2Wr3fRyjxy4gJPNMA3",
                      "display": "Specimen 25X-232P0001"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXL.8SncssMZsELakHhPZ5zKb7V3pwOVRejrunELXFVHtw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071465"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071465",
                              "display": "Measles Interpretation"
                          }
                      ],
                      "text": "Measles Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "No serological evidence of recent or past Measles infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e7.gyYdk.PdaO5kghaWdEAw1iGYIAJoJgsE78pTKJdXIdad2VmMs5b-t4CiqAeS6j84ifkiFmqY0lIos-9IpCfw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eAqo09SexQagGhha8eAKkw4oFTpdrnDdY4Xlg4lhgeas3",
                          "display": "Measles, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071466"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071466",
                              "display": "Measles Note"
                          }
                      ],
                      "text": "Measles Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:11Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FVxz.71UUVdWo9H4KXzmgEqgWcXQsB0L4soF8Z6LQjGA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071467"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10842-3"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION:IMP:Pt:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071467",
                              "display": "Mumps Interpretation"
                          }
                      ],
                      "text": "Mumps Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "No evidence of immunity (indicates susceptibility)",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5FNPavE2TFh4NI3hNZp2LLgsqIGzaDLbPXA.EfPWzVAuA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071468"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071468",
                              "display": "Mumps Note"
                          }
                      ],
                      "text": "Mumps Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient. For assistance regarding the interpretation of specific IgG and IgM serology refer to Public Health Labstract Diagnostic Interpretation of Viral Specific IgM and IgG  Serology Lab-SD-044 at: http:www.publichealthontario.ca/Labstracts",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.NW-vOFVXVDbmVOr47aHCCLGBe9vnWnBdsyFD0sepI91g3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071473"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071473",
                              "display": "Rubella Interpretation"
                          }
                      ],
                      "text": "Rubella Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "No serological evidence of recent or past Rubella infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eeX03o8Vo4SX2ylnGKQZttkiOy3VfZ9t7y5sQu2o83.MjxteVujqcP.wz3.IO69zUTse3xR-SlBpSyhG9hnJcAQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfhAbPLeTLtL4EO59NXgm7iUnpRvgIlO7gDfZUeVYw83",
                          "display": "Rubella, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071474"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071474",
                              "display": "Rubella Note"
                          }
                      ],
                      "text": "Rubella Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:48:31Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTueg1kgc-rweHZtgqM7LtaoHa-GVW2SGyu2piyv.k1tQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071477"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071477",
                              "display": "Syphilis Serology Interpretation"
                          }
                      ],
                      "text": "Syphilis Serology Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No serological evidence of current or past infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRKKDkh.dVR7.Vl-DmBMoNg64FhDuzMcshJc2j.kEOyrg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071478"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071478",
                              "display": "Syphilis Serology Note"
                          }
                      ],
                      "text": "Syphilis Serology Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "No confirmatory testing is performed on samples with non-reactive screening results. If not done already, repeat syphilis serology testing is recommended in 4 weeks for individuals suspected of syphilis infection or re-infection.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQygnhd8jaDM0u9dSTsL2V1VJiJ5eZYXGcQze98Xto4WPCA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071479"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071479",
                              "display": "Toxoplasmosis Interpretation"
                          }
                      ],
                      "text": "Toxoplasmosis Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "No serological evidence of recent or past Toxoplasma gondii infection.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eelrTsRcypMakVFtWkY3r6Fkx3PBFOD2WCZMGD2UYQyja4EbNsPUUAkz58GzveZyNpzk-xTMYLJN4d7kUoEODdg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/elGh9ZQj9IXx1qDUkc0XhpXbri3Kx5dnpMSkpf5KeoAM3",
                          "display": "Toxoplasma gondii, Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071480"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071480",
                              "display": "Toxoplasmosis Note"
                          }
                      ],
                      "text": "Toxoplasmosis Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:20:41Z",
                  "valueString": "Results should be interpreted in conjunction with clinical history, signs and symptoms.",
                  "specimen": {
                      "reference": "Specimen/eQB.U2qNPkHQ8ilSk6Dbxnw3",
                      "display": "Specimen 25X-233P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCQNcYeG85fym5kj0BV.57UhsG6SXQbr2HLN03.ZdT9EQ3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071481"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071481",
                              "display": "Varicella-Zoster Interpretation"
                          }
                      ],
                      "text": "Varicella-Zoster Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "No serological evidence of recent or past Varicella-Zoster infection. If clinically indicated, please submit a new sample to monitor for any significant change in antibody level.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqDhZDGi28c-k3AH-fY9-.VPp8vs5EMTqF6Ii4aF2HbZlA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071482"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "77202-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Laboratory comment:Txt:Pt:Report:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071482",
                              "display": "Varicella-Zoster Note"
                          }
                      ],
                      "text": "Varicella-Zoster Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Results to be interpreted in the context of the clinical history, signs and symptoms of the patient.",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e792XJzulT2gGiGnVHHyTh3GE1Fd7yEB0tn22W0aNB5EPCYY0WNslK0Sgsl4Aq7Ok2JQvmT2lerD4Bu5CpcRaYg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/ebDFLIZilG4hKKqqtM5ilSYV1aCI8UP2zH1hB1NCZXWM3",
                          "display": "Mumps, Immunity Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "22415-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123071488"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "MUMPS VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123071488",
                              "display": "Mumps IgG MFI"
                          }
                      ],
                      "text": "Mumps IgG MFI"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:14:56Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "el51ZgW9PRw2oQ6bng4MA4IYfksOafcGp.KHk8V2UTqCcbwVMrck5M85xfmVNjlqHGNfNpJmK7V2e7qi6q8mqJg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eZfso70fdYJL3Gb3Pbo6mogoR5vL8L9dNi9PD-5bm-U03",
                          "display": "Varicella-Zoster Virus (VZV), Diagnostic Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "123120003"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "19162-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "VARICELLA ZOSTER VIRUS AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "123120003",
                              "display": "Varicella-Zoster IgG"
                          }
                      ],
                      "text": "Varicella-Zoster IgG"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-20T18:44:00Z",
                  "issued": "2025-08-20T18:49:41Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/e5dK7oD4T4EXL.HUmH28luQ3",
                      "display": "Specimen 25X-232P0002"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "eOq4ypXobm12Wme3FDGDQMGifBNkn0GlE4OKcGazCza1NXYtnNr2iCwQLInDLFwjb18vL.zUmpPyt8YAeW.zEyw3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/eX4wg7PnM.CXpETHbEwyF8QnG56FcHd-zGU94uPwf4ew3",
                          "display": "Hepatitis C, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1230300203"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON13050-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Hepatitis C virus Ab supplemental:ACnc:Pt:Ser:Ord"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1230300203",
                              "display": "Hepatitis C Antibody Supplemental"
                          }
                      ],
                      "text": "Hepatitis C Antibody Supplemental"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:16:41Z",
                  "valueString": "Nonreactive",
                  "note": [
                      {
                          "text": "HCV RNA reflex testing is performed on: \r\n1) First-time reactive HCV antibody results to determine active/current infection.\r\n2) Patients with a previous Positive HCV antibody result with no history of HCV RNA testing\r\n3) Inconclusive HCV antibody results. \r\nFor other HCV RNA requests, submit a serum specimen for HCV RNA testing Following PHOL recommended guidelines found at publichealthontario.ca/HepCRNA."
                      }
                  ],
                  "specimen": {
                      "reference": "Specimen/e1kmOI..x0BWM3dXXPATY2g3",
                      "display": "Specimen 25X-233P0003"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJRz-qLeRQUzUahICQtnr.osHOhMZMmFqeJ49Xun1Pb4oA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200001"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "5393-4"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Treponema pallidum Ab:ACnc:Pt:Ser:Ord:IF"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200001",
                              "display": "Syphilis FTA Abs"
                          }
                      ],
                      "text": "Syphilis FTA Abs"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e0DRQJBFLQJJOzz8JfKJIqUHky1vhS5XOxfU9bfYeCJTCdzCIiWZxgm3wv3ayzWTtceKWzjlR7FjWzRYmjTcg0A3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e5W-qzGaR1vZHZcv-ssy8yD5t34F2jsOGY747imkYgT43",
                          "display": "Syphilis, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1231200002"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "20507-0"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Reagin Ab:ACnc:Pt:Ser:Ord:RPR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1231200002",
                              "display": "Syphilis RPR Screen"
                          }
                      ],
                      "text": "Syphilis RPR Screen"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:13:26Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  },
                  "referenceRange": [
                      {
                          "text": " "
                      }
                  ]
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXyv4pw23KRHDEy6FoFLiDlj8TLIsS8BacqC77RBMTZ12w3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701021"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17850-9"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 1 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701021",
                              "display": "Herpes Simplex Virus 1 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 1 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwuNf-RT8VNI4jkQqfUGXixMqlftbZH11JTOlqa7nxDLg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701022"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "17851-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "HERPES SIMPLEX VIRUS 2 AB.IGG:ACNC:PT:SER:ORD"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701022",
                              "display": "Herpes Simplex Virus 2 IgG CLIA"
                          }
                      ],
                      "text": "Herpes Simplex Virus 2 IgG CLIA"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Nonreactive",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXwlA84pZo3NT8Rb.MSr74L32fx.3jthe8yS01e1BFkVtg3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701023"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON10312-7"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "INTERPRETATION.MICRO:IMP:PT:XXX:NAR"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701023",
                              "display": "Herpes Simplex Virus Interpretation"
                          }
                      ],
                      "text": "Herpes Simplex Virus Interpretation"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Herpes Simplex Virus 1 IgG and Herpes Simplex Virus 2 IgG antibodies not detected.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          },
          {
              "link": [
                  {
                      "relation": "self",
                      "url": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3"
                  }
              ],
              "fullUrl": "https://epic-rp-np.unityhealth.to/OAuth2-POC/api/FHIR/R4/Observation/e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
              "resource": {
                  "resourceType": "Observation",
                  "id": "e3yn1-iGSyC-DErogmoy93OLbAUyvYhVCmN-VeJauzXzHWKyWheQ56cjB40B6oE2eMejIGAQviy-SSnf6ROp7ZA3",
                  "basedOn": [
                      {
                          "reference": "ServiceRequest/e4pzGl2fGWpXd8jldclC810YXkfTTTY9GXPIODaK9QZY3",
                          "display": "Herpes Simplex (HSV) 1 & 2, Serology"
                      }
                  ],
                  "status": "final",
                  "category": [
                      {
                          "coding": [
                              {
                                  "system": "http://terminology.hl7.org/CodeSystem/observation-category",
                                  "code": "laboratory",
                                  "display": "Laboratory"
                              }
                          ],
                          "text": "Laboratory"
                      },
                      {
                          "coding": [
                              {
                                  "system": "urn:oid:1.2.840.114350.1.13.744.3.7.10.798268.30",
                                  "code": "Microbiology",
                                  "display": "Microbiology"
                              }
                          ],
                          "text": "Microbiology"
                      }
                  ],
                  "code": {
                      "coding": [
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.326",
                              "code": "1232701024"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.331",
                              "code": "XON12722-5"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.5.737384.368",
                              "code": "Comment:Imp:XXX:XXX:Nar"
                          },
                          {
                              "system": "urn:oid:1.2.840.114350.1.13.744.3.7.2.768282",
                              "code": "1232701024",
                              "display": "Herpes Simplex Virus Note"
                          }
                      ],
                      "text": "Herpes Simplex Virus Note"
                  },
                  "subject": {
                      "reference": "Patient/eZ4Fxy8ToBxyhpU9iFBCBKA3",
                      "display": "SMHOne, RecipientOne"
                  },
                  "encounter": {
                      "reference": "Encounter/e92ZSrfl5RWO8QkaU9dmnSHO2mLDswz7Kw9nLvIsAebs3",
                      "identifier": {
                          "use": "usual",
                          "system": "urn:oid:1.2.840.114350.1.13.744.3.7.3.698084.8",
                          "value": "10000044301"
                      },
                      "display": "Treatment"
                  },
                  "effectiveDateTime": "2025-08-21T19:08:00Z",
                  "issued": "2025-08-21T19:15:31Z",
                  "valueString": "Note: Early antiviral therapy following acute HSV infection may result in a blunted or delayed IgG antibody response. The absence of detectable HSV IgG antibodies may not rule out recent HSV infection. If a recent HSV infection is suspected and has not been confirmed by virus detection (e.g. culture), a follow-up blood sample should be submitted 3-6 months post-exposure to detect the late development of HSV antibodies. Diagnosis of HSV infection is best performed by culture of the virus from vesicular fluid or lesion scrapings.",
                  "specimen": {
                      "reference": "Specimen/ex.xMM8jlyMc8flEezyPeiQ3",
                      "display": "Specimen 25X-233P0004"
                  }
              },
              "search": {
                  "mode": "match"
              }
          }
      ]
  ],
  "sectionsChecked": [],
  "episode_id": "eXnJ9xsrVd8Gnkgi.MGk6-g3"
};
const uhnOATSRecipientMock = {
  "_id": "692efe62f4e9e21a199efee6",
  "client_id": 68938,
  "created_at": "2025-12-02T14:57:38.873Z",
  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
  "death": {
      "_id": null,
      "autopsy": null,
      "cause_category": null,
      "cause_category_code": null,
      "cause_type": null,
      "cause_type_code": null,
      "cause_type_other": null,
      "comments": null,
      "created_at": "2025-12-02T14:57:38.874Z",
      "created_by": null,
      "death_date": null,
      "estimated_death_date": null,
      "prior_cause_category": null,
      "prior_cause_category_code": null,
      "prior_cause_type": null,
      "prior_cause_type_code": null,
      "related_to_waittime": null,
      "transplant_functioning_code": null,
      "updated_at": "2025-12-02T14:57:38.874Z",
      "updated_by": null
  },
  "diagnostics": {
      "_id": null,
      "blood": {
          "_id": null,
          "rh_indicator": "+",
          "type": "AB",
          "type_verified": true
      },
      "created_at": "2025-12-02T14:57:38.874Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "hla": {
          "_id": null,
          "cumulative_cpra": null,
          "cumulative_cpra_comments": null,
          "cumulative_historical_cpra_heart": null,
          "cumulative_historical_cpra_hsp": null,
          "cumulative_pra_class1": null,
          "cumulative_pra_class2": null,
          "hla_antibody_first_lab_date": null,
          "hla_comments": null,
          "hla_comments_updated_at": null
      },
      "miscellaneous": {
          "_id": null,
          "meld_first_date": null
      },
      "number_of_previous_transplants": null,
      "updated_at": "2025-12-05T16:00:30.512Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
  },
  "financial_assistance": {
      "_id": null,
      "comments": null,
      "created_at": "2025-12-02T14:57:38.874Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "date": null,
      "program_type": null,
      "status": null,
      "status_code": null,
      "tper_applicable": false,
      "updated_at": "2025-12-02T14:57:38.874Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
  },
  "migrated_recipient": false,
  "oop_recipient": false,
  "state": "inactive",
  "updated_at": "2025-12-05T16:42:29.309Z",
  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
  "urgent": false,
  "urgent_last_toggled_date": null,
  "clinical_transaction": null,
  "patient_profile": {
      "_id": "692efe62f4e9e21a199efee7",
      "addresses": [
          {
              "_id": "692efe62f4e9e21a199efeeb",
              "administrative_region_code": null,
              "city": "Toronto",
              "country_code": "CAN",
              "country_other": "",
              "postal_code": "M4Y 1X4",
              "province_code": "ON",
              "street": "465 Yonge St",
              "type": "permanent"
          }
      ],
      "age": null,
      "birth": {
          "_id": "692efe62f4e9e21a199efee8",
          "city": null,
          "country": null,
          "date": "1991-11-07",
          "province": null
      },
      "comments": null,
      "contact_details": {
          "_id": "692efe62f4e9e21a199efee9",
          "email": "123@email.ca",
          "phone_alternate": null,
          "phone_alternate_ext": null,
          "phone_alternate_other": null,
          "phone_mobile": "",
          "phone_pager": "",
          "phone_primary": "",
          "phone_primary_ext": null,
          "phone_primary_other": null,
          "primary_contact_name": null,
          "primary_contact_relationship_code": null,
          "secondary_contact_name": null,
          "secondary_contact_relationship_code": null
      },
      "created_at": "2025-12-02T14:57:39.391Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "donor_id": null,
      "effective_date": null,
      "ethnicity_code": "10",
      "ethnicity_other": "testone",
      "first_name": "RecipientOne",
      "gender": "",
      "gender_other": "",
      "gender_sex_different": false,
      "in_utero": false,
      "insurance": {
          "_id": "692efe62f4e9e21a199efeea",
          "number": null,
          "other_plan": "883874784",
          "other_province_plan": null,
          "plan": null,
          "plan_checked": false,
          "plan_code": 3,
          "version": null
      },
      "last_name": "RecipientOne",
      "living_donor_id": null,
      "marital_status_code": null,
      "middle_name": "Testone",
      "postal_code": null,
      "recipient_id": "692efe62f4e9e21a199efee6",
      "sex": "M",
      "updated_at": "2025-12-05T16:42:29.317Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
  },
  "dialysis_procedures": [],
  "pancreas_islets_procedures": [],
  "virology_labs": [],
  "measurements": [
      {
          "_id": "696e509e4424806f57e8a440",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-01-19T15:41:18.277Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "date": "2026-01-05",
          "height": 182.9,
          "recipient_id": "692efe62f4e9e21a199efee6",
          "updated_at": "2026-01-19T15:41:18.277Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "weight": 49.9,
          "bmi": 14.9
      },
      {
          "_id": "696ac002c8395fae51fc81ec",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-01-16T22:47:30.940Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "date": "2026-01-01",
          "height": 182.9,
          "recipient_id": "692efe62f4e9e21a199efee6",
          "updated_at": "2026-01-16T22:47:30.940Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "weight": 100,
          "bmi": 29.9
      }
  ],
  "journeys": []
}
const uhnOATSRecipient69958 = {
  "_id": "695f21e251a43d7279dbbfdf",
  "client_id": 69958,
  "created_at": "2026-01-08T03:17:54.368Z",
  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
  "death": {
      "_id": null,
      "autopsy": null,
      "cause_category": null,
      "cause_category_code": null,
      "cause_type": null,
      "cause_type_code": null,
      "cause_type_other": null,
      "comments": null,
      "created_at": "2026-01-08T03:17:54.370Z",
      "created_by": null,
      "death_date": null,
      "estimated_death_date": null,
      "prior_cause_category": null,
      "prior_cause_category_code": null,
      "prior_cause_type": null,
      "prior_cause_type_code": null,
      "related_to_waittime": null,
      "transplant_functioning_code": null,
      "updated_at": "2026-01-08T03:17:54.370Z",
      "updated_by": null
  },
  "diagnostics": {
      "_id": null,
      "blood": {
          "_id": null,
          "rh_indicator": "+",
          "type": "A",
          "type_verified": true
      },
      "created_at": "2026-01-08T03:17:54.370Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "hla": {
          "_id": null,
          "cumulative_cpra": null,
          "cumulative_cpra_comments": null,
          "cumulative_historical_cpra_heart": null,
          "cumulative_historical_cpra_hsp": null,
          "cumulative_pra_class1": null,
          "cumulative_pra_class2": null,
          "hla_antibody_first_lab_date": null,
          "hla_comments": null,
          "hla_comments_updated_at": null
      },
      "miscellaneous": {
          "_id": null,
          "meld_first_date": "*******"
      },
      "number_of_previous_transplants": null,
      "updated_at": "2026-01-16T17:56:58.839Z",
      "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA"
  },
  "financial_assistance": {
      "_id": null,
      "comments": null,
      "created_at": "2026-01-08T03:17:54.371Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "date": null,
      "program_type": null,
      "status": null,
      "status_code": null,
      "tper_applicable": false,
      "updated_at": "2026-01-08T03:17:54.371Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
  },
  "journeys": [
      {
          "_id": "695f2415d76e660683dbc36b",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-01-08T03:27:17.697Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-01-08T03:27:17.699Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": false,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-01-30T19:12:59.493Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "NEPHROPATHY DUE TO ANALGESIC DRUGS",
              "primary_diagnosis_code": 31,
              "primary_diagnosis_date": "2026-02-05",
              "secondary_diagnosis": null,
              "secondary_diagnosis_code": null,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-01-08T03:27:17.699Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": true,
              "updated_at": "2026-01-29T02:07:13.227Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-01-26T15:34:09.460Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 3,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-01-27",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 16,
                      "assessment_decision_reason_other": "other further testing reason",
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "consultation_decision_date": "2026-01-27",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": "635dccb81ffc8d044ca029d3",
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "treatment_required",
                  "updated_at": "2026-01-27T19:44:05.284Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-01-08T03:27:17.700Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": "te",
                      "decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "decision_date": "2026-01-26",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-01-09",
                  "referral_number": 38139,
                  "referrer": {
                      "_id": "697787c36f93897312bf2118",
                      "organization": {
                          "_id": "697787c36f93897312bf211a",
                          "city": "Mississauga",
                          "country": "USA",
                          "name": "Doctor's Office Updated Again",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "35006",
                          "province": "AL",
                          "street": "5 Bloor St",
                          "type": null,
                          "type_code": 3
                      },
                      "professional": {
                          "_id": "697787c36f93897312bf2119",
                          "first_name": "Simon",
                          "last_name": "SavinSavin",
                          "type": null,
                          "type_code": 17
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-01-30T21:16:13.066Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-01-08T03:27:17.700Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-01-08T03:27:17.717Z",
                  "updated_by": null,
                  "waitlist_history_snapshots": [
                      {
                          "_id": "6984fe58f7686a9a802a95b1",
                          "journey_id": "695f2415d76e660683dbc36b",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-02-05T20:32:24.203+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-01-07",
          "state": "treatment_required",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "yellow",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005115",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-01-30T21:16:13.088Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "696a7b6257a113ffecfc7bf9",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-01-16T17:54:42.908Z",
          "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": true,
              "comments": null,
              "created_at": "2026-01-16T17:54:42.910Z",
              "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": true,
              "hcv_nat_positive": true,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-01-16T17:57:06.627Z",
              "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "ACUTE REJECTION",
              "primary_diagnosis_code": 44,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": null,
              "secondary_diagnosis_code": null,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Liver",
          "organ_code": 1,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "albumin": null,
              "albumin_date": null,
              "bilirubin": null,
              "bilirubin_date": null,
              "created_at": "2026-01-16T17:54:42.909Z",
              "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "egfr": null,
              "egfr_date": null,
              "inr": null,
              "inr_date": null,
              "latest_smc": {
                  "_id": null,
                  "accumulated_exception_points": null,
                  "baseline_date": "2026-01-16",
                  "baseline_override": null,
                  "baseline_score": null,
                  "created_at": "2026-01-16T18:04:59.127Z",
                  "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
                  "exception_diseases": false,
                  "exception_points_params": {
                      "_id": "696a7dcb66a87169cafc7bf3",
                      "age": null,
                      "birth_date": "1975-12-30",
                      "blackout_days": 0,
                      "exception_diseases": false,
                      "hcc": true,
                      "hcc_blackout_days": 0,
                      "hcc_in_criteria_date": "2026-01-16T18:04:58.787+00:00",
                      "hepatoblastoma": false,
                      "listing_date": "2026-01-16T00:00:00.000+00:00",
                      "liver_ped_cond": false,
                      "meld_peld": 20,
                      "metabolic_disease": false,
                      "organ_code": [
                          1
                      ],
                      "pediatric": false,
                      "refractory_pruritus_blackout_days": 0,
                      "refractory_pruritus_disease": false,
                      "refractory_pruritus_disease_date": null,
                      "smc_baseline_date": null,
                      "smc_flat_score": null,
                      "smc_override": false,
                      "version": null
                  },
                  "exception_points_scores": {
                      "_id": "696a7dcb66a87169cafc7bf4",
                      "exception_diseases": 0,
                      "hcc": 22,
                      "meld_peld": 20,
                      "multi_organ": 0,
                      "pediatric": 0
                  },
                  "flat_score": null,
                  "hcc": true,
                  "hcc_id": "696a7da457a113ffecfc7c15",
                  "liver_bridging_id": null,
                  "liver_downstaging_id": null,
                  "meld_id": "696a7beac8395fae51fc7d1e",
                  "override": null,
                  "override_comment": null,
                  "pediatric": false,
                  "peld_id": null,
                  "review_date": null,
                  "score": 22,
                  "score_source_code": "h",
                  "updated_at": "2026-01-16T18:04:59.148Z",
                  "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA"
              },
              "organ_specification_preference_code": null,
              "previous_malignancy": null,
              "previous_transfusion": null,
              "sodium": null,
              "sodium_date": null,
              "updated_at": "2026-01-16T18:04:59.159Z",
              "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "waitlist",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-01-16T17:55:53.104Z",
                  "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 112,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "assessment_decision_date": "2026-01-16",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "consultation_decision_date": "2026-01-16",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "eligible",
                  "updated_at": "2026-01-16T18:02:45.500Z",
                  "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-01-16T17:54:42.910Z",
                  "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "decision_date": "2026-01-16",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-01-16",
                  "referral_number": 38152,
                  "referrer": {
                      "_id": "696a7b9f57a113ffecfc7c00",
                      "organization": {
                          "_id": "696a7b9f57a113ffecfc7c02",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "ABCD",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M3H2G3",
                          "province": "ON",
                          "street": "123 Torrono st",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "696a7b9f57a113ffecfc7c01",
                          "first_name": "Test",
                          "last_name": "Name",
                          "type": null,
                          "type_code": 1
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-01-16T17:55:53.143Z",
                  "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-01-16T18:02:45.463Z",
                  "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": "2026-01-16",
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": "2026-01-16",
                      "liver_hcc_in_criteria_date": "2026-01-16T18:04:58.787+00:00",
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": "0",
                      "medical_status_date": "2026-01-16T18:02:45.573+00:00",
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": "2026-01-16T18:03:24.404+00:00",
                      "on_hold_medical_expiry_date": "2026-04-17T18:03:24.404+00:00",
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": 12,
                      "on_hold_medical_reason_comment": "with any exception condition (ED)",
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": true,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": true,
                      "suspended_liver_non_medical_date": "2026-01-16T18:03:24.404+00:00",
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": "inactive",
                  "updated_at": "2026-01-16T18:04:59.300Z",
                  "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
                  "waitlist_history_snapshots": [],
                  "waitlist_history_snapshots_date": null,
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": 19,
                  "waitlist_report_calculated_wait_days_date": "2026-02-04T20:03:07.352+00:00"
              }
          },
          "start_date": "2026-01-16",
          "state": "inactive",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "red",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "635c844fc8957dc3d2bde7e8",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": null,
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-01-16T18:04:59.322Z",
          "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
          "urgent": false
      }
  ],
  "migrated_recipient": false,
  "oop_recipient": false,
  "state": "active",
  "updated_at": "2026-01-30T21:16:13.097Z",
  "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
  "urgent": false,
  "urgent_last_toggled_date": null,
  "clinical_transaction": null,
  "patient_profile": {
      "_id": "695f21e151a43d7279dbbfde",
      "addresses": [
          {
              "_id": "695f21e251a43d7279dbbfe3",
              "administrative_region_code": null,
              "city": "Toronto",
              "country_code": "CAN",
              "country_other": "",
              "postal_code": "L9K 8J7",
              "province_code": "ON",
              "street": "1111 Bloor St.",
              "type": "permanent"
          }
      ],
      "age": null,
      "birth": {
          "_id": "695f21e251a43d7279dbbfe0",
          "city": null,
          "country": null,
          "date": "1975-12-30",
          "province": null
      },
      "comments": null,
      "contact_details": {
          "_id": "695f21e251a43d7279dbbfe1",
          "email": "email@email.com",
          "phone_alternate": null,
          "phone_alternate_ext": null,
          "phone_alternate_other": null,
          "phone_mobile": "+1 416-574-7444",
          "phone_pager": "",
          "phone_primary": "+1 415-222-4444",
          "phone_primary_ext": null,
          "phone_primary_other": null,
          "primary_contact_name": null,
          "primary_contact_relationship_code": null,
          "secondary_contact_name": null,
          "secondary_contact_relationship_code": null
      },
      "created_at": "2026-01-08T03:17:54.437Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "donor_id": null,
      "effective_date": null,
      "ethnicity_code": "3",
      "ethnicity_other": "",
      "first_name": "RecipientFour",
      "gender": "",
      "gender_other": "",
      "gender_sex_different": false,
      "in_utero": false,
      "insurance": {
          "_id": "695f21e251a43d7279dbbfe2",
          "number": null,
          "other_plan": null,
          "other_province_plan": null,
          "plan": null,
          "plan_checked": false,
          "plan_code": 0,
          "version": null
      },
      "last_name": "UHNFive",
      "living_donor_id": null,
      "marital_status_code": null,
      "middle_name": "",
      "postal_code": null,
      "recipient_id": "695f21e251a43d7279dbbfdf",
      "sex": "F",
      "updated_at": "2026-01-16T17:56:15.994Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
  },
  "dialysis_procedures": [],
  "pancreas_islets_procedures": [],
  "virology_labs": [
      {
          "_id": "697b7237de1a7db60c1e5144",
          "comments": null,
          "created_at": "2026-01-29T14:44:08.020Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "lab_code": "TOS",
          "lab_id": null,
          "lab_other": null,
          "recipient_id": "695f21e251a43d7279dbbfdf",
          "results": [
              {
                  "_id": "697b7238de1a7db60c1e5145",
                  "code": "CMV_IGG_AB",
                  "comments": null,
                  "created_at": "2026-01-29T14:44:08.020Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-01-29T14:44:08.020Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "697b7238de1a7db60c1e5146",
                  "code": "CMV_IGM_AB",
                  "comments": null,
                  "created_at": "2026-01-29T14:44:08.021Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-01-29T14:44:08.021Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              }
          ],
          "sample_date": null,
          "sample_number": null,
          "test_code": null,
          "test_date": "2026-01-23T16:11:00.000+00:00",
          "updated_at": "2026-01-29T14:44:08.045Z",
          "updated_by": "AUTOMATION_TGLNADMIN"
      },
      {
          "_id": "697b7246de1a7db60c1e5147",
          "comments": null,
          "created_at": "2026-01-29T14:44:22.991Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "lab_code": "TOS",
          "lab_id": null,
          "lab_other": null,
          "recipient_id": "695f21e251a43d7279dbbfdf",
          "results": [
              {
                  "_id": "697b7246de1a7db60c1e5148",
                  "code": "HCV_NAT",
                  "comments": null,
                  "created_at": "2026-01-29T14:44:22.992Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-01-29T14:44:22.992Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "697b7246de1a7db60c1e5149",
                  "code": "HIV",
                  "comments": null,
                  "created_at": "2026-01-29T14:44:22.992Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-01-29T14:44:22.992Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              }
          ],
          "sample_date": null,
          "sample_number": null,
          "test_code": null,
          "test_date": "2026-01-01T16:11:00.000+00:00",
          "updated_at": "2026-01-29T14:44:23.012Z",
          "updated_by": "AUTOMATION_TGLNADMIN"
      }
  ],
  "measurements": [
      {
          "_id": "696a7bc857a113ffecfc7c08",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-01-16T17:56:24.725Z",
          "created_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
          "date": "2026-01-16",
          "height": 155,
          "recipient_id": "695f21e251a43d7279dbbfdf",
          "updated_at": "2026-01-16T17:56:24.725Z",
          "updated_by": "BHAUTIK.CHHETA+CSCMANAGER@ONEID.ON.CA",
          "weight": 55,
          "bmi": 22.9
      }
  ]
}
const uhnOATSRecipient70068 = {
  "_id": "69961af3b8f5b90db728de05",
  "client_id": 70068,
  "created_at": "2026-03-02T16:09:03.770Z",
  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
  "death": {
      "_id": null,
      "autopsy": null,
      "cause_category": null,
      "cause_category_code": null,
      "cause_type": null,
      "cause_type_code": null,
      "cause_type_other": null,
      "comments": null,
      "created_at": "2026-02-18T20:02:59.273Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "death_date": null,
      "estimated_death_date": null,
      "prior_cause_category": null,
      "prior_cause_category_code": null,
      "prior_cause_type": null,
      "prior_cause_type_code": null,
      "related_to_waittime": null,
      "transplant_functioning_code": null,
      "updated_at": "2026-03-02T18:09:47.396Z",
      "updated_by": null
  },
  "diagnostics": {
      "_id": null,
      "blood": {
          "_id": null,
          "rh_indicator": "+",
          "type": "O",
          "type_verified": true
      },
      "created_at": "2026-02-18T20:02:59.274Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "hla": {
          "_id": null,
          "cumulative_antibodies": {
              "_id": null,
              "class1": {
                  "_id": null,
                  "antibodies": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate_allele_group": [],
                      "indeterminate_allele_specific": [],
                      "indeterminate_alpha_beta": [],
                      "possible_allele_specific": [],
                      "unacceptable_allele_group": [],
                      "unacceptable_allele_specific": [],
                      "unacceptable_alpha_beta": [],
                      "untested": []
                  },
                  "epitopes": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate": [],
                      "unacceptable": [],
                      "untested": []
                  }
              },
              "class2": {
                  "_id": null,
                  "antibodies": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate_allele_group": [],
                      "indeterminate_allele_specific": [],
                      "indeterminate_alpha_beta": [],
                      "possible_allele_specific": [],
                      "unacceptable_allele_group": [],
                      "unacceptable_allele_specific": [],
                      "unacceptable_alpha_beta": [],
                      "untested": []
                  },
                  "epitopes": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate": [],
                      "unacceptable": [],
                      "untested": []
                  }
              }
          },
          "cumulative_cpra": 0,
          "cumulative_cpra_comments": null,
          "cumulative_historical_cpra_heart": null,
          "cumulative_historical_cpra_hsp": null,
          "cumulative_pra_class1": 0,
          "cumulative_pra_class2": 0,
          "hla_antibody_first_lab_date": "2026-03-01T00:00:00.000+00:00",
          "hla_comments": null,
          "hla_comments_updated_at": null
      },
      "miscellaneous": {
          "_id": null,
          "meld_first_date": "*******"
      },
      "number_of_previous_transplants": null,
      "updated_at": "2026-03-31T14:54:20.230Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
  },
  "financial_assistance": {
      "_id": null,
      "comments": null,
      "created_at": "2026-02-18T20:02:59.274Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "date": null,
      "program_type": null,
      "status": null,
      "status_code": null,
      "tper_applicable": true,
      "updated_at": "2026-04-10T19:46:55.522Z",
      "updated_by": "AUTOMATION_TGLNADMIN"
  },
  "journeys": [
      {
          "_id": "699cb16162912e87f03f4776",
          "comments": "TEst TEst Test",
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-02-23T19:58:25.772Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699cb16162912e87f03f4776",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": true,
              "comments": "DAC Testing comments",
              "created_at": "2026-02-23T19:58:25.773Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": true,
              "hcv_nat_positive": true,
              "hep_ab_core_positive": null,
              "living_donor": true,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-24T19:12:52.792Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "OTHER",
              "primary_diagnosis_code": 99,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "RETRANSPLANT",
              "secondary_diagnosis_code": 24,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Lung",
          "organ_code": 4,
          "organ_specific_details": {
              "_id": null,
              "actual_forced_expiratory_volume": 88,
              "actual_total_lung_capacity": 94,
              "cardiac_output": null,
              "cell_mediated_immunity_skin_reactivity": null,
              "chest_ct_scan_date": "2026-04-14",
              "chest_ct_scan_result": "This is the song that never ends. It just goes on and on my friends. Some people...",
              "created_at": "2026-02-23T19:58:25.773Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "echocardiogram": false,
              "echocardiogram_comment": "ttt",
              "echocardiogram_date": "2026-04-06",
              "ejection_fraction_percent": null,
              "estimated_right_ventricular_systolic_pressure": 99,
              "extra_corporeal_life_support": "U",
              "extra_corporeal_life_support_comment": null,
              "intubated": null,
              "left_ventricle_remodel": null,
              "left_ventricle_result": null,
              "left_ventricular_ejection_fraction_percent_exercise": null,
              "left_ventricular_ejection_fraction_percent_resting": null,
              "lung_allocation_score": null,
              "organ_specification_preference_code": 422,
              "partial_pressure_dissolved_co2": null,
              "partial_pressure_dissolved_o2": null,
              "perfusion_left": 88,
              "perfusion_right": 77,
              "pneumoreduction": null,
              "pneumothorax": null,
              "predicted_forced_vital_capacity": 90,
              "predicted_total_lung_capacity": 96,
              "pulmonary_artery_diastolic_pressure": 22,
              "pulmonary_artery_systolic_pressure": 55,
              "pulmonary_mean_arterial_pressure": 11,
              "pulmonary_vascular_resistance_type": null,
              "pulmonary_vascular_resistance_woods": null,
              "right_arterial_diastolic_pressure": null,
              "right_arterial_systolic_pressure": null,
              "right_ventricle_result": null,
              "right_ventriclular_diastolic_pressure": null,
              "right_ventriclular_systolic_pressure": null,
              "right_ventricular_ejection_fraction_percent_exercise": null,
              "right_ventricular_ejection_fraction_percent_resting": null,
              "transmyorcardial_revascularization": null,
              "updated_at": "2026-04-14T18:27:17.773Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "ventilator": "U",
              "ventilator_comment": null
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-02-23T19:58:28.144Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 1,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-02-24",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": "Tesing consulation comments",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-02-24",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "eligible",
                  "updated_at": "2026-03-19T13:43:59.133Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-23T19:58:25.774Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-23",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-01-12",
                  "referral_number": 38380,
                  "referrer": {
                      "_id": "699cb1620229999f883f42e8",
                      "organization": {
                          "_id": "699cb1620229999f883f42e9",
                          "city": null,
                          "country": null,
                          "name": null,
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": null,
                          "province": null,
                          "street": null,
                          "type": null,
                          "type_code": null
                      },
                      "professional": {
                          "_id": "699cb1620229999f883f42ea",
                          "first_name": "John",
                          "last_name": "Granton",
                          "type": null,
                          "type_code": 18
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-04-09T13:33:13.239Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": null
          },
          "start_date": "2026-02-23",
          "state": "eligible",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-14T18:27:17.785Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699cb4a195da7293a53f4811",
          "comments": "Gigantic heart specific details comment box",
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-02-23T20:12:17.461Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699cb4a195da7293a53f4811",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-02-23T20:12:17.464Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-23T20:12:17.464Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "CONGENITAL ANOMALY",
              "primary_diagnosis_code": 8,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "CARDIOMYOPATHY",
              "secondary_diagnosis_code": 5,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Heart",
          "organ_code": 2,
          "organ_specific_details": {
              "_id": null,
              "acceptable_maximum_donor_weight": null,
              "acceptable_minimal_donor_weight": null,
              "anticoagulant_medications": null,
              "congenital_heart_disease": false,
              "created_at": "2026-02-23T20:12:17.463Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "extra_corporeal_membraneous_oxygenator": "N",
              "impella_heart_pump": "N",
              "impella_heart_pump_days": null,
              "intra_aortal_balloon_pump": "N",
              "intra_aortal_balloon_pump_days": null,
              "mechanical_circulatory_support_other": null,
              "medical_comments": null,
              "organ_specification_preference_code": null,
              "other_surgery_required_comments": null,
              "surgical_comments": null,
              "total_artifical_heart": null,
              "total_artifical_heart_days": null,
              "updated_at": "2026-03-02T15:46:01.811Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA",
              "vad_duration": null,
              "vad_insert_side": null,
              "vad_type": null,
              "vad_type_other_comment": null,
              "ventilator_support": null,
              "ventilator_support_days": null
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "consulting",
                  "created_at": "2026-03-19T13:35:33.432Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": [],
                      "assessment_decision": null,
                      "assessment_decision_code": null,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": null,
                      "assessment_decision_date": null,
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": [],
                      "consultation_decision": null,
                      "consultation_decision_code": null,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": null,
                      "consultation_decision_date": null,
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "assessing",
                  "updated_at": "2026-03-19T13:35:33.460Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-23T20:12:17.465Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-23",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-01-12",
                  "referral_number": 38381,
                  "referrer": {
                      "_id": "699fb7b4504bd13490c9c8a8",
                      "organization": {
                          "_id": "699fb7b4504bd13490c9c8a9",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Heart Function Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2N2",
                          "province": "ON",
                          "street": "UHN Toronto General Hospital, 585 Universtiy Avenue",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "699fb7b4504bd13490c9c8aa",
                          "first_name": "Heather",
                          "last_name": "Ross",
                          "type": null,
                          "type_code": 2
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-03-19T13:35:33.500Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": null
          },
          "start_date": "2026-02-23",
          "state": "assessing",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-03-19T13:37:31.530Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699dfcebe05cf3adfe224a8e",
          "comments": null,
          "completed": true,
          "completed_date": "2026-02-24",
          "completed_reason": "Cancelled",
          "completed_reason_code": 3,
          "created_at": "2026-02-24T19:33:00.114Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699dfcebe05cf3adfe224a8e",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-02-24T19:33:00.115Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": null,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": null,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-24T19:33:00.115Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "NON-LISTED RENAL DISORDERS",
              "primary_diagnosis_code": 99,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "GOODPASTURE'S SYNDROME",
              "secondary_diagnosis_code": 86,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-02-24T19:33:00.115Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-02-24T19:33:00.115Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "referral",
          "stage_attributes": {
              "_id": null,
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-24T19:33:00.115Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 5,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-24",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": 11
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-01-11",
                  "referral_number": 38384,
                  "referrer": {
                      "_id": "699dfcec5e328b70c52245ec",
                      "organization": {
                          "_id": "699dfcec5e328b70c52245ed",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 3
                      },
                      "professional": {
                          "_id": "699dfcec5e328b70c52245ee",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "cancelled",
                  "updated_at": "2026-02-24T19:33:01.547Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-02-24T19:33:00.115Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": "2026-03-07",
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-04-02T12:56:50.772Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "699dfd097930d36f5e5f71f5",
                          "journey_id": "699dfcebe05cf3adfe224a8e",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-02-24T19:33:29.424+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-02-24",
          "state": "cancelled",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-02T12:56:50.807Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699dfdcde05cf3adfe224ef9",
          "comments": null,
          "completed": true,
          "completed_date": "2026-02-24",
          "completed_reason": "Declined",
          "completed_reason_code": 4,
          "created_at": "2026-02-24T19:36:45.435Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699dfdcde05cf3adfe224ef9",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-02-24T19:36:45.436Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": null,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": null,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-24T19:36:45.436Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "NON-LISTED RENAL DISORDERS",
              "primary_diagnosis_code": 99,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "GOODPASTURE'S SYNDROME",
              "secondary_diagnosis_code": 86,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-02-24T19:36:45.436Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-02-24T19:36:45.436Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "referral",
          "stage_attributes": {
              "_id": null,
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-24T19:36:45.436Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 3,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-24",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": 9
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-02-24",
                  "referral_number": 38385,
                  "referrer": {
                      "_id": "699dfdcee05cf3adfe224ff7",
                      "organization": {
                          "_id": "699dfdcee05cf3adfe224ff8",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 7
                      },
                      "professional": {
                          "_id": "699dfdcee05cf3adfe224ff9",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "declined",
                  "updated_at": "2026-02-24T19:40:05.565Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-02-24T19:36:45.436Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": "2026-03-07",
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-02-24T19:36:45.449Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "699dffd27930d36f5e5f7213",
                          "journey_id": "699dfdcde05cf3adfe224ef9",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-02-24T19:45:22.196+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-02-24",
          "state": "declined",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-02T12:56:50.685Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699dff16e05cf3adfe2253ee",
          "comments": null,
          "completed": true,
          "completed_date": "2026-02-24",
          "completed_reason": "cancelled",
          "completed_reason_code": 3,
          "created_at": "2026-02-24T19:42:14.258Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699dff16e05cf3adfe2253ee",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-02-24T19:42:14.259Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": null,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": null,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-24T19:42:14.259Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "NON-LISTED RENAL DISORDERS",
              "primary_diagnosis_code": 99,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "GOODPASTURE'S SYNDROME",
              "secondary_diagnosis_code": 86,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-02-24T19:42:14.259Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-02-24T19:42:14.259Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "cancelled",
                  "created_at": "2026-02-24T19:43:23.211Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": [],
                      "assessment_decision": null,
                      "assessment_decision_code": 4,
                      "assessment_decision_comments": "Per Consultation cancellation",
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-02-24",
                      "assessment_decision_reason": "Per Consultation cancellation",
                      "assessment_decision_reason_code": 201,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": [],
                      "consultation_decision": null,
                      "consultation_decision_code": 4,
                      "consultation_decision_comments": "Moving to europe",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-02-24",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": 9
                  },
                  "migration_comment": null,
                  "state": "cancelled",
                  "updated_at": "2026-02-24T19:44:49.203Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-24T19:42:14.259Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-23",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-02-23",
                  "referral_number": 38386,
                  "referrer": {
                      "_id": "699dff165e328b70c5224b2e",
                      "organization": {
                          "_id": "699dff165e328b70c5224b2f",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "699dff165e328b70c5224b30",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-02-24T19:43:23.263Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-02-24T19:42:14.260Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": "2026-03-07",
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-02-24T19:42:14.272Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "699dffd86585f58a30b73589",
                          "journey_id": "699dff16e05cf3adfe2253ee",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-02-24T19:45:28.884+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-02-24",
          "state": "cancelled",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-02T12:56:50.685Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699e000ed975a705d5225a05",
          "comments": null,
          "completed": true,
          "completed_date": "2026-02-24",
          "completed_reason": "cancelled",
          "completed_reason_code": 3,
          "created_at": "2026-02-24T19:46:22.638Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699e000ed975a705d5225a05",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-02-24T19:46:22.639Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": null,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": null,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-24T19:46:22.639Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "NON-LISTED RENAL DISORDERS",
              "primary_diagnosis_code": 99,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "GOODPASTURE'S SYNDROME",
              "secondary_diagnosis_code": 86,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-02-24T19:46:22.639Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-02-24T19:46:22.639Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "cancelled",
                  "created_at": "2026-02-24T19:46:24.148Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 4,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-02-24",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 202,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 4,
                      "consultation_decision_comments": "Per Medical Assessment cancellation",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-02-24",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": "Per Medical Assessment cancellation",
                      "consultation_decision_reason_code": 200
                  },
                  "migration_comment": null,
                  "state": "cancelled",
                  "updated_at": "2026-02-24T19:47:19.594Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-24T19:46:22.639Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-24",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-02-24",
                  "referral_number": 38387,
                  "referrer": {
                      "_id": "699e000f23bbe97b48225515",
                      "organization": {
                          "_id": "699e000f23bbe97b48225516",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Kidney Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "699e000f23bbe97b48225517",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-02-24T19:46:24.196Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-02-24T19:46:22.640Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": "2026-03-07",
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-02-24T19:46:22.652Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "699e00606585f58a30b7359e",
                          "journey_id": "699e000ed975a705d5225a05",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-02-24T19:47:44.308+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-02-24",
          "state": "cancelled",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-02T12:56:50.685Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699e00a423bbe97b48225965",
          "comments": null,
          "completed": true,
          "completed_date": "2026-03-02",
          "completed_reason": null,
          "completed_reason_code": 15,
          "created_at": "2026-02-24T19:48:52.770Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699e00a423bbe97b48225965",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": true,
              "comments": null,
              "created_at": "2026-02-24T19:48:52.771Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": true,
              "hcv_ab_positive": true,
              "hcv_nat_positive": true,
              "hep_ab_core_positive": true,
              "living_donor": true,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-03-02T15:26:24.841Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "NON-LISTED RENAL DISORDERS",
              "primary_diagnosis_code": 99,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "GOODPASTURE'S SYNDROME",
              "secondary_diagnosis_code": 86,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-02-24T19:48:52.771Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-03-02T15:49:36.553Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": 165276,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "waitlist",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-02-24T19:48:54.264Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 112,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "635c844ec8957dc3d2bdded6",
                      "assessment_decision_date": "2026-03-02",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": "635c844ec8957dc3d2bddf04",
                      "consultation_decision_date": "2026-03-02",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "eligible",
                  "updated_at": "2026-03-02T15:26:29.160Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-24T19:48:52.771Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-24",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-02-24",
                  "referral_number": 38388,
                  "referrer": {
                      "_id": "699e00a5d975a705d5225cff",
                      "organization": {
                          "_id": "699e00a5d975a705d5225d00",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 8
                      },
                      "professional": {
                          "_id": "699e00a5d975a705d5225d01",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-02-24T19:48:54.310Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-02-24T19:48:52.771Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": "2026-03-02",
                      "dialysis_start_date": "2026-03-07",
                      "kidney_prior_journey_id": null,
                      "listing_date": "2026-03-02",
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": "N",
                      "medical_status_date": "2026-03-02T15:51:11.844+00:00",
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": "2026-03-01T00:00:00.000+00:00",
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": "active",
                  "updated_at": "2026-03-02T15:51:11.959Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "69a5acaef945567dedd131fb",
                          "journey_id": "699e00a423bbe97b48225965",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": "2026-03-02T05:00:00.000Z",
                          "created_at": "2026-03-02T05:00:00.000Z",
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-03-02T15:28:46.488+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": "2026-03-02T15:51:11.844+00:00",
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": 15,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-02-24",
          "state": "active",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-17T21:14:43.241Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699e0147d975a705d5225dff",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-02-24T19:51:35.459Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699e0147d975a705d5225dff",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-02-24T19:51:35.461Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-24T19:51:35.461Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "SHORT GUT SYNDROME",
              "primary_diagnosis_code": 1,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "SHORT GUT SYNDROME",
              "secondary_diagnosis_code": 1,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Small Bowel",
          "organ_code": 7,
          "organ_specific_details": {
              "_id": null,
              "created_at": "2026-02-24T19:51:35.460Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "organ_specification_preference_code": null,
              "other_comments": null,
              "stomach_included": false,
              "updated_at": "2026-02-24T19:51:35.460Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "consulting",
                  "created_at": "2026-03-19T13:39:23.607Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": [],
                      "assessment_decision": null,
                      "assessment_decision_code": null,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": null,
                      "assessment_decision_date": null,
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": [],
                      "consultation_decision": null,
                      "consultation_decision_code": null,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": null,
                      "consultation_decision_date": null,
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "assessing",
                  "updated_at": "2026-03-19T13:39:23.627Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-24T19:51:35.461Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-02-23",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-02-23",
                  "referral_number": 38389,
                  "referrer": {
                      "_id": "699f669306a89f564cc99f2a",
                      "organization": {
                          "_id": "699f669306a89f564cc99f2b",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Gi Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "UHN - TGH, 9N-975 - 200 Elizabeth Street",
                          "type": null,
                          "type_code": 4
                      },
                      "professional": {
                          "_id": "699f669306a89f564cc99f2c",
                          "first_name": "Peter",
                          "last_name": "Rossos",
                          "type": null,
                          "type_code": 4
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-03-19T13:39:23.661Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": null
          },
          "start_date": "2026-02-24",
          "state": "assessing",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-03-19T13:39:23.699Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "699e0247e05cf3adfe225ee2",
          "comments": null,
          "completed": true,
          "completed_date": "2026-03-02",
          "completed_reason": "Cancelled",
          "completed_reason_code": 3,
          "created_at": "2026-02-24T19:55:51.288Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "699e0247e05cf3adfe225ee2",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-02-24T19:55:51.289Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-02-24T19:55:51.289Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "RETRANPSLANT",
              "primary_diagnosis_code": 6,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": null,
              "secondary_diagnosis_code": null,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Pancreas (whole)",
          "organ_code": 6,
          "organ_specific_details": {
              "_id": null,
              "created_at": "2026-02-24T19:55:51.288Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "diabetes_type_code": null,
              "organ_specification_preference_code": null,
              "other_comments": null,
              "pancreas_type": "PTA",
              "receiving_insulin": null,
              "receiving_insulin_years": 0,
              "updated_at": "2026-02-24T19:55:51.288Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "referral",
          "stage_attributes": {
              "_id": null,
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-02-24T19:55:51.289Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 5,
                      "decision_comments": null,
                      "decision_coordinator_id": "635c844ec8957dc3d2bdd8c3",
                      "decision_date": "2026-03-02",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": 3
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-02-25",
                  "referral_number": 38390,
                  "referrer": {
                      "_id": "699faf1beca59b305bc9c35e",
                      "organization": {
                          "_id": "699faf1beca59b305bc9c35f",
                          "city": null,
                          "country": "CAN",
                          "name": null,
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": null,
                          "province": "ON",
                          "street": null,
                          "type": null,
                          "type_code": null
                      },
                      "professional": {
                          "_id": "699faf1ceca59b305bc9c360",
                          "first_name": null,
                          "last_name": null,
                          "type": null,
                          "type_code": null
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "cancelled",
                  "updated_at": "2026-03-02T15:15:08.555Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-02-24T19:55:51.289Z",
                  "created_by": null,
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-02-24T19:55:51.301Z",
                  "updated_by": null,
                  "waitlist_history_snapshots": [
                      {
                          "_id": "69a5aa57b5f3a0efc365cfcf",
                          "journey_id": "699e0247e05cf3adfe225ee2",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-03-02T15:18:47.547+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-02-24",
          "state": "cancelled",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "635c844ec8957dc3d2bdd858",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-03-02T15:30:11.170Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "urgent": true
      },
      {
          "_id": "69a5aa2e84cdff7553bda8ef",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-03-02T15:18:06.240Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "69a5aa2e84cdff7553bda8ef",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": true,
              "comments": "Testing Pancreas DAC",
              "created_at": "2026-03-02T15:18:06.241Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": true,
              "hcv_nat_positive": true,
              "hep_ab_core_positive": true,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-03-02T15:21:53.065Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "PANCREATITIS",
              "primary_diagnosis_code": 1,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "RETRANPSLANT",
              "secondary_diagnosis_code": 6,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Pancreas (whole)",
          "organ_code": 6,
          "organ_specific_details": {
              "_id": null,
              "created_at": "2026-03-02T15:18:06.241Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "diabetes_type_code": 1,
              "organ_specification_preference_code": null,
              "other_comments": null,
              "pancreas_type": "PTA",
              "receiving_insulin": null,
              "receiving_insulin_years": 0,
              "updated_at": "2026-03-02T15:52:12.015Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": 165277,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "post-transplant",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-03-02T15:18:07.443Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 112,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-03-02",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": "Testing consultation comments",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-03-02",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "eligible",
                  "updated_at": "2026-03-02T15:52:21.980Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "post_transplant": {
                  "_id": null,
                  "created_at": "2026-03-02T16:11:38.125Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "graft_failure_cause": null,
                      "graft_failure_cause_other": null,
                      "graft_failure_comments": null,
                      "graft_failure_date": null,
                      "post_transplant_date": null
                  },
                  "follow_ups": [
                      {
                          "_id": "69a5d26b2af6119a29bdcf62",
                          "a1c_date": null,
                          "a1c_value": null,
                          "amylase_date": null,
                          "amylase_value": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-03-02T18:09:47.341Z",
                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "creatinine_date": null,
                          "creatinine_value": null,
                          "date_of_entry": "2026-03-02",
                          "diabetes_indicator": null,
                          "diabetes_new_date": null,
                          "diabetes_post_transplant": null,
                          "diabetes_pre_transplant": null,
                          "dialysis_date": null,
                          "dialysis_indicator": null,
                          "dialysis_location": null,
                          "dialysis_province_code": null,
                          "dialysis_type": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": "2026-03-02",
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "graft_failure_cause": null,
                          "graft_failure_cause_other": null,
                          "graft_failure_comments": null,
                          "graft_failure_date": null,
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "insulin_date": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": null,
                          "medication_compliance_indicator": null,
                          "organ_rejection_indicator": null,
                          "post_transplant_complications": null,
                          "post_transplant_malignancy": null,
                          "primary_diagnosis": null,
                          "primary_disease_code": null,
                          "recipient_status_code": 1,
                          "records_stopped": null,
                          "renal_function_indicator": null,
                          "secondary_diagnosis": null,
                          "secondary_disease_code": null,
                          "source_of_followup": 6,
                          "source_of_followup_other": null,
                          "sugar_control_code": null,
                          "type": null,
                          "updated_at": "2026-03-02T18:09:47.341Z",
                          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                      }
                  ],
                  "kidney_removal_date": null,
                  "previous_graft_failure_code": null,
                  "state": "follow-up",
                  "updated_at": "2026-03-02T18:09:47.352Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-03-02T15:18:06.241Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-03-02",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-03-02",
                  "referral_number": 38817,
                  "referrer": {
                      "_id": "69a5aa2ed4484ab961bdbcef",
                      "organization": {
                          "_id": "69a5aa2ed4484ab961bdbcf0",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 7
                      },
                      "professional": {
                          "_id": "69a5aa2ed4484ab961bdbcf1",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-03-02T15:18:07.491Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "transplant": {
                  "_id": null,
                  "admission_date": null,
                  "clamp_removal_date": null,
                  "cold_isch_time": null,
                  "comments": null,
                  "complication_category_code": null,
                  "complication_date": null,
                  "complication_type_code": null,
                  "created_at": "2026-03-02T16:36:02.973Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "discharge_date": null,
                  "donor_client_id": 595947,
                  "donor_id": "677f5eda977e54001bb180c7",
                  "end_cold_storage_date": null,
                  "end_perfuse_date": null,
                  "factors": {
                      "_id": null,
                      "national_transplant_id": null,
                      "transplant_date": "2026-03-02"
                  },
                  "icu_days": null,
                  "list_of_vessels_used": null,
                  "number_of_transfusions": null,
                  "organ_specification_code": null,
                  "rewarm_time": null,
                  "state": "transplanted",
                  "surgical_persons": [],
                  "total_anesthesia_time": null,
                  "total_op_room_time": null,
                  "total_surgery_time": null,
                  "transplant_end_date": null,
                  "transplant_start_date": null,
                  "tumor": false,
                  "tumor_type": null,
                  "updated_at": "2026-03-02T16:37:36.766Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA",
                  "vascular_clamp_release_date": null,
                  "vessels_used": false
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-03-02T15:18:06.241Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": "2026-03-02",
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": "2026-03-02",
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": "H",
                      "medical_status_date": "2026-03-02T05:00:00.000+00:00",
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": "69a5b51dff7fd40e34039794",
                      "transplant_in_progress_date": "2026-03-02T16:09:03.766+00:00",
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": "active",
                  "updated_at": "2026-03-02T16:37:36.748Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "69a5ac3cf945567dedd131f1",
                          "journey_id": "69a5aa2e84cdff7553bda8ef",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-03-02T15:26:52.762+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": "2026-03-02T00:00:00.000+00:00",
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": 14,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-03-02",
          "state": "follow-up",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-17T21:14:43.217Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "69b31cbc1059618df45f121d",
          "comments": null,
          "completed": true,
          "completed_date": "2026-04-10",
          "completed_reason": "cancelled",
          "completed_reason_code": 3,
          "created_at": "2026-03-12T20:06:21.114Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "ctr_id": "69b31cbc1059618df45f121d",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-03-12T20:06:21.115Z",
              "created_by": "AMY.NI1@ONEID.ON.CA",
              "deceased_donor": null,
              "ecd_donor": null,
              "hcv_ab_positive": true,
              "hcv_nat_positive": true,
              "hep_ab_core_positive": null,
              "living_donor": null,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-03-12T20:06:21.115Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "HEPATITIS - TYPE B",
              "primary_diagnosis_code": 2,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "OTHER",
              "secondary_diagnosis_code": 78,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Liver",
          "organ_code": 1,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "albumin": null,
              "albumin_date": null,
              "bilirubin": null,
              "bilirubin_date": null,
              "created_at": "2026-03-12T20:06:21.115Z",
              "created_by": "AMY.NI1@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "egfr": null,
              "egfr_date": null,
              "inr": null,
              "inr_date": null,
              "latest_smc": {
                  "_id": null,
                  "accumulated_exception_points": null,
                  "baseline_date": "2026-04-07",
                  "baseline_override": null,
                  "baseline_score": null,
                  "created_at": "2026-04-07T13:11:55.223Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "exception_diseases": false,
                  "exception_points_params": {
                      "_id": "69d5029b78a76e1f56391690",
                      "age": null,
                      "birth_date": "1960-11-12",
                      "blackout_days": 0,
                      "exception_diseases": false,
                      "hcc": false,
                      "hcc_blackout_days": 0,
                      "hcc_in_criteria_date": null,
                      "hepatoblastoma": false,
                      "listing_date": "2026-04-07T13:11:55.082+00:00",
                      "liver_ped_cond": false,
                      "meld_peld": 26,
                      "metabolic_disease": false,
                      "organ_code": [
                          1
                      ],
                      "pediatric": false,
                      "refractory_pruritus_blackout_days": 0,
                      "refractory_pruritus_disease": false,
                      "refractory_pruritus_disease_date": null,
                      "smc_baseline_date": null,
                      "smc_flat_score": null,
                      "smc_override": false,
                      "version": null
                  },
                  "exception_points_scores": {
                      "_id": "69d5029b78a76e1f56391691",
                      "exception_diseases": 0,
                      "hcc": 0,
                      "meld_peld": 26,
                      "multi_organ": 0,
                      "pediatric": 0
                  },
                  "flat_score": null,
                  "hcc": false,
                  "hcc_id": null,
                  "liver_bridging_id": null,
                  "liver_downstaging_id": null,
                  "meld_id": "69d5012851237c7c8e39259c",
                  "override": null,
                  "override_comment": null,
                  "pediatric": false,
                  "peld_id": null,
                  "review_date": null,
                  "score": 26,
                  "score_source_code": "mp",
                  "updated_at": "2026-04-07T13:11:55.253Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              "organ_specification_preference_code": null,
              "previous_malignancy": null,
              "previous_transfusion": null,
              "sodium": null,
              "sodium_date": null,
              "updated_at": "2026-04-07T13:11:55.269Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "cancelled",
                  "created_at": "2026-04-09T13:47:54.835Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": [],
                      "assessment_decision": null,
                      "assessment_decision_code": 4,
                      "assessment_decision_comments": "Per Consultation cancellation",
                      "assessment_decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "assessment_decision_date": "2026-04-10",
                      "assessment_decision_reason": "Per Consultation cancellation",
                      "assessment_decision_reason_code": 201,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": [],
                      "consultation_decision": null,
                      "consultation_decision_code": 4,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "consultation_decision_date": "2026-04-10",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": "635c84512aa868bc227aadf0",
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": 10
                  },
                  "migration_comment": null,
                  "state": "cancelled",
                  "updated_at": "2026-04-10T18:37:43.793Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-03-12T20:06:21.115Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-04-09",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-03-23",
                  "referral_number": 39087,
                  "referrer": {
                      "_id": "69c14d5ae5e854b390aca173",
                      "organization": {
                          "_id": "69c14d5ae5e854b390aca174",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Transplant Liver Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "UHN - TGH, 9N-975 - 200 Elizabeth Street",
                          "type": null,
                          "type_code": 4
                      },
                      "professional": {
                          "_id": "69c14d5ae5e854b390aca175",
                          "first_name": "Peter",
                          "last_name": "Rossos",
                          "type": null,
                          "type_code": 4
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-04-09T13:47:54.898Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-03-12T20:10:52.004Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": "69b31ccad8e71454b25f0d93",
                      "living_donor_transplant_in_progress_date": "2026-03-12T20:10:51.998+00:00",
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-03-12T20:10:52.015Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA",
                  "waitlist_history_snapshots": [],
                  "waitlist_history_snapshots_date": null,
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-03-12",
          "state": "cancelled",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-10T18:37:43.830Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "69b9a529cbdf24c934adb882",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-03-17T19:02:01.297Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "69b9a529cbdf24c934adb882",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": false,
              "comments": "Testing both cluster reasons",
              "created_at": "2026-03-17T19:02:01.298Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": true,
              "hcv_ab_positive": false,
              "hcv_nat_positive": false,
              "hep_ab_core_positive": false,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-04-07T13:46:17.674Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "NON-LISTED RENAL DISORDERS",
              "primary_diagnosis_code": 99,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "GOODPASTURE'S SYNDROME",
              "secondary_diagnosis_code": 86,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": 99,
              "a1c_date": "2026-04-02",
              "created_at": "2026-03-17T19:02:01.298Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-04-02T12:56:47.513Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-03-23T14:57:41.047Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 3,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-03-30",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 21,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": "testing consultation completed for kidney",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-03-30",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "treatment_required",
                  "updated_at": "2026-04-02T12:44:14.084Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-03-17T19:02:01.298Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-03-17",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-03-03",
                  "referral_number": 39252,
                  "referrer": {
                      "_id": "69c154e4e5e854b390acabbd",
                      "organization": {
                          "_id": "69c154e4e5e854b390acabbe",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Transplant Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "69c154e4e5e854b390acabbf",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-03-23T14:57:41.100Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-03-17T19:02:01.298Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": "2026-03-07",
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-03-17T19:02:01.314Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA",
                  "waitlist_history_snapshots": [],
                  "waitlist_history_snapshots_date": null,
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-03-17",
          "state": "treatment_required",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "yellow",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-17T21:14:31.360Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "urgent": false
      },
      {
          "_id": "69b9a52aa6b165ab53adc308",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-03-17T19:02:02.203Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": "69b9a52aa6b165ab53adc308",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": false,
              "comments": "Testing both cluster reasons",
              "created_at": "2026-03-17T19:02:02.204Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": false,
              "hcv_nat_positive": false,
              "hep_ab_core_positive": false,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-04-07T13:46:20.946Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "DIABETES TYPE 2",
              "primary_diagnosis_code": 7,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "OTHER",
              "secondary_diagnosis_code": 99,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Pancreas (whole)",
          "organ_code": 6,
          "organ_specific_details": {
              "_id": null,
              "created_at": "2026-03-17T19:02:02.204Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "diabetes_type_code": 1,
              "organ_specification_preference_code": null,
              "other_comments": null,
              "pancreas_type": "PAK",
              "receiving_insulin": null,
              "receiving_insulin_years": 0,
              "updated_at": "2026-04-02T12:58:58.025Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "delayed",
                  "created_at": "2026-03-30T14:45:30.779Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 1,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-03-30",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 7,
                      "consultation_decision_comments": "Testing pancreas consultation comments",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-03-30",
                      "consultation_decision_delay_end_date": "2026-03-30",
                      "consultation_decision_delay_start_date": "2026-03-30",
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": 4
                  },
                  "migration_comment": null,
                  "state": "eligible",
                  "updated_at": "2026-03-30T14:53:22.273Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "USA",
                  "administrative_province_code": "AL",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-03-17T19:02:02.205Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-03-17",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-03-03",
                  "referral_number": 39253,
                  "referrer": {
                      "_id": "69ca8c89b9f830181638e128",
                      "organization": {
                          "_id": "69ca8c89b9f830181638e129",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Transplant Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "69ca8c89b9f830181638e12a",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-03-30T14:45:30.839Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-03-17T19:02:02.205Z",
                  "created_by": null,
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-03-17T19:02:02.217Z",
                  "updated_by": null,
                  "waitlist_history_snapshots": [],
                  "waitlist_history_snapshots_date": null,
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-03-17",
          "state": "eligible",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100004801",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-07T13:46:20.957Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      }
  ],
  "migrated_recipient": false,
  "oop_recipient": false,
  "state": "active",
  "updated_at": "2026-04-17T21:14:43.241Z",
  "updated_by": "AUTOMATION_TGLNADMIN",
  "urgent": false,
  "urgent_last_toggled_date": null,
  "clinical_transaction": null,
  "patient_profile": {
      "_id": "69961af3b8f5b90db728de06",
      "addresses": [
          {
              "_id": "69961af3b8f5b90db728de09",
              "administrative_region_code": null,
              "city": "ADAMSVILLE",
              "country_code": "USA",
              "country_other": "",
              "postal_code": "35005",
              "province_code": "AL",
              "street": "280 Dundas Street",
              "type": "permanent"
          }
      ],
      "age": null,
      "birth": {
          "_id": "69961af3b8f5b90db728de07",
          "city": null,
          "country": null,
          "date": "1960-11-12",
          "province": null
      },
      "comments": null,
      "contact_details": {
          "_id": "69961af3b8f5b90db728de0a",
          "email": "",
          "phone_alternate": null,
          "phone_alternate_ext": null,
          "phone_alternate_other": null,
          "phone_mobile": null,
          "phone_pager": "",
          "phone_primary": null,
          "phone_primary_ext": null,
          "phone_primary_other": null,
          "primary_contact_name": null,
          "primary_contact_relationship_code": null,
          "secondary_contact_name": null,
          "secondary_contact_relationship_code": null
      },
      "created_at": "2026-02-18T20:02:59.350Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "ctr": {
          "_id": "69a5ac25d4484ab961bdbd75",
          "ctd_override": null,
          "ctr_last_updated": null,
          "national_donor_id": null,
          "national_recipient_id": "CTR060371",
          "national_recipient_serum_id": null,
          "now_consent_withdrawn": false
      },
      "donor_id": null,
      "effective_date": null,
      "ethnicity_code": "9",
      "ethnicity_other": null,
      "first_name": "RecipientFour",
      "gender": null,
      "gender_other": null,
      "gender_sex_different": false,
      "in_utero": false,
      "insurance": {
          "_id": "69961af3b8f5b90db728de08",
          "number": null,
          "other_plan": "985896525",
          "other_province_plan": null,
          "plan": null,
          "plan_checked": false,
          "plan_code": 7,
          "version": null
      },
      "last_name": "UHNFour",
      "living_donor_id": null,
      "marital_status_code": null,
      "middle_name": "",
      "postal_code": null,
      "recipient_id": "69961af3b8f5b90db728de05",
      "sex": "M",
      "updated_at": "2026-04-17T21:14:34.576Z",
      "updated_by": "AUTOMATION_TGLNADMIN"
  },
  "dialysis_procedures": [
      {
          "_id": "69a5b19284cdff7553bdac02",
          "access_method_code": 2,
          "access_method_other": null,
          "comments": null,
          "created_at": "2026-03-02T15:49:38.926Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "date": null,
          "dialysis_provider_code": 22,
          "dialysis_type_code": 6,
          "dialysis_type_other": null,
          "end_date": null,
          "location_type_code": 2,
          "other_location_desc": null,
          "previous_type_code": null,
          "recipient_id": "69961af3b8f5b90db728de05",
          "start_date": "2026-03-07",
          "updated_at": "2026-04-02T12:56:50.467Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA"
      },
      {
          "_id": "69ce686653b8ff2398391eb8",
          "access_method_code": 5,
          "access_method_other": null,
          "comments": null,
          "created_at": "2026-04-02T13:00:22.101Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "date": null,
          "dialysis_provider_code": 178,
          "dialysis_type_code": 2,
          "dialysis_type_other": null,
          "end_date": null,
          "location_type_code": 1,
          "other_location_desc": null,
          "previous_type_code": null,
          "recipient_id": "69961af3b8f5b90db728de05",
          "start_date": "2026-04-02",
          "updated_at": "2026-04-02T13:00:22.101Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
      }
  ],
  "pancreas_islets_procedures": [],
  "virology_labs": [
      {
          "_id": "69dfa74e53b8ff239839a509",
          "comments": null,
          "created_at": "2026-04-15T14:57:18.066Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "lab_code": null,
          "lab_id": null,
          "lab_other": "OTHER",
          "recipient_id": "69961af3b8f5b90db728de05",
          "results": [
              {
                  "_id": "69dfa74e53b8ff239839a50a",
                  "code": "CMV_IGG_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.066Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:18.066Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a50b",
                  "code": "EBV_CAPSID_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a50c",
                  "code": "HBV_CORE_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a50d",
                  "code": "HBV_SURFACE_AG",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a50e",
                  "code": "EBV_EARLY_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a50f",
                  "code": "HBV_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a510",
                  "code": "HCV_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a511",
                  "code": "HBV_NAT",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a512",
                  "code": "HCV_NAT",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74e53b8ff239839a513",
                  "code": "HIV",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:18.067Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:18.067Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              }
          ],
          "sample_date": null,
          "sample_number": null,
          "test_code": null,
          "test_date": "2026-03-26T00:00:00.000+00:00",
          "updated_at": "2026-04-15T14:57:18.146Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
      },
      {
          "_id": "69dfa74db9f8301816398d56",
          "comments": null,
          "created_at": "2026-04-15T14:57:17.616Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "lab_code": null,
          "lab_id": null,
          "lab_other": "OTHER",
          "recipient_id": "69961af3b8f5b90db728de05",
          "results": [
              {
                  "_id": "69dfa74db9f8301816398d57",
                  "code": "HIV_NAT",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.616Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:17.616Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74db9f8301816398d58",
                  "code": "MEASLES_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.616Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:17.616Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              }
          ],
          "sample_date": null,
          "sample_number": null,
          "test_code": null,
          "test_date": "2026-03-01T00:00:00.000+00:00",
          "updated_at": "2026-04-15T14:57:17.633Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
      },
      {
          "_id": "69dfa74d53b8ff239839a430",
          "comments": null,
          "created_at": "2026-04-15T14:57:17.123Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "lab_code": null,
          "lab_id": null,
          "lab_other": "OTHER",
          "recipient_id": "69961af3b8f5b90db728de05",
          "results": [
              {
                  "_id": "69dfa74d53b8ff239839a431",
                  "code": "HTLV1",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.124Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:17.124Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74d53b8ff239839a432",
                  "code": "TOXOPLASMOSIS",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.124Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:17.124Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74d53b8ff239839a433",
                  "code": "VDRL",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.124Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:17.124Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74d53b8ff239839a434",
                  "code": "VZV_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.124Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:17.124Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74d53b8ff239839a435",
                  "code": "MUMPS_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.124Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-04-15T14:57:17.124Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              {
                  "_id": "69dfa74d53b8ff239839a436",
                  "code": "RUBELLA_AB",
                  "comments": "",
                  "created_at": "2026-04-15T14:57:17.124Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-04-15T14:57:17.124Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              }
          ],
          "sample_date": null,
          "sample_number": null,
          "test_code": null,
          "test_date": "2026-02-09T00:00:00.000+00:00",
          "updated_at": "2026-04-15T14:57:17.177Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
      }
  ],
  "measurements": [
      {
          "_id": "69ca8a9351237c7c8e38ddf9",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-03-30T14:37:07.202Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "date": "2026-03-30",
          "height": 181,
          "recipient_id": "69961af3b8f5b90db728de05",
          "updated_at": "2026-03-30T14:37:07.202Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "weight": 79,
          "bmi": 24.1
      },
      {
          "_id": "69ca8a93b9f830181638df82",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-03-30T14:37:07.551Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "date": "2026-03-05",
          "height": 182.5,
          "recipient_id": "69961af3b8f5b90db728de05",
          "updated_at": "2026-03-30T14:37:07.551Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "weight": 80,
          "bmi": 24
      },
      {
          "_id": "699df950e05cf3adfe22456d",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-02-24T19:17:36.896Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "date": "2026-02-24",
          "height": 182,
          "recipient_id": "69961af3b8f5b90db728de05",
          "updated_at": "2026-02-24T19:17:36.896Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "weight": 71.2,
          "bmi": 21.5
      },
      {
          "_id": "699df95123bbe97b4822418f",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-02-24T19:17:37.318Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "date": "2025-09-03",
          "height": 90,
          "recipient_id": "69961af3b8f5b90db728de05",
          "updated_at": "2026-02-24T19:17:37.318Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "weight": 90,
          "bmi": 111.1
      }
  ],
  "liver_melds": [
      {
          "_id": "69d5012851237c7c8e39259c",
          "comments": null,
          "created_at": "2026-04-07T13:05:44.203Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "expiry_date": "2026-07-07",
          "inr": 3,
          "na_meld": 26,
          "on_dialysis": null,
          "recent_dialysis_and_creatinine_test": false,
          "recertification_end_date": null,
          "recertification_start_date": null,
          "recipient_id": "69961af3b8f5b90db728de05",
          "send_expiry_alert": null,
          "send_suspended_alert": null,
          "serum_albumin": 150,
          "serum_bilirubin": 1,
          "serum_creatinine": 70,
          "serum_sodium": 12,
          "test_code": null,
          "test_date": "2026-04-07",
          "updated_at": "2026-04-07T13:11:54.953Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "deceased_donor_id": null,
          "donor_client_id": null,
          "_type": "liver_meld_recipient"
      },
      {
          "_id": "69cec03b51237c7c8e391c04",
          "comments": null,
          "created_at": "2026-04-02T19:15:07.164Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "expiry_date": "2026-06-30",
          "inr": 7,
          "na_meld": 40,
          "on_dialysis": null,
          "recent_dialysis_and_creatinine_test": true,
          "recertification_end_date": null,
          "recertification_start_date": null,
          "recipient_id": "69961af3b8f5b90db728de05",
          "send_expiry_alert": null,
          "send_suspended_alert": null,
          "serum_albumin": 96,
          "serum_bilirubin": 119,
          "serum_creatinine": 72,
          "serum_sodium": 151,
          "test_code": null,
          "test_date": "2026-03-31",
          "updated_at": "2026-04-02T19:17:46.005Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "deceased_donor_id": null,
          "donor_client_id": null,
          "_type": "liver_meld_recipient"
      },
      {
          "_id": "69cebea578a76e1f56390eee",
          "comments": null,
          "created_at": "2026-04-02T19:08:21.240Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "expiry_date": "2026-06-22",
          "inr": 7,
          "na_meld": 40,
          "on_dialysis": null,
          "recent_dialysis_and_creatinine_test": true,
          "recertification_end_date": null,
          "recertification_start_date": null,
          "recipient_id": "69961af3b8f5b90db728de05",
          "send_expiry_alert": null,
          "send_suspended_alert": null,
          "serum_albumin": 96,
          "serum_bilirubin": 79,
          "serum_creatinine": 72,
          "serum_sodium": 151,
          "test_code": null,
          "test_date": "2026-03-23",
          "updated_at": "2026-04-02T19:12:13.477Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "deceased_donor_id": null,
          "donor_client_id": null,
          "_type": "liver_meld_recipient"
      },
      {
          "_id": "69cebbc2b9f8301816390d4e",
          "comments": null,
          "created_at": "2026-04-02T18:56:02.934Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "expiry_date": "2026-06-22",
          "inr": 7,
          "na_meld": 40,
          "on_dialysis": null,
          "recent_dialysis_and_creatinine_test": true,
          "recertification_end_date": null,
          "recertification_start_date": null,
          "recipient_id": "69961af3b8f5b90db728de05",
          "send_expiry_alert": null,
          "send_suspended_alert": null,
          "serum_albumin": 96,
          "serum_bilirubin": 89,
          "serum_creatinine": 72,
          "serum_sodium": 151,
          "test_code": null,
          "test_date": "2026-03-23",
          "updated_at": "2026-04-02T19:02:19.468Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "deceased_donor_id": null,
          "donor_client_id": null,
          "_type": "liver_meld_recipient"
      }
  ]
};
const uhnOATSRecipient71099 = {
  "_id": "69dd063151237c7c8e3973c2",
  "client_id": 71099,
  "created_at": "2026-04-13T15:05:21.656Z",
  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
  "death": {
      "_id": null,
      "autopsy": null,
      "cause_category": null,
      "cause_category_code": null,
      "cause_type": null,
      "cause_type_code": null,
      "cause_type_other": null,
      "comments": null,
      "created_at": "2026-04-13T15:05:21.657Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "death_date": null,
      "estimated_death_date": null,
      "prior_cause_category": null,
      "prior_cause_category_code": null,
      "prior_cause_type": null,
      "prior_cause_type_code": null,
      "related_to_waittime": null,
      "transplant_functioning_code": null,
      "updated_at": "2026-04-20T14:54:13.954Z",
      "updated_by": null
  },
  "diagnostics": {
      "_id": null,
      "blood": {
          "_id": null,
          "rh_indicator": "+",
          "type": "B",
          "type_verified": false
      },
      "created_at": "2026-04-13T15:05:21.657Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "hla": {
          "_id": null,
          "cumulative_cpra": null,
          "cumulative_cpra_comments": null,
          "cumulative_historical_cpra_heart": null,
          "cumulative_historical_cpra_hsp": null,
          "cumulative_pra_class1": null,
          "cumulative_pra_class2": null,
          "hla_antibody_first_lab_date": null,
          "hla_comments": null,
          "hla_comments_updated_at": null
      },
      "miscellaneous": {
          "_id": null,
          "meld_first_date": "*******"
      },
      "number_of_previous_transplants": null,
      "updated_at": "2026-05-19T17:22:19.296Z",
      "updated_by": "AMY.NI1@ONEID.ON.CA"
  },
  "financial_assistance": {
      "_id": null,
      "comments": null,
      "created_at": "2026-04-13T15:05:21.657Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "date": null,
      "program_type": null,
      "status": null,
      "status_code": null,
      "tper_applicable": true,
      "updated_at": "2026-04-28T14:30:43.325Z",
      "updated_by": "AUTOMATION_TGLNADMIN"
  },
  "journeys": [
      {
          "_id": "69e0d79e51237c7c8e3991e8",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-04-16T12:35:42.173Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": true,
              "comments": "DAC Transplanted Kidney",
              "created_at": "2026-04-16T12:35:42.175Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": false,
              "ecd_donor": true,
              "hcv_ab_positive": true,
              "hcv_nat_positive": true,
              "hep_ab_core_positive": true,
              "living_donor": true,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-04-30T19:47:10.700Z",
              "updated_by": "AUTOMATION_TGLNADMIN"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "FOCAL GLOMERULOSCLEROSIS - ADULTS",
              "primary_diagnosis_code": 9,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "DIABETES - NON-INSULIN DEPENDENT (TYPE II)",
              "secondary_diagnosis_code": 81,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-04-16T12:35:42.174Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-04-23T12:49:20.646Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": true,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "post-transplant",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-04-16T12:35:43.384Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": [
                          "A3-1"
                      ],
                      "assessment_decision": null,
                      "assessment_decision_code": 2,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-04-16",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 3,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": [
                          "A3-1"
                      ],
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": "Testing kidney consultation comments",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-04-16",
                      "consultation_decision_delay_end_date": "2026-04-25",
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "not_eligible",
                  "updated_at": "2026-05-15T13:25:27.771Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "post_transplant": {
                  "_id": null,
                  "created_at": "2026-04-20T14:40:00.676Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "factors": {
                      "_id": null,
                      "graft_failure_cause": 1,
                      "graft_failure_cause_other": null,
                      "graft_failure_comments": null,
                      "graft_failure_date": "2026-04-27",
                      "post_transplant_date": null
                  },
                  "follow_ups": [
                      {
                          "_id": "69e63e15b9f830181639deb5",
                          "a1c": null,
                          "clinical_grade_code": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-04-20T14:54:13.919Z",
                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "date_a1c": null,
                          "date_graft_nephrectomy": null,
                          "date_insulin_inited": null,
                          "date_insulin_initiated": null,
                          "date_of_dialysis": null,
                          "date_of_egfr": null,
                          "date_of_entry": "2026-04-20",
                          "date_of_onset_rec": null,
                          "date_returned_to_chronic_dialysis": null,
                          "date_serum_creatinine": null,
                          "diabetes_since_last_follow": null,
                          "dialysis_initiation_since_fu": null,
                          "dialysis_location": null,
                          "dialysis_provider_code": null,
                          "dialysis_type_code": null,
                          "dialysis_wihin_7_days": null,
                          "donor_related_malignancy": null,
                          "egfr": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": null,
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "grade_code": null,
                          "graf_nephrectomy": null,
                          "graft_failure_cause": 18,
                          "graft_failure_cause_other": null,
                          "graft_failure_comments": null,
                          "graft_failure_date": "2026-04-20",
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "hypertension_indicator": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": null,
                          "malignancy_indicator": null,
                          "medication_compliance_indicator": null,
                          "method_for_sugar_control_code": null,
                          "new_onset": null,
                          "no_dialysis_wihin_7_days": null,
                          "organ_rejection_indicator": null,
                          "pat_kidney_follow_up": null,
                          "post_transplant_denovo_tumor": null,
                          "post_transplant_dialysis": null,
                          "post_transplant_lymph_disease": null,
                          "post_transplant_malignancy": null,
                          "pre_transplant_tumor": null,
                          "primary_diagnosis": null,
                          "recipient_status_code": 2,
                          "records_stopped": null,
                          "recurrence": null,
                          "renal_function_indicator": null,
                          "returned_to_chronic_dialysis": "U",
                          "secondary_diagnosis": null,
                          "serum_creatinine": null,
                          "serum_creatinine_unknown": null,
                          "source_of_followup": 6,
                          "source_of_followup_other": null,
                          "type": null,
                          "updated_at": "2026-04-20T14:54:13.919Z",
                          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                      },
                      {
                          "_id": "69e63e5951237c7c8e39bd8d",
                          "a1c": null,
                          "clinical_grade_code": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-04-20T14:55:21.598Z",
                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "date_a1c": null,
                          "date_graft_nephrectomy": null,
                          "date_insulin_inited": null,
                          "date_insulin_initiated": null,
                          "date_of_dialysis": null,
                          "date_of_egfr": null,
                          "date_of_entry": "2026-04-20",
                          "date_of_onset_rec": null,
                          "date_returned_to_chronic_dialysis": null,
                          "date_serum_creatinine": null,
                          "diabetes_since_last_follow": null,
                          "dialysis_initiation_since_fu": null,
                          "dialysis_location": null,
                          "dialysis_provider_code": null,
                          "dialysis_type_code": null,
                          "dialysis_wihin_7_days": null,
                          "donor_related_malignancy": null,
                          "egfr": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": null,
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "grade_code": null,
                          "graf_nephrectomy": null,
                          "graft_failure_cause": null,
                          "graft_failure_cause_other": null,
                          "graft_failure_comments": null,
                          "graft_failure_date": null,
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "hypertension_indicator": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": 4,
                          "malignancy_indicator": null,
                          "medication_compliance_indicator": null,
                          "method_for_sugar_control_code": null,
                          "new_onset": null,
                          "no_dialysis_wihin_7_days": null,
                          "organ_rejection_indicator": null,
                          "pat_kidney_follow_up": null,
                          "post_transplant_denovo_tumor": null,
                          "post_transplant_dialysis": null,
                          "post_transplant_lymph_disease": null,
                          "post_transplant_malignancy": null,
                          "pre_transplant_tumor": null,
                          "primary_diagnosis": null,
                          "recipient_status_code": 3,
                          "records_stopped": null,
                          "recurrence": null,
                          "renal_function_indicator": null,
                          "returned_to_chronic_dialysis": "U",
                          "secondary_diagnosis": null,
                          "serum_creatinine": null,
                          "serum_creatinine_unknown": null,
                          "source_of_followup": null,
                          "source_of_followup_other": null,
                          "type": null,
                          "updated_at": "2026-04-20T14:55:21.598Z",
                          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                      },
                      {
                          "_id": "69ea161b53b8ff23983a49ae",
                          "a1c": null,
                          "clinical_grade_code": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-04-23T12:52:44.008Z",
                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "date_a1c": null,
                          "date_graft_nephrectomy": null,
                          "date_insulin_inited": null,
                          "date_insulin_initiated": null,
                          "date_of_dialysis": null,
                          "date_of_egfr": null,
                          "date_of_entry": "2026-04-23",
                          "date_of_onset_rec": null,
                          "date_returned_to_chronic_dialysis": null,
                          "date_serum_creatinine": null,
                          "diabetes_since_last_follow": null,
                          "dialysis_initiation_since_fu": null,
                          "dialysis_location": null,
                          "dialysis_provider_code": null,
                          "dialysis_type_code": null,
                          "dialysis_wihin_7_days": null,
                          "donor_related_malignancy": null,
                          "egfr": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": null,
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "grade_code": null,
                          "graf_nephrectomy": null,
                          "graft_failure_cause": 10,
                          "graft_failure_cause_other": "Graft Thrombosis",
                          "graft_failure_comments": null,
                          "graft_failure_date": "2026-04-23",
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "hypertension_indicator": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": null,
                          "malignancy_indicator": null,
                          "medication_compliance_indicator": null,
                          "method_for_sugar_control_code": null,
                          "new_onset": null,
                          "no_dialysis_wihin_7_days": null,
                          "organ_rejection_indicator": null,
                          "pat_kidney_follow_up": null,
                          "post_transplant_denovo_tumor": null,
                          "post_transplant_dialysis": null,
                          "post_transplant_lymph_disease": null,
                          "post_transplant_malignancy": null,
                          "pre_transplant_tumor": null,
                          "primary_diagnosis": null,
                          "recipient_status_code": 2,
                          "records_stopped": null,
                          "recurrence": null,
                          "renal_function_indicator": null,
                          "returned_to_chronic_dialysis": "U",
                          "secondary_diagnosis": null,
                          "serum_creatinine": null,
                          "serum_creatinine_unknown": null,
                          "source_of_followup": 6,
                          "source_of_followup_other": null,
                          "type": null,
                          "updated_at": "2026-04-23T19:11:49.526Z",
                          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                      },
                      {
                          "_id": "69eb83fc51237c7c8e3a4bd0",
                          "a1c": null,
                          "clinical_grade_code": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-04-24T14:53:48.859Z",
                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "date_a1c": null,
                          "date_graft_nephrectomy": null,
                          "date_insulin_inited": null,
                          "date_insulin_initiated": null,
                          "date_of_dialysis": null,
                          "date_of_egfr": null,
                          "date_of_entry": "2026-04-24",
                          "date_of_onset_rec": null,
                          "date_returned_to_chronic_dialysis": null,
                          "date_serum_creatinine": null,
                          "diabetes_since_last_follow": null,
                          "dialysis_initiation_since_fu": null,
                          "dialysis_location": null,
                          "dialysis_provider_code": null,
                          "dialysis_type_code": null,
                          "dialysis_wihin_7_days": null,
                          "donor_related_malignancy": null,
                          "egfr": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": null,
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "grade_code": null,
                          "graf_nephrectomy": null,
                          "graft_failure_cause": 10,
                          "graft_failure_cause_other": "Infection",
                          "graft_failure_comments": null,
                          "graft_failure_date": "2026-04-23",
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "hypertension_indicator": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": null,
                          "malignancy_indicator": null,
                          "medication_compliance_indicator": null,
                          "method_for_sugar_control_code": null,
                          "new_onset": null,
                          "no_dialysis_wihin_7_days": null,
                          "organ_rejection_indicator": null,
                          "pat_kidney_follow_up": null,
                          "post_transplant_denovo_tumor": null,
                          "post_transplant_dialysis": null,
                          "post_transplant_lymph_disease": null,
                          "post_transplant_malignancy": null,
                          "pre_transplant_tumor": null,
                          "primary_diagnosis": null,
                          "recipient_status_code": 2,
                          "records_stopped": null,
                          "recurrence": null,
                          "renal_function_indicator": null,
                          "returned_to_chronic_dialysis": "U",
                          "secondary_diagnosis": null,
                          "serum_creatinine": null,
                          "serum_creatinine_unknown": null,
                          "source_of_followup": 6,
                          "source_of_followup_other": null,
                          "type": null,
                          "updated_at": "2026-04-24T14:57:35.123Z",
                          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                      },
                      {
                          "_id": "69f17f9b51237c7c8e3a8aef",
                          "a1c": null,
                          "clinical_grade_code": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-04-29T03:48:43.171Z",
                          "created_by": "AUTOMATION_TGLNADMIN",
                          "date_a1c": null,
                          "date_graft_nephrectomy": null,
                          "date_insulin_inited": null,
                          "date_insulin_initiated": null,
                          "date_of_dialysis": null,
                          "date_of_egfr": null,
                          "date_of_entry": "2026-04-28",
                          "date_of_onset_rec": null,
                          "date_returned_to_chronic_dialysis": null,
                          "date_serum_creatinine": "2026-04-24",
                          "diabetes_since_last_follow": null,
                          "dialysis_initiation_since_fu": null,
                          "dialysis_location": null,
                          "dialysis_provider_code": null,
                          "dialysis_type_code": null,
                          "dialysis_wihin_7_days": null,
                          "donor_related_malignancy": null,
                          "egfr": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": "2026-04-25",
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "grade_code": null,
                          "graf_nephrectomy": null,
                          "graft_failure_cause": null,
                          "graft_failure_cause_other": null,
                          "graft_failure_comments": null,
                          "graft_failure_date": null,
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "hypertension_indicator": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": null,
                          "malignancy_indicator": null,
                          "medication_compliance_indicator": null,
                          "method_for_sugar_control_code": null,
                          "new_onset": null,
                          "no_dialysis_wihin_7_days": null,
                          "organ_rejection_indicator": null,
                          "pat_kidney_follow_up": null,
                          "post_transplant_denovo_tumor": null,
                          "post_transplant_dialysis": null,
                          "post_transplant_lymph_disease": null,
                          "post_transplant_malignancy": null,
                          "pre_transplant_tumor": null,
                          "primary_diagnosis": null,
                          "recipient_status_code": 1,
                          "records_stopped": null,
                          "recurrence": null,
                          "renal_function_indicator": null,
                          "returned_to_chronic_dialysis": "U",
                          "secondary_diagnosis": null,
                          "serum_creatinine": 22,
                          "serum_creatinine_unknown": null,
                          "source_of_followup": 6,
                          "source_of_followup_other": null,
                          "type": null,
                          "updated_at": "2026-04-29T03:48:43.171Z",
                          "updated_by": "AUTOMATION_TGLNADMIN"
                      },
                      {
                          "_id": "69f184a951237c7c8e3a8c06",
                          "a1c": null,
                          "clinical_grade_code": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-04-29T04:10:17.252Z",
                          "created_by": "AUTOMATION_TGLNADMIN",
                          "date_a1c": null,
                          "date_graft_nephrectomy": null,
                          "date_insulin_inited": null,
                          "date_insulin_initiated": null,
                          "date_of_dialysis": null,
                          "date_of_egfr": null,
                          "date_of_entry": "2026-04-29",
                          "date_of_onset_rec": null,
                          "date_returned_to_chronic_dialysis": null,
                          "date_serum_creatinine": null,
                          "diabetes_since_last_follow": null,
                          "dialysis_initiation_since_fu": null,
                          "dialysis_location": null,
                          "dialysis_provider_code": null,
                          "dialysis_type_code": null,
                          "dialysis_wihin_7_days": null,
                          "donor_related_malignancy": null,
                          "egfr": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": null,
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "grade_code": null,
                          "graf_nephrectomy": null,
                          "graft_failure_cause": 1,
                          "graft_failure_cause_other": null,
                          "graft_failure_comments": null,
                          "graft_failure_date": "2026-04-27",
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "hypertension_indicator": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": null,
                          "malignancy_indicator": null,
                          "medication_compliance_indicator": null,
                          "method_for_sugar_control_code": null,
                          "new_onset": null,
                          "no_dialysis_wihin_7_days": null,
                          "organ_rejection_indicator": null,
                          "pat_kidney_follow_up": null,
                          "post_transplant_denovo_tumor": null,
                          "post_transplant_dialysis": null,
                          "post_transplant_lymph_disease": null,
                          "post_transplant_malignancy": null,
                          "pre_transplant_tumor": null,
                          "primary_diagnosis": null,
                          "recipient_status_code": 2,
                          "records_stopped": null,
                          "recurrence": null,
                          "renal_function_indicator": null,
                          "returned_to_chronic_dialysis": "U",
                          "secondary_diagnosis": null,
                          "serum_creatinine": null,
                          "serum_creatinine_unknown": null,
                          "source_of_followup": 6,
                          "source_of_followup_other": null,
                          "type": null,
                          "updated_at": "2026-04-29T04:10:17.252Z",
                          "updated_by": "AUTOMATION_TGLNADMIN"
                      }
                  ],
                  "kidney_removal_date": null,
                  "previous_graft_failure_code": null,
                  "state": "follow-up",
                  "updated_at": "2026-05-05T14:33:09.614Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-04-16T12:35:42.175Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-04-16",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-04-13",
                  "referral_number": 39445,
                  "referrer": {
                      "_id": "69e0d79e53b8ff239839afc3",
                      "organization": {
                          "_id": "69e0d79e53b8ff239839afc4",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Transplant Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 4
                      },
                      "professional": {
                          "_id": "69e0d79e53b8ff239839afc5",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-04-30T12:49:08.260Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "transplant": {
                  "_id": null,
                  "admission_date": null,
                  "arterial_anas_type": null,
                  "central_line_placement": null,
                  "clamp_removal_date_left_kid": "2026-04-20T01:00:00.000+00:00",
                  "clamp_removal_date_right_kid": null,
                  "cold_isch_time_left_kid": 0,
                  "cold_isch_time_right_kid": null,
                  "comments": null,
                  "complication_category_code": null,
                  "complication_date": null,
                  "complication_type_code": null,
                  "cooling_jacket": null,
                  "created_at": "2026-04-20T14:40:00.676Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "discharge_date": null,
                  "donor_client_id": 129465,
                  "donor_id": "69e0e7e878a76e1f5639a37f",
                  "end_cold_storage_date_left_kid": "2026-04-20T00:50:00.000+00:00",
                  "end_cold_storage_date_right_kid": null,
                  "end_perfuse_date_left_kid": null,
                  "end_perfuse_date_right_kid": null,
                  "factors": {
                      "_id": null,
                      "national_transplant_id": null,
                      "transplant_date": "2026-04-19"
                  },
                  "icu_days": null,
                  "incision_side": null,
                  "list_of_vessels_used": null,
                  "number_of_transfusions": null,
                  "organ_specification_code": 312,
                  "rewarm_time_left_kid": 600,
                  "rewarm_time_right_kid": null,
                  "state": "transplanted",
                  "surgical_persons": [],
                  "total_anesthesia_time": null,
                  "total_op_room_time": null,
                  "total_surgery_time": null,
                  "transplant_end_date": null,
                  "transplant_start_date": "2026-04-20T01:24:00.000+00:00",
                  "tumor": false,
                  "tumor_type": null,
                  "updated_at": "2026-05-19T17:11:12.512Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "ureteric_anas": null,
                  "urine_output": null,
                  "vascular_reconstruction": null,
                  "vascular_release_date_left_kid": null,
                  "vascular_release_date_right_kid": null,
                  "vessels_used": null
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-04-16T12:35:42.176Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": "2026-04-13",
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": "69e0e7e878a76e1f5639a37f",
                      "living_donor_transplant_in_progress_date": "2026-04-16T13:52:08.687+00:00",
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-04-20T14:40:00.676Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "6a0f0107f89dbf796fa4a574",
                          "journey_id": "69e0d79e51237c7c8e3991e8",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-05-21T12:56:39.972+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": "2026-04-19T00:00:00.000+00:00",
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": 14,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-04-16",
          "state": "follow-up",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-05-19T17:11:12.555Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "urgent": false
      },
      {
          "_id": "69e0db0478a76e1f563992d3",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-04-16T12:50:12.364Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": true,
              "abo_incompatible": true,
              "comments": "Testing liver DAC comments",
              "created_at": "2026-04-16T12:50:12.364Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": true,
              "hcv_nat_positive": false,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-05-01T14:22:20.119Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "HEPATITIS - TYPE B",
              "primary_diagnosis_code": 2,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "OTHER",
              "secondary_diagnosis_code": 78,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Liver",
          "organ_code": 1,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "albumin": null,
              "albumin_date": null,
              "bilirubin": null,
              "bilirubin_date": null,
              "created_at": "2026-04-16T12:50:12.364Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "egfr": null,
              "egfr_date": null,
              "inr": null,
              "inr_date": null,
              "latest_smc": {
                  "_id": null,
                  "accumulated_exception_points": null,
                  "baseline_date": "2026-04-16",
                  "baseline_override": null,
                  "baseline_score": null,
                  "created_at": "2026-04-16T12:53:15.950Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "exception_diseases": false,
                  "exception_points_params": {
                      "_id": "69e0dbbb78a76e1f563998b5",
                      "age": null,
                      "birth_date": "1994-09-20",
                      "blackout_days": 0,
                      "exception_diseases": false,
                      "hcc": false,
                      "hcc_blackout_days": 0,
                      "hcc_in_criteria_date": null,
                      "hepatoblastoma": false,
                      "listing_date": "2026-04-16T12:53:15.798+00:00",
                      "liver_ped_cond": false,
                      "meld_peld": 33,
                      "metabolic_disease": false,
                      "organ_code": [
                          1
                      ],
                      "pediatric": false,
                      "refractory_pruritus_blackout_days": 0,
                      "refractory_pruritus_disease": false,
                      "refractory_pruritus_disease_date": null,
                      "smc_baseline_date": null,
                      "smc_flat_score": null,
                      "smc_override": false,
                      "version": null
                  },
                  "exception_points_scores": {
                      "_id": "69e0dbbb78a76e1f563998b6",
                      "exception_diseases": 0,
                      "hcc": 0,
                      "meld_peld": 33,
                      "multi_organ": 0,
                      "pediatric": 0
                  },
                  "flat_score": null,
                  "hcc": false,
                  "hcc_id": null,
                  "liver_bridging_id": null,
                  "liver_downstaging_id": null,
                  "meld_id": "69e0dbbb78a76e1f563998b4",
                  "override": null,
                  "override_comment": null,
                  "pediatric": false,
                  "peld_id": null,
                  "review_date": null,
                  "score": 33,
                  "score_source_code": "mp",
                  "updated_at": "2026-04-16T12:53:15.973Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "organ_specification_preference_code": null,
              "previous_malignancy": null,
              "previous_transfusion": null,
              "sodium": null,
              "sodium_date": null,
              "updated_at": "2026-04-16T12:53:15.987Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "post-transplant",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "delayed",
                  "created_at": "2026-04-16T12:50:13.451Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": [
                          "A1-2"
                      ],
                      "assessment_decision": null,
                      "assessment_decision_code": 2,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-04-16",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 3,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": "Testing liver consultation comments",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-04-16",
                      "consultation_decision_delay_end_date": "2026-04-16",
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "not_eligible",
                  "updated_at": "2026-05-15T13:25:51.470Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "post_transplant": {
                  "_id": null,
                  "created_at": "2026-04-20T14:58:39.602Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "factors": {
                      "_id": null,
                      "graft_failure_cause": null,
                      "graft_failure_cause_other": null,
                      "graft_failure_comments": null,
                      "graft_failure_date": null,
                      "post_transplant_date": null
                  },
                  "follow_ups": [
                      {
                          "_id": "69e63f9578a76e1f5639e056",
                          "biliary_complications": null,
                          "cardio_event": null,
                          "comments": null,
                          "compliance": null,
                          "compliance_comment": null,
                          "created_at": "2026-04-20T15:00:38.031Z",
                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "date_of_entry": "2026-04-20",
                          "diabetes_indicator": null,
                          "diabetes_new": null,
                          "diabetes_new_date": null,
                          "diabetes_pre_transplant": null,
                          "dialysis_date": null,
                          "dialysis_indicator": null,
                          "employment_status_code": null,
                          "employment_status_comment": null,
                          "follow_up_date": "2026-04-20",
                          "functional_status_code": null,
                          "functional_status_comment": null,
                          "graft_failure_cause": null,
                          "graft_failure_cause_other": null,
                          "graft_failure_comments": null,
                          "graft_failure_date": null,
                          "graft_functioning_at_death": null,
                          "graft_status_code": null,
                          "hospital_id": null,
                          "insulin_date": null,
                          "lab_values": null,
                          "lifestyle_compliance_indicator": null,
                          "lost_to_followup_reason": null,
                          "medication_compliance_indicator": null,
                          "new_hypertension_indicator": null,
                          "new_hypertention_date": null,
                          "organ_rejection_indicator": null,
                          "post_transplant_malignancy": null,
                          "primary_diagnosis": null,
                          "primary_diagnosis_path_confirm": null,
                          "primary_diagnosis_recurrence": null,
                          "primary_diagnosis_recurrence_date": null,
                          "primary_disease_code": null,
                          "recipient_status_code": 1,
                          "records_stopped": null,
                          "renal_function_indicator": null,
                          "secondary_diagnosis": null,
                          "secondary_diagnosis_path_confirm": null,
                          "secondary_diagnosis_recurrence": null,
                          "secondary_diagnosis_recurrence_date": null,
                          "secondary_disease_code": null,
                          "source_of_followup": 6,
                          "source_of_followup_other": null,
                          "sugar_control_code": null,
                          "type": null,
                          "updated_at": "2026-04-20T15:00:38.031Z",
                          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "vascular_complications": null
                      }
                  ],
                  "kidney_removal_date": null,
                  "previous_graft_failure_code": null,
                  "state": "follow-up",
                  "updated_at": "2026-05-06T19:24:34.206Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-04-16T12:50:12.365Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-04-16",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-04-16",
                  "referral_number": 39446,
                  "referrer": {
                      "_id": "69e0db0451237c7c8e3999ae",
                      "organization": {
                          "_id": "69e0db0451237c7c8e3999af",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Liver Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "UHN - TGH, 9N-975 - 200 Elizabeth Street",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "69e0db0451237c7c8e3999b0",
                          "first_name": "Peter",
                          "last_name": "Rossos",
                          "type": null,
                          "type_code": 4
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-04-16T12:50:13.482Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "transplant": {
                  "_id": null,
                  "admission_date": null,
                  "anhep_bp": null,
                  "arterial_reconstruction_type": null,
                  "bile_production_indicator": null,
                  "biliary_anas_type": null,
                  "child_pugh_score": null,
                  "cholec_indicator": null,
                  "cold_isch_time": 0,
                  "comments": null,
                  "complication_category_code": null,
                  "complication_date": null,
                  "complication_type_code": null,
                  "created_at": "2026-04-20T14:58:39.602Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "crystalloid": null,
                  "discharge_date": null,
                  "donor_client_id": 129464,
                  "donor_id": "69e0dffab9f83018163998de",
                  "end_cold_storage_date": "2026-04-20T00:30:00.000+00:00",
                  "factors": {
                      "_id": null,
                      "national_transplant_id": null,
                      "transplant_date": "2026-04-19"
                  },
                  "ha_clamp_off_date": "2026-04-20T01:20:00.000+00:00",
                  "hemostasis_result_type": null,
                  "icu_days": null,
                  "list_of_vessels_used": null,
                  "liver_appearance_type_code": null,
                  "liver_consistency_type_code": null,
                  "liver_reduction_type": null,
                  "number_of_transfusions": null,
                  "organ_specification_code": 103,
                  "other_procedure_comment": null,
                  "portal_clamp_date": null,
                  "portal_vein_cross_clamp_date": "2026-04-20T01:22:00.000+00:00",
                  "post_anas_press_dias": null,
                  "post_anas_press_sys": null,
                  "pre_anhep_press_dias": null,
                  "pre_anhep_press_sys": null,
                  "pv_anomaly_type_code": null,
                  "pv_atresia_indicator": null,
                  "pv_clamp_off_date": "2026-04-20T01:11:00.000+00:00",
                  "pv_recon_type": null,
                  "pv_thrombosis_indicator": null,
                  "removed_from_normothermic_perf_pump_date": "2026-04-20T00:45:00.000+00:00",
                  "rewarm_time": 2460,
                  "splenectomy_indicator": null,
                  "state": "transplanted",
                  "surgical_persons": [],
                  "total_anesthesia_time": null,
                  "total_op_room_time": null,
                  "total_surgery_time": null,
                  "transplant_end_date": null,
                  "transplant_inr": null,
                  "transplant_start_date": "2026-04-20T01:24:00.000+00:00",
                  "tumor": false,
                  "tumor_type": null,
                  "updated_at": "2026-05-12T14:27:15.136Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "venous_bypass_indicator": null,
                  "vessels_used": false
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-04-16T13:40:49.745Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": "69e0dffab9f83018163998de",
                      "living_donor_transplant_in_progress_date": "2026-04-16T13:40:49.735+00:00",
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-04-20T14:58:39.602Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA",
                  "waitlist_history_snapshots": [],
                  "waitlist_history_snapshots_date": null,
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": "2026-04-19T00:00:00.000+00:00",
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": 14,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-04-16",
          "state": "follow-up",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-05-15T13:25:51.506Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "69e644c551237c7c8e39d340",
          "comments": null,
          "completed": true,
          "completed_date": "2026-05-15",
          "completed_reason": "not_eligible",
          "completed_reason_code": 5,
          "created_at": "2026-04-20T15:22:46.027Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-04-20T15:22:46.028Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-04-20T15:22:46.028Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "CONGENITAL ANOMALY",
              "primary_diagnosis_code": 8,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "CARDIOMYOPATHY",
              "secondary_diagnosis_code": 5,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Heart",
          "organ_code": 2,
          "organ_specific_details": {
              "_id": null,
              "acceptable_maximum_donor_weight": null,
              "acceptable_minimal_donor_weight": null,
              "anticoagulant_medications": null,
              "congenital_heart_disease": false,
              "created_at": "2026-04-20T15:22:46.028Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "extra_corporeal_membraneous_oxygenator": null,
              "impella_heart_pump": null,
              "impella_heart_pump_days": null,
              "intra_aortal_balloon_pump": null,
              "intra_aortal_balloon_pump_days": null,
              "mechanical_circulatory_support_other": null,
              "medical_comments": null,
              "organ_specification_preference_code": null,
              "other_surgery_required_comments": null,
              "surgical_comments": null,
              "total_artifical_heart": null,
              "total_artifical_heart_days": null,
              "updated_at": "2026-04-20T15:22:46.028Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vad_duration": null,
              "vad_insert_side": null,
              "vad_type": null,
              "vad_type_other_comment": null,
              "ventilator_support": null,
              "ventilator_support_days": null
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-04-20T15:25:51.515Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": [
                          "A2-7"
                      ],
                      "assessment_decision": null,
                      "assessment_decision_code": 2,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "assessment_decision_date": "2026-05-15",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 3,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": [
                          "A2-11"
                      ],
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": "Testing heart consultation comments.",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-04-20",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "not_eligible",
                  "updated_at": "2026-05-15T13:26:39.476Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-04-20T15:22:46.028Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-04-20",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-04-20",
                  "referral_number": 39450,
                  "referrer": {
                      "_id": "69e644c6b9f830181639ecc8",
                      "organization": {
                          "_id": "69e644c6b9f830181639ecc9",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Heart Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2N2",
                          "province": "ON",
                          "street": "UHN Toronto General Hospital, 585 Universtiy Avenue",
                          "type": null,
                          "type_code": 2
                      },
                      "professional": {
                          "_id": "69e644c6b9f830181639ecca",
                          "first_name": "Heather",
                          "last_name": "Ross",
                          "type": null,
                          "type_code": 2
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-05-19T17:22:39.609Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": null
          },
          "start_date": "2026-04-20",
          "state": "not_eligible",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-05-19T17:22:39.706Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "69e7bc2a51237c7c8e39e385",
          "comments": null,
          "completed": true,
          "completed_date": "2026-05-05",
          "completed_reason": "cancelled",
          "completed_reason_code": 3,
          "created_at": "2026-04-21T18:04:26.617Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-04-21T18:04:26.619Z",
              "created_by": "AMY.NI1@ONEID.ON.CA",
              "deceased_donor": null,
              "ecd_donor": null,
              "hcv_ab_positive": true,
              "hcv_nat_positive": true,
              "hep_ab_core_positive": null,
              "living_donor": null,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-04-21T18:04:26.619Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "EOSINOPHILIC GRANULOMA",
              "primary_diagnosis_code": 26,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": null,
              "secondary_diagnosis_code": null,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Lung",
          "organ_code": 4,
          "organ_specific_details": {
              "_id": null,
              "actual_forced_expiratory_volume": 342,
              "actual_total_lung_capacity": 11,
              "cardiac_output": null,
              "cell_mediated_immunity_skin_reactivity": null,
              "chest_ct_scan_date": "2026-04-24",
              "chest_ct_scan_result": "Test TEst",
              "created_at": "2026-04-21T18:04:26.618Z",
              "created_by": "AMY.NI1@ONEID.ON.CA",
              "default_values": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "ejection_fraction_percent": null,
              "estimated_right_ventricular_systolic_pressure": null,
              "extra_corporeal_life_support": "U",
              "extra_corporeal_life_support_comment": "22",
              "intubated": null,
              "left_ventricle_remodel": null,
              "left_ventricle_result": null,
              "left_ventricular_ejection_fraction_percent_exercise": null,
              "left_ventricular_ejection_fraction_percent_resting": null,
              "lung_allocation_score": 4,
              "organ_specification_preference_code": 403,
              "partial_pressure_dissolved_co2": null,
              "partial_pressure_dissolved_o2": null,
              "perfusion_left": 11,
              "perfusion_right": 11,
              "pneumoreduction": null,
              "pneumothorax": null,
              "predicted_forced_vital_capacity": null,
              "predicted_total_lung_capacity": 11,
              "pulmonary_artery_diastolic_pressure": 4,
              "pulmonary_artery_systolic_pressure": 4,
              "pulmonary_mean_arterial_pressure": 4,
              "pulmonary_vascular_resistance_type": null,
              "pulmonary_vascular_resistance_woods": null,
              "right_arterial_diastolic_pressure": null,
              "right_arterial_systolic_pressure": null,
              "right_ventricle_result": null,
              "right_ventriclular_diastolic_pressure": null,
              "right_ventriclular_systolic_pressure": null,
              "right_ventricular_ejection_fraction_percent_exercise": null,
              "right_ventricular_ejection_fraction_percent_resting": null,
              "transmyorcardial_revascularization": null,
              "updated_at": "2026-04-24T15:51:59.136Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "ventilator": "U",
              "ventilator_comment": null
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-05-08T20:57:23.991Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 4,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "637e81be8826510024dec411",
                      "assessment_decision_date": "2026-05-05",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 7,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": "637e81be8826510024dec411",
                      "consultation_decision_date": "2026-05-01",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "cancelled",
                  "updated_at": "2026-05-08T20:59:17.611Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-04-21T18:04:26.619Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "635c844fc8957dc3d2bde7e8",
                      "decision_date": "2026-05-01",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-04-24",
                  "referral_number": 39451,
                  "referrer": {
                      "_id": "69eb8f27b9f83018163a5db3",
                      "organization": {
                          "_id": "69eb8f27b9f83018163a5db5",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "asdf",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2N2",
                          "province": "ON",
                          "street": "UHN, 585 University Avenue-11 Munk 124",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "69eb8f27b9f83018163a5db4",
                          "first_name": "John",
                          "last_name": "Granton",
                          "type": null,
                          "type_code": 15
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-05-08T20:57:24.040Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "waitlist": null
          },
          "start_date": "2026-04-21",
          "state": "cancelled",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "635c844ec8957dc3d2bdd858",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-05-19T17:22:39.609Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "urgent": false
      },
      {
          "_id": "69e7bd0cb9f830181639fc35",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-04-21T18:08:12.831Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": false,
              "abo_incompatible": false,
              "comments": null,
              "created_at": "2026-04-21T18:08:12.832Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": false,
              "hcv_ab_positive": false,
              "hcv_nat_positive": false,
              "hep_ab_core_positive": false,
              "living_donor": true,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-04-21T18:08:12.832Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "FOCAL GLOMERULOSCLEROSIS - ADULTS",
              "primary_diagnosis_code": 9,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "DIABETES - NON-INSULIN DEPENDENT (TYPE II)",
              "secondary_diagnosis_code": 81,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-04-21T18:08:12.832Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-04-21T18:08:12.832Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "delayed",
                  "created_at": "2026-04-23T13:58:37.504Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 3,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-04-23",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": 12,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 7,
                      "consultation_decision_comments": "test test",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-04-23",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": "2026-04-23",
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": 7
                  },
                  "migration_comment": null,
                  "state": "treatment_required",
                  "updated_at": "2026-04-24T14:52:01.216Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-04-21T18:08:12.832Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-04-23",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-04-21",
                  "referral_number": 39452,
                  "referrer": {
                      "_id": "69e7bd0d78a76e1f5639fe00",
                      "organization": {
                          "_id": "69e7bd0d78a76e1f5639fe01",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn Kidney Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 7
                      },
                      "professional": {
                          "_id": "69e7bd0d78a76e1f5639fe02",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-05-15T20:31:21.450Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-04-21T18:08:12.832Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": "2026-04-13",
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": true,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": "69e0d79e51237c7c8e3991e8",
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": "2026-04-21",
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": 2,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-04-21T18:38:40.553Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "waitlist_history_snapshots": [
                      {
                          "_id": "6a1f3a08ba6cf1d26e77e09e",
                          "journey_id": "69e7bd0cb9f830181639fc35",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-06-02T20:16:08.682+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-04-21",
          "state": "treatment_required",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "yellow",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-05-19T17:22:39.610Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "69eb8a1eb9f83018163a5236",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-04-24T15:19:58.287Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": true,
              "comments": null,
              "created_at": "2026-04-24T15:19:58.288Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": false,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-04-30T13:21:07.389Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "HEPATITIS - TYPE B",
              "primary_diagnosis_code": 2,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": "OTHER",
              "secondary_diagnosis_code": 78,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Liver",
          "organ_code": 1,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "albumin": null,
              "albumin_date": null,
              "bilirubin": null,
              "bilirubin_date": null,
              "created_at": "2026-04-24T15:19:58.288Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "egfr": null,
              "egfr_date": null,
              "inr": null,
              "inr_date": null,
              "latest_smc": {
                  "_id": null,
                  "accumulated_exception_points": null,
                  "baseline_date": "2026-05-06",
                  "baseline_override": null,
                  "baseline_score": null,
                  "created_at": "2026-05-06T14:01:29.673Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "exception_diseases": false,
                  "exception_points_params": {
                      "_id": "69fb49b96818dc6532f84a85",
                      "age": null,
                      "birth_date": "1994-09-20",
                      "blackout_days": 0,
                      "exception_diseases": false,
                      "hcc": false,
                      "hcc_blackout_days": 0,
                      "hcc_in_criteria_date": null,
                      "hepatoblastoma": false,
                      "listing_date": "2026-05-06T14:01:29.512+00:00",
                      "liver_ped_cond": false,
                      "meld_peld": 33,
                      "metabolic_disease": false,
                      "organ_code": [
                          1
                      ],
                      "pediatric": false,
                      "refractory_pruritus_blackout_days": 0,
                      "refractory_pruritus_disease": false,
                      "refractory_pruritus_disease_date": null,
                      "smc_baseline_date": null,
                      "smc_flat_score": null,
                      "smc_override": false,
                      "version": null
                  },
                  "exception_points_scores": {
                      "_id": "69fb49b96818dc6532f84a86",
                      "exception_diseases": 0,
                      "hcc": 0,
                      "meld_peld": 33,
                      "multi_organ": 0,
                      "pediatric": 0
                  },
                  "flat_score": null,
                  "hcc": false,
                  "hcc_id": null,
                  "liver_bridging_id": null,
                  "liver_downstaging_id": null,
                  "meld_id": "69eb8a2db9f83018163a53f6",
                  "override": null,
                  "override_comment": null,
                  "pediatric": false,
                  "peld_id": null,
                  "review_date": null,
                  "score": 33,
                  "score_source_code": "mp",
                  "updated_at": "2026-05-06T14:01:29.705Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "organ_specification_preference_code": null,
              "previous_malignancy": null,
              "previous_transfusion": null,
              "sodium": null,
              "sodium_date": null,
              "updated_at": "2026-05-06T14:01:29.721Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "referral",
          "stage_attributes": {
              "_id": null,
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-04-24T15:19:58.289Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 2,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-05-10",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-04-24",
                  "referral_number": 39455,
                  "referrer": {
                      "_id": "69eb8a1e51237c7c8e3a554f",
                      "organization": {
                          "_id": "69eb8a1e51237c7c8e3a5550",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Uhn",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "UHN - TGH, 9N-975 - 200 Elizabeth Street",
                          "type": null,
                          "type_code": 2
                      },
                      "professional": {
                          "_id": "69eb8a1e51237c7c8e3a5551",
                          "first_name": "Peter",
                          "last_name": "Rossos",
                          "type": null,
                          "type_code": 4
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "deferred",
                  "updated_at": "2026-05-12T20:01:57.659Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": null
          },
          "start_date": "2026-04-24",
          "state": "deferred",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "yellow",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-05-19T17:22:39.610Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "69fb80ab6818dc6532f85761",
          "comments": null,
          "completed": true,
          "completed_date": "2026-05-14",
          "completed_reason": "cancelled",
          "completed_reason_code": 3,
          "created_at": "2026-05-06T17:55:55.910Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-05-06T17:55:55.911Z",
              "created_by": "AMY.NI1@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-05-06T17:55:55.911Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "DIABETES TYPE 1",
              "primary_diagnosis_code": 2,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": null,
              "secondary_diagnosis_code": null,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Pancreas (whole)",
          "organ_code": 6,
          "organ_specific_details": {
              "_id": null,
              "created_at": "2026-05-06T17:55:55.911Z",
              "created_by": "AMY.NI1@ONEID.ON.CA",
              "default_values": false,
              "diabetes_type_code": null,
              "organ_specification_preference_code": null,
              "other_comments": null,
              "pancreas_type": "PTA",
              "receiving_insulin": null,
              "receiving_insulin_years": 0,
              "updated_at": "2026-05-06T17:55:55.911Z",
              "updated_by": "AMY.NI1@ONEID.ON.CA"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "assessment",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "cancelled",
                  "created_at": "2026-05-14T19:06:51.206Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 4,
                      "assessment_decision_comments": "Per Consultation cancellation",
                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "assessment_decision_date": "2026-05-14",
                      "assessment_decision_reason": "Per Consultation cancellation",
                      "assessment_decision_reason_code": 201,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 4,
                      "consultation_decision_comments": "testtttttt",
                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "consultation_decision_date": "2026-05-14",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": 9
                  },
                  "migration_comment": null,
                  "state": "cancelled",
                  "updated_at": "2026-05-14T19:12:13.506Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-05-06T17:55:55.912Z",
                  "created_by": "AMY.NI1@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                      "decision_date": "2026-05-03",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-05-01",
                  "referral_number": 39470,
                  "referrer": {
                      "_id": "6a060dce678126809b9321e5",
                      "organization": {
                          "_id": "6a060dce678126809b9321e7",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Pancreas Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "6a060dce678126809b9321e6",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-05-21T13:23:53.076Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-05-06T17:55:55.912Z",
                  "created_by": null,
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-05-06T17:55:55.929Z",
                  "updated_by": null,
                  "waitlist_history_snapshots": [
                      {
                          "_id": "6a10947bf89dbf796fa6198d",
                          "journey_id": "69fb80ab6818dc6532f85761",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-05-22T17:38:03.748+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-05-06",
          "state": "cancelled",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "grey",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-05-21T13:23:53.120Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "urgent": false
      },
      {
          "_id": "6a0f056ce27ee11f3a08f69c",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-05-21T13:15:24.561Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "ctr_id": null,
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": null,
              "abo_incompatible": null,
              "comments": null,
              "created_at": "2026-05-21T13:15:24.563Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "deceased_donor": true,
              "ecd_donor": null,
              "hcv_ab_positive": null,
              "hcv_nat_positive": null,
              "hep_ab_core_positive": null,
              "living_donor": false,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-05-21T13:15:24.563Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "DIABETES TYPE 1",
              "primary_diagnosis_code": 2,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": null,
              "secondary_diagnosis_code": null,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Pancreas (whole)",
          "organ_code": 6,
          "organ_specific_details": {
              "_id": null,
              "created_at": "2026-05-21T13:15:24.563Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "default_values": false,
              "diabetes_type_code": 1,
              "organ_specification_preference_code": null,
              "other_comments": null,
              "pancreas_type": "PAK",
              "receiving_insulin": null,
              "receiving_insulin_years": 0,
              "updated_at": "2026-06-02T20:19:55.089Z",
              "updated_by": "AUTOMATION_TGLNADMIN"
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": null,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "referral",
          "stage_attributes": {
              "_id": null,
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-05-21T13:15:24.563Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": null,
                      "decision_comments": null,
                      "decision_coordinator_id": null,
                      "decision_date": null,
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-05-14",
                  "referral_number": 39541,
                  "referrer": {
                      "_id": "6a0f056ee27ee11f3a08f79a",
                      "organization": {
                          "_id": "6a0f056ee27ee11f3a08f79b",
                          "city": "Toronto",
                          "country": "CAN",
                          "name": "Pancreas Clinic",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "M5G 2C4",
                          "province": "ON",
                          "street": "Toronto General Hospital, 200 Elizabeth Street,8N-842",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "6a0f056ee27ee11f3a08f79c",
                          "first_name": "Christopher",
                          "last_name": "Chan",
                          "type": null,
                          "type_code": 12
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": null,
                  "updated_at": "2026-05-21T13:15:26.777Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-05-21T13:15:24.563Z",
                  "created_by": null,
                  "factors": {
                      "_id": null,
                      "added_date": null,
                      "dialysis_start_date": null,
                      "kidney_prior_journey_id": null,
                      "listing_date": null,
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": null,
                      "medical_status_date": null,
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": null,
                      "transplant_in_progress_date": null,
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": null,
                  "updated_at": "2026-05-21T13:15:24.577Z",
                  "updated_by": null,
                  "waitlist_history_snapshots": [
                      {
                          "_id": "6a1f3c00f6f8457dcc7e47ff",
                          "journey_id": "6a0f056ce27ee11f3a08f69c",
                          "stage": "waitlist",
                          "stage_factor_code": 101,
                          "to": true,
                          "extra": "missing",
                          "superceded_date": null,
                          "superceded_reason": null,
                          "_type": "f",
                          "event_date": null,
                          "created_at": null,
                          "created_by": "System",
                          "sequence_number": null,
                          "__v": 0
                      }
                  ],
                  "waitlist_history_snapshots_date": "2026-06-02T20:24:32.537+00:00",
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": null,
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": null,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-05-21",
          "state": "requested",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": "100005950",
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-06-02T20:19:55.100Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "urgent": false
      }
  ],
  "migrated_recipient": false,
  "oop_recipient": false,
  "state": "active",
  "updated_at": "2026-06-02T20:19:55.150Z",
  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
  "urgent": false,
  "urgent_last_toggled_date": null,
  "clinical_transaction": null,
  "patient_profile": {
      "_id": "69dd063151237c7c8e3973c1",
      "addresses": [
          {
              "_id": "69dd063151237c7c8e3973c6",
              "administrative_region_code": null,
              "city": "Toronto",
              "country_code": "CAN",
              "country_other": "",
              "postal_code": "M4A 2C2",
              "province_code": "ON",
              "street": "123 Anywhere Street",
              "type": "permanent"
          }
      ],
      "age": null,
      "birth": {
          "_id": "69dd063151237c7c8e3973c3",
          "city": null,
          "country": null,
          "date": "1994-09-20",
          "province": null
      },
      "comments": null,
      "contact_details": {
          "_id": "69dd063151237c7c8e3973c4",
          "email": "three.oats@me.com",
          "phone_alternate": null,
          "phone_alternate_ext": null,
          "phone_alternate_other": null,
          "phone_mobile": "416-876-9352",
          "phone_pager": "",
          "phone_primary": "647-524-7853",
          "phone_primary_ext": null,
          "phone_primary_other": null,
          "primary_contact_name": null,
          "primary_contact_relationship_code": null,
          "secondary_contact_name": null,
          "secondary_contact_relationship_code": null
      },
      "created_at": "2026-04-13T15:05:21.718Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "donor_id": null,
      "effective_date": null,
      "ethnicity_code": "11",
      "ethnicity_other": "",
      "first_name": "Three",
      "gender": "O",
      "gender_other": "other",
      "gender_sex_different": true,
      "in_utero": false,
      "insurance": {
          "_id": "69dd063151237c7c8e3973c5",
          "number": null,
          "other_plan": null,
          "other_province_plan": null,
          "plan": null,
          "plan_checked": false,
          "plan_code": 7,
          "version": null
      },
      "last_name": "OATSrecipient",
      "living_donor_id": null,
      "marital_status_code": null,
      "middle_name": "UHN",
      "postal_code": null,
      "recipient_id": "69dd063151237c7c8e3973c2",
      "sex": "M",
      "updated_at": "2026-05-19T17:22:39.738Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
  },
  "dialysis_procedures": [
      {
          "_id": "69e0d96778a76e1f56398a64",
          "access_method_code": 5,
          "access_method_other": null,
          "comments": null,
          "created_at": "2026-04-16T12:43:19.652Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "date": null,
          "dialysis_provider_code": 1,
          "dialysis_type_code": 2,
          "dialysis_type_other": null,
          "end_date": null,
          "location_type_code": 4,
          "other_location_desc": "Testing kidney dialysis other location",
          "previous_type_code": null,
          "recipient_id": "69dd063151237c7c8e3973c2",
          "start_date": "2026-04-13",
          "updated_at": "2026-04-16T12:44:57.289Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
      }
  ],
  "pancreas_islets_procedures": [],
  "virology_labs": [
      {
          "_id": "6a1dec10a4456382479bc8fb",
          "comments": null,
          "created_at": "2026-06-01T20:31:12.712Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "lab_code": "TOS",
          "lab_id": null,
          "lab_other": null,
          "recipient_id": "69dd063151237c7c8e3973c2",
          "results": [
              {
                  "_id": "6a1dec10a4456382479bc8fc",
                  "code": "CMV_IGM_AB",
                  "comments": null,
                  "created_at": "2026-06-01T20:31:12.712Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "other_code_details": null,
                  "positive": true,
                  "updated_at": "2026-06-01T20:31:12.712Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "6a1dec10a4456382479bc8fd",
                  "code": "EBV_NUCLEAR_AB",
                  "comments": null,
                  "created_at": "2026-06-01T20:31:12.713Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-06-01T20:31:12.713Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              }
          ],
          "sample_date": null,
          "sample_number": null,
          "test_code": null,
          "test_date": "2026-05-14T05:41:00.000+00:00",
          "updated_at": "2026-06-01T20:31:12.735Z",
          "updated_by": "AUTOMATION_TGLNADMIN"
      },
      {
          "_id": "6a1dec39876bc4a95f9bceac",
          "comments": null,
          "created_at": "2026-06-01T20:31:53.888Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "lab_code": "TOS",
          "lab_id": null,
          "lab_other": null,
          "recipient_id": "69dd063151237c7c8e3973c2",
          "results": [
              {
                  "_id": "6a1dec39876bc4a95f9bcead",
                  "code": "HCV_NAT",
                  "comments": null,
                  "created_at": "2026-06-01T20:31:53.888Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-06-01T20:31:53.888Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              }
          ],
          "sample_date": null,
          "sample_number": null,
          "test_code": null,
          "test_date": "2026-05-08T00:25:00.000+00:00",
          "updated_at": "2026-06-01T20:31:53.900Z",
          "updated_by": "AUTOMATION_TGLNADMIN"
      }
  ],
  "measurements": [
      {
          "_id": "6a0612820e4100552193236e",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-05-14T18:20:50.406Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "date": "2026-05-09",
          "height": 88,
          "recipient_id": "69dd063151237c7c8e3973c2",
          "updated_at": "2026-05-14T18:28:41.662Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "weight": 0,
          "bmi": 0
      },
      {
          "_id": "69e0d60851237c7c8e399114",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-04-16T12:28:56.437Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "date": "2026-04-15",
          "height": 78,
          "recipient_id": "69dd063151237c7c8e3973c2",
          "updated_at": "2026-04-16T12:28:56.437Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "weight": 78,
          "bmi": 128.2
      }
  ],
  "liver_melds": []
};
const uhnOATSRecipient71065 = {
  "_id": "69bbc088cfa5ba70f5aed09d",
  "client_id": 71065,
  "created_at": "2026-03-19T09:33:11.475Z",
  "created_by": "AUTOMATION_SP",
  "death": {
      "_id": null,
      "autopsy": null,
      "cause_category": null,
      "cause_category_code": null,
      "cause_type": null,
      "cause_type_code": null,
      "cause_type_other": null,
      "comments": null,
      "created_at": "2026-03-19T09:23:21.121Z",
      "created_by": null,
      "death_date": null,
      "estimated_death_date": null,
      "prior_cause_category": null,
      "prior_cause_category_code": null,
      "prior_cause_type": null,
      "prior_cause_type_code": null,
      "related_to_waittime": null,
      "transplant_functioning_code": null,
      "updated_at": "2026-03-19T09:23:21.121Z",
      "updated_by": null
  },
  "diagnostics": {
      "_id": null,
      "blood": {
          "_id": null,
          "rh_indicator": "+",
          "type": "A",
          "type_verified": true
      },
      "created_at": "2026-03-19T09:23:21.121Z",
      "created_by": "AUTOMATION_SP",
      "hla": {
          "_id": null,
          "cumulative_antibodies": {
              "_id": null,
              "class1": {
                  "_id": null,
                  "antibodies": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate_allele_group": [],
                      "indeterminate_allele_specific": [],
                      "indeterminate_alpha_beta": [],
                      "possible_allele_specific": [],
                      "unacceptable_allele_group": [],
                      "unacceptable_allele_specific": [],
                      "unacceptable_alpha_beta": [],
                      "untested": []
                  },
                  "epitopes": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate": [],
                      "unacceptable": [],
                      "untested": []
                  }
              },
              "class2": {
                  "_id": null,
                  "antibodies": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate_allele_group": [],
                      "indeterminate_allele_specific": [],
                      "indeterminate_alpha_beta": [],
                      "possible_allele_specific": [],
                      "unacceptable_allele_group": [],
                      "unacceptable_allele_specific": [],
                      "unacceptable_alpha_beta": [],
                      "untested": []
                  },
                  "epitopes": {
                      "_id": null,
                      "acceptable": [],
                      "indeterminate": [],
                      "unacceptable": [],
                      "untested": []
                  }
              }
          },
          "cumulative_cpra": 0,
          "cumulative_cpra_comments": null,
          "cumulative_historical_cpra_heart": null,
          "cumulative_historical_cpra_hsp": null,
          "cumulative_pra_class1": 0,
          "cumulative_pra_class2": 0,
          "hla_antibody_first_lab_date": "2026-03-19T00:00:00.000+00:00",
          "hla_comments": null,
          "hla_comments_updated_at": null
      },
      "miscellaneous": {
          "_id": null,
          "meld_first_date": null
      },
      "number_of_previous_transplants": null,
      "updated_at": "2026-03-19T09:24:09.164Z",
      "updated_by": "AUTOMATION_SP"
  },
  "financial_assistance": {
      "_id": null,
      "comments": null,
      "created_at": "2026-03-19T09:23:21.121Z",
      "created_by": "AUTOMATION_SP",
      "date": null,
      "program_type": null,
      "status": null,
      "status_code": null,
      "tper_applicable": false,
      "updated_at": "2026-03-19T09:23:21.121Z",
      "updated_by": "AUTOMATION_SP"
  },
  "journeys": [
      {
          "_id": "69bbc0e3cbdf24c934aebb0a",
          "comments": null,
          "completed": false,
          "completed_date": null,
          "completed_reason": null,
          "completed_reason_code": null,
          "created_at": "2026-03-19T09:24:51.391Z",
          "created_by": "AUTOMATION_SP",
          "ctr_id": "69bbc0e3cbdf24c934aebb0a",
          "donor_acceptability": {
              "_id": null,
              "a2_or_a2b_donor": false,
              "abo_incompatible": false,
              "comments": "This is the DAC comment!",
              "created_at": "2026-03-19T09:24:51.393Z",
              "created_by": "AUTOMATION_SP",
              "deceased_donor": true,
              "ecd_donor": false,
              "hcv_ab_positive": false,
              "hcv_nat_positive": false,
              "hep_ab_core_positive": false,
              "living_donor": true,
              "max_age": null,
              "max_height": null,
              "max_weight": null,
              "min_age": null,
              "min_height": null,
              "min_weight": null,
              "updated_at": "2026-03-19T09:26:48.913Z",
              "updated_by": "AUTOMATION_SP"
          },
          "donor_acceptability_from_journey_id": null,
          "failed_organ": {
              "_id": null,
              "cause_of_failure": null,
              "cause_of_failure_code": null,
              "comments": null,
              "failure_date": null,
              "former_cause_of_failure": null,
              "former_cause_of_failure_code": null,
              "primary_diagnosis": "ACQUIRED OBSTRUCTIVE UROPATHY",
              "primary_diagnosis_code": 67,
              "primary_diagnosis_date": null,
              "secondary_diagnosis": null,
              "secondary_diagnosis_code": null,
              "secondary_diagnosis_date": null
          },
          "historical_registration_date": null,
          "migrated_journey": false,
          "migration_comment": null,
          "oop_journey": false,
          "organ": "Kidney",
          "organ_code": 3,
          "organ_specific_details": {
              "_id": null,
              "a1c": null,
              "a1c_date": null,
              "created_at": "2026-03-19T09:24:51.393Z",
              "created_by": "AUTOMATION_SP",
              "creatinine": null,
              "creatinine_date": null,
              "default_values": false,
              "double_kidney": false,
              "echocardiogram": false,
              "echocardiogram_comment": null,
              "echocardiogram_date": null,
              "egfr": null,
              "egfr_date": null,
              "hep_ab_positive_donor": null,
              "hep_c_positive_donor": null,
              "organ_specification_preference_code": null,
              "override_comments": null,
              "override_end_date": null,
              "override_pediatric_age": false,
              "override_start_date": null,
              "peritoneal_access_exhausted": false,
              "pre_emptive_gfr": false,
              "previous_live_birth_count": 0,
              "previous_nephrectomy": null,
              "previous_nephrectomy_count": 0,
              "previous_pregnancy_count": 0,
              "previous_transfusions_count": 0,
              "staged_kidney": false,
              "updated_at": "2026-03-19T09:24:51.393Z",
              "updated_by": "AUTOMATION_SP",
              "vascular_access_exhausted": false
          },
          "recipient_programs": {
              "_id": null,
              "double_leg_amputee": false,
              "hsx_eligible": false,
              "kidney_paired_donation": false,
              "list_exchange": false,
              "list_exchange_date": null,
              "national_organ_request_id": 166020,
              "previous_living_donation_date": null,
              "previous_living_donor": false
          },
          "related_journeys": [],
          "stage": "post-transplant",
          "stage_attributes": {
              "_id": null,
              "assessment": {
                  "_id": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "consultation_state": "completed",
                  "created_at": "2026-03-19T09:25:23.367Z",
                  "created_by": "AUTOMATION_SP",
                  "factors": {
                      "_id": null,
                      "assessment_absolute_contraindication_code": null,
                      "assessment_decision": null,
                      "assessment_decision_code": 112,
                      "assessment_decision_comments": null,
                      "assessment_decision_coordinator_id": "68a49f90f7fb6a82e5aad577",
                      "assessment_decision_date": "2026-03-19",
                      "assessment_decision_reason": null,
                      "assessment_decision_reason_code": null,
                      "assessment_decision_reason_other": null,
                      "assessment_relative_contraindication_code": null,
                      "consultation_decision": null,
                      "consultation_decision_code": 6,
                      "consultation_decision_comments": null,
                      "consultation_decision_coordinator_id": "68a49f90f7fb6a82e5aad577",
                      "consultation_decision_date": "2026-03-19",
                      "consultation_decision_delay_end_date": null,
                      "consultation_decision_delay_start_date": null,
                      "consultation_decision_primary_physician_id": null,
                      "consultation_decision_reason": null,
                      "consultation_decision_reason_code": null
                  },
                  "migration_comment": null,
                  "state": "eligible",
                  "updated_at": "2026-03-19T09:26:59.523Z",
                  "updated_by": "AUTOMATION_SP"
              },
              "post_transplant": {
                  "_id": null,
                  "created_at": "2026-04-28T19:50:45.822Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "factors": {
                      "_id": null,
                      "graft_failure_cause": null,
                      "graft_failure_cause_other": null,
                      "graft_failure_comments": null,
                      "graft_failure_date": null,
                      "post_transplant_date": null
                  },
                  "kidney_removal_date": null,
                  "previous_graft_failure_code": null,
                  "state": "follow-up",
                  "updated_at": "2026-04-28T19:50:45.844Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              "referral": {
                  "_id": null,
                  "administrative_country_code": "CAN",
                  "administrative_province_code": "ON",
                  "administrative_region_code": null,
                  "alcoholic_liver_disease_type": null,
                  "alcoholic_liver_disease_type_code": null,
                  "comments": null,
                  "coordinator_id": null,
                  "created_at": "2026-03-19T09:24:51.393Z",
                  "created_by": "AUTOMATION_SP",
                  "dialysis_not_applicable": null,
                  "expiry_date": null,
                  "factors": {
                      "_id": null,
                      "decision": null,
                      "decision_code": 4,
                      "decision_comments": null,
                      "decision_coordinator_id": "68a49f90f7fb6a82e5aad577",
                      "decision_date": "2026-03-19",
                      "decision_other_reason": null,
                      "decision_reason": null,
                      "decision_reason_code": null
                  },
                  "hospital_id": null,
                  "inpatient": null,
                  "migration_comment": null,
                  "mrn": null,
                  "on_dialysis": null,
                  "primary_disease": null,
                  "primary_disease_code": null,
                  "received_date": "2026-03-19",
                  "referral_number": 39398,
                  "referrer": {
                      "_id": "69bbc0f9cbdf24c934aebb0d",
                      "organization": {
                          "_id": "69bbc0f9cbdf24c934aebb0f",
                          "city": "SomeCity",
                          "country": "CAN",
                          "name": "organizationName",
                          "other_country": null,
                          "phone_number": null,
                          "phone_number_type_code": null,
                          "postal_code": "L1L2L3",
                          "province": "ON",
                          "street": "SomeAddress",
                          "type": null,
                          "type_code": 1
                      },
                      "professional": {
                          "_id": "69bbc0f9cbdf24c934aebb0e",
                          "first_name": "Abc",
                          "last_name": "Def",
                          "type": null,
                          "type_code": 1
                      }
                  },
                  "secondary_disease": null,
                  "secondary_disease_code": null,
                  "state": "accepted",
                  "updated_at": "2026-03-19T09:25:23.402Z",
                  "updated_by": "AUTOMATION_SP"
              },
              "transplant": {
                  "_id": null,
                  "admission_date": null,
                  "arterial_anas_type": null,
                  "central_line_placement": null,
                  "clamp_removal_date_left_kid": "2026-04-15T15:11:00.000+00:00",
                  "clamp_removal_date_right_kid": "2026-04-23T15:11:00.000+00:00",
                  "cold_isch_time_left_kid": 0,
                  "cold_isch_time_right_kid": 0,
                  "comments": null,
                  "complication_category_code": null,
                  "complication_date": null,
                  "complication_type_code": null,
                  "cooling_jacket": null,
                  "created_at": "2026-04-28T19:50:45.822Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "discharge_date": null,
                  "donor_client_id": 129445,
                  "donor_id": "69bbbedfcbdf24c934aeb9af",
                  "end_cold_storage_date_left_kid": "2026-04-23T15:11:00.000+00:00",
                  "end_cold_storage_date_right_kid": "2026-04-23T15:11:00.000+00:00",
                  "end_perfuse_date_left_kid": null,
                  "end_perfuse_date_right_kid": null,
                  "factors": {
                      "_id": null,
                      "national_transplant_id": null,
                      "transplant_date": "2026-04-22"
                  },
                  "icu_days": null,
                  "incision_side": null,
                  "list_of_vessels_used": null,
                  "number_of_transfusions": null,
                  "organ_specification_code": 311,
                  "rewarm_time_left_kid": -691200,
                  "rewarm_time_right_kid": 0,
                  "state": "transplanted",
                  "surgical_persons": [],
                  "total_anesthesia_time": null,
                  "total_op_room_time": null,
                  "total_surgery_time": null,
                  "transplant_end_date": null,
                  "transplant_start_date": "2026-04-21T15:11:00.000+00:00",
                  "tumor": false,
                  "tumor_type": null,
                  "updated_at": "2026-04-28T19:50:45.872Z",
                  "updated_by": "AUTOMATION_TGLNADMIN",
                  "ureteric_anas": null,
                  "urine_output": null,
                  "vascular_reconstruction": null,
                  "vascular_release_date_left_kid": null,
                  "vascular_release_date_right_kid": null,
                  "vessels_used": true
              },
              "waitlist": {
                  "_id": null,
                  "created_at": "2026-03-19T09:24:51.393Z",
                  "created_by": "AUTOMATION_SP",
                  "factors": {
                      "_id": null,
                      "added_date": "2026-03-19",
                      "dialysis_start_date": "2026-03-19",
                      "kidney_prior_journey_id": null,
                      "listing_date": "2026-03-19",
                      "liver_hcc_in_criteria_date": null,
                      "living_donor_transplant_in_progress": null,
                      "living_donor_transplant_in_progress_date": null,
                      "medical_status_code": "N",
                      "medical_status_date": "2026-03-19T09:26:59.617+00:00",
                      "medical_status_secondary_code": null,
                      "on_hold_cluster": false,
                      "on_hold_cluster_inducing_journeys": [],
                      "on_hold_incomplete_cluster": false,
                      "on_hold_incomplete_data": false,
                      "on_hold_initial_waitlisted": false,
                      "on_hold_medical": false,
                      "on_hold_medical_assessment_date": null,
                      "on_hold_medical_change_type": null,
                      "on_hold_medical_date": null,
                      "on_hold_medical_expiry_date": null,
                      "on_hold_medical_extension_date": null,
                      "on_hold_medical_other_reason": null,
                      "on_hold_medical_reason": null,
                      "on_hold_medical_reason_code": null,
                      "on_hold_medical_reason_comment": null,
                      "on_hold_non_medical_reason_change_date": null,
                      "on_hold_partial_cluster_transplant": false,
                      "on_hold_serum_hla_antibody": false,
                      "on_hold_serum_hla_antibody_date": null,
                      "on_hold_with_non_medical_reason": false,
                      "previous_transplant_failure_date": null,
                      "reinstatement_automatic": null,
                      "reinstatement_manual": null,
                      "retransplant_prior_journey_id": null,
                      "suspended_cluster": false,
                      "suspended_cluster_inducing_journeys": [],
                      "suspended_heart": false,
                      "suspended_heart_date": null,
                      "suspended_liver_hcc": false,
                      "suspended_liver_hcc_date": null,
                      "suspended_liver_non_medical": false,
                      "suspended_liver_non_medical_date": null,
                      "suspended_liver_sodium_meld": false,
                      "suspended_liver_sodium_meld_date": null,
                      "suspended_medical": false,
                      "suspended_medical_date": null,
                      "transplant_in_progress": "69bbc1a0f675b5631efd5239",
                      "transplant_in_progress_date": "2026-03-19T09:33:11.474+00:00",
                      "wait_days_adjustment": 0,
                      "wait_days_adjustment_comment": null,
                      "wait_days_adjustment_date": null,
                      "wait_days_adjustment_other_reason": null,
                      "wait_days_adjustment_reason_code": null,
                      "on_hold_incomplete_cluster_date": null,
                      "on_hold_cluster_date": null,
                      "suspended_cluster_date": null,
                      "on_hold_partial_cluster_transplant_date": null
                  },
                  "state": "active",
                  "updated_at": "2026-04-28T19:50:45.822Z",
                  "updated_by": "AUTOMATION_SP",
                  "waitlist_history_snapshots": [],
                  "waitlist_history_snapshots_date": null,
                  "waitlist_removal_comment": null,
                  "waitlist_removal_date": "2026-04-22T00:00:00.000+00:00",
                  "waitlist_removal_reason": null,
                  "waitlist_removal_reason_code": 14,
                  "waitlist_removal_reason_other": null,
                  "waitlist_report_calculated_allocation_points": null,
                  "waitlist_report_calculated_wait_days": null,
                  "waitlist_report_calculated_wait_days_date": null
              }
          },
          "start_date": "2026-03-19",
          "state": "follow-up",
          "state_description_long": "",
          "state_description_short": "",
          "stoplight": "green",
          "transfer_in_progress": false,
          "transplant_program": {
              "_id": null,
              "transplant_coordinator_id": "68a49f90f7fb6a82e5aad577",
              "transplant_hospital_abbreviation": null,
              "transplant_hospital_id": "635c84467575ec2a0b026422",
              "transplant_hospital_mrn": null,
              "transplant_hospital_short_name": null
          },
          "updated_at": "2026-04-28T19:50:55.579Z",
          "updated_by": "AUTOMATION_CSCMANAGERCOORDINATOR",
          "urgent": false
      }
  ],
  "migrated_recipient": false,
  "oop_recipient": false,
  "state": "active",
  "updated_at": "2026-04-28T19:50:55.579Z",
  "updated_by": "AUTOMATION_CSCMANAGERCOORDINATOR",
  "urgent": false,
  "urgent_last_toggled_date": null,
  "clinical_transaction": null,
  "patient_profile": {
      "_id": "69bbc088cfa5ba70f5aed09c",
      "addresses": [
          {
              "_id": "69bbc089cfa5ba70f5aed0a1",
              "administrative_region_code": null,
              "city": "North Faviola",
              "country_code": "CAN",
              "country_other": null,
              "postal_code": "Y8N 3E9",
              "province_code": "ON",
              "street": "Suite 268 3184 Jones Cliff",
              "type": "permanent"
          }
      ],
      "age": null,
      "birth": {
          "_id": "69bbc089cfa5ba70f5aed09e",
          "city": null,
          "country": null,
          "date": "1958-03-19",
          "province": null
      },
      "comments": null,
      "contact_details": {
          "_id": "69bbc089cfa5ba70f5aed0a0",
          "email": "",
          "phone_alternate": null,
          "phone_alternate_ext": null,
          "phone_alternate_other": null,
          "phone_mobile": null,
          "phone_pager": null,
          "phone_primary": null,
          "phone_primary_ext": null,
          "phone_primary_other": null,
          "primary_contact_name": null,
          "primary_contact_relationship_code": null,
          "secondary_contact_name": null,
          "secondary_contact_relationship_code": null
      },
      "created_at": "2026-03-19T09:23:21.188Z",
      "created_by": "AUTOMATION_SP",
      "ctr": {
          "_id": "69bbc17f67ab650a89164ed2",
          "ctd_override": null,
          "ctr_last_updated": null,
          "national_donor_id": null,
          "national_recipient_id": "CTR061492",
          "national_recipient_serum_id": null,
          "now_consent_withdrawn": false
      },
      "donor_id": null,
      "effective_date": null,
      "ethnicity_code": "11",
      "ethnicity_other": null,
      "first_name": "DYMWRIEXE AFN",
      "gender": null,
      "gender_other": null,
      "gender_sex_different": false,
      "in_utero": false,
      "insurance": {
          "_id": "69bbc089cfa5ba70f5aed09f",
          "number": null,
          "other_plan": null,
          "other_province_plan": null,
          "plan": null,
          "plan_checked": false,
          "plan_code": 0,
          "version": null
      },
      "last_name": "BZVZMYGX ALN",
      "living_donor_id": null,
      "marital_status_code": null,
      "middle_name": "",
      "postal_code": null,
      "recipient_id": "69bbc088cfa5ba70f5aed09d",
      "sex": "M",
      "updated_at": "2026-04-28T19:50:49.053Z",
      "updated_by": "AUTOMATION_SP"
  },
  "dialysis_procedures": [
      {
          "_id": "69bbc136585dfddf77ae9db1",
          "access_method_code": 1,
          "access_method_other": null,
          "comments": null,
          "created_at": "2026-03-19T09:26:14.564Z",
          "created_by": "AUTOMATION_SP",
          "date": null,
          "dialysis_provider_code": 1,
          "dialysis_type_code": 1,
          "dialysis_type_other": null,
          "end_date": null,
          "location_type_code": 1,
          "other_location_desc": null,
          "previous_type_code": null,
          "recipient_id": "69bbc088cfa5ba70f5aed09d",
          "start_date": "2026-03-19",
          "updated_at": "2026-03-19T09:26:14.564Z",
          "updated_by": "AUTOMATION_SP"
      }
  ],
  "pancreas_islets_procedures": [],
  "virology_labs": [
      {
          "_id": "69bbc089cfa5ba70f5aed0aa",
          "comments": null,
          "created_at": "2026-03-19T09:23:21.238Z",
          "created_by": "AUTOMATION_SP",
          "lab_code": "TOS",
          "lab_id": null,
          "lab_other": null,
          "recipient_id": "69bbc088cfa5ba70f5aed09d",
          "results": [
              {
                  "_id": "69bbc089cfa5ba70f5aed0a2",
                  "code": "CMV_IGG_AB",
                  "comments": "CMV IGG negative comment",
                  "created_at": "2026-03-19T09:23:21.239Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.239Z",
                  "updated_by": "AUTOMATION_SP"
              },
              {
                  "_id": "69bbc089cfa5ba70f5aed0a3",
                  "code": "CMV_IGM_AB",
                  "comments": "CMV IGM negative comment",
                  "created_at": "2026-03-19T09:23:21.239Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.239Z",
                  "updated_by": "AUTOMATION_SP"
              },
              {
                  "_id": "69bbc089cfa5ba70f5aed0a4",
                  "code": "EBV_NUCLEAR_AB",
                  "comments": "EBV Nuclear negative comment",
                  "created_at": "2026-03-19T09:23:21.239Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.239Z",
                  "updated_by": "AUTOMATION_SP"
              },
              {
                  "_id": "69bbc089cfa5ba70f5aed0a5",
                  "code": "EBV_CAPSID_AB",
                  "comments": "EBV Capsid negative comment",
                  "created_at": "2026-03-19T09:23:21.239Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.239Z",
                  "updated_by": "AUTOMATION_SP"
              },
              {
                  "_id": "69bbc089cfa5ba70f5aed0a6",
                  "code": "EBV_EARLY_AB",
                  "comments": "EBV Early negative comment",
                  "created_at": "2026-03-19T09:23:21.239Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.239Z",
                  "updated_by": "AUTOMATION_SP"
              },
              {
                  "_id": "69bbc089cfa5ba70f5aed0a7",
                  "code": "HBV_SURFACE_AG",
                  "comments": "HBs Ag negative comment",
                  "created_at": "2026-03-19T09:23:21.239Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.239Z",
                  "updated_by": "AUTOMATION_SP"
              },
              {
                  "_id": "69bbc089cfa5ba70f5aed0a8",
                  "code": "HBV_CORE_AB",
                  "comments": "Hep B Core AB comment",
                  "created_at": "2026-03-19T09:23:21.240Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.240Z",
                  "updated_by": "AUTOMATION_SP"
              },
              {
                  "_id": "69bbc089cfa5ba70f5aed0a9",
                  "code": "HCV_AB",
                  "comments": "HCV Negative Comment",
                  "created_at": "2026-03-19T09:23:21.240Z",
                  "created_by": "AUTOMATION_SP",
                  "other_code_details": null,
                  "positive": false,
                  "updated_at": "2026-03-19T09:23:21.240Z",
                  "updated_by": "AUTOMATION_SP"
              }
          ],
          "sample_date": "2026-03-19T04:01:00.000+00:00",
          "sample_number": "sj3aa0",
          "test_code": null,
          "test_date": "2026-03-19T04:01:00.000+00:00",
          "updated_at": "2026-03-19T09:23:21.302Z",
          "updated_by": "AUTOMATION_SP"
      }
  ],
  "measurements": [
      {
          "_id": "69bbc089cfa5ba70f5aed0ab",
          "abdominal_girth": null,
          "chest_circumference": null,
          "chest_transverse": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-03-19T09:23:21.229Z",
          "created_by": "AUTOMATION_SP",
          "date": "2026-03-19",
          "height": 159,
          "recipient_id": "69bbc088cfa5ba70f5aed09d",
          "updated_at": "2026-03-19T09:23:21.229Z",
          "updated_by": "AUTOMATION_SP",
          "weight": 78,
          "bmi": 30.9
      }
  ],
  "liver_melds": []
};
const uhnOATSLivingDonor129464 = {
  "_id": "69e0dffab9f83018163998de",
  "blood": {
      "_id": null,
      "rh": "-",
      "sub_type": "A2B",
      "type": "AB",
      "type_verified": true
  },
  "client_id": 142773,
  "comments": null,
  "consented_for_research": null,
  "created_at": "2026-04-16T13:11:23.382Z",
  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
  "death": {
      "_id": null,
      "cause_of_death_code": null,
      "created_at": "*******",
      "created_by": null,
      "death_date": null,
      "first_declare_date": null,
      "first_declarer": null,
      "hospital_id_declared": null,
      "hospital_id_retested": null,
      "hospital_id_retested_primary": null,
      "neurological_death": null,
      "other_cause_of_death": null,
      "retest_declare_date": null,
      "retest_declarer": null,
      "second_declare_date": null,
      "second_declarer": null,
      "updated_at": "*******",
      "updated_by": null
  },
  "deceased_donor_id": null,
  "default_hla_laboratory_id": null,
  "indicators": {
      "_id": null,
      "approach_over_the_phone": null,
      "deceased_at_referral_time": null,
      "deceased_donor": false,
      "double_kidney": "*******",
      "ecd_donor": "*******",
      "exceptional_distribution": true,
      "exd_reason_codes": [
          501,
          402,
          200,
          300
      ],
      "exd_reason_details_other": "IRD Incarceration >72 consecutive hours in last 3 months",
      "exd_reason_details_transmission": null,
      "exd_reason_details_travel": "Testing travel risk",
      "from_itransplant": null,
      "glasgow_coma_scale": null,
      "heart_beat_at_referral": null,
      "kdpi": null,
      "kdpi_datetime": null,
      "kidney_paired_donation": false,
      "oop_kidneys_available": "*******",
      "organ_donor": null,
      "out_of_province": null,
      "post_release": null,
      "post_release_by": null,
      "post_release_date": null,
      "post_release_reason": null,
      "read_only": null,
      "registered_consent_decision": null,
      "results_reason": null,
      "results_received": null,
      "results_received_by": null,
      "results_received_date": null,
      "results_reported": null,
      "results_reported_by": null,
      "results_reported_date": null,
      "rnr_complete": null,
      "tissue_donor": null,
      "unknown_donor_type": null,
      "ventilator_at_referral": null,
      "ventilator_status": null,
      "ventilator_type": null,
      "ventilator_type_other": null,
      "withdrawal_discussion": null
  },
  "living_donor_id": 129464,
  "living_donor_info": {
      "_id": null,
      "comments": null,
      "created_at": "2026-04-16T13:11:23.383Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "journeys": [
          {
              "_id": "69e0dffbb9f83018163998e4",
              "anonymous": null,
              "comments": null,
              "completed": false,
              "completed_date": null,
              "completed_reason": null,
              "completed_reason_code": null,
              "created_at": "2026-04-16T13:11:23.383Z",
              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "directed_donation": true,
              "historical": false,
              "intended_recipients": [
                  {
                      "_id": "69e0e59b78a76e1f5639a1f0",
                      "created_at": "2026-04-16T13:35:23.783Z",
                      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                      "donor_relationship_code": 6,
                      "link_date": "2026-04-16",
                      "recipient_id": "69dd063151237c7c8e3973c2",
                      "recipient_journey_id": "69e0db0478a76e1f563992d3",
                      "unlink_date": null,
                      "unlink_reason_code": null,
                      "unlink_reason_other": null,
                      "updated_at": "2026-04-16T13:35:23.783Z",
                      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                      "recipient": {
                          "id": "69dd063151237c7c8e3973c2",
                          "client_id": 71099,
                          "patient_profile": {
                              "first_name": "Three",
                              "last_name": "OATSrecipient"
                          }
                      },
                      "journey": {
                          "_id": "69e0db0478a76e1f563992d3",
                          "comments": null,
                          "completed": false,
                          "completed_date": null,
                          "completed_reason": null,
                          "completed_reason_code": null,
                          "created_at": "2026-04-16T12:50:12.364Z",
                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                          "ctr_id": null,
                          "donor_acceptability": {
                              "_id": null,
                              "a2_or_a2b_donor": true,
                              "abo_incompatible": true,
                              "comments": "Testing liver DAC comments",
                              "created_at": "2026-04-16T12:50:12.364Z",
                              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                              "deceased_donor": true,
                              "ecd_donor": null,
                              "hcv_ab_positive": true,
                              "hcv_nat_positive": false,
                              "hep_ab_core_positive": null,
                              "living_donor": false,
                              "max_age": null,
                              "max_height": null,
                              "max_weight": null,
                              "min_age": null,
                              "min_height": null,
                              "min_weight": null,
                              "updated_at": "2026-05-01T14:22:20.119Z",
                              "updated_by": "AMY.NI1@ONEID.ON.CA"
                          },
                          "donor_acceptability_from_journey_id": null,
                          "failed_organ": {
                              "_id": null,
                              "cause_of_failure": null,
                              "cause_of_failure_code": null,
                              "comments": null,
                              "failure_date": null,
                              "former_cause_of_failure": null,
                              "former_cause_of_failure_code": null,
                              "primary_diagnosis": "HEPATITIS - TYPE B",
                              "primary_diagnosis_code": 2,
                              "primary_diagnosis_date": null,
                              "secondary_diagnosis": "OTHER",
                              "secondary_diagnosis_code": 78,
                              "secondary_diagnosis_date": null
                          },
                          "historical_registration_date": null,
                          "migrated_journey": false,
                          "migration_comment": null,
                          "oop_journey": false,
                          "organ": "Liver",
                          "organ_code": 1,
                          "organ_specific_details": {
                              "_id": null,
                              "a1c": null,
                              "a1c_date": null,
                              "albumin": null,
                              "albumin_date": null,
                              "bilirubin": null,
                              "bilirubin_date": null,
                              "created_at": "2026-04-16T12:50:12.364Z",
                              "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                              "creatinine": null,
                              "creatinine_date": null,
                              "default_values": false,
                              "egfr": null,
                              "egfr_date": null,
                              "inr": null,
                              "inr_date": null,
                              "latest_smc": {
                                  "_id": null,
                                  "accumulated_exception_points": null,
                                  "baseline_date": "2026-04-16",
                                  "baseline_override": null,
                                  "baseline_score": null,
                                  "created_at": "2026-04-16T12:53:15.950Z",
                                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                                  "exception_diseases": false,
                                  "exception_points_params": {
                                      "_id": "69e0dbbb78a76e1f563998b5",
                                      "age": null,
                                      "birth_date": "1994-09-20",
                                      "blackout_days": 0,
                                      "exception_diseases": false,
                                      "hcc": false,
                                      "hcc_blackout_days": 0,
                                      "hcc_in_criteria_date": null,
                                      "hepatoblastoma": false,
                                      "listing_date": "2026-04-16T12:53:15.798+00:00",
                                      "liver_ped_cond": false,
                                      "meld_peld": 33,
                                      "metabolic_disease": false,
                                      "organ_code": [
                                          1
                                      ],
                                      "pediatric": false,
                                      "refractory_pruritus_blackout_days": 0,
                                      "refractory_pruritus_disease": false,
                                      "refractory_pruritus_disease_date": null,
                                      "smc_baseline_date": null,
                                      "smc_flat_score": null,
                                      "smc_override": false,
                                      "version": null
                                  },
                                  "exception_points_scores": {
                                      "_id": "69e0dbbb78a76e1f563998b6",
                                      "exception_diseases": 0,
                                      "hcc": 0,
                                      "meld_peld": 33,
                                      "multi_organ": 0,
                                      "pediatric": 0
                                  },
                                  "flat_score": null,
                                  "hcc": false,
                                  "hcc_id": null,
                                  "liver_bridging_id": null,
                                  "liver_downstaging_id": null,
                                  "meld_id": "69e0dbbb78a76e1f563998b4",
                                  "override": null,
                                  "override_comment": null,
                                  "pediatric": false,
                                  "peld_id": null,
                                  "review_date": null,
                                  "score": 33,
                                  "score_source_code": "mp",
                                  "updated_at": "2026-04-16T12:53:15.973Z",
                                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                              },
                              "organ_specification_preference_code": null,
                              "previous_malignancy": null,
                              "previous_transfusion": null,
                              "sodium": null,
                              "sodium_date": null,
                              "updated_at": "2026-04-16T12:53:15.987Z",
                              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                          },
                          "recipient_programs": {
                              "_id": null,
                              "double_leg_amputee": false,
                              "hsx_eligible": false,
                              "kidney_paired_donation": false,
                              "list_exchange": false,
                              "list_exchange_date": null,
                              "national_organ_request_id": null,
                              "previous_living_donation_date": null,
                              "previous_living_donor": false
                          },
                          "related_journeys": [],
                          "stage": "post-transplant",
                          "stage_attributes": {
                              "_id": null,
                              "assessment": {
                                  "_id": null,
                                  "alcoholic_liver_disease_type": null,
                                  "alcoholic_liver_disease_type_code": null,
                                  "consultation_state": "delayed",
                                  "created_at": "2026-04-16T12:50:13.451Z",
                                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                                  "factors": {
                                      "_id": null,
                                      "assessment_absolute_contraindication_code": null,
                                      "assessment_decision": null,
                                      "assessment_decision_code": 5,
                                      "assessment_decision_comments": null,
                                      "assessment_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                                      "assessment_decision_date": "2026-04-16",
                                      "assessment_decision_reason": null,
                                      "assessment_decision_reason_code": null,
                                      "assessment_decision_reason_other": null,
                                      "assessment_relative_contraindication_code": null,
                                      "consultation_decision": null,
                                      "consultation_decision_code": 6,
                                      "consultation_decision_comments": "Testing liver consultation comments",
                                      "consultation_decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                                      "consultation_decision_date": "2026-04-16",
                                      "consultation_decision_delay_end_date": "2026-04-16",
                                      "consultation_decision_delay_start_date": null,
                                      "consultation_decision_primary_physician_id": null,
                                      "consultation_decision_reason": null,
                                      "consultation_decision_reason_code": null
                                  },
                                  "migration_comment": null,
                                  "state": "living_donor",
                                  "updated_at": "2026-05-11T11:53:53.366Z",
                                  "updated_by": "AUTOMATION_TGLNADMIN"
                              },
                              "post_transplant": {
                                  "_id": null,
                                  "created_at": "2026-04-20T14:58:39.602Z",
                                  "created_by": "AUTOMATION_TGLNADMIN",
                                  "factors": {
                                      "_id": null,
                                      "graft_failure_cause": null,
                                      "graft_failure_cause_other": null,
                                      "graft_failure_comments": null,
                                      "graft_failure_date": null,
                                      "post_transplant_date": null
                                  },
                                  "follow_ups": [
                                      {
                                          "_id": "69e63f9578a76e1f5639e056",
                                          "biliary_complications": null,
                                          "cardio_event": null,
                                          "comments": null,
                                          "compliance": null,
                                          "compliance_comment": null,
                                          "created_at": "2026-04-20T15:00:38.031Z",
                                          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                                          "date_of_entry": "2026-04-20",
                                          "diabetes_indicator": null,
                                          "diabetes_new": null,
                                          "diabetes_new_date": null,
                                          "diabetes_pre_transplant": null,
                                          "dialysis_date": null,
                                          "dialysis_indicator": null,
                                          "employment_status_code": null,
                                          "employment_status_comment": null,
                                          "follow_up_date": "2026-04-20",
                                          "functional_status_code": null,
                                          "functional_status_comment": null,
                                          "graft_failure_cause": null,
                                          "graft_failure_cause_other": null,
                                          "graft_failure_comments": null,
                                          "graft_failure_date": null,
                                          "graft_functioning_at_death": null,
                                          "graft_status_code": null,
                                          "hospital_id": null,
                                          "insulin_date": null,
                                          "lab_values": null,
                                          "lifestyle_compliance_indicator": null,
                                          "lost_to_followup_reason": null,
                                          "medication_compliance_indicator": null,
                                          "new_hypertension_indicator": null,
                                          "new_hypertention_date": null,
                                          "organ_rejection_indicator": null,
                                          "post_transplant_malignancy": null,
                                          "primary_diagnosis": null,
                                          "primary_diagnosis_path_confirm": null,
                                          "primary_diagnosis_recurrence": null,
                                          "primary_diagnosis_recurrence_date": null,
                                          "primary_disease_code": null,
                                          "recipient_status_code": 1,
                                          "records_stopped": null,
                                          "renal_function_indicator": null,
                                          "secondary_diagnosis": null,
                                          "secondary_diagnosis_path_confirm": null,
                                          "secondary_diagnosis_recurrence": null,
                                          "secondary_diagnosis_recurrence_date": null,
                                          "secondary_disease_code": null,
                                          "source_of_followup": 6,
                                          "source_of_followup_other": null,
                                          "sugar_control_code": null,
                                          "type": null,
                                          "updated_at": "2026-04-20T15:00:38.031Z",
                                          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                                          "vascular_complications": null
                                      }
                                  ],
                                  "kidney_removal_date": null,
                                  "previous_graft_failure_code": null,
                                  "state": "follow-up",
                                  "updated_at": "2026-05-06T19:24:34.206Z",
                                  "updated_by": "AUTOMATION_TGLNADMIN"
                              },
                              "referral": {
                                  "_id": null,
                                  "administrative_country_code": "CAN",
                                  "administrative_province_code": "ON",
                                  "administrative_region_code": null,
                                  "alcoholic_liver_disease_type": null,
                                  "alcoholic_liver_disease_type_code": null,
                                  "comments": null,
                                  "coordinator_id": null,
                                  "created_at": "2026-04-16T12:50:12.365Z",
                                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                                  "dialysis_not_applicable": null,
                                  "expiry_date": null,
                                  "factors": {
                                      "_id": null,
                                      "decision": null,
                                      "decision_code": 4,
                                      "decision_comments": null,
                                      "decision_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                                      "decision_date": "2026-04-16",
                                      "decision_other_reason": null,
                                      "decision_reason": null,
                                      "decision_reason_code": null
                                  },
                                  "hospital_id": null,
                                  "inpatient": null,
                                  "migration_comment": null,
                                  "mrn": null,
                                  "on_dialysis": null,
                                  "primary_disease": null,
                                  "primary_disease_code": null,
                                  "received_date": "2026-04-16",
                                  "referral_number": 39446,
                                  "referrer": {
                                      "_id": "69e0db0451237c7c8e3999ae",
                                      "organization": {
                                          "_id": "69e0db0451237c7c8e3999af",
                                          "city": "Toronto",
                                          "country": "CAN",
                                          "name": "Uhn Liver Clinic",
                                          "other_country": null,
                                          "phone_number": null,
                                          "phone_number_type_code": null,
                                          "postal_code": "M5G 2C4",
                                          "province": "ON",
                                          "street": "UHN - TGH, 9N-975 - 200 Elizabeth Street",
                                          "type": null,
                                          "type_code": 1
                                      },
                                      "professional": {
                                          "_id": "69e0db0451237c7c8e3999b0",
                                          "first_name": "Peter",
                                          "last_name": "Rossos",
                                          "type": null,
                                          "type_code": 4
                                      }
                                  },
                                  "secondary_disease": null,
                                  "secondary_disease_code": null,
                                  "state": "accepted",
                                  "updated_at": "2026-04-16T12:50:13.482Z",
                                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
                              },
                              "transplant": {
                                  "_id": null,
                                  "admission_date": null,
                                  "anhep_bp": null,
                                  "arterial_reconstruction_type": null,
                                  "bile_production_indicator": null,
                                  "biliary_anas_type": null,
                                  "child_pugh_score": null,
                                  "cholec_indicator": null,
                                  "cold_isch_time": 0,
                                  "comments": null,
                                  "complication_category_code": null,
                                  "complication_date": null,
                                  "complication_type_code": null,
                                  "created_at": "2026-04-20T14:58:39.602Z",
                                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                                  "crystalloid": null,
                                  "discharge_date": null,
                                  "donor_client_id": 129464,
                                  "donor_id": "69e0dffab9f83018163998de",
                                  "end_cold_storage_date": "2026-04-20T00:30:00.000+00:00",
                                  "factors": {
                                      "_id": null,
                                      "national_transplant_id": null,
                                      "transplant_date": "2026-04-19"
                                  },
                                  "ha_clamp_off_date": "2026-04-20T01:20:00.000+00:00",
                                  "hemostasis_result_type": null,
                                  "icu_days": null,
                                  "list_of_vessels_used": null,
                                  "liver_appearance_type_code": null,
                                  "liver_consistency_type_code": null,
                                  "liver_reduction_type": null,
                                  "number_of_transfusions": null,
                                  "organ_specification_code": 103,
                                  "other_procedure_comment": null,
                                  "portal_clamp_date": null,
                                  "portal_vein_cross_clamp_date": "2026-04-20T01:22:00.000+00:00",
                                  "post_anas_press_dias": null,
                                  "post_anas_press_sys": null,
                                  "pre_anhep_press_dias": null,
                                  "pre_anhep_press_sys": null,
                                  "pv_anomaly_type_code": null,
                                  "pv_atresia_indicator": null,
                                  "pv_clamp_off_date": "2026-04-20T01:11:00.000+00:00",
                                  "pv_recon_type": null,
                                  "pv_thrombosis_indicator": null,
                                  "removed_from_normothermic_perf_pump_date": "2026-04-20T00:45:00.000+00:00",
                                  "rewarm_time": 2460,
                                  "splenectomy_indicator": null,
                                  "state": "transplanted",
                                  "surgical_persons": [],
                                  "total_anesthesia_time": null,
                                  "total_op_room_time": null,
                                  "total_surgery_time": null,
                                  "transplant_end_date": null,
                                  "transplant_inr": null,
                                  "transplant_start_date": "2026-04-20T01:24:00.000+00:00",
                                  "tumor": false,
                                  "tumor_type": null,
                                  "updated_at": "2026-05-12T14:27:15.136Z",
                                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                                  "venous_bypass_indicator": null,
                                  "vessels_used": false
                              },
                              "waitlist": {
                                  "_id": null,
                                  "created_at": "2026-04-16T13:40:49.745Z",
                                  "created_by": "AMY.NI1@ONEID.ON.CA",
                                  "factors": {
                                      "_id": null,
                                      "added_date": null,
                                      "dialysis_start_date": null,
                                      "kidney_prior_journey_id": null,
                                      "listing_date": null,
                                      "liver_hcc_in_criteria_date": null,
                                      "living_donor_transplant_in_progress": "69e0dffab9f83018163998de",
                                      "living_donor_transplant_in_progress_date": "2026-04-16T13:40:49.735+00:00",
                                      "medical_status_code": null,
                                      "medical_status_date": null,
                                      "medical_status_secondary_code": null,
                                      "on_hold_cluster": false,
                                      "on_hold_cluster_inducing_journeys": [],
                                      "on_hold_incomplete_cluster": false,
                                      "on_hold_incomplete_data": false,
                                      "on_hold_initial_waitlisted": false,
                                      "on_hold_medical": false,
                                      "on_hold_medical_assessment_date": null,
                                      "on_hold_medical_change_type": null,
                                      "on_hold_medical_date": null,
                                      "on_hold_medical_expiry_date": null,
                                      "on_hold_medical_extension_date": null,
                                      "on_hold_medical_other_reason": null,
                                      "on_hold_medical_reason": null,
                                      "on_hold_medical_reason_code": null,
                                      "on_hold_medical_reason_comment": null,
                                      "on_hold_non_medical_reason_change_date": null,
                                      "on_hold_partial_cluster_transplant": false,
                                      "on_hold_serum_hla_antibody": false,
                                      "on_hold_serum_hla_antibody_date": null,
                                      "on_hold_with_non_medical_reason": false,
                                      "previous_transplant_failure_date": null,
                                      "reinstatement_automatic": null,
                                      "reinstatement_manual": null,
                                      "retransplant_prior_journey_id": null,
                                      "suspended_cluster": false,
                                      "suspended_cluster_inducing_journeys": [],
                                      "suspended_heart": false,
                                      "suspended_heart_date": null,
                                      "suspended_liver_hcc": false,
                                      "suspended_liver_hcc_date": null,
                                      "suspended_liver_non_medical": false,
                                      "suspended_liver_non_medical_date": null,
                                      "suspended_liver_sodium_meld": false,
                                      "suspended_liver_sodium_meld_date": null,
                                      "suspended_medical": false,
                                      "suspended_medical_date": null,
                                      "transplant_in_progress": null,
                                      "transplant_in_progress_date": null,
                                      "wait_days_adjustment": 0,
                                      "wait_days_adjustment_comment": null,
                                      "wait_days_adjustment_date": null,
                                      "wait_days_adjustment_other_reason": null,
                                      "wait_days_adjustment_reason_code": null,
                                      "on_hold_incomplete_cluster_date": null,
                                      "on_hold_cluster_date": null,
                                      "suspended_cluster_date": null,
                                      "on_hold_partial_cluster_transplant_date": null
                                  },
                                  "state": null,
                                  "updated_at": "2026-04-20T14:58:39.602Z",
                                  "updated_by": "AMY.NI1@ONEID.ON.CA",
                                  "waitlist_history_snapshots": [],
                                  "waitlist_history_snapshots_date": null,
                                  "waitlist_removal_comment": null,
                                  "waitlist_removal_date": "2026-04-19T00:00:00.000+00:00",
                                  "waitlist_removal_reason": null,
                                  "waitlist_removal_reason_code": 14,
                                  "waitlist_removal_reason_other": null,
                                  "waitlist_report_calculated_allocation_points": null,
                                  "waitlist_report_calculated_wait_days": null,
                                  "waitlist_report_calculated_wait_days_date": null
                              }
                          },
                          "start_date": "2026-04-16",
                          "state": "follow-up",
                          "state_description_long": "",
                          "state_description_short": "",
                          "stoplight": "green",
                          "transfer_in_progress": false,
                          "transplant_program": {
                              "_id": null,
                              "transplant_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                              "transplant_hospital_abbreviation": null,
                              "transplant_hospital_id": "635c84467575ec2a0b026422",
                              "transplant_hospital_mrn": "100005950",
                              "transplant_hospital_short_name": null
                          },
                          "updated_at": "2026-05-12T14:27:15.176Z",
                          "updated_by": "AMY.NI1@ONEID.ON.CA",
                          "urgent": false
                      }
                  }
              ],
              "list_exchange": false,
              "migration_comment": null,
              "organ": "Liver",
              "organ_code": 1,
              "recovery_info": {
                  "_id": null,
                  "comments": null,
                  "completed": true,
                  "created_at": "2026-04-16T13:35:58.873Z",
                  "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
                  "cross_clamp_date": "2026-04-18T00:00:00.000+00:00",
                  "end_date": "2026-04-17T20:18:00.000+00:00",
                  "flush_date": "2026-04-18T04:15:00.000+00:00",
                  "liver_abnormalities_concerns": "testing donor liver comments",
                  "liver_graft_weight": 1250,
                  "organ_shipped": true,
                  "organ_shipped_info": {
                      "_id": null,
                      "oop": true,
                      "organ_successfully_transplanted": true,
                      "perfusion_date": null,
                      "perfusion_pump": null
                  },
                  "organ_specification_code": 103,
                  "start_date": "2026-04-17T20:17:00.000+00:00",
                  "surgeon1": "SELZNER, MARKUS",
                  "surgeon2": "",
                  "transplant_date": "2026-04-19",
                  "transplant_hospital_id": null,
                  "updated_at": "2026-05-13T18:47:30.655Z",
                  "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA"
              },
              "registration_date": "2026-04-16T13:11:23.359+00:00",
              "start_date": "2026-04-16",
              "transfer_in_progress": false,
              "transplant_program": {
                  "_id": null,
                  "living_donor_coordinator_id": "68b6edda8b7e20f8bf34b22e",
                  "transplant_hospital_abbreviation": null,
                  "transplant_hospital_id": "635c84467575ec2a0b026422",
                  "transplant_hospital_mrn": "100005953",
                  "transplant_hospital_short_name": null
              },
              "updated_at": "2026-05-13T18:47:30.668Z",
              "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
              "recovery_info_set": true
          }
      ],
      "updated_at": "2026-05-13T18:47:30.668Z",
      "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "virology_comments": null
  },
  "migrated_donor": false,
  "migration_comment": null,
  "organ_consents": [
      {
          "_id": "69e0dffbb9f83018163998e5",
          "consented": true,
          "consented_date": "2026-04-16",
          "created_at": "2026-04-16T13:11:23.361Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "organ": "Liver",
          "organ_code": 1,
          "updated_at": "2026-05-01T14:08:05.197Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "running_allocation_tasks": {},
          "available_allocation_types": [],
          "runnable_allocation_types": [
              "living_anonymous"
          ]
      }
  ],
  "organ_decline_reason_category": null,
  "organ_decline_reason_type": null,
  "organ_donations_eligible_for_recovery": false,
  "referral": {
      "_id": null,
      "extension": null,
      "fax": null,
      "first_name": null,
      "last_name": null,
      "managing_coordinator_id": null,
      "originating_hosp_unit_code": null,
      "originating_hospital_id": null,
      "originating_hospital_mrn": null,
      "other_referral_hospital_name": null,
      "phone_number": null,
      "referer_profession_code": null,
      "referral_date": null,
      "referring_coordinator_id": null,
      "referring_hosp_unit_code": null,
      "referring_hospital_id": null,
      "referring_hospital_mrn": null
  },
  "rnr_admitting_diagnosis": null,
  "tissue_decline_reason_category": null,
  "tissue_decline_reason_type": null,
  "updated_at": "2026-05-13T18:47:30.668Z",
  "updated_by": "AMY.NI1@ONEID.ON.CA",
  "allocation_unavailable_due_to_positive_hbv_surface_ag": false,
  "allocation_must_be_expedited_due_to_missing_virology": {
      "1": [
          "HBV_SURFACE_AG"
      ],
      "2": [
          "HBV_SURFACE_AG"
      ],
      "3": [
          "HBV_SURFACE_AG"
      ],
      "4": [
          "HBV_SURFACE_AG"
      ],
      "6": [
          "HBV_SURFACE_AG"
      ],
      "7": [
          "HBV_SURFACE_AG"
      ],
      "7.5": [
          "HBV_SURFACE_AG"
      ],
      "6.5": [
          "HBV_SURFACE_AG"
      ]
  },
  "allocation_must_be_expedited_due_to_missing_hla_typing": [
      3,
      2,
      4,
      6,
      6.5,
      7.5
  ],
  "patient_profile": {
      "_id": "69e0dff9b9f83018163998dd",
      "addresses": [
          {
              "_id": "69e0dffbb9f83018163998e3",
              "administrative_region_code": null,
              "city": "City",
              "country_code": "CAN",
              "country_other": null,
              "postal_code": "X2X2X2",
              "province_code": "QC",
              "street": "321 Anywhere Street",
              "type": "permanent"
          }
      ],
      "age": null,
      "birth": {
          "_id": "69e0dffab9f83018163998df",
          "city": null,
          "country": null,
          "date": "2004-01-21",
          "province": null
      },
      "comments": null,
      "contact_details": {
          "_id": "69e0dffbb9f83018163998e2",
          "email": "one.oatsdonor@me.com",
          "phone_alternate": null,
          "phone_alternate_ext": null,
          "phone_alternate_other": null,
          "phone_mobile": "(437) 485-1256",
          "phone_pager": null,
          "phone_primary": "(416) 875-9654",
          "phone_primary_ext": null,
          "phone_primary_other": null,
          "primary_contact_name": null,
          "primary_contact_relationship_code": null,
          "secondary_contact_name": null,
          "secondary_contact_relationship_code": null
      },
      "created_at": "2026-04-16T13:11:23.454Z",
      "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
      "donor_id": "69e0dffab9f83018163998de",
      "effective_date": null,
      "ethnicity_code": "10",
      "ethnicity_other": "Other",
      "first_name": "One",
      "gender": null,
      "gender_other": null,
      "gender_sex_different": false,
      "in_utero": false,
      "insurance": {
          "_id": "69e0dffab9f83018163998e0",
          "number": "5881482029",
          "other_plan": null,
          "other_province_plan": null,
          "plan": null,
          "plan_checked": false,
          "plan_code": 1,
          "version": null
      },
      "last_name": "OATSdonor",
      "living_donor_id": "69e0dffab9f83018163998de",
      "marital_status_code": null,
      "middle_name": "UHN",
      "postal_code": null,
      "recipient_id": null,
      "sex": "M",
      "updated_at": "2026-05-01T14:08:05.159Z",
      "updated_by": "AMY.NI1@ONEID.ON.CA"
  },
  "measurements": [
      {
          "_id": "69e0dffab9f83018163998e1",
          "abdominal_girth": null,
          "bmi": null,
          "bronchoscopy_comments": null,
          "cardiac_silhouette": null,
          "chest_circumference": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-04-16T13:11:23.497Z",
          "created_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "date": "2026-04-16",
          "donor_id": "69e0dffab9f83018163998de",
          "height": 180.3,
          "lung_horizontal_measu": null,
          "suction_comments": null,
          "total_lung_capacity": null,
          "updated_at": "2026-04-16T13:15:01.803Z",
          "updated_by": "UHN_EMR_Integration:ELIZABETH.SELMAN.UHN@ONEID.ON.CA",
          "weight": 90
      }
  ],
  "organ_donations": [],
  "virologies": [
      {
          "_id": "69f02feb51237c7c8e3a7fdb",
          "archive": null,
          "comments": null,
          "created_at": "2026-04-28T03:56:27.240Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "donor_id": "69e0dffab9f83018163998de",
          "effective_date": null,
          "expiry_date": null,
          "from_mother": null,
          "lab_id": "635c8443f09aaf215e233c95",
          "lab_other": null,
          "national_sample_id": null,
          "receive_date": null,
          "results": [
              {
                  "_id": "69f02feb51237c7c8e3a7fdc",
                  "code": "HIV_NAT",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "P",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.256Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fdd",
                  "code": "HCV_NAT",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "P",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.256Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fde",
                  "code": "CMV_IGG_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "P",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.256Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fdf",
                  "code": "HBV_CORE_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "P",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.256Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe0",
                  "code": "HBV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "P",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.256Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe1",
                  "code": "HBV_SURFACE_AG",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.256Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe2",
                  "code": "HCV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "N",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.256Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe3",
                  "code": "HIV",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "N",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.257Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe4",
                  "code": "HTLV1",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "N",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.257Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe5",
                  "code": "HTLV2",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.241Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "N",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.257Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe6",
                  "code": "VDRL",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.242Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.257Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe7",
                  "code": "TOXOPLASMOSIS",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.242Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "N",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.257Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe8",
                  "code": "EBV_CAPSID_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.242Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.257Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fe9",
                  "code": "HSV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.242Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.257Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7fea",
                  "code": "WEST_NILE_IGM",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.242Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.258Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              },
              {
                  "_id": "69f02feb51237c7c8e3a7feb",
                  "code": "VZV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-28T03:56:27.242Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-30T13:40:04.258Z",
                  "updated_by": "AMY.NI1@ONEID.ON.CA"
              }
          ],
          "rpt_date": null,
          "sample_date": null,
          "sample_number": null,
          "sample_type": null,
          "superceded_date": null,
          "test_code": null,
          "test_date": "2026-04-20T15:11:00.000+00:00",
          "updated_at": "2026-04-30T13:40:04.406Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "deceased_donor_id": null,
          "donor_client_id": 142773,
          "_type": "virology_donor"
      },
      {
          "_id": "69e6ee9253b8ff23983a16c1",
          "archive": null,
          "comments": null,
          "created_at": "2026-04-21T03:27:14.533Z",
          "created_by": "AUTOMATION_TGLNADMIN",
          "donor_id": "69e0dffab9f83018163998de",
          "effective_date": null,
          "expiry_date": null,
          "from_mother": null,
          "lab_id": "635c8443f09aaf215e233c95",
          "lab_other": null,
          "national_sample_id": null,
          "receive_date": null,
          "results": [
              {
                  "_id": "69e6ee9253b8ff23983a16c2",
                  "code": "HIV_NAT",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "P",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:36:11.175Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16c3",
                  "code": "HCV_NAT",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "N",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:36:11.176Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16c4",
                  "code": "CMV_IGG_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16c5",
                  "code": "HBV_CORE_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16c6",
                  "code": "HBV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16c7",
                  "code": "HBV_SURFACE_AG",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16c8",
                  "code": "HCV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16c9",
                  "code": "HIV",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16ca",
                  "code": "HTLV1",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "P",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:36:11.176Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16cb",
                  "code": "HTLV2",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16cc",
                  "code": "VDRL",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16cd",
                  "code": "TOXOPLASMOSIS",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.534Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.534Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16ce",
                  "code": "EBV_CAPSID_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.535Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.535Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16cf",
                  "code": "HSV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.535Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.535Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16d0",
                  "code": "WEST_NILE_IGM",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.535Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.535Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              },
              {
                  "_id": "69e6ee9253b8ff23983a16d1",
                  "code": "VZV_AB",
                  "comments": null,
                  "confirm_comparative_result": null,
                  "confirm_comparative_test_kit": null,
                  "created_at": "2026-04-21T03:27:14.535Z",
                  "created_by": "AUTOMATION_TGLNADMIN",
                  "effective_date": null,
                  "expired_date": null,
                  "initial_result": "U",
                  "repeat_result": null,
                  "test_type": null,
                  "updated_at": "2026-04-21T03:27:14.535Z",
                  "updated_by": "AUTOMATION_TGLNADMIN"
              }
          ],
          "rpt_date": null,
          "sample_date": null,
          "sample_number": null,
          "sample_type": null,
          "superceded_date": null,
          "test_code": null,
          "test_date": "2026-04-20T15:11:00.000+00:00",
          "updated_at": "2026-04-21T03:36:11.201Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "deceased_donor_id": null,
          "donor_client_id": 142773,
          "_type": "virology_donor"
      }
  ]
}
const uhnOATSLivingDonor129467 = {
  "_id": "69f8f20803febc97e02271e1",
  "blood": {
      "_id": null,
      "rh": "+",
      "sub_type": "A1",
      "type": "A",
      "type_verified": true
  },
  "client_id": 142776,
  "comments": null,
  "consented_for_research": null,
  "created_at": "2026-05-04T19:22:48.117Z",
  "created_by": "AMY.NI1@ONEID.ON.CA",
  "death": {
      "_id": null,
      "cause_of_death_code": null,
      "created_at": "*******",
      "created_by": null,
      "death_date": null,
      "first_declare_date": null,
      "first_declarer": null,
      "hospital_id_declared": null,
      "hospital_id_retested": null,
      "hospital_id_retested_primary": null,
      "neurological_death": null,
      "other_cause_of_death": null,
      "retest_declare_date": null,
      "retest_declarer": null,
      "second_declare_date": null,
      "second_declarer": null,
      "updated_at": "*******",
      "updated_by": null
  },
  "deceased_donor_id": null,
  "default_hla_laboratory_id": null,
  "indicators": {
      "_id": null,
      "approach_over_the_phone": null,
      "deceased_at_referral_time": null,
      "deceased_donor": false,
      "double_kidney": "*******",
      "ecd_donor": "*******",
      "exceptional_distribution": false,
      "exd_reason_codes": [],
      "exd_reason_details_other": null,
      "exd_reason_details_transmission": null,
      "exd_reason_details_travel": null,
      "from_itransplant": null,
      "glasgow_coma_scale": null,
      "heart_beat_at_referral": null,
      "kdpi": null,
      "kdpi_datetime": null,
      "kidney_paired_donation": true,
      "oop_kidneys_available": "*******",
      "organ_donor": null,
      "out_of_province": null,
      "post_release": null,
      "post_release_by": null,
      "post_release_date": null,
      "post_release_reason": null,
      "read_only": null,
      "registered_consent_decision": null,
      "results_reason": null,
      "results_received": null,
      "results_received_by": null,
      "results_received_date": null,
      "results_reported": null,
      "results_reported_by": null,
      "results_reported_date": null,
      "rnr_complete": null,
      "tissue_donor": null,
      "unknown_donor_type": null,
      "ventilator_at_referral": null,
      "ventilator_status": null,
      "ventilator_type": null,
      "ventilator_type_other": null,
      "withdrawal_discussion": null
  },
  "living_donor_id": 129467,
  "living_donor_info": {
      "_id": null,
      "comments": null,
      "created_at": "2026-05-04T19:22:48.119Z",
      "created_by": "AMY.NI1@ONEID.ON.CA",
      "journeys": [
          {
              "_id": "69f8f20803febc97e02271e7",
              "anonymous": null,
              "comments": null,
              "completed": false,
              "completed_date": null,
              "completed_reason": null,
              "completed_reason_code": null,
              "created_at": "2026-05-04T19:22:48.119Z",
              "created_by": "AMY.NI1@ONEID.ON.CA",
              "directed_donation": false,
              "historical": false,
              "list_exchange": false,
              "migration_comment": null,
              "organ": "Kidney",
              "organ_code": 3,
              "recovery_info": {
                  "_id": null,
                  "comments": null,
                  "completed": null,
                  "created_at": "2026-05-04T21:18:57.812Z",
                  "created_by": null,
                  "cross_clamp_date": null,
                  "end_date": null,
                  "flush_date": null,
                  "liver_abnormalities_concerns": null,
                  "liver_graft_weight": null,
                  "organ_shipped": false,
                  "organ_specification_code": null,
                  "start_date": null,
                  "surgeon1": null,
                  "surgeon2": null,
                  "transplant_date": null,
                  "transplant_hospital_id": null,
                  "updated_at": "2026-05-04T21:18:57.812Z",
                  "updated_by": null
              },
              "registration_date": "2026-05-04T19:22:48.093+00:00",
              "start_date": "2026-05-01",
              "transfer_in_progress": false,
              "transplant_program": {
                  "_id": null,
                  "living_donor_coordinator_id": "635c844cc8957dc3d2bdcbc5",
                  "transplant_hospital_abbreviation": null,
                  "transplant_hospital_id": "635c84467575ec2a0b026422",
                  "transplant_hospital_mrn": null,
                  "transplant_hospital_short_name": null
              },
              "updated_at": "2026-05-04T21:18:57.820Z",
              "updated_by": "AUTOMATION_TGLNADMIN",
              "recovery_info_set": false,
              "intended_recipients": []
          }
      ],
      "updated_at": "2026-05-05T14:09:31.494Z",
      "updated_by": "AMY.NI1@ONEID.ON.CA",
      "virology_comments": null
  },
  "migrated_donor": false,
  "migration_comment": null,
  "organ_consents": [
      {
          "_id": "69f8f20803febc97e02271e8",
          "consented": true,
          "consented_date": "2026-05-01",
          "created_at": "2026-05-04T19:22:48.095Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "organ": "Kidney",
          "organ_code": 3,
          "updated_at": "2026-05-04T21:12:37.502Z",
          "updated_by": "AUTOMATION_TGLNADMIN",
          "running_allocation_tasks": {},
          "available_allocation_types": [],
          "runnable_allocation_types": [
              "living_anonymous"
          ]
      }
  ],
  "organ_decline_reason_category": null,
  "organ_decline_reason_type": null,
  "organ_donations_eligible_for_recovery": false,
  "rnr_admitting_diagnosis": null,
  "tissue_decline_reason_category": null,
  "tissue_decline_reason_type": null,
  "updated_at": "2026-05-05T14:09:31.513Z",
  "updated_by": "AUTOMATION_TGLNADMIN",
  "allocation_unavailable_due_to_positive_hbv_surface_ag": false,
  "allocation_must_be_expedited_due_to_missing_virology": {
      "1": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ],
      "2": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ],
      "3": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ],
      "4": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ],
      "6": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ],
      "7": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ],
      "7.5": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ],
      "6.5": [
          "HBV_CORE_AB",
          "HBV_SURFACE_AG",
          "HCV_AB"
      ]
  },
  "allocation_must_be_expedited_due_to_missing_hla_typing": [
      3,
      2,
      4,
      6,
      6.5,
      7.5
  ],
  "patient_profile": {
      "_id": "69f8f20703febc97e02271e0",
      "addresses": [
          {
              "_id": "69f8f20803febc97e02271e6",
              "administrative_region_code": null,
              "city": "City",
              "country_code": "CAN",
              "country_other": null,
              "postal_code": "X2X2X2",
              "province_code": "ON",
              "street": "Office",
              "type": "permanent"
          }
      ],
      "age": null,
      "birth": {
          "_id": "69f8f20803febc97e02271e2",
          "city": null,
          "country": null,
          "date": "2015-05-07",
          "province": null
      },
      "comments": null,
      "contact_details": {
          "_id": "69f8f20803febc97e02271e4",
          "email": null,
          "phone_alternate": null,
          "phone_alternate_ext": null,
          "phone_alternate_other": null,
          "phone_mobile": null,
          "phone_pager": null,
          "phone_primary": null,
          "phone_primary_ext": null,
          "phone_primary_other": null,
          "primary_contact_name": null,
          "primary_contact_relationship_code": null,
          "secondary_contact_name": null,
          "secondary_contact_relationship_code": null
      },
      "created_at": "2026-05-04T19:22:48.187Z",
      "created_by": "AMY.NI1@ONEID.ON.CA",
      "donor_id": "69f8f20803febc97e02271e1",
      "effective_date": null,
      "ethnicity_code": "7",
      "ethnicity_other": null,
      "first_name": "Name",
      "gender": null,
      "gender_other": null,
      "gender_sex_different": false,
      "in_utero": false,
      "insurance": {
          "_id": "69f8f20803febc97e02271e3",
          "number": null,
          "other_plan": null,
          "other_province_plan": null,
          "plan": null,
          "plan_checked": false,
          "plan_code": null,
          "version": null
      },
      "last_name": "Name",
      "living_donor_id": "69f8f20803febc97e02271e1",
      "marital_status_code": null,
      "middle_name": "",
      "postal_code": null,
      "recipient_id": null,
      "sex": "M",
      "updated_at": "2026-05-04T21:12:37.472Z",
      "updated_by": "AMY.NI1@ONEID.ON.CA"
  },
  "measurements": [
      {
          "_id": "69f8f20803febc97e02271e5",
          "abdominal_girth": null,
          "bmi": null,
          "bronchoscopy_comments": null,
          "cardiac_silhouette": null,
          "chest_circumference": null,
          "chest_vertical_left": null,
          "chest_vertical_right": null,
          "comments": null,
          "created_at": "2026-05-04T19:22:48.227Z",
          "created_by": "AMY.NI1@ONEID.ON.CA",
          "date": "2026-05-01",
          "donor_id": "69f8f20803febc97e02271e1",
          "height": 88,
          "lung_horizontal_measu": null,
          "suction_comments": null,
          "total_lung_capacity": null,
          "updated_at": "2026-05-04T19:22:48.227Z",
          "updated_by": "AMY.NI1@ONEID.ON.CA",
          "weight": 88
      }
  ],
  "organ_donations": [],
  "virologies": []
}
export {
  mock_recipient_episodes_of_care,
  mock_donor_episodes_of_care,
  mock_donor_and_recipient_EOC,
  mock_patient,
  mock_patient_bundle,
  mock_patient_RAM,
  mock_patient_SMHOne,
  mock_patient_SMHTwo,
  mock_patient_SMHThree,
  mock_patient_SMHFour,
  initialDataMock3,
  mock_patient_UHNOne,
  mock_patient_UHNTwo,
  uhnDataMock1,
  uhnDataMock2,
  uhnDataMock3,
  uhnOATSRecipientMock,
  uhnOATSRecipient69958,
  uhnOATSRecipient70068,
  uhnOATSRecipient71099,
  uhnOATSRecipient71065,
  uhnOATSLivingDonor129464,
  uhnOATSLivingDonor129467,
  mock_patient_UHNThree
};
